
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("5PFTV", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.12.2';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = '';
        this.appliedFillStyle = ''; //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = ''; //
        this.currentLineWidth = '';
        this.appliedLineWidth = ''; //
        this.currentLineCap = '';
        this.appliedLineCap = ''; //
        this.currentLineJoin = '';
        this.appliedLineJoin = ''; //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof1(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer'); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


var $13411541fd799095$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"lTyLO\",\"index.a7890f9e.js\",\"bv7gN\",\"create-template.4960343d.png\",\"hJmdA\",\"frames.9d882bf0.png\",\"loMBq\",\"multi-layer.51c2107f.png\",\"285js\",\"organization.cd8f5da8.png\",\"bfy0L\",\"overview.5e43ba7d.png\",\"1t8Z2\",\"publish-a.78969d2d.png\",\"ab0qh\",\"publish-b.d88a6c84.png\",\"efisr\",\"text-fields-a.0af48e87.png\",\"g0upU\",\"text-fields-b.f0dea3e1.png\",\"97XpQ\",\"worker.b9129586.js\",\"cFQq4\",\"index.5bcb191d.css\"]"));

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));




var $acw62 = parcelRequire("acw62");
class $968f28756c67bd23$export$b9721ef022f71a68 extends Error {
}
$968f28756c67bd23$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $968f28756c67bd23$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $968f28756c67bd23$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $968f28756c67bd23$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $968f28756c67bd23$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $968f28756c67bd23$var$base64UrlDecode(part);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $968f28756c67bd23$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}


const $5e3cd3c8fb9f0af3$export$923ea8233b386e99 = `${window.location.protocol}//${"api.intaglio.dev"}/api`;


var $e1959a6d31579a72$export$9c339144a54ec389 = /*#__PURE__*/ function(TokenTypes) {
    TokenTypes["GOOGLE"] = "google";
    TokenTypes["LOGIN_LINK"] = "login_link";
    return TokenTypes;
}({});
const $e1959a6d31579a72$export$f901672b588105c0 = ()=>{
    const tokens = localStorage.getItem('auth_tokens');
    return tokens ? JSON.parse(tokens) : {};
};
const $e1959a6d31579a72$export$84773cc9bf7dbe87 = async ()=>{
    const tokens = $e1959a6d31579a72$export$f901672b588105c0();
    const token = tokens.access;
    const refreshToken = tokens.refresh;
    if ((!token || $e1959a6d31579a72$var$isTokenExpired(token)) && refreshToken) {
        await $e1959a6d31579a72$export$63642a92eb2645f0();
        return $e1959a6d31579a72$export$f901672b588105c0().access_token;
    }
    return token;
};
const $e1959a6d31579a72$export$d4c818fcbfc5fcf = (tokens)=>{
    localStorage.setItem('auth_tokens', JSON.stringify(tokens));
};
const $e1959a6d31579a72$export$8b6bb3dd62a01be2 = (user)=>{
    localStorage.setItem('auth_user', JSON.stringify(user));
};
const $e1959a6d31579a72$export$7cbf767827cd68ba = ()=>{
    const user = localStorage.getItem('auth_user');
    return user ? JSON.parse(user) : null;
};
const $e1959a6d31579a72$export$ac527d777915178 = ()=>{
    localStorage.removeItem('auth_user');
};
const $e1959a6d31579a72$export$67488bf92fa15f1e = ()=>{
    localStorage.removeItem('auth_tokens');
    $e1959a6d31579a72$export$ac527d777915178();
};
const $e1959a6d31579a72$export$ebb7813e3fb8f4f2 = async ()=>{
    return !!await $e1959a6d31579a72$export$84773cc9bf7dbe87();
};
const $e1959a6d31579a72$export$a0973bcfe11b05c9 = ()=>{
    $e1959a6d31579a72$export$67488bf92fa15f1e();
    $e1959a6d31579a72$export$ac527d777915178();
};
const $e1959a6d31579a72$export$63642a92eb2645f0 = async ()=>{
    const tokens = $e1959a6d31579a72$export$f901672b588105c0();
    const refreshToken = tokens.refresh;
    fetch(`${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}/auth/refresh_token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            refresh: refreshToken
        })
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new Error('Failed to refresh tokens');
    }).then((data)=>{
        $e1959a6d31579a72$export$d4c818fcbfc5fcf({
            ...data,
            refresh: refreshToken
        });
    }).catch((error)=>{
        console.error('Error refreshing tokens:', error);
        $e1959a6d31579a72$export$a0973bcfe11b05c9();
    });
};
const $e1959a6d31579a72$export$951bd37fdf4d8a9e = async (token, type)=>{
    const result = await fetch(`${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}/auth/exchange_token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            token: token,
            token_type: type
        })
    });
    if (result.ok) {
        const response = await result.json();
        $e1959a6d31579a72$export$d4c818fcbfc5fcf(response);
        return;
    }
    throw new Error('Failed to exchange token');
};
const $e1959a6d31579a72$export$f17229473791149b = async (token, firstName, lastName)=>{
    const result = await fetch(`${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}/invitations/accept`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            token: token,
            first_name: firstName,
            last_name: lastName
        })
    });
    if (result.ok) {
        const response = await result.json();
        $e1959a6d31579a72$export$d4c818fcbfc5fcf(response);
        return;
    }
    throw new Error('Failed to accept invite');
};
function $e1959a6d31579a72$var$isTokenExpired(token) {
    try {
        const { exp: exp } = (0, $968f28756c67bd23$export$fa1e2fb699b7861e)(token);
        const currentTime = Math.floor(Date.now() / 1000);
        return exp ? exp < currentTime : true;
    } catch (error) {
        console.error('Error decoding token:', error);
        return true;
    }
}




function $647d702c229b8211$export$887bad18d4e1e94a(obj) {
    if (Array.isArray(obj)) {
        const newObj = obj.map((item)=>$647d702c229b8211$export$887bad18d4e1e94a(item));
        return newObj;
    }
    if (typeof obj === 'object' && obj !== null) {
        const newObj = {};
        for(const key in obj)if (Object.hasOwn(obj, key)) {
            const camelCaseKey = key.replace(/_([a-z])/g, (g)=>g[1].toUpperCase());
            newObj[camelCaseKey] = $647d702c229b8211$export$887bad18d4e1e94a(obj[key]);
        }
        return newObj;
    }
    return obj;
}
function $647d702c229b8211$export$7daef87da786a8bf(obj) {
    if (Array.isArray(obj)) {
        const newObj = obj.map((item)=>$647d702c229b8211$export$887bad18d4e1e94a(item));
        return newObj;
    }
    if (typeof obj === 'object' && obj !== null) {
        const newObj = {};
        for(const key in obj)if (Object.hasOwn(obj, key)) {
            const underscoreKey = key.replace(/([A-Z])/g, (g)=>`_${g.toLowerCase()}`);
            newObj[underscoreKey] = $647d702c229b8211$export$7daef87da786a8bf(obj[key]);
        }
        return newObj;
    }
    return obj;
}
const $647d702c229b8211$export$7d6f1c8842f9f527 = {
    async post (path, body) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const url = `${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}${path}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(body)
        });
        if (response.ok) try {
            return await response.json();
        } catch (e) {
            return {};
        }
        throw new Error('Failed to fetch data');
    },
    async get (path, query) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const queryString = query ? `?${new URLSearchParams(query).toString()}` : '';
        const url = `${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}${path}${queryString}`;
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (response.ok) return response.json().then((data)=>$647d702c229b8211$export$887bad18d4e1e94a(data));
        throw new Error('Failed to fetch data');
    },
    async getFile (absPath, mimeType) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const response = await fetch(absPath, {
            headers: {
                Accept: mimeType
            }
        });
        if (response.ok) return response;
        throw new Error('Failed to fetch data');
    },
    async delete (path) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const url = `${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}${path}`;
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (response.ok) try {
            return await response.json().then((data)=>$647d702c229b8211$export$887bad18d4e1e94a(data));
        } catch (e) {
            return {};
        }
        throw new Error('Failed to fetch data');
    },
    async put (path, body) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const url = `${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}${path}`;
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(body)
        });
        if (response.ok) return response.json().then((data)=>$647d702c229b8211$export$887bad18d4e1e94a(data));
        throw new Error('Failed to fetch data');
    },
    async patch (path, body) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const url = `${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}${path}`;
        const response = await fetch(url, {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify(body)
        });
        if (response.ok) try {
            return await response.json().then((data)=>$647d702c229b8211$export$887bad18d4e1e94a(data));
        } catch (e) {
            return {};
        }
        throw new Error('Failed to fetch data');
    },
    async upload (path, method, body, onProgress, onDone) {
        const token = await (0, $e1959a6d31579a72$export$84773cc9bf7dbe87)();
        const url = `${(0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)}${path}`;
        const xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.upload.onprogress = onProgress;
        xhr.onload = onDone;
        xhr.send(body);
        return xhr;
    }
};


const $2a781f80f599a2ae$export$cad58da5ead13057 = {
    async createVariants (variants) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/variants', variants);
    }
};



const $1dd987508bfe6892$export$9fb430c001a9d1c7 = {
    async getTemplateList (query) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/templates', query);
    },
    async createTemplate (template) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/templates', template);
    },
    async getTemplate (id) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get(`/templates/${id}`);
    },
    async getTemplateTags (templateId) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get(`/templates/${templateId}/tags`);
    },
    async shareTemplate (templateId, email) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).post(`/templates/${templateId}/share`, {
            email: email
        });
    }
};



const $6e8033ab95c7a58f$export$51b5be145b8f662b = {
    async sendLoginLink (email) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/auth/login_link', {
            email: email
        });
    }
};



const $9550621969846473$export$da5e64576956de1f = {
    async uploadSVGFile (file, onProgress, onDone) {
        const formData = new FormData();
        formData.append('file', file);
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).upload('/svg_files', 'POST', formData, onProgress, onDone);
    }
};



const $4de9f2a2c6cffb7a$export$c4e1fba60e7266e2 = {
    async deleteTemplateTag (tagId) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/template_tags/${tagId}`);
    },
    async createTemplateTag (templateId, tagId) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/template_tags', {
            template: templateId,
            tag: tagId
        });
    }
};




const $c0753412de87ef15$export$86659b0ff913db80 = {
    async getCurrentUser (refetch = false) {
        let user = (0, $e1959a6d31579a72$export$7cbf767827cd68ba)();
        if (user && !refetch) return user;
        user = await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/users/current');
        (0, $e1959a6d31579a72$export$8b6bb3dd62a01be2)(user);
        return user;
    },
    async updateUser (firstName, last_name, email, picture, onUpdated) {
        const user = await this.getCurrentUser();
        const updates = new FormData();
        if (firstName) updates.append('first_name', firstName);
        if (last_name) updates.append('last_name', last_name);
        if (email) updates.append('email', email);
        if (picture) updates.append('profile_picture', picture);
        (0, $647d702c229b8211$export$7d6f1c8842f9f527).upload(`/users/${user.id}`, 'PATCH', updates, ()=>{}, onUpdated);
    },
    async getOrganizationUsers () {
        const user = (0, $e1959a6d31579a72$export$7cbf767827cd68ba)();
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/organization_users');
    },
    async updateUserType (userId, type) {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(`/organization_users/${userId}/update_type`, {
            user_type: type
        });
    },
    async deleteUser (userId) {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/organization_users/${userId}`);
    }
};




const $a74acb8e10f991c3$export$7cae0ceb639f991d = {
    async updateOrganization (name, picture, onUpdated) {
        const user = (0, $e1959a6d31579a72$export$7cbf767827cd68ba)();
        const updates = new FormData();
        if (name) updates.append('name', name);
        if (picture) updates.append('logo', picture);
        (0, $647d702c229b8211$export$7d6f1c8842f9f527).upload(`/organizations/${user?.organization.id}`, 'PATCH', updates, ()=>{}, onUpdated);
    }
};



const $ee0b2042adda2a3b$export$5ffdd261dd91a68a = {
    async getInvitations () {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/invitations');
    },
    async createInvitation (email, type) {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/invitations', {
            email: email,
            user_type: type
        });
    },
    async updateInvitationType (invitationId, type) {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(`/invitations/${invitationId}`, {
            user_type: type
        });
    },
    async deleteInvitation (invitationId) {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/invitations/${invitationId}`);
    },
    async resendInvitation (invitationId) {
        return (0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(`/invitations/${invitationId}/resend`, {});
    },
    async validateInviteToken (token) {
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/invitations/validate', {
            token: token
        });
    }
};



const $c31e9b81d8391e7c$export$1811d82788a05bc9 = {
    async getCreativeList (query) {
        const endpoint = `/creatives${query}`;
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get(endpoint);
    },
    async getCreative (creativeId) {
        const endpoint = `/creatives/${creativeId}`;
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get(endpoint);
    },
    async createCreative (data) {
        const endpoint = '/creatives';
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).post(endpoint, data);
    },
    async updateCreative (creativeId, data) {
        const endpoint = `/creatives/${creativeId}`;
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(endpoint, data);
    },
    async getExports (creativeId) {
        const endpoint = `/creatives/${creativeId}/exports`;
        return await (0, $647d702c229b8211$export$7d6f1c8842f9f527).get(endpoint);
    }
};




const $701fdb377a36f454$var$AuthContext = /*#__PURE__*/ (0, $acw62.createContext)({
    login: async ()=>{},
    loginViaInvite: async ()=>{},
    logout: ()=>{},
    checkAuth: async ()=>false
});
const $701fdb377a36f454$export$1d39dc5b47e56ff0 = ()=>{
    return (0, $acw62.useContext)($701fdb377a36f454$var$AuthContext);
};
const $701fdb377a36f454$export$87091915187a1a85 = ({ children: children })=>{
    const login = async (token, type)=>{
        await (0, $e1959a6d31579a72$export$951bd37fdf4d8a9e)(token, type);
    };
    const loginViaInvite = async (token, firstName, lastName)=>{
        await (0, $e1959a6d31579a72$export$f17229473791149b)(token, firstName, lastName);
    };
    const logout = ()=>{
        (0, $e1959a6d31579a72$export$67488bf92fa15f1e)();
    };
    const checkAuth = async ()=>{
        return await (0, $e1959a6d31579a72$export$ebb7813e3fb8f4f2)();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($701fdb377a36f454$var$AuthContext.Provider, {
        value: {
            checkAuth: checkAuth,
            login: login,
            logout: logout,
            loginViaInvite: loginViaInvite
        },
        children: children
    });
};


// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "9.15.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return 0, $1a40e26460b4422e$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $b0bfa51115099518$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $db00931c27c5ec41$export$7e223ec222791509(name, creator, obj = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] = __SENTRY__[0, $b0bfa51115099518$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $9a62450b4f3c2c3b$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $9a62450b4f3c2c3b$export$49034edbe6b62415(request, Request);
}



const $cccaafc2216668b2$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = 'Sentry Logger ';
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $18144a665bc8acf7$export$16a28057038b10ef) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $db00931c27c5ec41$export$7e223ec222791509)('logger', $c9674f9e04798056$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) return false;
    if ((0, $9a62450b4f3c2c3b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d)(target) ? (0, $cccaafc2216668b2$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $cee8faa76567523a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $cee8faa76567523a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $4f55103f4332a5b0$var$getCrypto() {
    const gbl = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496(crypto = $4f55103f4332a5b0$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $cee8faa76567523a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $cee8faa76567523a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $4f6ba265374890ec$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $4f6ba265374890ec$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $4f6ba265374890ec$export$baf075a948ffc0bf() {
    if (!$4f6ba265374890ec$var$cachedTimeOrigin) $4f6ba265374890ec$var$cachedTimeOrigin = $4f6ba265374890ec$var$getBrowserTimeOrigin();
    return $4f6ba265374890ec$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}


/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}






/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)().substring(16);
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $33c387bb26fe522d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $33c387bb26fe522d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(newScope, (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $99af9a2b040631ba$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $cee8faa76567523a$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $99af9a2b040631ba$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $db00931c27c5ec41$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $db00931c27c5ec41$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $4354bb0fac58a6e0$export$6f1b9191db9c4d5)(), (0, $4354bb0fac58a6e0$export$de9862929b76bf57)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $ab23dab597a507b7$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $db00931c27c5ec41$export$7e223ec222791509)('globalScope', ()=>new (0, $33c387bb26fe522d$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $fbb22756c9507e85$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}



const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


const $b99d5bb3db344fdd$var$INTEGRATION_NAME = 'Dedupe';
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $4010ef0d9b3761f9$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}




let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = 'FunctionToString';
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $18144a665bc8acf7$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}


const $0e303f054920e2b1$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}



/**
 * Get a list of possible event messages from a Sentry event.
 */ function $e5904939f3a5a4e3$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}





// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $42e5926860cf11cf$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $42e5926860cf11cf$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $42e5926860cf11cf$export$9a84f518c163c552 = (0, $fbb22756c9507e85$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $42e5926860cf11cf$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $42e5926860cf11cf$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $42e5926860cf11cf$var$_mergeOptions(options, clientOptions);
            }
            return $42e5926860cf11cf$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $42e5926860cf11cf$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)((options = {})=>{
    return {
        ...$42e5926860cf11cf$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $42e5926860cf11cf$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $42e5926860cf11cf$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $42e5926860cf11cf$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($42e5926860cf11cf$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($42e5926860cf11cf$var$_isUselessError(event)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($42e5926860cf11cf$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$42e5926860cf11cf$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$42e5926860cf11cf$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}.\nUrl: ${$42e5926860cf11cf$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($42e5926860cf11cf$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $42e5926860cf11cf$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $e5904939f3a5a4e3$export$d55a97c329cacfcc)(event).some((message)=>(0, $cee8faa76567523a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $42e5926860cf11cf$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $42e5926860cf11cf$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $42e5926860cf11cf$var$_getEventFilterUrl(event);
    return !url ? false : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $42e5926860cf11cf$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $42e5926860cf11cf$var$_getEventFilterUrl(event);
    return !url ? true : (0, $cee8faa76567523a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $42e5926860cf11cf$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $42e5926860cf11cf$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $42e5926860cf11cf$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $4f55103f4332a5b0$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $42e5926860cf11cf$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $b776c95debaa4af0$export$16a28057038b10ef) (0, $c9674f9e04798056$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().setClient(client);
}




const $3592a0510b526070$export$849dbeeeda01ae98 = 'production';







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && processor.id && result === null && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}






/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $5eb42146e0d2c9ef$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $f4dd084fe83374eb$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9a62450b4f3c2c3b$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9a62450b4f3c2c3b$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $5eb42146e0d2c9ef$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = 'sentry.profile_id';
const $068c396dceb690a1$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $068c396dceb690a1$export$b016f89ac1066ec = 'cache.hit';
const $068c396dceb690a1$export$3110e4c3f4386399 = 'cache.key';
const $068c396dceb690a1$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = 'http.request.method';
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $068c396dceb690a1$export$ff77b5fd5b2d627b = 'sentry.link.type';



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $39d14882dc0612d9$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $39d14882dc0612d9$export$5008da00b1b6dee6 = $39d14882dc0612d9$export$1f70765132c3c225;






const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}





const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = 'sentry-';
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $dc99b4184ec29e47$export$dc6d7ea554bcce10)(), spanId = (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $06e5b8314e290bf2$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $dc99b4184ec29e47$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $06e5b8314e290bf2$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
            status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
            op: attributes[0, $068c396dceb690a1$export$1a413bd9a88fdb09],
            origin: attributes[0, $068c396dceb690a1$export$cca8dd30f57f805e],
            links: $36b15c0d755e29f6$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $006ad32cdaebe09b$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $006ad32cdaebe09b$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $db00931c27c5ec41$export$19eade501500c6c1)();
    const acs = (0, $5cec0a7bd2540b32$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $99af9a2b040631ba$export$91f063ebb8eff307)((0, $f106fce27ec076f7$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $068c396dceb690a1$export$d7a7d984b0791405)]: 'custom',
        [(0, $068c396dceb690a1$export$165ce9a229f6f050)]: name
    });
}





/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $3592a0510b526070$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $068c396dceb690a1$export$ccfe0a40627cc34b];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $068c396dceb690a1$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $39d14882dc0612d9$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $36b15c0d755e29f6$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $4509d165411fd11c$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $bcdb7fb6cf7e08bf$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'extra', extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'tags', tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'user', user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $05f9869a4b646370$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $36b15c0d755e29f6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $36b15c0d755e29f6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f106fce27ec076f7$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $29ab5181ea4a2c1b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $29ab5181ea4a2c1b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $fa62667502ab5c7a$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $3592a0510b526070$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $cee8faa76567523a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $107941ce73c7a34f$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $5eb42146e0d2c9ef$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $33c387bb26fe522d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $33c387bb26fe522d$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $baba650ac852ba0c$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}







/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureException(exception, (0, $baba650ac852ba0c$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f106fce27ec076f7$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $f106fce27ec076f7$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (!client) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $4f6ba265374890ec$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $f106fce27ec076f7$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $f106fce27ec076f7$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ecc06dd71ed8ff5f$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ecc06dd71ed8ff5f$export$56521d9ba90f62ee)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}




const $020e060e3b422828$var$WINDOW = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$67fc34576016d6ec() {
    return 'history' in $020e060e3b422828$var$WINDOW && !!$020e060e3b422828$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return 'ReportingObserver' in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}













/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    const carrier = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    const carrier = (0, $db00931c27c5ec41$export$c8bfa33e4e8ae492)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $5eb42146e0d2c9ef$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    otel_log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $f5682b06913d5b03$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $36b15c0d755e29f6$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $36b15c0d755e29f6$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f5682b06913d5b03$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, items);
}












/**
 * Converts a transaction event to a span JSON object.
 */ function $fc63bcb83eb88e73$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $068c396dceb690a1$export$1efec95406bbe327],
        exclusive_time: data?.[0, $068c396dceb690a1$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $fc63bcb83eb88e73$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $068c396dceb690a1$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $068c396dceb690a1$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}








/* eslint-disable max-lines */ const $76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $76d0d0aa71b7be3b$var$_makeInternalError(message) {
    return {
        message: message,
        [$76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $76d0d0aa71b7be3b$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $76d0d0aa71b7be3b$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $76d0d0aa71b7be3b$var$INTERNAL_ERROR_SYMBOL in error;
}
function $76d0d0aa71b7be3b$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $76d0d0aa71b7be3b$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $76d0d0aa71b7be3b$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(options.dsn);
        else (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(exception)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $4f55103f4332a5b0$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $4f55103f4332a5b0$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $4f55103f4332a5b0$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log($76d0d0aa71b7be3b$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $f5682b06913d5b03$export$d650323442802f6f)(env, (0, $f5682b06913d5b03$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $3592a0510b526070$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn($76d0d0aa71b7be3b$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ecc06dd71ed8ff5f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $baba650ac852ba0c$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $f106fce27ec076f7$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)(), isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)()) {
        if ((0, $b776c95debaa4af0$export$16a28057038b10ef) && $76d0d0aa71b7be3b$var$isErrorEvent(event)) (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Captured error event \`${(0, $e5904939f3a5a4e3$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $b776c95debaa4af0$export$16a28057038b10ef) {
                if ($76d0d0aa71b7be3b$var$_isDoNotSendEventError(reason)) (0, $c9674f9e04798056$export$af88d00dbe7f521).log(reason.message);
                else if ($76d0d0aa71b7be3b$var$_isInternalError(reason)) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(reason.message);
                else (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $76d0d0aa71b7be3b$var$isTransactionEvent(event);
        const isError = $76d0d0aa71b7be3b$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)($76d0d0aa71b7be3b$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $76d0d0aa71b7be3b$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $76d0d0aa71b7be3b$var$processBeforeSend(this, options, prepared, hint);
            return $76d0d0aa71b7be3b$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $76d0d0aa71b7be3b$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($76d0d0aa71b7be3b$var$_isDoNotSendEventError(reason) || $76d0d0aa71b7be3b$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $76d0d0aa71b7be3b$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $bbe8beff1aee2812$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9171e4713e443b9b$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $76d0d0aa71b7be3b$export$4f22f74eddb7716a = $76d0d0aa71b7be3b$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $76d0d0aa71b7be3b$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $9a62450b4f3c2c3b$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(event) && event !== null) throw $76d0d0aa71b7be3b$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $76d0d0aa71b7be3b$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $76d0d0aa71b7be3b$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $76d0d0aa71b7be3b$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($76d0d0aa71b7be3b$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($76d0d0aa71b7be3b$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $fc63bcb83eb88e73$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $05f9869a4b646370$export$4950aa0f605343fb)(event, (0, $fc63bcb83eb88e73$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $36b15c0d755e29f6$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $76d0d0aa71b7be3b$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $76d0d0aa71b7be3b$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $76d0d0aa71b7be3b$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    const traceContext = span ? (0, $36b15c0d755e29f6$export$46c6fbd1d265ebf0)(span) : (0, $f106fce27ec076f7$export$1e83db7ee4876dc4)(scope);
    const dynamicSamplingContext = span ? (0, $dfdaf30e5fcd5fd9$export$a117f995597e25df)(span) : (0, $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b)(client, scope);
    return [
        dynamicSamplingContext,
        traceContext
    ];
}







/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $04aadcf3f679e7b5$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates OTEL log envelope item for a serialized OTEL log.
 *
 * @param log - The serialized OTEL log to include in the envelope.
 * @returns The created OTEL log envelope item.
 */ function $d42718a865457723$export$3fb4f8e4a128d620(log) {
    return [
        {
            type: 'otel_log'
        },
        log
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $d42718a865457723$export$4324f1d0c59fd57b(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn);
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, logs.map($d42718a865457723$export$3fb4f8e4a128d620));
}


const $e2016958b0149e1a$var$MAX_LOG_BUFFER_SIZE = 100;
const $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $e2016958b0149e1a$export$84cb46f4adfc5d14(key, value) {
    switch(typeof value){
        case 'number':
            return {
                key: key,
                value: {
                    doubleValue: value
                }
            };
        case 'boolean':
            return {
                key: key,
                value: {
                    boolValue: value
                }
            };
        case 'string':
            return {
                key: key,
                value: {
                    stringValue: value
                }
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    key: key,
                    value: {
                        stringValue: stringValue
                    }
                };
            }
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$3ab3d16b9eebd986(beforeLog, client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)(), scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)()) {
    if (!client) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $76d0d0aa71b7be3b$export$fb7d833b3fdedf5f)(client, scope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    if (release) processedLogAttributes['sentry.release'] = release;
    if (environment) processedLogAttributes['sentry.environment'] = environment;
    const { sdk: sdk } = client.getSdkMetadata() ?? {};
    if (sdk) {
        processedLogAttributes['sentry.sdk.name'] = sdk.name;
        processedLogAttributes['sentry.sdk.version'] = sdk.version;
    }
    const beforeLogMessage = beforeLog.message;
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $99af9a2b040631ba$export$91f063ebb8eff307)(scope);
    if (span) // Add the parent span ID to the log attributes for trace context
    processedLogAttributes['sentry.trace.parent_span_id'] = span.spanContext().spanId;
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        severityText: level,
        body: {
            stringValue: message
        },
        attributes: Object.entries(attributes).map(([key, value])=>$e2016958b0149e1a$export$84cb46f4adfc5d14(key, value)),
        timeUnixNano: `${new Date().getTime().toString()}000000`,
        traceId: traceContext?.trace_id,
        severityNumber: severityNumber ?? (0, $04aadcf3f679e7b5$export$4fb50c0840d636d1)[level]
    };
    const logBuffer = $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP.get(client);
    if (logBuffer === undefined) $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP.set(client, [
        serializedLog
    ]);
    else {
        logBuffer.push(serializedLog);
        if (logBuffer.length > $e2016958b0149e1a$var$MAX_LOG_BUFFER_SIZE) $e2016958b0149e1a$export$f8ed83d3b6a0b504(client, logBuffer);
    }
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $e2016958b0149e1a$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $e2016958b0149e1a$var$CLIENT_TO_LOG_BUFFER_MAP.get(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $d42718a865457723$export$4324f1d0c59fd57b)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    logBuffer.length = 0;
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
            })),
        version: (0, $b0bfa51115099518$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $5eb42146e0d2c9ef$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(exception) || (0, $9a62450b4f3c2c3b$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $9a62450b4f3c2c3b$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $9a62450b4f3c2c3b$export$53b83ca8eaab0383)(exception) || (0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $9a62450b4f3c2c3b$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $f4dd084fe83374eb$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $9a62450b4f3c2c3b$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $9a62450b4f3c2c3b$export$9671ea99bd126ace)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4f55103f4332a5b0$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $4f55103f4332a5b0$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $f4dd084fe83374eb$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}


const $72d27c0252bb80ff$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $76d0d0aa71b7be3b$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1d72e3a9e632bed3$export$8ad33f488b1ab046)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const client = this;
        const { sendDefaultPii: sendDefaultPii, _experiments: _experiments } = client._options;
        const enableLogs = _experiments?.enableLogs;
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                this._flushOutcomes();
                if (enableLogs) (0, $e2016958b0149e1a$export$f8ed83d3b6a0b504)(client);
            }
        });
        if (enableLogs) {
            client.on('flush', ()=>{
                (0, $e2016958b0149e1a$export$f8ed83d3b6a0b504)(client);
            });
            client.on('afterCaptureLog', ()=>{
                if (client._logFlushIdleTimeout) clearTimeout(client._logFlushIdleTimeout);
                client._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $e2016958b0149e1a$export$f8ed83d3b6a0b504)(client);
                }, $72d27c0252bb80ff$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            client.on('postprocessEvent', (0, $2cca66f9c5e6f810$export$3e12ad68afa434ac));
            client.on('beforeSendSession', (0, $2cca66f9c5e6f810$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $f106fce27ec076f7$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $4f6ba265374890ec$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $18144a665bc8acf7$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $4010ef0d9b3761f9$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!('console' in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1))) return;
    (0, $c9674f9e04798056$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console)) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $c9674f9e04798056$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $c9674f9e04798056$export$77c4ce905194557b)[level];
                log?.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $020e060e3b422828$export$c82d238e23c40b21)()) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $da5e32477400e3c6$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $1a40e26460b4422e$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($da5e32477400e3c6$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $da5e32477400e3c6$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $9a62450b4f3c2c3b$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $2bf5ed435a4428b5$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $2bf5ed435a4428b5$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $2bf5ed435a4428b5$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith('/');
    const base = urlBase ?? (isRelative ? $2bf5ed435a4428b5$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$5339fcdc8e2a427c(url) {
    if ($2bf5ed435a4428b5$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1);


const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f079126c500c7ea2$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $955496f5d3029976$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $f4dd084fe83374eb$export$e73679ffaf56810e)(target, '_sentryId', (0, $4f55103f4332a5b0$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $3d87653da885c31c$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $3d87653da885c31c$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $020e060e3b422828$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(header) && (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $4f6ba265374890ec$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $f079126c500c7ea2$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $63e43e59b4196dc4$var$parseXhrUrlArg(url) {
    if ((0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = 'Breadcrumbs';
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $16d762171e064dbd$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $da5e32477400e3c6$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4f55103f4332a5b0$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $cccaafc2216668b2$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $cccaafc2216668b2$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $cee8faa76567523a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setTimeout', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'setInterval', $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), 'requestAnimationFrame', $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $f4dd084fe83374eb$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $4010ef0d9b3761f9$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $f4dd084fe83374eb$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $f2b90654edf2c0a1$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $f2b90654edf2c0a1$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('error', handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f079126c500c7ea2$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $1a40e26460b4422e$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $3920039f2d643754$var$INTEGRATION_NAME = 'GlobalHandlers';
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $f106fce27ec076f7$export$6bb76d6eba7e258c)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $f2b90654edf2c0a1$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $9a62450b4f3c2c3b$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $9a62450b4f3c2c3b$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $cccaafc2216668b2$export$1cfafeee2987818b)();
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $9a62450b4f3c2c3b$export$49034edbe6b62415)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = 'cause';
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = 'LinkedErrors';
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $71a9151fcd5ea774$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $4010ef0d9b3761f9$export$a5739666fb2d03d4)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $4010ef0d9b3761f9$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






const $f3cbf180d3404fe0$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $9ad49a0639c06d33$export$78e43115b553f358)($f3cbf180d3404fe0$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $9ad49a0639c06d33$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f3cbf180d3404fe0$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f5682b06913d5b03$export$b11169581eeaf237)(type);
            if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $f5682b06913d5b03$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f5682b06913d5b03$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $f3cbf180d3404fe0$export$c8667f1887a128dc)) {
                (0, $b776c95debaa4af0$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $9ad49a0639c06d33$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $020e060e3b422828$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8('setTimeout')(...rest);
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $9ad49a0639c06d33$export$78e43115b553f358)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $42e5926860cf11cf$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)(),
        (0, $8a5b32760c0daa50$export$1baa7880e357371c)()
    ];
}
/** Exported only for tests. */ function $928f566aa50bb77a$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$928f566aa50bb77a$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $928f566aa50bb77a$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $cccaafc2216668b2$export$1cfafeee2987818b)() || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $c9674f9e04798056$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if ((0, $7b8b500cb80621bc$export$16a28057038b10ef) && !(0, $020e060e3b422828$export$edf3cb81fd7d2a3e)()) (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    const clientOptions = {
        ...options,
        stackParser: (0, $4010ef0d9b3761f9$export$1d5cf88b347146d4)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    return (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $f106fce27ec076f7$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $f2b90654edf2c0a1$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $acw62 = parcelRequire("acw62");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe334ae3892c74f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





var $acw62 = parcelRequire("acw62");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $262dc4fd22993153$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $262dc4fd22993153$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $262dc4fd22993153$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($262dc4fd22993153$export$a87138b73900f5b((0, $acw62.version)) && (0, $9a62450b4f3c2c3b$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $262dc4fd22993153$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $f2b90654edf2c0a1$export$f5282963edea4a68)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $262dc4fd22993153$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $262dc4fd22993153$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


var $72623ab6bcb0a33b$exports = {};
'use strict';
var $3251146683c5d714$exports = {};
'use strict';

$3251146683c5d714$exports = (parcelRequire("9cCWX"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$3251146683c5d714$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($3251146683c5d714$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $a0fc5be3f0cb3d79$export$6c1f0397687d8b2 = $72623ab6bcb0a33b$exports.default || $72623ab6bcb0a33b$exports;


const $8921079907ea55d7$export$6ef4c0367e27f2d5 = 'unknown';
const $8921079907ea55d7$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8921079907ea55d7$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = $8921079907ea55d7$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $f106fce27ec076f7$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $f106fce27ec076f7$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $262dc4fd22993153$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $8921079907ea55d7$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($8921079907ea55d7$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $acw62.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($acw62.isValidElement(element)) return element;
        if (fallback) (0, $fe334ae3892c74f1$export$16a28057038b10ef) && (0, $c9674f9e04798056$export$af88d00dbe7f521).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8921079907ea55d7$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8921079907ea55d7$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($8921079907ea55d7$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $acw62.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $a0fc5be3f0cb3d79$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}




var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, 'react');
    (0, $f2b90654edf2c0a1$export$2f04de43fe27971a)('react', {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $4730acf0753ac89a$export$6acf61af03e62db = typeof window === 'undefined';
function $4730acf0753ac89a$export$8793edee2d425525() {
    return undefined;
}
function $4730acf0753ac89a$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $4730acf0753ac89a$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $4730acf0753ac89a$export$4d32d63f64b825b9(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $4730acf0753ac89a$export$acaf96a27438246b(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function $4730acf0753ac89a$export$224e3b7078227b8a(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $4730acf0753ac89a$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $4730acf0753ac89a$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
        queryKey: arg1
    });
}
function $4730acf0753ac89a$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
        mutationFn: arg1
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg1);
}
function $4730acf0753ac89a$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? [
        (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $4730acf0753ac89a$export$42387eeaac09cf54(arg1, arg2) {
    return $4730acf0753ac89a$export$aaae5295ec3351c9(arg1) ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function $4730acf0753ac89a$export$eafbe052e989494f(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function $4730acf0753ac89a$export$c5d1efe363797780(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = $4730acf0753ac89a$export$eafbe052e989494f(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $4730acf0753ac89a$export$a1ea5fb559f63ae3(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if ($4730acf0753ac89a$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($4730acf0753ac89a$export$5fcb678681417b54(mutation.options.mutationKey) !== $4730acf0753ac89a$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$4730acf0753ac89a$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $4730acf0753ac89a$export$cc90ca97bc0d73fd(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $4730acf0753ac89a$export$5fcb678681417b54;
    return hashFn(queryKey);
}
function $4730acf0753ac89a$export$5fcb678681417b54(queryKey) {
    var asArray = $4730acf0753ac89a$export$4d32d63f64b825b9(queryKey);
    return $4730acf0753ac89a$export$e7f2f041280beb00(asArray);
}
function $4730acf0753ac89a$export$e7f2f041280beb00(value) {
    return JSON.stringify(value, function(_, val) {
        return $4730acf0753ac89a$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function $4730acf0753ac89a$export$2f07189bb9fa26a7(a, b) {
    return $4730acf0753ac89a$export$3bc9138b70293839($4730acf0753ac89a$export$4d32d63f64b825b9(a), $4730acf0753ac89a$export$4d32d63f64b825b9(b));
}
function $4730acf0753ac89a$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !$4730acf0753ac89a$export$3bc9138b70293839(a[key], b[key]);
    });
    return false;
}
function $4730acf0753ac89a$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || $4730acf0753ac89a$export$53b83ca8eaab0383(a) && $4730acf0753ac89a$export$53b83ca8eaab0383(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = $4730acf0753ac89a$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $4730acf0753ac89a$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $4730acf0753ac89a$export$53b83ca8eaab0383(o) {
    if (!$4730acf0753ac89a$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!$4730acf0753ac89a$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $4730acf0753ac89a$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $4730acf0753ac89a$export$aaae5295ec3351c9(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function $4730acf0753ac89a$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $4730acf0753ac89a$export$e772c8ff12451969(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $4730acf0753ac89a$export$4304cb76768ca134(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function $4730acf0753ac89a$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}






var $a326eb7faf36b653$export$c3ab47f7c70c8aa4 = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this.notifyFn(callback);
        });
    } /**
   * All calls to the wrapped function will be batched.
   */ ;
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, $4730acf0753ac89a$export$4304cb76768ca134)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    } /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ ;
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    } /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ ;
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var $a326eb7faf36b653$export$520687f44db6e1ab = new $a326eb7faf36b653$export$c3ab47f7c70c8aa4();


// TYPES
// FUNCTIONS
var $71a71a329ca2584f$var$logger = console;
function $71a71a329ca2584f$export$2b1d391cd05230fd() {
    return $71a71a329ca2584f$var$logger;
}
function $71a71a329ca2584f$export$3abbd92f765bee58(newLogger) {
    $71a71a329ca2584f$var$logger = newLogger;
}



var $8806d6a418db4b9d$export$d26086b469ecdbcc = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();



var $dd382c2a22c34b78$export$86f1af424b2ca4de = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $dd382c2a22c34b78$export$6bf54661be5b02cf = new $dd382c2a22c34b78$export$86f1af424b2ca4de();





var $8283b4ebace21c13$export$58774fb55d5ff7fc = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, $4730acf0753ac89a$export$6acf61af03e62db) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
var $8283b4ebace21c13$export$b113e788b2dd3fdc = new $8283b4ebace21c13$export$58774fb55d5ff7fc();



function $90c5b2b1a5489698$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function $90c5b2b1a5489698$export$22e08d49843051be(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var $90c5b2b1a5489698$export$a8430ed4188f35a9 = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function $90c5b2b1a5489698$export$986cc6445c1d323(value) {
    return value instanceof $90c5b2b1a5489698$export$a8430ed4188f35a9;
} // CLASS
var $90c5b2b1a5489698$export$586a619a4618a582 = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new $90c5b2b1a5489698$export$a8430ed4188f35a9(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if ($90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = $90c5b2b1a5489698$export$22e08d49843051be(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $90c5b2b1a5489698$var$defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, $4730acf0753ac89a$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() || !(0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};


var $b3c5b3b704751c57$export$62297b13309008b2 = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, $4730acf0753ac89a$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, $4730acf0753ac89a$export$7f095f455ad5af3f)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, $4730acf0753ac89a$export$4d32d63f64b825b9)(this.queryKey);
        var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, $90c5b2b1a5489698$export$986cc6445c1d323)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, $90c5b2b1a5489698$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.revertState);
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();




var $55146b963a737dee$export$5dde0cd941da8468 = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, $b3c5b3b704751c57$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, $4730acf0753ac89a$export$c5d1efe363797780)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));









var $8d56420e30839da2$export$17b8b19c814bcf56 = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || $8d56420e30839da2$export$a1659b54bac3252a();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, $90c5b2b1a5489698$export$586a619a4618a582)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = $8d56420e30839da2$var$reducer(this.state, action);
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function $8d56420e30839da2$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function $8d56420e30839da2$var$reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action.state);
        default:
            return state;
    }
}




var $10b6fdd47d933258$export$1fcfd9a244434844 = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, $8d56420e30839da2$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, $4730acf0753ac89a$export$a1ea5fb559f63ae3)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, $4730acf0753ac89a$export$8793edee2d425525));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));







function $73df723cfc461e76$export$84470d1367601e8d() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, $4730acf0753ac89a$export$382ca5d13a8f252c)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : $73df723cfc461e76$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : $73df723cfc461e76$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : $73df723cfc461e76$export$1186159d57de7255(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, $90c5b2b1a5489698$export$22e08d49843051be)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function $73df723cfc461e76$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function $73df723cfc461e76$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = $73df723cfc461e76$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function $73df723cfc461e76$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = $73df723cfc461e76$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}


var $13e074efb1ecf7c6$export$405d0624ed55a03f = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, $55146b963a737dee$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $10b6fdd47d933258$export$1fcfd9a244434844)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).subscribe(function() {
            if ((0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused() && (0, $8283b4ebace21c13$export$b113e788b2dd3fdc).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filters, {
            active: true
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, $4730acf0753ac89a$export$18e8f4b987e6c111)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $73df723cfc461e76$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, $4730acf0753ac89a$export$8793edee2d425525)).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(queryKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$5fcb678681417b54)(mutationKey) === (0, $4730acf0753ac89a$export$5fcb678681417b54)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, $4730acf0753ac89a$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $4730acf0753ac89a$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();


// Side effects


var $d0188f2d930898c2$export$c78a37762a8d58e1 = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).unstable_batchedUpdates;


(0, $a326eb7faf36b653$export$520687f44db6e1ab).setBatchNotifyFunction((0, $d0188f2d930898c2$export$c78a37762a8d58e1));



var $a9338c6a303143c8$export$af88d00dbe7f521 = console;


(0, $71a71a329ca2584f$export$3abbd92f765bee58)((0, $a9338c6a303143c8$export$af88d00dbe7f521));



var $acw62 = parcelRequire("acw62");
var $ccb8f828cefd6075$var$defaultContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $ccb8f828cefd6075$var$QueryClientSharingContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $ccb8f828cefd6075$var$getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $ccb8f828cefd6075$var$defaultContext;
        return window.ReactQueryClientContext;
    }
    return $ccb8f828cefd6075$var$defaultContext;
}
var $ccb8f828cefd6075$export$22e77b9572c4fded = function useQueryClient() {
    var queryClient = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$getQueryClientContext((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($ccb8f828cefd6075$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var $ccb8f828cefd6075$export$45604f0cc8ae667b = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = $ccb8f828cefd6075$var$getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ccb8f828cefd6075$var$QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: client
    }, children));
};







var $acw62 = parcelRequire("acw62");







var $d69ec76a7f524d37$export$d3c1860ee66f291a = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, $8d56420e30839da2$export$a1659b54bac3252a)();
        var result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



function $a92a0ee821c291b8$export$2072f68e6c3507cf(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}


function $0bcdd0ea2a5866d5$export$609860bf8b0084c(arg1, arg2, arg3) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var options = (0, $4730acf0753ac89a$export$b646c531ea475334)(arg1, arg2, arg3);
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var obsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    if (!obsRef.current) obsRef.current = new (0, $d69ec76a7f524d37$export$d3c1860ee66f291a)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, $4730acf0753ac89a$export$8793edee2d425525));
    }, []);
    if (currentResult.error && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}










var $461f073e5b72a6b1$export$a06cf8c0066f0d4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if ($461f073e5b72a6b1$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return $461f073e5b72a6b1$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $4730acf0753ac89a$export$8793edee2d425525));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.options.staleTime)) return;
        var time = (0, $4730acf0753ac89a$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $4730acf0753ac89a$export$6acf61af03e62db) || this.options.enabled === false || !(0, $4730acf0753ac89a$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, $dd382c2a22c34b78$export$6bf54661be5b02cf).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && $461f073e5b72a6b1$var$shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, $4730acf0753ac89a$export$77a71fc411098696)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, $71a71a329ca2584f$export$2b1d391cd05230fd)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: $461f073e5b72a6b1$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, $4730acf0753ac89a$export$3e67810a3f0e9f1c)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, $90c5b2b1a5489698$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));
function $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $461f073e5b72a6b1$var$shouldFetchOnMount(query, options) {
    return $461f073e5b72a6b1$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $461f073e5b72a6b1$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $461f073e5b72a6b1$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $461f073e5b72a6b1$var$isStale(query, options);
    }
    return false;
}
function $461f073e5b72a6b1$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $461f073e5b72a6b1$var$isStale(query, options);
}
function $461f073e5b72a6b1$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $af499ad4852a56cf$var$createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var $af499ad4852a56cf$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($af499ad4852a56cf$var$createValue()); // HOOK
var $af499ad4852a56cf$export$50dfac555130cafd = function useQueryErrorResetBoundary() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($af499ad4852a56cf$var$QueryErrorResetBoundaryContext);
}; // COMPONENT
var $af499ad4852a56cf$export$ddb9962d870f2330 = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $af499ad4852a56cf$var$createValue();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($af499ad4852a56cf$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




function $02303e84e5b435f8$export$fff0865807e996c5(options, Observer) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var errorResetBoundary = (0, $af499ad4852a56cf$export$50dfac555130cafd)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a92a0ee821c291b8$export$2072f68e6c3507cf)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}


function $369f47a093b8c0cf$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    var parsedOptions = (0, $4730acf0753ac89a$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $02303e84e5b435f8$export$fff0865807e996c5)(parsedOptions, (0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c));
}



var $acw62 = parcelRequire("acw62");






var $3fe6fab6545cf77d$export$15352e437905ad4c = /*#__PURE__*/ function(_Subscribable) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(QueriesObserver, _Subscribable);
    function QueriesObserver(client, queries) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.queries = [];
        _this.result = [];
        _this.observers = [];
        _this.observersMap = {};
        if (queries) _this.setQueries(queries);
        return _this;
    }
    var _proto = QueriesObserver.prototype;
    _proto.onSubscribe = function onSubscribe() {
        var _this2 = this;
        if (this.listeners.length === 1) this.observers.forEach(function(observer) {
            observer.subscribe(function(result) {
                _this2.onUpdate(observer, result);
            });
        });
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.observers.forEach(function(observer) {
            observer.destroy();
        });
    };
    _proto.setQueries = function setQueries(queries, notifyOptions) {
        this.queries = queries;
        this.updateObservers(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.result;
    };
    _proto.getOptimisticResult = function getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map(function(match) {
            return match.observer.getOptimisticResult(match.defaultedQueryOptions);
        });
    };
    _proto.findMatchingObservers = function findMatchingObservers(queries) {
        var _this3 = this;
        var prevObservers = this.observers;
        var defaultedQueryOptions = queries.map(function(options) {
            return _this3.client.defaultQueryObserverOptions(options);
        });
        var matchingObservers = defaultedQueryOptions.flatMap(function(defaultedOptions) {
            var match = prevObservers.find(function(observer) {
                return observer.options.queryHash === defaultedOptions.queryHash;
            });
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        var matchedQueryHashes = matchingObservers.map(function(match) {
            return match.defaultedQueryOptions.queryHash;
        });
        var unmatchedQueries = defaultedQueryOptions.filter(function(defaultedOptions) {
            return !matchedQueryHashes.includes(defaultedOptions.queryHash);
        });
        var unmatchedObservers = prevObservers.filter(function(prevObserver) {
            return !matchingObservers.some(function(match) {
                return match.observer === prevObserver;
            });
        });
        var newOrReusedObservers = unmatchedQueries.map(function(options, index) {
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                var previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: _this3.getObserver(options)
            };
        });
        var sortMatchesByOrderOfQueries = function sortMatchesByOrderOfQueries(a, b) {
            return defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        };
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    };
    _proto.getObserver = function getObserver(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var currentObserver = this.observersMap[defaultedOptions.queryHash];
        return currentObserver != null ? currentObserver : new (0, $461f073e5b72a6b1$export$a06cf8c0066f0d4c)(this.client, defaultedOptions);
    };
    _proto.updateObservers = function updateObservers(notifyOptions) {
        var _this4 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            var prevObservers = _this4.observers;
            var newObserverMatches = _this4.findMatchingObservers(_this4.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach(function(match) {
                return match.observer.setOptions(match.defaultedQueryOptions, notifyOptions);
            });
            var newObservers = newObserverMatches.map(function(match) {
                return match.observer;
            });
            var newObserversMap = Object.fromEntries(newObservers.map(function(observer) {
                return [
                    observer.options.queryHash,
                    observer
                ];
            }));
            var newResult = newObservers.map(function(observer) {
                return observer.getCurrentResult();
            });
            var hasIndexChange = newObservers.some(function(observer, index) {
                return observer !== prevObservers[index];
            });
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            _this4.observers = newObservers;
            _this4.observersMap = newObserversMap;
            _this4.result = newResult;
            if (!_this4.hasListeners()) return;
            (0, $4730acf0753ac89a$export$acaf96a27438246b)(prevObservers, newObservers).forEach(function(observer) {
                observer.destroy();
            });
            (0, $4730acf0753ac89a$export$acaf96a27438246b)(newObservers, prevObservers).forEach(function(observer) {
                observer.subscribe(function(result) {
                    _this4.onUpdate(observer, result);
                });
            });
            _this4.notify();
        });
    };
    _proto.onUpdate = function onUpdate(observer, result) {
        var index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, $4730acf0753ac89a$export$224e3b7078227b8a)(this.result, index, result);
            this.notify();
        }
    };
    _proto.notify = function notify() {
        var _this5 = this;
        (0, $a326eb7faf36b653$export$520687f44db6e1ab).batch(function() {
            _this5.listeners.forEach(function(listener) {
                listener(_this5.result);
            });
        });
    };
    return QueriesObserver;
}((0, $8806d6a418db4b9d$export$d26086b469ecdbcc));



function $990eb380e3560bcc$export$408667c6c87da1e5(queries) {
    var mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    var defaultedQueries = (0, $acw62.useMemo)(function() {
        return queries.map(function(options) {
            var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions.optimisticResults = true;
            return defaultedOptions;
        });
    }, [
        queries,
        queryClient
    ]);
    var _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(function() {
        return new (0, $3fe6fab6545cf77d$export$15352e437905ad4c)(queryClient, defaultedQueries);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedQueries);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = observer.subscribe((0, $a326eb7faf36b653$export$520687f44db6e1ab).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        observer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    return result;
}









/**
 * react-router v7.1.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // lib/router/history.ts

var $acw62 = parcelRequire("acw62");
var $413e902c144ded2c$exports = {};
"use strict";
Object.defineProperty($413e902c144ded2c$exports, "__esModule", {
    value: true
});
$413e902c144ded2c$exports.encode = $413e902c144ded2c$exports.decode = void 0;
var $ae2d30592eda6ba7$exports = {};
"use strict";
Object.defineProperty($ae2d30592eda6ba7$exports, "__esModule", {
    value: true
});
$ae2d30592eda6ba7$exports.flatten = void 0;
var $e81dbde66bf3e10c$exports = {};
"use strict";
Object.defineProperty($e81dbde66bf3e10c$exports, "__esModule", {
    value: true
});
$e81dbde66bf3e10c$exports.createLineSplittingTransform = $e81dbde66bf3e10c$exports.Deferred = $e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED = $e81dbde66bf3e10c$exports.TYPE_URL = $e81dbde66bf3e10c$exports.TYPE_SYMBOL = $e81dbde66bf3e10c$exports.TYPE_SET = $e81dbde66bf3e10c$exports.TYPE_REGEXP = $e81dbde66bf3e10c$exports.TYPE_PROMISE = $e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT = $e81dbde66bf3e10c$exports.TYPE_MAP = $e81dbde66bf3e10c$exports.TYPE_ERROR = $e81dbde66bf3e10c$exports.TYPE_DATE = $e81dbde66bf3e10c$exports.TYPE_BIGINT = $e81dbde66bf3e10c$exports.UNDEFINED = $e81dbde66bf3e10c$exports.POSITIVE_INFINITY = $e81dbde66bf3e10c$exports.NULL = $e81dbde66bf3e10c$exports.NEGATIVE_ZERO = $e81dbde66bf3e10c$exports.NEGATIVE_INFINITY = $e81dbde66bf3e10c$exports.NAN = $e81dbde66bf3e10c$exports.HOLE = void 0;
$e81dbde66bf3e10c$exports.HOLE = -1;
$e81dbde66bf3e10c$exports.NAN = -2;
$e81dbde66bf3e10c$exports.NEGATIVE_INFINITY = -3;
$e81dbde66bf3e10c$exports.NEGATIVE_ZERO = -4;
$e81dbde66bf3e10c$exports.NULL = -5;
$e81dbde66bf3e10c$exports.POSITIVE_INFINITY = -6;
$e81dbde66bf3e10c$exports.UNDEFINED = -7;
$e81dbde66bf3e10c$exports.TYPE_BIGINT = "B";
$e81dbde66bf3e10c$exports.TYPE_DATE = "D";
$e81dbde66bf3e10c$exports.TYPE_ERROR = "E";
$e81dbde66bf3e10c$exports.TYPE_MAP = "M";
$e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT = "N";
$e81dbde66bf3e10c$exports.TYPE_PROMISE = "P";
$e81dbde66bf3e10c$exports.TYPE_REGEXP = "R";
$e81dbde66bf3e10c$exports.TYPE_SET = "S";
$e81dbde66bf3e10c$exports.TYPE_SYMBOL = "Y";
$e81dbde66bf3e10c$exports.TYPE_URL = "U";
$e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED = "Z";
class $e81dbde66bf3e10c$var$Deferred {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
$e81dbde66bf3e10c$exports.Deferred = $e81dbde66bf3e10c$var$Deferred;
function $e81dbde66bf3e10c$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            // The last part might be a partial line, so keep it for the next chunk.
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            // If there's any leftover data, enqueue it before closing.
            if (leftover) controller.enqueue(leftover);
        }
    });
}
$e81dbde66bf3e10c$exports.createLineSplittingTransform = $e81dbde66bf3e10c$var$createLineSplittingTransform;


function $ae2d30592eda6ba7$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === undefined) return $e81dbde66bf3e10c$exports.UNDEFINED;
    if (input === null) return $e81dbde66bf3e10c$exports.NULL;
    if (Number.isNaN(input)) return $e81dbde66bf3e10c$exports.NAN;
    if (input === Number.POSITIVE_INFINITY) return $e81dbde66bf3e10c$exports.POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $e81dbde66bf3e10c$exports.NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $e81dbde66bf3e10c$exports.NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $ae2d30592eda6ba7$var$stringify.call(this, input, index);
    return index;
}
$ae2d30592eda6ba7$exports.flatten = $ae2d30592eda6ba7$var$flatten;
function $ae2d30592eda6ba7$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$ae2d30592eda6ba7$var$flatten.call(this, k)}":${$ae2d30592eda6ba7$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$e81dbde66bf3e10c$exports.NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$ae2d30592eda6ba7$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? $ae2d30592eda6ba7$var$flatten.call(this, input[i]) : $e81dbde66bf3e10c$exports.HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_DATE}",${input.getTime()}]`;
                        else if (input instanceof URL) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_SET}",${[
                                ...input
                            ].map((val)=>$ae2d30592eda6ba7$var$flatten.call(this, val)).join(",")}]`;
                            else str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    $ae2d30592eda6ba7$var$flatten.call(this, k),
                                    $ae2d30592eda6ba7$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($ae2d30592eda6ba7$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>$ae2d30592eda6ba7$var$flatten.call(this, v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>$ae2d30592eda6ba7$var$flatten.call(this, v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $ae2d30592eda6ba7$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $ae2d30592eda6ba7$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $ae2d30592eda6ba7$var$objectProtoNames;
}


var $a0100cdae301b2b2$exports = {};
"use strict";
Object.defineProperty($a0100cdae301b2b2$exports, "__esModule", {
    value: true
});
$a0100cdae301b2b2$exports.unflatten = void 0;

const $a0100cdae301b2b2$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : undefined;
function $a0100cdae301b2b2$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $a0100cdae301b2b2$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $a0100cdae301b2b2$var$hydrate.call(this, startIndex);
}
$a0100cdae301b2b2$exports.unflatten = $a0100cdae301b2b2$var$unflatten;
function $a0100cdae301b2b2$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case $e81dbde66bf3e10c$exports.UNDEFINED:
                set(undefined);
                continue;
            case $e81dbde66bf3e10c$exports.NULL:
                set(null);
                continue;
            case $e81dbde66bf3e10c$exports.NAN:
                set(NaN);
                continue;
            case $e81dbde66bf3e10c$exports.POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $e81dbde66bf3e10c$exports.NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $e81dbde66bf3e10c$exports.NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $e81dbde66bf3e10c$exports.TYPE_DATE:
                        set(hydrated[index] = new Date(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_URL:
                        set(hydrated[index] = new URL(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_BIGINT:
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_REGEXP:
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_SYMBOL:
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_SET:
                        const newSet = new Set();
                        hydrated[index] = newSet;
                        for(let i = 1; i < value.length; i++)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_MAP:
                        const map = new Map();
                        hydrated[index] = map;
                        for(let i = 1; i < value.length; i += 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_NULL_OBJECT:
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new $e81dbde66bf3e10c$exports.Deferred();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $a0100cdae301b2b2$var$globalObj && $a0100cdae301b2b2$var$globalObj[errorType] ? new $a0100cdae301b2b2$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case $e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        // Run plugins at the end so we have a chance to resolve primitives
                        // without running into a loop
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $e81dbde66bf3e10c$exports.HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}



async function $413e902c144ded2c$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $e81dbde66bf3e10c$exports.Deferred();
    const reader = readable.pipeThrough((0, $e81dbde66bf3e10c$exports.createLineSplittingTransform)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $413e902c144ded2c$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $413e902c144ded2c$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
$413e902c144ded2c$exports.decode = $413e902c144ded2c$var$decode;
async function $413e902c144ded2c$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $a0100cdae301b2b2$exports.unflatten.call(this, line)
    };
}
async function $413e902c144ded2c$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $e81dbde66bf3e10c$exports.TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $a0100cdae301b2b2$exports.unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $e81dbde66bf3e10c$exports.TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $a0100cdae301b2b2$exports.unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $413e902c144ded2c$var$encode(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $ae2d30592eda6ba7$exports.flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = new WeakSet();
            while(Object.keys(encoder.deferred).length > 0){
                for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                    if (seenPromises.has(deferred)) continue;
                    seenPromises.add(encoder.deferred[Number(deferredId)] = $413e902c144ded2c$var$raceSignal(deferred, encoder.signal).then((resolved)=>{
                        const id = $ae2d30592eda6ba7$exports.flatten.call(encoder, resolved);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_PROMISE}${deferredId}:[["${$e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_PROMISE}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_PROMISE}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }, (reason)=>{
                        if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                        const id = $ae2d30592eda6ba7$exports.flatten.call(encoder, reason);
                        if (Array.isArray(id)) {
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_ERROR}${deferredId}:[["${$e81dbde66bf3e10c$exports.TYPE_PREVIOUS_RESOLVED}",${id[0]}]]\n`));
                            encoder.index++;
                            lastSentIndex++;
                        } else if (id < 0) controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_ERROR}${deferredId}:${id}\n`));
                        else {
                            const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                            controller.enqueue(textEncoder.encode(`${$e81dbde66bf3e10c$exports.TYPE_ERROR}${deferredId}:[${values}]\n`));
                            lastSentIndex = encoder.stringified.length - 1;
                        }
                    }).finally(()=>{
                        delete encoder.deferred[Number(deferredId)];
                    }));
                }
                await Promise.race(Object.values(encoder.deferred));
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
$413e902c144ded2c$exports.encode = $413e902c144ded2c$var$encode;
function $413e902c144ded2c$var$raceSignal(promise, signal) {
    if (!signal) return promise;
    if (signal.aborted) return Promise.reject(signal.reason || new Error("Signal was aborted."));
    const abort = new Promise((resolve, reject)=>{
        signal.addEventListener("abort", (event)=>{
            reject(signal.reason || new Error("Signal was aborted."));
        });
        promise.then(resolve).catch(reject);
    });
    abort.catch(()=>{});
    return Promise.race([
        abort,
        promise
    ]);
}


var $9fd38747d73cb940$exports = {};
"use strict";
Object.defineProperty($9fd38747d73cb940$exports, "__esModule", {
    value: true
});
$9fd38747d73cb940$exports.parse = $9fd38747d73cb940$var$parse;
$9fd38747d73cb940$exports.serialize = $9fd38747d73cb940$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $9fd38747d73cb940$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $9fd38747d73cb940$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $9fd38747d73cb940$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $9fd38747d73cb940$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $9fd38747d73cb940$var$__toString = Object.prototype.toString;
const $9fd38747d73cb940$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $9fd38747d73cb940$var$parse(str, options) {
    const obj = new $9fd38747d73cb940$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $9fd38747d73cb940$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $9fd38747d73cb940$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $9fd38747d73cb940$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $9fd38747d73cb940$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $9fd38747d73cb940$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $9fd38747d73cb940$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $9fd38747d73cb940$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $9fd38747d73cb940$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$9fd38747d73cb940$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$9fd38747d73cb940$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$9fd38747d73cb940$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$9fd38747d73cb940$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$9fd38747d73cb940$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $9fd38747d73cb940$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $9fd38747d73cb940$var$isDate(val) {
    return $9fd38747d73cb940$var$__toString.call(val) === "[object Date]";
}


var $e4a96bcce5e8f1ac$exports = {};
"use strict";
var $e4a96bcce5e8f1ac$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $e4a96bcce5e8f1ac$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $e4a96bcce5e8f1ac$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($e4a96bcce5e8f1ac$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser encountered an error while decoding a cookie with value '" + value + "'. Set options.decodeValues to false to disable this feature.", e);
    }
    var cookie = {
        name: name,
        value: value
    };
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") cookie.maxAge = parseInt(value, 10);
        else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else cookie[key] = value;
    });
    return cookie;
}
function $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $e4a96bcce5e8f1ac$var$parse(input, options) {
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return {};
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).map(function(str) {
        return $e4a96bcce5e8f1ac$var$parseString(str, options);
    });
    else {
        var cookies = {};
        return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $e4a96bcce5e8f1ac$var$parseString(str, options);
            cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $e4a96bcce5e8f1ac$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$e4a96bcce5e8f1ac$exports = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parse = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parseString = $e4a96bcce5e8f1ac$var$parseString;
$e4a96bcce5e8f1ac$exports.splitCookiesString = $e4a96bcce5e8f1ac$var$splitCookiesString;


var $32578012b727878c$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-SYFQ2XB5.mjs"
});
var $32578012b727878c$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($32578012b727878c$export$e19cd5f9376f8cee || {});
var $32578012b727878c$var$PopStateEventType = "popstate";
function $32578012b727878c$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $32578012b727878c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $32578012b727878c$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $32578012b727878c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $32578012b727878c$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $32578012b727878c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $32578012b727878c$export$fe53371bee54353d(to);
    }
    return $32578012b727878c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $32578012b727878c$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $32578012b727878c$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $32578012b727878c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $32578012b727878c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $32578012b727878c$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $32578012b727878c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $32578012b727878c$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $32578012b727878c$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $32578012b727878c$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $32578012b727878c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $32578012b727878c$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $32578012b727878c$var$createKey()
    };
    return location;
}
function $32578012b727878c$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $32578012b727878c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $32578012b727878c$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $32578012b727878c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $32578012b727878c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $32578012b727878c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $32578012b727878c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        let base = window2.location.origin !== "null" ? window2.location.origin : window2.location.href;
        let href = typeof to === "string" ? to : $32578012b727878c$export$fe53371bee54353d(to);
        href = href.replace(/ $/, "%20");
        $32578012b727878c$export$f5708dca728d7177(base, `No window.location.(origin|href) available to create URL for href: ${href}`);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($32578012b727878c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($32578012b727878c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
// lib/router/utils.ts
var $32578012b727878c$var$immutableRouteKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $32578012b727878c$var$isIndexRoute(route) {
    return route.index === true;
}
function $32578012b727878c$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, parentPath = [], manifest = {}) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $32578012b727878c$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $32578012b727878c$export$f5708dca728d7177(!manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($32578012b727878c$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $32578012b727878c$var$convertRoutesToDataRoutes(route.children, mapRouteProperties2, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
function $32578012b727878c$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $32578012b727878c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $32578012b727878c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $32578012b727878c$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $32578012b727878c$var$flattenRoutes(routes);
    $32578012b727878c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $32578012b727878c$var$decodePath(pathname);
        matches = $32578012b727878c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $32578012b727878c$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $32578012b727878c$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $32578012b727878c$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $32578012b727878c$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $32578012b727878c$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $32578012b727878c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $32578012b727878c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $32578012b727878c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
function $32578012b727878c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $32578012b727878c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $32578012b727878c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $32578012b727878c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $32578012b727878c$var$paramRe = /^:[\w-]+$/;
var $32578012b727878c$var$dynamicSegmentValue = 3;
var $32578012b727878c$var$indexRouteValue = 2;
var $32578012b727878c$var$emptySegmentValue = 1;
var $32578012b727878c$var$staticSegmentValue = 10;
var $32578012b727878c$var$splatPenalty = -2;
var $32578012b727878c$var$isSplat = (s)=>s === "*";
function $32578012b727878c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($32578012b727878c$var$isSplat)) initialScore += $32578012b727878c$var$splatPenalty;
    if (index) initialScore += $32578012b727878c$var$indexRouteValue;
    return segments.filter((s)=>!$32578012b727878c$var$isSplat(s)).reduce((score, segment)=>score + ($32578012b727878c$var$paramRe.test(segment) ? $32578012b727878c$var$dynamicSegmentValue : segment === "" ? $32578012b727878c$var$emptySegmentValue : $32578012b727878c$var$staticSegmentValue), initialScore);
}
function $32578012b727878c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $32578012b727878c$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $32578012b727878c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $32578012b727878c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $32578012b727878c$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $32578012b727878c$var$normalizePathname($32578012b727878c$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $32578012b727878c$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $32578012b727878c$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $32578012b727878c$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $32578012b727878c$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return stringify(param);
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $32578012b727878c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $32578012b727878c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $32578012b727878c$var$compilePath(path, caseSensitive = false, end = true) {
    $32578012b727878c$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $32578012b727878c$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $32578012b727878c$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $32578012b727878c$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $32578012b727878c$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $32578012b727878c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $32578012b727878c$var$normalizeSearch(search),
        hash: $32578012b727878c$var$normalizeHash(hash)
    };
}
function $32578012b727878c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $32578012b727878c$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $32578012b727878c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $32578012b727878c$var$getResolveToMatches(matches) {
    let pathMatches = $32578012b727878c$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $32578012b727878c$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $32578012b727878c$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $32578012b727878c$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $32578012b727878c$var$getInvalidPathError("?", "pathname", "search", to));
        $32578012b727878c$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $32578012b727878c$var$getInvalidPathError("#", "pathname", "hash", to));
        $32578012b727878c$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $32578012b727878c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $32578012b727878c$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $32578012b727878c$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $32578012b727878c$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $32578012b727878c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $32578012b727878c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $32578012b727878c$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $32578012b727878c$export$4051a07651545597(data2, init) {
    return new $32578012b727878c$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $32578012b727878c$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $32578012b727878c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $32578012b727878c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $32578012b727878c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $32578012b727878c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $32578012b727878c$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $32578012b727878c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $32578012b727878c$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $32578012b727878c$var$validMutationMethods = new Set($32578012b727878c$var$validMutationMethodsArr);
var $32578012b727878c$var$validRequestMethodsArr = [
    "GET",
    ...$32578012b727878c$var$validMutationMethodsArr
];
var $32578012b727878c$var$validRequestMethods = new Set($32578012b727878c$var$validRequestMethodsArr);
var $32578012b727878c$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $32578012b727878c$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $32578012b727878c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $32578012b727878c$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $32578012b727878c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $32578012b727878c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $32578012b727878c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $32578012b727878c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $32578012b727878c$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $32578012b727878c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $32578012b727878c$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties2 = init.mapRouteProperties || $32578012b727878c$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $32578012b727878c$var$convertRoutesToDataRoutes(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $32578012b727878c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $32578012b727878c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        let error = $32578012b727878c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $32578012b727878c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
    } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
    else {
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$32578012b727878c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$32578012b727878c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $32578012b727878c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $32578012b727878c$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $32578012b727878c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $32578012b727878c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$32578012b727878c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $32578012b727878c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $32578012b727878c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $32578012b727878c$export$386d57f03f0b2883));
        }
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $32578012b727878c$var$isMutationMethod(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $32578012b727878c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $32578012b727878c$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $32578012b727878c$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $32578012b727878c$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $32578012b727878c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $32578012b727878c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $32578012b727878c$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $32578012b727878c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        if (state.initialized && !isRevalidationRequired && $32578012b727878c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $32578012b727878c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $32578012b727878c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $32578012b727878c$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $32578012b727878c$var$isMutationMethod(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($32578012b727878c$var$isErrorResult(result) && $32578012b727878c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $32578012b727878c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $32578012b727878c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$32578012b727878c$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, isFogOfWar, opts = {}) {
        interruptActiveLoads();
        let navigation = $32578012b727878c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $32578012b727878c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $32578012b727878c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $32578012b727878c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($32578012b727878c$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $32578012b727878c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($32578012b727878c$var$isErrorResult(result)) {
            let boundaryMatch = $32578012b727878c$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $32578012b727878c$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $32578012b727878c$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $32578012b727878c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $32578012b727878c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $32578012b727878c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$32578012b727878c$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $32578012b727878c$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $32578012b727878c$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $32578012b727878c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$32578012b727878c$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $32578012b727878c$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $32578012b727878c$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $32578012b727878c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $32578012b727878c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $32578012b727878c$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $32578012b727878c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $32578012b727878c$var$isMutationMethod(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $32578012b727878c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $32578012b727878c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $32578012b727878c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $32578012b727878c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $32578012b727878c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($32578012b727878c$var$isRedirectResult(actionResult) || $32578012b727878c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $32578012b727878c$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($32578012b727878c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $32578012b727878c$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $32578012b727878c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($32578012b727878c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $32578012b727878c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $32578012b727878c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $32578012b727878c$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $32578012b727878c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $32578012b727878c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $32578012b727878c$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect2 = $32578012b727878c$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $32578012b727878c$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $32578012b727878c$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        if (state.fetchers.has(key)) {
            let doneFetcher = $32578012b727878c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $32578012b727878c$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $32578012b727878c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $32578012b727878c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $32578012b727878c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $32578012b727878c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $32578012b727878c$var$getTargetMatch(matches, path);
            }
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $32578012b727878c$var$getDoneFetcher(void 0));
            return;
        }
        if ($32578012b727878c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $32578012b727878c$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($32578012b727878c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $32578012b727878c$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $32578012b727878c$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $32578012b727878c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $32578012b727878c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($32578012b727878c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $32578012b727878c$var$stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $32578012b727878c$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($32578012b727878c$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $32578012b727878c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $32578012b727878c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(type, state2, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $32578012b727878c$var$callDataStrategyImpl(dataStrategyImpl, type, state2, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2);
        } catch (e) {
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($32578012b727878c$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $32578012b727878c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $32578012b727878c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state2, matches, matchesToLoad, fetchersToLoad, request) {
        let loaderResultsPromise = callDataStrategy("loader", state2, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state2, $32578012b727878c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $32578012b727878c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $32578012b727878c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $32578012b727878c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $32578012b727878c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $32578012b727878c$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $32578012b727878c$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $32578012b727878c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $32578012b727878c$export$386d57f03f0b2883;
        $32578012b727878c$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $32578012b727878c$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $32578012b727878c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $32578012b727878c$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $32578012b727878c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$32578012b727878c$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $32578012b727878c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $32578012b727878c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $32578012b727878c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $32578012b727878c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $32578012b727878c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $32578012b727878c$var$convertRoutesToDataRoutes(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $32578012b727878c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
function $32578012b727878c$var$createStaticHandler(routes, opts) {
    $32578012b727878c$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $32578012b727878c$var$defaultMapRouteProperties;
    let dataRoutes = $32578012b727878c$var$convertRoutesToDataRoutes(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $32578012b727878c$var$createLocation("", $32578012b727878c$export$fe53371bee54353d(url), null, "default");
        let matches = $32578012b727878c$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$32578012b727878c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $32578012b727878c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $32578012b727878c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        } else if (!matches) {
            let error = $32578012b727878c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $32578012b727878c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($32578012b727878c$var$isResponse(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $32578012b727878c$var$createLocation("", $32578012b727878c$export$fe53371bee54353d(url), null, "default");
        let matches = $32578012b727878c$export$2708184779ceb39d(dataRoutes, location, basename);
        if (!$32578012b727878c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $32578012b727878c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $32578012b727878c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $32578012b727878c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $32578012b727878c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $32578012b727878c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($32578012b727878c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : void 0;
        if (error !== void 0) throw error;
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) return Object.values(result.loaderData)[0];
        return void 0;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $32578012b727878c$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($32578012b727878c$var$isMutationMethod(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $32578012b727878c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $32578012b727878c$var$isResponse(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($32578012b727878c$var$isDataStrategyResult(e) && $32578012b727878c$var$isResponse(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($32578012b727878c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $32578012b727878c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $32578012b727878c$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($32578012b727878c$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($32578012b727878c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($32578012b727878c$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $32578012b727878c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...context2,
                statusCode: $32578012b727878c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return {
            ...context,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $32578012b727878c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $32578012b727878c$var$isErrorResult(pendingActionResult[1]) ? $32578012b727878c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $32578012b727878c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $32578012b727878c$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let context = $32578012b727878c$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return {
            ...context,
            matches: matches
        };
    }
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $32578012b727878c$var$callDataStrategyImpl(dataStrategy || $32578012b727878c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties2, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($32578012b727878c$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $32578012b727878c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if ($32578012b727878c$var$isResponse(result.result) && isRouteRequest) throw result;
            dataResults[match.route.id] = await $32578012b727878c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $32578012b727878c$var$getStaticContextFromError(routes, context, error) {
    let newContext = {
        ...context,
        statusCode: $32578012b727878c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    };
    return newContext;
}
function $32578012b727878c$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $32578012b727878c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $32578012b727878c$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $32578012b727878c$var$resolveTo(to ? to : ".", $32578012b727878c$var$getResolveToMatches(contextualMatches), $32578012b727878c$var$stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $32578012b727878c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $32578012b727878c$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $32578012b727878c$export$fe53371bee54353d(path);
}
function $32578012b727878c$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$32578012b727878c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$32578012b727878c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $32578012b727878c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $32578012b727878c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $32578012b727878c$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$32578012b727878c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$32578012b727878c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $32578012b727878c$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $32578012b727878c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $32578012b727878c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $32578012b727878c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $32578012b727878c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($32578012b727878c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $32578012b727878c$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $32578012b727878c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $32578012b727878c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $32578012b727878c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary = false) {
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $32578012b727878c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $32578012b727878c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let boundaryMatches = matches;
    if (initialHydration && state.errors) boundaryMatches = $32578012b727878c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $32578012b727878c$var$isErrorResult(pendingActionResult[1])) boundaryMatches = $32578012b727878c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) return true;
        if (route.loader == null) return false;
        if (initialHydration) return $32578012b727878c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        if ($32578012b727878c$var$isNewLoader(state.loaderData, state.matches[index], match)) return true;
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $32578012b727878c$var$shouldRevalidateLoader(match, {
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $32578012b727878c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        });
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcherMatches = $32578012b727878c$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $32578012b727878c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === void 0) shouldRevalidate = isRevalidationRequired;
        else shouldRevalidate = $32578012b727878c$var$shouldRevalidateLoader(fetcherMatch, {
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params,
            ...submission,
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        });
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $32578012b727878c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== void 0;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $32578012b727878c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $32578012b727878c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $32578012b727878c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $32578012b727878c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $32578012b727878c$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$32578012b727878c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $32578012b727878c$var$convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties2, [
        routeId || "_",
        "patch",
        String(childrenToPatch?.length || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $32578012b727878c$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$32578012b727878c$var$isSameRoute(aChild, bChild)));
}
async function $32578012b727878c$var$loadLazyRouteModule(route, mapRouteProperties2, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $32578012b727878c$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $32578012b727878c$var$warning(!isPropertyStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
        if (!isPropertyStaticallyDefined && !$32578012b727878c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    Object.assign(routeToUpdate, routeUpdates);
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided `mapRouteProperties`
        // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
        // since the logic will differ between frameworks.
        ...mapRouteProperties2(routeToUpdate),
        lazy: void 0
    });
}
async function $32578012b727878c$var$defaultDataStrategy({ matches: matches }) {
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $32578012b727878c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties2, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $32578012b727878c$var$loadLazyRouteModule(m.route, mapRouteProperties2, manifest) : void 0);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $32578012b727878c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        };
        return {
            ...match,
            shouldLoad: shouldLoad,
            resolve: resolve
        };
    });
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {}
    return results;
}
async function $32578012b727878c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (loadRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $32578012b727878c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $32578012b727878c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $32578012b727878c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($32578012b727878c$var$isResponse(result)) {
        let data2;
        try {
            let contentType = result.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data2 = null;
                else data2 = await result.json();
            } else data2 = await result.text();
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $32578012b727878c$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($32578012b727878c$var$isDataWithResponseInit(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status
            };
            result = new $32578012b727878c$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data);
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $32578012b727878c$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($32578012b727878c$var$isDataWithResponseInit(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $32578012b727878c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $32578012b727878c$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$32578012b727878c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $32578012b727878c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $32578012b727878c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($32578012b727878c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $32578012b727878c$var$stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $32578012b727878c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($32578012b727878c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $32578012b727878c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $32578012b727878c$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $32578012b727878c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $32578012b727878c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $32578012b727878c$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $32578012b727878c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $32578012b727878c$export$f5708dca728d7177(!$32578012b727878c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($32578012b727878c$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $32578012b727878c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $32578012b727878c$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $32578012b727878c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $32578012b727878c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $32578012b727878c$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $32578012b727878c$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if (controller && controller.signal.aborted) return;
        else if ($32578012b727878c$var$isErrorResult(result)) {
            let boundaryMatch = $32578012b727878c$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($32578012b727878c$var$isRedirectResult(result)) $32578012b727878c$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $32578012b727878c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $32578012b727878c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $32578012b727878c$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $32578012b727878c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $32578012b727878c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $32578012b727878c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $32578012b727878c$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $32578012b727878c$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $32578012b727878c$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $32578012b727878c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($32578012b727878c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $32578012b727878c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(path) : path;
    return $32578012b727878c$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $32578012b727878c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $32578012b727878c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $32578012b727878c$var$isRedirectDataStrategyResult(result) {
    return $32578012b727878c$var$isResponse(result.result) && $32578012b727878c$var$redirectStatusCodes.has(result.result.status);
}
function $32578012b727878c$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $32578012b727878c$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $32578012b727878c$var$isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $32578012b727878c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $32578012b727878c$var$isRedirectStatusCode(statusCode) {
    return $32578012b727878c$var$redirectStatusCodes.has(statusCode);
}
function $32578012b727878c$var$isRedirectResponse(result) {
    return $32578012b727878c$var$isResponse(result) && $32578012b727878c$var$isRedirectStatusCode(result.status) && result.headers.has("Location");
}
function $32578012b727878c$var$isValidMethod(method) {
    return $32578012b727878c$var$validRequestMethods.has(method.toUpperCase());
}
function $32578012b727878c$var$isMutationMethod(method) {
    return $32578012b727878c$var$validMutationMethods.has(method.toUpperCase());
}
function $32578012b727878c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $32578012b727878c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $32578012b727878c$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $32578012b727878c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $32578012b727878c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $32578012b727878c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $32578012b727878c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $32578012b727878c$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $32578012b727878c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $32578012b727878c$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $32578012b727878c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($32578012b727878c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $32578012b727878c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($32578012b727878c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $32578012b727878c$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $32578012b727878c$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $32578012b727878c$export$2eeee58951ff3c1c = $acw62.createContext(null);
$32578012b727878c$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $32578012b727878c$export$315e3ffb01f217 = $acw62.createContext(null);
$32578012b727878c$export$315e3ffb01f217.displayName = "DataRouterState";
var $32578012b727878c$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$32578012b727878c$export$3681f408decb40d1.displayName = "ViewTransition";
var $32578012b727878c$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$32578012b727878c$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $32578012b727878c$var$AwaitContext = $acw62.createContext(null);
$32578012b727878c$var$AwaitContext.displayName = "Await";
var $32578012b727878c$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$32578012b727878c$export$3044ab7fdabeaee6.displayName = "Navigation";
var $32578012b727878c$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$32578012b727878c$export$e6a44b110a0c44d3.displayName = "Location";
var $32578012b727878c$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$32578012b727878c$export$aac280ed165a4397.displayName = "Route";
var $32578012b727878c$var$RouteErrorContext = $acw62.createContext(null);
$32578012b727878c$var$RouteErrorContext.displayName = "RouteError";
var $32578012b727878c$var$ENABLE_DEV_WARNINGS = true;
function $32578012b727878c$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $32578012b727878c$export$f5708dca728d7177($32578012b727878c$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator2 } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $32578012b727878c$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $32578012b727878c$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator2.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $32578012b727878c$export$9c954a9d03d32f4a() {
    return $acw62.useContext($32578012b727878c$export$e6a44b110a0c44d3) != null;
}
function $32578012b727878c$export$45d76561a5302f2b() {
    $32578012b727878c$export$f5708dca728d7177($32578012b727878c$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($32578012b727878c$export$e6a44b110a0c44d3).location;
}
function $32578012b727878c$export$1b3f31771c5d07c() {
    return $acw62.useContext($32578012b727878c$export$e6a44b110a0c44d3).navigationType;
}
function $32578012b727878c$export$6c330e8992e8a295(pattern) {
    $32578012b727878c$export$f5708dca728d7177($32578012b727878c$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $32578012b727878c$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$32578012b727878c$export$81336c211d5ff295(pattern, $32578012b727878c$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $32578012b727878c$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $32578012b727878c$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $32578012b727878c$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    return isDataRoute ? $32578012b727878c$var$useNavigateStable() : $32578012b727878c$var$useNavigateUnstable();
}
function $32578012b727878c$var$useNavigateUnstable() {
    $32578012b727878c$export$f5708dca728d7177($32578012b727878c$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($32578012b727878c$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator2 } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    let { pathname: locationPathname } = $32578012b727878c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($32578012b727878c$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $32578012b727878c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $32578012b727878c$var$warning(activeRef.current, $32578012b727878c$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator2.go(to);
            return;
        }
        let path = $32578012b727878c$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $32578012b727878c$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator2.replace : navigator2.push)(path, options.state, options);
    }, [
        basename,
        navigator2,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $32578012b727878c$var$OutletContext = $acw62.createContext(null);
function $32578012b727878c$export$4138103a3ae699cc() {
    return $acw62.useContext($32578012b727878c$var$OutletContext);
}
function $32578012b727878c$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($32578012b727878c$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $32578012b727878c$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $32578012b727878c$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    let { pathname: locationPathname } = $32578012b727878c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($32578012b727878c$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$32578012b727878c$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $32578012b727878c$export$5d3fca4a98652595(routes, locationArg) {
    return $32578012b727878c$var$useRoutesImpl(routes, locationArg);
}
function $32578012b727878c$var$useRoutesImpl(routes, locationArg, dataRouterState, future) {
    $32578012b727878c$export$f5708dca728d7177($32578012b727878c$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator2 } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($32578012b727878c$var$ENABLE_DEV_WARNINGS) {
        let parentPath = parentRoute && parentRoute.path || "";
        $32578012b727878c$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $32578012b727878c$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $32578012b727878c$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $32578012b727878c$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $32578012b727878c$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($32578012b727878c$var$ENABLE_DEV_WARNINGS) {
        $32578012b727878c$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $32578012b727878c$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $32578012b727878c$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $32578012b727878c$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $32578012b727878c$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator2.encodeLocation ? navigator2.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $32578012b727878c$var$DefaultErrorComponent() {
    let error = $32578012b727878c$export$ed527bf60f6e05f2();
    let message = $32578012b727878c$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($32578012b727878c$var$ENABLE_DEV_WARNINGS) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\u{1F4BF} Hey developer \u{1F44B}"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $32578012b727878c$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$DefaultErrorComponent, null);
var $32578012b727878c$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $32578012b727878c$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($32578012b727878c$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $32578012b727878c$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $32578012b727878c$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $32578012b727878c$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $32578012b727878c$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
function $32578012b727878c$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $32578012b727878c$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($32578012b727878c$export$2eeee58951ff3c1c);
    $32578012b727878c$export$f5708dca728d7177(ctx, $32578012b727878c$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $32578012b727878c$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($32578012b727878c$export$315e3ffb01f217);
    $32578012b727878c$export$f5708dca728d7177(state, $32578012b727878c$var$getDataRouterConsoleError(hookName));
    return state;
}
function $32578012b727878c$var$useRouteContext(hookName) {
    let route = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    $32578012b727878c$export$f5708dca728d7177(route, $32578012b727878c$var$getDataRouterConsoleError(hookName));
    return route;
}
function $32578012b727878c$var$useCurrentRouteId(hookName) {
    let route = $32578012b727878c$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $32578012b727878c$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $32578012b727878c$var$useRouteId() {
    return $32578012b727878c$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $32578012b727878c$export$d0fd4b7106de2769() {
    let state = $32578012b727878c$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $32578012b727878c$export$600dc272ed516c15() {
    let dataRouterContext = $32578012b727878c$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $32578012b727878c$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    return $acw62.useMemo(()=>({
            async revalidate () {
                await dataRouterContext.router.revalidate();
            },
            state: state.revalidation
        }), [
        dataRouterContext.router,
        state.revalidation
    ]);
}
function $32578012b727878c$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $32578012b727878c$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$32578012b727878c$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $32578012b727878c$export$1448a5050d252c4d() {
    let state = $32578012b727878c$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $32578012b727878c$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $32578012b727878c$export$fd5d37484eab868d(routeId) {
    let state = $32578012b727878c$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $32578012b727878c$export$fdc00f3f26066d5e() {
    let state = $32578012b727878c$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $32578012b727878c$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $32578012b727878c$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($32578012b727878c$var$RouteErrorContext);
    let state = $32578012b727878c$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $32578012b727878c$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $32578012b727878c$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($32578012b727878c$var$AwaitContext);
    return value?._data;
}
function $32578012b727878c$export$17f53340677d5831() {
    let value = $acw62.useContext($32578012b727878c$var$AwaitContext);
    return value?._error;
}
var $32578012b727878c$var$blockerId = 0;
function $32578012b727878c$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $32578012b727878c$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $32578012b727878c$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $32578012b727878c$var$stripBasename(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $32578012b727878c$var$stripBasename(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$32578012b727878c$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $32578012b727878c$export$386d57f03f0b2883;
}
function $32578012b727878c$var$useNavigateStable() {
    let { router: router } = $32578012b727878c$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $32578012b727878c$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $32578012b727878c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $32578012b727878c$var$warning(activeRef.current, $32578012b727878c$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $32578012b727878c$var$alreadyWarned = {};
function $32578012b727878c$var$warningOnce(key, cond, message) {
    if (!cond && !$32578012b727878c$var$alreadyWarned[key]) {
        $32578012b727878c$var$alreadyWarned[key] = true;
        $32578012b727878c$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $32578012b727878c$var$alreadyWarned2 = {};
function $32578012b727878c$var$warnOnce(condition, message) {
    if (!condition && !$32578012b727878c$var$alreadyWarned2[message]) {
        $32578012b727878c$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $32578012b727878c$var$ENABLE_DEV_WARNINGS2 = true;
function $32578012b727878c$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($32578012b727878c$var$ENABLE_DEV_WARNINGS2) {
            if (route.element) $32578012b727878c$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($32578012b727878c$var$ENABLE_DEV_WARNINGS2) {
            if (route.hydrateFallbackElement) $32578012b727878c$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($32578012b727878c$var$ENABLE_DEV_WARNINGS2) {
            if (route.errorElement) $32578012b727878c$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
function $32578012b727878c$export$f30f7e456d254e83(routes, opts) {
    return $32578012b727878c$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $32578012b727878c$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: $32578012b727878c$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $32578012b727878c$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $32578012b727878c$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl }) {
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $32578012b727878c$var$warnOnce(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $32578012b727878c$var$warnOnce(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else $acw62.startTransition(()=>setStateImpl(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $32578012b727878c$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $acw62.startTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator2 = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator2,
            static: false,
            basename: basename
        }), [
        router,
        navigator2,
        basename
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator2
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), null);
}
var $32578012b727878c$var$MemoizedDataRoutes = $acw62.memo($32578012b727878c$var$DataRoutes);
function $32578012b727878c$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return $32578012b727878c$var$useRoutesImpl(routes, void 0, state, future);
}
function $32578012b727878c$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $32578012b727878c$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $32578012b727878c$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $32578012b727878c$export$f5708dca728d7177($32578012b727878c$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    $32578012b727878c$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    let { pathname: locationPathname } = $32578012b727878c$export$45d76561a5302f2b();
    let navigate = $32578012b727878c$export$9770f232ac06a008();
    let path = $32578012b727878c$var$resolveTo(to, $32578012b727878c$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $32578012b727878c$export$910ae8079b2c2852(props) {
    return $32578012b727878c$export$a3be3530d8e40d0b(props.context);
}
function $32578012b727878c$export$e7b0ac011bb776c6(_props) {
    $32578012b727878c$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $32578012b727878c$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator2, static: staticProp = false }) {
    $32578012b727878c$export$f5708dca728d7177(!$32578012b727878c$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator2,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator2,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $32578012b727878c$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $32578012b727878c$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $32578012b727878c$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $32578012b727878c$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $32578012b727878c$export$5d3fca4a98652595($32578012b727878c$export$16da398f5434bdec(children), location);
}
function $32578012b727878c$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$ResolveAwait, null, children));
}
var $32578012b727878c$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $32578012b727878c$var$ResolveAwait({ children: children }) {
    let data2 = $32578012b727878c$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $32578012b727878c$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $32578012b727878c$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $32578012b727878c$export$f5708dca728d7177(element.type === $32578012b727878c$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $32578012b727878c$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $32578012b727878c$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $32578012b727878c$export$9b5b6d122dea0c88 = $32578012b727878c$export$16da398f5434bdec;
function $32578012b727878c$export$daf73786167a7f72(matches) {
    return $32578012b727878c$var$_renderMatches(matches);
}
// lib/dom/dom.ts
var $32578012b727878c$var$defaultMethod = "get";
var $32578012b727878c$var$defaultEncType = "application/x-www-form-urlencoded";
function $32578012b727878c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $32578012b727878c$var$isButtonElement(object) {
    return $32578012b727878c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $32578012b727878c$var$isFormElement(object) {
    return $32578012b727878c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $32578012b727878c$var$isInputElement(object) {
    return $32578012b727878c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $32578012b727878c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $32578012b727878c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$32578012b727878c$var$isModifiedEvent(event);
}
function $32578012b727878c$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $32578012b727878c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $32578012b727878c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $32578012b727878c$var$_formDataSupportsSubmitter = null;
function $32578012b727878c$var$isFormDataSubmitterSupported() {
    if ($32578012b727878c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $32578012b727878c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $32578012b727878c$var$_formDataSupportsSubmitter = true;
    }
    return $32578012b727878c$var$_formDataSupportsSubmitter;
}
var $32578012b727878c$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $32578012b727878c$var$getFormEncType(encType) {
    if (encType != null && !$32578012b727878c$var$supportedFormEncTypes.has(encType)) {
        $32578012b727878c$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$32578012b727878c$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $32578012b727878c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($32578012b727878c$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $32578012b727878c$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("method") || $32578012b727878c$var$defaultMethod;
        encType = $32578012b727878c$var$getFormEncType(target.getAttribute("enctype")) || $32578012b727878c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($32578012b727878c$var$isButtonElement(target) || $32578012b727878c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $32578012b727878c$var$stripBasename(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $32578012b727878c$var$defaultMethod;
        encType = $32578012b727878c$var$getFormEncType(target.getAttribute("formenctype")) || $32578012b727878c$var$getFormEncType(form.getAttribute("enctype")) || $32578012b727878c$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$32578012b727878c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($32578012b727878c$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $32578012b727878c$var$defaultMethod;
        action = null;
        encType = $32578012b727878c$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// lib/dom/ssr/invariant.ts
function $32578012b727878c$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/routeModules.ts
async function $32578012b727878c$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $32578012b727878c$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $32578012b727878c$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $32578012b727878c$var$getCurrentPageModulePreloadHrefs(matches, manifest);
    return $32578012b727878c$var$dedupeLinkDescriptors(descriptors, preloads);
}
async function $32578012b727878c$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$32578012b727878c$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        })));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$32578012b727878c$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    let matchingLinks = styleLinks.filter((link)=>(!link.media || window.matchMedia(link.media).matches) && !document.querySelector(`link[rel="stylesheet"][href="${link.href}"]`));
    await Promise.all(matchingLinks.map($32578012b727878c$var$prefetchStyleLink));
}
async function $32578012b727878c$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $32578012b727878c$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $32578012b727878c$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $32578012b727878c$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $32578012b727878c$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $32578012b727878c$var$dedupeLinkDescriptors(links.flat(1).filter($32578012b727878c$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $32578012b727878c$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $32578012b727878c$var$getModuleLinkHrefs(matches, manifestPatch) {
    return $32578012b727878c$var$dedupeHrefs(matches.map((match)=>{
        let route = manifestPatch.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $32578012b727878c$var$getCurrentPageModulePreloadHrefs(matches, manifest) {
    return $32578012b727878c$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $32578012b727878c$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $32578012b727878c$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $32578012b727878c$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$32578012b727878c$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($32578012b727878c$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $32578012b727878c$var$_isPreloadSupported;
function $32578012b727878c$var$isPreloadSupported() {
    if ($32578012b727878c$var$_isPreloadSupported !== void 0) return $32578012b727878c$var$_isPreloadSupported;
    let el = document.createElement("link");
    $32578012b727878c$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $32578012b727878c$var$_isPreloadSupported;
}
// lib/dom/ssr/markup.ts
var $32578012b727878c$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $32578012b727878c$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $32578012b727878c$var$escapeHtml(html) {
    return html.replace($32578012b727878c$var$ESCAPE_REGEX, (match)=>$32578012b727878c$var$ESCAPE_LOOKUP[match]);
}
function $32578012b727878c$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/data.ts
async function $32578012b727878c$var$createRequestInit(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/single-fetch.tsx
var $32578012b727878c$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
function $32578012b727878c$var$StreamTransfer({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$32578012b727878c$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$StreamTransfer, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $32578012b727878c$export$c7c51be9b423c4d6(manifest, routeModules, getRouter) {
    return async ({ request: request, matches: matches, fetcherKey: fetcherKey })=>{
        if (request.method !== "GET") return $32578012b727878c$var$singleFetchActionStrategy(request, matches);
        if (fetcherKey) return $32578012b727878c$var$singleFetchLoaderFetcherStrategy(request, matches);
        return $32578012b727878c$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, getRouter(), request, matches);
    };
}
async function $32578012b727878c$var$singleFetchActionStrategy(request, matches) {
    let actionMatch = matches.find((m)=>m.shouldLoad);
    $32578012b727878c$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let url = $32578012b727878c$var$singleFetchUrl(request.url);
            let init = await $32578012b727878c$var$createRequestInit(request);
            let { data: data2, status: status } = await $32578012b727878c$var$fetchAndDecode(url, init);
            actionStatus = status;
            return $32578012b727878c$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($32578012b727878c$var$isResponse(result.result) || $32578012b727878c$export$972111febbeef05b(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $32578012b727878c$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $32578012b727878c$var$singleFetchLoaderNavigationStrategy(manifest, routeModules, router, request, matches) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = matches.map(()=>$32578012b727878c$var$createDeferred2());
    let routesLoadedPromise = Promise.all(routeDfds.map((d)=>d.promise));
    let singleFetchDfd = $32578012b727878c$var$createDeferred2();
    let url = $32578012b727878c$var$stripIndexParam($32578012b727878c$var$singleFetchUrl(request.url));
    let init = await $32578012b727878c$var$createRequestInit(request);
    let results = {};
    let resolvePromise = Promise.all(matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let manifestRoute = manifest.routes[m.route.id];
            if (!m.shouldLoad) {
                if (!router.state.initialized) return;
                if (m.route.id in router.state.loaderData && manifestRoute && manifestRoute.hasLoader && routeModules[m.route.id]?.shouldRevalidate) {
                    foundOptOutRoute = true;
                    return;
                }
            }
            if (manifestRoute && manifestRoute.hasClientLoader) {
                if (manifestRoute.hasLoader) foundOptOutRoute = true;
                try {
                    let result = await $32578012b727878c$var$fetchSingleLoader(handler, url, init, m.route.id);
                    results[m.route.id] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[m.route.id] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (manifestRoute && manifestRoute.hasLoader) routesParams.add(m.route.id);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $32578012b727878c$var$unwrapSingleFetchResults(data2, m.route.id);
                });
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await routesLoadedPromise;
    if ((!router.state.initialized || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({});
    else try {
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", matches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        let data2 = await $32578012b727878c$var$fetchAndDecode(url, init);
        singleFetchDfd.resolve(data2.data);
    } catch (e) {
        singleFetchDfd.reject(e);
    }
    await resolvePromise;
    return results;
}
async function $32578012b727878c$var$singleFetchLoaderFetcherStrategy(request, matches) {
    let fetcherMatch = matches.find((m)=>m.shouldLoad);
    $32578012b727878c$var$invariant2(fetcherMatch, "No fetcher match found");
    let result = await fetcherMatch.resolve(async (handler)=>{
        let url = $32578012b727878c$var$stripIndexParam($32578012b727878c$var$singleFetchUrl(request.url));
        let init = await $32578012b727878c$var$createRequestInit(request);
        return $32578012b727878c$var$fetchSingleLoader(handler, url, init, fetcherMatch.route.id);
    });
    return {
        [fetcherMatch.route.id]: result
    };
}
function $32578012b727878c$var$fetchSingleLoader(handler, url, init, routeId) {
    return handler(async ()=>{
        let singleLoaderUrl = new URL(url);
        singleLoaderUrl.searchParams.set("_routes", routeId);
        let { data: data2 } = await $32578012b727878c$var$fetchAndDecode(singleLoaderUrl, init);
        return $32578012b727878c$var$unwrapSingleFetchResults(data2, routeId);
    });
}
function $32578012b727878c$var$stripIndexParam(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $32578012b727878c$var$singleFetchUrl(reqUrl) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = "_root.data";
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.data`;
    return url;
}
async function $32578012b727878c$var$fetchAndDecode(url, init) {
    let res = await fetch(url, init);
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $32578012b727878c$export$f2680fa305b734ca(404, "Not Found", true);
    $32578012b727878c$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $32578012b727878c$export$4023ad4ecd4126a2(res.body, window);
        return {
            status: res.status,
            data: decoded.value
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $32578012b727878c$export$4023ad4ecd4126a2(body, global2) {
    return (0, $413e902c144ded2c$exports.decode)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global2 && typeof global2[name] === "function") Constructor = global2[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $32578012b727878c$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$32578012b727878c$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $32578012b727878c$var$unwrapSingleFetchResults(results, routeId) {
    let redirect2 = results[$32578012b727878c$export$60644022b8b46aaa];
    if (redirect2) return $32578012b727878c$var$unwrapSingleFetchResult(redirect2, routeId);
    return results[routeId] !== void 0 ? $32578012b727878c$var$unwrapSingleFetchResult(results[routeId], routeId) : null;
}
function $32578012b727878c$var$unwrapSingleFetchResult(result, routeId) {
    if ("error" in result) throw result.error;
    else if ("redirect" in result) {
        let headers = {};
        if (result.revalidate) headers["X-Remix-Revalidate"] = "yes";
        if (result.reload) headers["X-Remix-Reload-Document"] = "yes";
        if (result.replace) headers["X-Remix-Replace"] = "yes";
        throw $32578012b727878c$export$89e12c5b50f7529d(result.redirect, {
            status: result.status,
            headers: headers
        });
    } else if ("data" in result) return result.data;
    else throw new Error(`No response found for routeId "${routeId}"`);
}
function $32578012b727878c$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $32578012b727878c$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $32578012b727878c$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://remix.run/guides/errors for more information."
        );
      `
        }
    });
    if ($32578012b727878c$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), heyDeveloper);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $32578012b727878c$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $32578012b727878c$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$ff0bf87698939488, null) : null)));
}
function $32578012b727878c$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://remix.run/route/hydrate-fallback " +
                "for more information."
              );
            `
        }
    }));
}
// lib/dom/ssr/routes.tsx
function $32578012b727878c$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $32578012b727878c$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $32578012b727878c$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $32578012b727878c$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($32578012b727878c$var$RemixRootDefaultErrorBoundary, {
            error: $32578012b727878c$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $32578012b727878c$var$createServerRoutes(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $32578012b727878c$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $32578012b727878c$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$32578012b727878c$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $32578012b727878c$var$createServerRoutes(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $32578012b727878c$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, future, isSpaMode) {
    return $32578012b727878c$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, "", $32578012b727878c$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $32578012b727878c$var$preventInvalidServerHandlerCall(type, route, isSpaMode) {
    if (isSpaMode) {
        let fn2 = type === "action" ? "serverAction()" : "serverLoader()";
        let msg2 = `You cannot call ${fn2} in SPA Mode (routeId: "${route.id}")`;
        console.error(msg2);
        throw new $32578012b727878c$export$f2680fa305b734ca(400, "Bad Request", new Error(msg2), true);
    }
    let fn = type === "action" ? "serverAction()" : "serverLoader()";
    let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        console.error(msg);
        throw new $32578012b727878c$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $32578012b727878c$var$noActionDefinedError(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $32578012b727878c$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $32578012b727878c$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, parentId = "", routesByParentId = $32578012b727878c$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $32578012b727878c$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $32578012b727878c$var$noActionDefinedError("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $32578012b727878c$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$32578012b727878c$var$getRouteComponents(route, routeModule, isSpaMode),
                handle: routeModule.handle,
                shouldRevalidate: $32578012b727878c$var$getShouldRevalidateFunction(routeModule, route.id, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $32578012b727878c$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) {
                            if (isSpaMode) return null;
                            return fetchServerLoader(singleFetch);
                        }
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            async serverLoader () {
                                $32578012b727878c$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $32578012b727878c$export$6ac68922d4e92125(route, routeModule, isSpaMode);
            dataRoute.action = ({ request: request, params: params }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $32578012b727878c$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $32578012b727878c$var$noActionDefinedError("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        async serverAction () {
                            $32578012b727878c$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) return Promise.resolve(null);
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = ({ request: request }, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $32578012b727878c$var$noActionDefinedError("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            dataRoute.lazy = async ()=>{
                let mod = await $32578012b727878c$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                let lazyRoute = {
                    ...mod
                };
                if (mod.clientLoader) {
                    let clientLoader = mod.clientLoader;
                    lazyRoute.loader = (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $32578012b727878c$var$preventInvalidServerHandlerCall("loader", route, isSpaMode);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                }
                if (mod.clientAction) {
                    let clientAction = mod.clientAction;
                    lazyRoute.action = (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $32578012b727878c$var$preventInvalidServerHandlerCall("action", route, isSpaMode);
                                return fetchServerAction(singleFetch);
                            }
                        });
                }
                return {
                    ...lazyRoute.loader ? {
                        loader: lazyRoute.loader
                    } : {},
                    ...lazyRoute.action ? {
                        action: lazyRoute.action
                    } : {},
                    hasErrorBoundary: lazyRoute.hasErrorBoundary,
                    shouldRevalidate: $32578012b727878c$var$getShouldRevalidateFunction(lazyRoute, route.id, needsRevalidation),
                    handle: lazyRoute.handle,
                    // No need to wrap these in layout since the root route is never
                    // loaded via route.lazy()
                    Component: lazyRoute.Component,
                    ErrorBoundary: lazyRoute.ErrorBoundary
                };
            };
        }
        let children = $32578012b727878c$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $32578012b727878c$var$getShouldRevalidateFunction(route, routeId, needsRevalidation) {
    if (needsRevalidation) return $32578012b727878c$var$wrapShouldRevalidateForHdr(routeId, route.shouldRevalidate, needsRevalidation);
    if (route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $32578012b727878c$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $32578012b727878c$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModule = await $32578012b727878c$var$loadRouteModule(route, routeModules);
    await $32578012b727878c$var$prefetchStyleLinks(route, routeModule);
    return {
        Component: $32578012b727878c$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $32578012b727878c$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $32578012b727878c$export$6ac68922d4e92125(route, routeModule, isSpaMode) {
    return isSpaMode && route.id !== "root" || routeModule.clientLoader != null && (routeModule.clientLoader.hydrate === true || route.hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $32578012b727878c$var$nextPaths = /* @__PURE__ */ new Set();
var $32578012b727878c$var$discoveredPathsMaxSize = 1e3;
var $32578012b727878c$var$discoveredPaths = /* @__PURE__ */ new Set();
var $32578012b727878c$var$URL_LIMIT = 7680;
function $32578012b727878c$var$isFogOfWarEnabled(isSpaMode) {
    return !isSpaMode;
}
function $32578012b727878c$var$getPartialManifest(manifest, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $32578012b727878c$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes
    };
}
function $32578012b727878c$export$72ab377a1030deb9(manifest, routeModules, isSpaMode, basename) {
    if (!$32578012b727878c$var$isFogOfWarEnabled(isSpaMode)) return void 0;
    return async ({ path: path, patch: patch })=>{
        if ($32578012b727878c$var$discoveredPaths.has(path)) return;
        await $32578012b727878c$var$fetchAndApplyManifestPatches([
            path
        ], manifest, routeModules, isSpaMode, basename, patch);
    };
}
function $32578012b727878c$export$5ef046b23d96090d(router, manifest, routeModules, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$32578012b727878c$var$isFogOfWarEnabled(isSpaMode) || navigator.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let url = new URL(path, window.location.origin);
            if (!$32578012b727878c$var$discoveredPaths.has(url.pathname)) $32578012b727878c$var$nextPaths.add(url.pathname);
        }
        async function fetchPatches() {
            let lazyPaths = Array.from($32578012b727878c$var$nextPaths.keys()).filter((path)=>{
                if ($32578012b727878c$var$discoveredPaths.has(path)) {
                    $32578012b727878c$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $32578012b727878c$var$fetchAndApplyManifestPatches(lazyPaths, manifest, routeModules, isSpaMode, router.basename, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        document.body.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>registerElement(el));
        fetchPatches();
        let debouncedFetchPatches = $32578012b727878c$var$debounce(fetchPatches, 100);
        function isElement(node) {
            return node.nodeType === Node.ELEMENT_NODE;
        }
        let observer = new MutationObserver((records)=>{
            let elements = /* @__PURE__ */ new Set();
            records.forEach((r)=>{
                [
                    r.target,
                    ...r.addedNodes
                ].forEach((node)=>{
                    if (!isElement(node)) return;
                    if (node.tagName === "A" && node.getAttribute("data-discover")) elements.add(node);
                    else if (node.tagName === "FORM" && node.getAttribute("data-discover")) elements.add(node);
                    if (node.tagName !== "A") node.querySelectorAll("a[data-discover], form[data-discover]").forEach((el)=>elements.add(el));
                });
            });
            elements.forEach((el)=>registerElement(el));
            debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        isSpaMode,
        manifest,
        routeModules,
        router
    ]);
}
async function $32578012b727878c$var$fetchAndApplyManifestPatches(paths, manifest, routeModules, isSpaMode, basename, patchRoutes) {
    let manifestPath = `${basename != null ? basename : "/"}/__manifest`.replace(/\/+/g, "/");
    let url = new URL(manifestPath, window.location.origin);
    paths.sort().forEach((path)=>url.searchParams.append("p", path));
    url.searchParams.set("version", manifest.version);
    if (url.toString().length > $32578012b727878c$var$URL_LIMIT) {
        $32578012b727878c$var$nextPaths.clear();
        return;
    }
    let res = await fetch(url);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    else if (res.status >= 400) throw new Error(await res.text());
    let serverPatches = await res.json();
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$32578012b727878c$var$addToFifoQueue(p, $32578012b727878c$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $32578012b727878c$export$af76e85f27ba0229(patches, routeModules, null, isSpaMode, parentId)));
}
function $32578012b727878c$var$addToFifoQueue(path, queue) {
    if (queue.size >= $32578012b727878c$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $32578012b727878c$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $32578012b727878c$var$useDataRouterContext2() {
    let context = $acw62.useContext($32578012b727878c$export$2eeee58951ff3c1c);
    $32578012b727878c$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $32578012b727878c$var$useDataRouterStateContext() {
    let context = $acw62.useContext($32578012b727878c$export$315e3ffb01f217);
    $32578012b727878c$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $32578012b727878c$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$32578012b727878c$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $32578012b727878c$var$useFrameworkContext() {
    let context = $acw62.useContext($32578012b727878c$export$208d6a3bc3aa62bd);
    $32578012b727878c$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $32578012b727878c$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($32578012b727878c$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $32578012b727878c$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $32578012b727878c$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $32578012b727878c$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $32578012b727878c$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $32578012b727878c$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $32578012b727878c$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $32578012b727878c$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$32578012b727878c$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
function $32578012b727878c$export$b2e089eb3692b073() {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $32578012b727878c$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $32578012b727878c$var$useDataRouterStateContext();
    let matches = $32578012b727878c$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$32578012b727878c$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, criticalCss ? /* @__PURE__ */ $acw62.createElement("style", {
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, keyedLinks.map(({ key: key, link: link })=>$32578012b727878c$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$60dcec93e67386bd, {
            key: key,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $32578012b727878c$export$60dcec93e67386bd({ page: page, ...dataLinkProps }) {
    let { router: router } = $32578012b727878c$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$32578012b727878c$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...dataLinkProps
    });
}
function $32578012b727878c$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $32578012b727878c$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $32578012b727878c$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $32578012b727878c$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $32578012b727878c$var$useFrameworkContext();
    let { loaderData: loaderData, matches: matches } = $32578012b727878c$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$32578012b727878c$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$32578012b727878c$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $32578012b727878c$var$singleFetchUrl(page);
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$32578012b727878c$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $32578012b727878c$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            ...link
        })));
}
function $32578012b727878c$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $32578012b727878c$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $32578012b727878c$var$useDataRouterStateContext();
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let _matches = $32578012b727878c$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$32578012b727878c$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $32578012b727878c$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $32578012b727878c$var$isHydrated = false;
function $32578012b727878c$export$ff0bf87698939488(props) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta } = $32578012b727878c$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $32578012b727878c$var$useDataRouterContext2();
    let { matches: routerMatches } = $32578012b727878c$var$useDataRouterStateContext();
    let enableFogOfWar = $32578012b727878c$var$isFogOfWarEnabled(isSpaMode);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $32578012b727878c$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $32578012b727878c$var$isHydrated = true;
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, index)=>`import * as route${index} from ${JSON.stringify(manifest.routes[match.route.id].module)};`).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($32578012b727878c$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $32578012b727878c$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...props,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $32578012b727878c$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let routePreloads = matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        return route ? (route.imports || []).concat([
            route.module
        ]) : [];
    }).flat(1);
    let preloads = $32578012b727878c$var$isHydrated ? [] : manifest.entry.imports.concat(routePreloads);
    return $32578012b727878c$var$isHydrated ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: props.crossOrigin
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: props.crossOrigin
    }), $32578012b727878c$var$dedupe(preloads).map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: props.crossOrigin
        })), initialScripts);
}
function $32578012b727878c$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $32578012b727878c$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/lib.tsx
var $32578012b727878c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($32578012b727878c$var$isBrowser) window.__reactRouterVersion = "7.1.3";
} catch (e) {}
function $32578012b727878c$export$1f3f55432a00e06d(routes, opts) {
    return $32578012b727878c$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $32578012b727878c$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $32578012b727878c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $32578012b727878c$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $32578012b727878c$export$1ba7ed8a3a7b3765(routes, opts) {
    return $32578012b727878c$export$baddd0131ee8c05b({
        basename: opts?.basename,
        future: opts?.future,
        history: $32578012b727878c$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $32578012b727878c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $32578012b727878c$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $32578012b727878c$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $32578012b727878c$var$deserializeErrors(state.errors)
    };
    return state;
}
function $32578012b727878c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $32578012b727878c$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $32578012b727878c$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $32578012b727878c$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $32578012b727878c$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $32578012b727878c$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $32578012b727878c$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$32578012b727878c$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $32578012b727878c$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $32578012b727878c$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $32578012b727878c$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($32578012b727878c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $32578012b727878c$var$stripBasename(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $32578012b727878c$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $32578012b727878c$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $32578012b727878c$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $32578012b727878c$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $32578012b727878c$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$32578012b727878c$export$a6c7ac8248d6e38a.displayName = "Link";
var $32578012b727878c$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $32578012b727878c$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($32578012b727878c$export$315e3ffb01f217);
    let { navigator: navigator2, basename: basename } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $32578012b727878c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator2.encodeLocation ? navigator2.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $32578012b727878c$var$stripBasename(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$32578012b727878c$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $32578012b727878c$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $32578012b727878c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $32578012b727878c$export$47c85c6e3a081d3();
    let formAction = $32578012b727878c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $32578012b727878c$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$32578012b727878c$export$a7fed597f4b8afd8.displayName = "Form";
function $32578012b727878c$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($32578012b727878c$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let matches = $32578012b727878c$export$2378eb7f5ff86053();
    $32578012b727878c$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $32578012b727878c$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $32578012b727878c$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$32578012b727878c$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $32578012b727878c$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $32578012b727878c$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($32578012b727878c$export$2eeee58951ff3c1c);
    $32578012b727878c$export$f5708dca728d7177(ctx, $32578012b727878c$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $32578012b727878c$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($32578012b727878c$export$315e3ffb01f217);
    $32578012b727878c$export$f5708dca728d7177(state, $32578012b727878c$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $32578012b727878c$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $32578012b727878c$export$9770f232ac06a008();
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let path = $32578012b727878c$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($32578012b727878c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $32578012b727878c$export$fe53371bee54353d(location) === $32578012b727878c$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $32578012b727878c$export$f1a78c17382fe22a(defaultInit) {
    $32578012b727878c$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($32578012b727878c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $32578012b727878c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $32578012b727878c$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $32578012b727878c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $32578012b727878c$var$fetcherId = 0;
var $32578012b727878c$var$getUniqueFetcherId = ()=>`__${String(++$32578012b727878c$var$fetcherId)}__`;
function $32578012b727878c$export$47c85c6e3a081d3() {
    let { router: router } = $32578012b727878c$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let currentRouteId = $32578012b727878c$var$useRouteId();
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $32578012b727878c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $32578012b727878c$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $32578012b727878c$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    $32578012b727878c$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$32578012b727878c$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $32578012b727878c$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $32578012b727878c$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $32578012b727878c$export$fe53371bee54353d(path);
}
function $32578012b727878c$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $32578012b727878c$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $32578012b727878c$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($32578012b727878c$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($32578012b727878c$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $32578012b727878c$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $32578012b727878c$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $32578012b727878c$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $32578012b727878c$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $32578012b727878c$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $32578012b727878c$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $32578012b727878c$export$fa996778a3a31087() {
    let state = $32578012b727878c$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $32578012b727878c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $32578012b727878c$var$savedScrollPositions = {};
function $32578012b727878c$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $32578012b727878c$var$stripBasename(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $32578012b727878c$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $32578012b727878c$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $32578012b727878c$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($32578012b727878c$export$3044ab7fdabeaee6);
    let location = $32578012b727878c$export$45d76561a5302f2b();
    let matches = $32578012b727878c$export$2378eb7f5ff86053();
    let navigation = $32578012b727878c$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $32578012b727878c$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $32578012b727878c$var$getScrollRestorationKey(location, matches, basename, getKey);
            $32578012b727878c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $32578012b727878c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($32578012b727878c$var$savedScrollPositions));
        } catch (error) {
            $32578012b727878c$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $32578012b727878c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $32578012b727878c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($32578012b727878c$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$32578012b727878c$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $32578012b727878c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $32578012b727878c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $32578012b727878c$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $32578012b727878c$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $32578012b727878c$export$e262bd1977bea848(to, opts = {}) {
    let vtContext = $acw62.useContext($32578012b727878c$export$3681f408decb40d1);
    $32578012b727878c$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $32578012b727878c$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $32578012b727878c$export$e75d2a2d1b3c245b(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $32578012b727878c$var$stripBasename(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $32578012b727878c$var$stripBasename(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $32578012b727878c$export$81336c211d5ff295(path.pathname, nextPath) != null || $32578012b727878c$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $32578012b727878c$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $32578012b727878c$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $32578012b727878c$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $32578012b727878c$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    $32578012b727878c$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $32578012b727878c$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $32578012b727878c$var$serializeErrors(context.errors)
        };
        let json = $32578012b727878c$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $32578012b727878c$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $32578012b727878c$var$useRoutesImpl(routes, void 0, state, future);
}
function $32578012b727878c$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($32578012b727878c$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $32578012b727878c$var$getStatelessNavigator() {
    return {
        createHref: $32578012b727878c$var$createHref,
        encodeLocation: $32578012b727878c$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $32578012b727878c$export$3336b097a6fbc59a(routes, opts) {
    return $32578012b727878c$var$createStaticHandler(routes, {
        ...opts,
        mapRouteProperties: $32578012b727878c$export$9269a41d8c4635e
    });
}
function $32578012b727878c$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $32578012b727878c$var$convertRoutesToDataRoutes(routes, $32578012b727878c$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $32578012b727878c$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $32578012b727878c$var$createHref,
        encodeLocation: $32578012b727878c$var$encodeLocation,
        getFetcher () {
            return $32578012b727878c$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $32578012b727878c$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $32578012b727878c$var$createHref(to) {
    return typeof to === "string" ? to : $32578012b727878c$export$fe53371bee54353d(to);
}
function $32578012b727878c$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $32578012b727878c$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $32578012b727878c$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $32578012b727878c$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $32578012b727878c$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $32578012b727878c$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $32578012b727878c$var$htmlEscape(str) {
    return str.replace($32578012b727878c$var$ESCAPE_REGEX2, (match)=>$32578012b727878c$var$ESCAPE_LOOKUP2[match]);
}
function $32578012b727878c$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = $32578012b727878c$var$createServerRoutes(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && $32578012b727878c$export$6ac68922d4e92125(manifestRoute, route, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = $32578012b727878c$export$3dd6171c30258b6f(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$208d6a3bc3aa62bd.Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            isSpaMode: context.isSpaMode,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$32e57f52df4b6e34, {
        location: router.state.location
    }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$3d80f15952491985, {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($32578012b727878c$var$StreamTransfer, {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $32578012b727878c$export$bea31554c7dfd2ad(routes, context = {}) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $acw62.useRef();
        let remixContextRef = $acw62.useRef();
        if (routerRef.current == null) {
            remixContextRef.current = {
                future: {},
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                isSpaMode: false
            };
            let patched = $32578012b727878c$var$processRoutes(// @ts-expect-error loader/action context types don't match :/
            $32578012b727878c$var$convertRoutesToDataRoutes(routes, (r)=>r), context, remixContextRef.current.manifest, remixContextRef.current.routeModules);
            routerRef.current = $32578012b727878c$export$f30f7e456d254e83(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$208d6a3bc3aa62bd.Provider, {
            value: remixContextRef.current
        }, /* @__PURE__ */ $acw62.createElement($32578012b727878c$export$323e4fc2fa4753fb, {
            router: routerRef.current
        }));
    };
}
function $32578012b727878c$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in @remix-run/testing processRoutes() function");
        let { loader: loader, action: action } = route;
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component,
            HydrateFallback: route.HydrateFallback,
            ErrorBoundary: route.ErrorBoundary,
            action: action ? (args)=>action({
                    ...args,
                    context: context
                }) : void 0,
            loader: loader ? (args)=>loader({
                    ...args,
                    context: context
                }) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should just be stubbing loader/action, not
            // trying to re-implement the full loader/clientLoader/SSR/hydration flow.
            // That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            module: "build/stub-path-to-module.js"
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: route.Component || $32578012b727878c$export$910ae8079b2c2852,
            ErrorBoundary: route.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $32578012b727878c$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $32578012b727878c$var$encoder = new TextEncoder();
var $32578012b727878c$var$sign = async (value, secret)=>{
    let data2 = $32578012b727878c$var$encoder.encode(value);
    let key = await $32578012b727878c$var$createKey2(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $32578012b727878c$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $32578012b727878c$var$encoder.encode(value);
    let key = await $32578012b727878c$var$createKey2(secret, [
        "verify"
    ]);
    let signature = $32578012b727878c$var$byteStringToUint8Array(atob(hash));
    let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
    return valid ? value : false;
};
var $32578012b727878c$var$createKey2 = async (secret, usages)=>crypto.subtle.importKey("raw", $32578012b727878c$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $32578012b727878c$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $32578012b727878c$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $32578012b727878c$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $9fd38747d73cb940$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $32578012b727878c$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $9fd38747d73cb940$exports.serialize)(name, value === "" ? "" : await $32578012b727878c$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $32578012b727878c$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $32578012b727878c$var$encodeCookieValue(value, secrets) {
    let encoded = $32578012b727878c$var$encodeData(value);
    if (secrets.length > 0) encoded = await $32578012b727878c$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $32578012b727878c$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $32578012b727878c$var$unsign(value, secret);
            if (unsignedValue !== false) return $32578012b727878c$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $32578012b727878c$var$decodeData(value);
}
function $32578012b727878c$var$encodeData(value) {
    return btoa($32578012b727878c$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $32578012b727878c$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($32578012b727878c$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $32578012b727878c$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $32578012b727878c$var$hex(code, 2);
            else result += "%u" + $32578012b727878c$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $32578012b727878c$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $32578012b727878c$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $32578012b727878c$var$warnOnceAboutExpiresCookie(name, expires) {
    $32578012b727878c$var$warnOnce(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $32578012b727878c$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo2, routeId)=>{
        let route = manifest[routeId];
        if (route) memo2[routeId] = route.module;
        return memo2;
    }, {});
}
// lib/server-runtime/mode.ts
var $32578012b727878c$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($32578012b727878c$export$e7973f87fd96e4f2 || {});
function $32578012b727878c$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $32578012b727878c$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $32578012b727878c$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $32578012b727878c$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $32578012b727878c$var$serializeError(error, serverMode) {
    let sanitized = $32578012b727878c$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $32578012b727878c$var$serializeErrors2(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($32578012b727878c$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $32578012b727878c$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $32578012b727878c$var$matchServerRoutes(routes, pathname, basename) {
    let matches = $32578012b727878c$export$2708184779ceb39d(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $32578012b727878c$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $32578012b727878c$var$stripRoutesParam($32578012b727878c$var$stripIndexParam2(args.request)),
        params: args.params,
        context: args.context
    });
    if ($32578012b727878c$var$isDataWithResponseInit(result) && result.init && result.init.status && $32578012b727878c$var$isRedirectStatusCode(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $32578012b727878c$var$stripIndexParam2(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $32578012b727878c$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $32578012b727878c$var$invariant3(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routes.ts
function $32578012b727878c$var$groupRoutesByParentId2(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $32578012b727878c$var$createRoutes(manifest, parentId = "", routesByParentId = $32578012b727878c$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $32578012b727878c$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $32578012b727878c$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $32578012b727878c$var$groupRoutesByParentId2(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                if (args.request.headers.has("X-React-Router-Prerender-Data")) {
                    const preRenderedData = args.request.headers.get("X-React-Router-Prerender-Data");
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $32578012b727878c$var$invariant3(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await $32578012b727878c$export$4023ad4ecd4126a2(stream, $parcel$global);
                    let data2 = decoded.value;
                    $32578012b727878c$var$invariant3(data2 && route.id in data2, "Unable to decode prerendered data");
                    let result = data2[route.id];
                    $32578012b727878c$var$invariant3("data" in result, "Unable to process prerendered data");
                    return result.data;
                }
                let val = await $32578012b727878c$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$32578012b727878c$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $32578012b727878c$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/markup.ts
var $32578012b727878c$var$ESCAPE_LOOKUP3 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $32578012b727878c$var$ESCAPE_REGEX3 = /[&><\u2028\u2029]/g;
function $32578012b727878c$var$escapeHtml2(html) {
    return html.replace($32578012b727878c$var$ESCAPE_REGEX3, (match)=>$32578012b727878c$var$ESCAPE_LOOKUP3[match]);
}
// lib/server-runtime/serverHandoff.ts
function $32578012b727878c$var$createServerHandoffString(serverHandoff) {
    return $32578012b727878c$var$escapeHtml2(JSON.stringify(serverHandoff));
}
// lib/server-runtime/dev.ts
var $32578012b727878c$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $32578012b727878c$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$32578012b727878c$var$globalDevServerHooksKey] = devServerHooks;
}
function $32578012b727878c$var$getDevServerHooks() {
    return globalThis[$32578012b727878c$var$globalDevServerHooksKey];
}
function $32578012b727878c$var$getDocumentHeaders(build, context) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let route = build.routes[id];
        $32578012b727878c$var$invariant3(route, `Route with id "${id}" not found in build`);
        let routeModule = route.module;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        if (routeModule.headers == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $32578012b727878c$var$prependCookies(errorHeaders, headers2);
            $32578012b727878c$var$prependCookies(actionHeaders, headers2);
            $32578012b727878c$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(routeModule.headers ? typeof routeModule.headers === "function" ? routeModule.headers({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : routeModule.headers : void 0);
        if (includeErrorCookies) $32578012b727878c$var$prependCookies(errorHeaders, headers);
        $32578012b727878c$var$prependCookies(actionHeaders, headers);
        $32578012b727878c$var$prependCookies(loaderHeaders, headers);
        $32578012b727878c$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers());
}
function $32578012b727878c$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $e4a96bcce5e8f1ac$exports.splitCookiesString)(parentSetCookieString);
        cookies.forEach((cookie)=>{
            childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/server-runtime/single-fetch.ts
var $32578012b727878c$var$SINGLE_FETCH_REDIRECT_STATUS = 202;
function $32578012b727878c$var$getSingleFetchDataStrategy2({ isActionDataRequest: isActionDataRequest, loadRouteIds: loadRouteIds } = {}) {
    return async ({ request: request, matches: matches })=>{
        if (isActionDataRequest && request.method === "GET") return {};
        let matchesToLoad = loadRouteIds ? matches.filter((m)=>loadRouteIds.includes(m.route.id)) : matches;
        let results = await Promise.all(matchesToLoad.map((match)=>match.resolve()));
        return results.reduce((acc, result, i)=>Object.assign(acc, {
                [matchesToLoad[i].route.id]: result
            }), {});
    };
}
async function $32578012b727878c$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $32578012b727878c$var$getSingleFetchDataStrategy2({
                isActionDataRequest: true
            })
        });
        if ($32578012b727878c$var$isResponse(result)) return {
            result: $32578012b727878c$var$getSingleFetchRedirect(result.status, result.headers, build.basename),
            headers: result.headers,
            status: $32578012b727878c$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $32578012b727878c$var$getDocumentHeaders(build, context);
        if ($32578012b727878c$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: $32578012b727878c$var$getSingleFetchRedirect(context.statusCode, headers, build.basename),
            headers: headers,
            status: $32578012b727878c$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$32578012b727878c$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $32578012b727878c$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        };
    }
}
async function $32578012b727878c$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let loadRouteIds = new URL(request.url).searchParams.get("_routes")?.split(",") || void 0;
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            dataStrategy: $32578012b727878c$var$getSingleFetchDataStrategy2({
                loadRouteIds: loadRouteIds
            })
        });
        if ($32578012b727878c$var$isResponse(result)) return {
            result: {
                [$32578012b727878c$export$60644022b8b46aaa]: $32578012b727878c$var$getSingleFetchRedirect(result.status, result.headers, build.basename)
            },
            headers: result.headers,
            status: $32578012b727878c$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        let context = result;
        let headers = $32578012b727878c$var$getDocumentHeaders(build, context);
        if ($32578012b727878c$var$isRedirectStatusCode(context.statusCode) && headers.has("Location")) return {
            result: {
                [$32578012b727878c$export$60644022b8b46aaa]: $32578012b727878c$var$getSingleFetchRedirect(context.statusCode, headers, build.basename)
            },
            headers: headers,
            status: $32578012b727878c$var$SINGLE_FETCH_REDIRECT_STATUS
        };
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!$32578012b727878c$export$972111febbeef05b(err) || err.error) handleError(err);
            });
            context.errors = $32578012b727878c$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = loadRouteIds ? context.matches.filter((m)=>m.route.loader && loadRouteIds.includes(m.route.id)) : context.matches;
        loadedMatches.forEach((m)=>{
            let { id: id } = m.route;
            if (context.errors && context.errors.hasOwnProperty(id)) results[id] = {
                error: context.errors[id]
            };
            else if (context.loaderData.hasOwnProperty(id)) results[id] = {
                data: context.loaderData[id]
            };
        });
        return {
            result: results,
            headers: headers,
            status: context.statusCode
        };
    } catch (error) {
        handleError(error);
        return {
            result: {
                root: {
                    error: error
                }
            },
            headers: new Headers(),
            status: 500
        };
    }
}
function $32578012b727878c$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = $32578012b727878c$var$stripBasename(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $32578012b727878c$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $413e902c144ded2c$exports.encode)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $32578012b727878c$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof $32578012b727878c$export$f2680fa305b734ca) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && $32578012b727878c$export$60644022b8b46aaa in value) return [
                    "SingleFetchRedirect",
                    value[$32578012b727878c$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $32578012b727878c$var$derive(build, mode) {
    let routes = $32578012b727878c$var$createRoutes(build.routes);
    let dataRoutes = $32578012b727878c$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $32578012b727878c$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = $32578012b727878c$var$createStaticHandler(dataRoutes, {
        basename: build.basename
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        $32578012b727878c$export$972111febbeef05b(error) && error.error ? error.error : error);
    });
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler
    };
}
var $32578012b727878c$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    return async function requestHandler(request, loadContext = {}) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $32578012b727878c$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler) {
            let derived = $32578012b727878c$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
        }
        let url = new URL(request.url);
        let params = {};
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $32578012b727878c$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        let manifestUrl = `${_build.basename ?? "/"}/__manifest`.replace(/\/+/g, "/");
        if (url.pathname === manifestUrl) try {
            let res = await $32578012b727878c$var$handleManifestRequest(_build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $32578012b727878c$var$matchServerRoutes(routes, url.pathname, _build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = handlerUrl.pathname.replace(/\.data$/, "").replace(/^\/_root$/, "/");
            let singleFetchMatches = $32578012b727878c$var$matchServerRoutes(routes, handlerUrl.pathname, _build.basename);
            response = await $32578012b727878c$var$handleSingleFetchRequest(serverMode, _build, staticHandler, request, handlerUrl, loadContext, handleError);
            if (_build.entry.module.handleDataRequest) {
                response = await _build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ($32578012b727878c$var$isRedirectResponse(response)) {
                    let result = $32578012b727878c$var$getSingleFetchRedirect(response.status, response.headers, _build.basename);
                    if (request.method === "GET") result = {
                        [$32578012b727878c$export$60644022b8b46aaa]: result
                    };
                    let headers = new Headers(response.headers);
                    headers.set("Content-Type", "text/x-script");
                    return new Response($32578012b727878c$var$encodeViaTurboStream(result, request.signal, _build.entry.module.streamTimeout, serverMode), {
                        status: $32578012b727878c$var$SINGLE_FETCH_REDIRECT_STATUS,
                        headers: headers
                    });
                }
            }
        } else if (matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $32578012b727878c$var$handleResourceRequest(serverMode, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let criticalCss = mode === "development" /* Development */  ? await $32578012b727878c$var$getDevServerHooks()?.getCriticalCss?.(_build, url.pathname) : void 0;
            response = await $32578012b727878c$var$handleDocumentRequest(serverMode, _build, staticHandler, request, loadContext, handleError, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
};
async function $32578012b727878c$var$handleManifestRequest(build, routes, url) {
    let patches = {};
    if (url.searchParams.has("p")) {
        for (let path of url.searchParams.getAll("p")){
            let matches = $32578012b727878c$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $32578012b727878c$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let { result: result, headers: headers, status: status } = request.method !== "GET" ? await $32578012b727878c$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $32578012b727878c$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if (status === 304) return new Response(null, {
        status: 304,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    return new Response($32578012b727878c$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
async function $32578012b727878c$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, criticalCss) {
    let context;
    try {
        context = await staticHandler.query(request, {
            requestContext: loadContext
        });
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    if ($32578012b727878c$var$isResponse(context)) return context;
    let headers = $32578012b727878c$var$getDocumentHeaders(build, context);
    if (context.statusCode === 304) return new Response(null, {
        status: 304,
        headers: headers
    });
    if (context.errors) {
        Object.values(context.errors).forEach((err)=>{
            if (!$32578012b727878c$export$972111febbeef05b(err) || err.error) handleError(err);
        });
        context.errors = $32578012b727878c$var$sanitizeErrors(context.errors, serverMode);
    }
    let state = {
        loaderData: context.loaderData,
        actionData: context.actionData,
        errors: $32578012b727878c$var$serializeErrors2(context.errors, serverMode)
    };
    let entryContext = {
        manifest: build.assets,
        routeModules: $32578012b727878c$var$createEntryRouteModules(build.routes),
        staticHandlerContext: context,
        criticalCss: criticalCss,
        serverHandoffString: $32578012b727878c$var$createServerHandoffString({
            basename: build.basename,
            criticalCss: criticalCss,
            future: build.future,
            isSpaMode: build.isSpaMode
        }),
        serverHandoffStream: $32578012b727878c$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
        renderMeta: {},
        future: build.future,
        isSpaMode: build.isSpaMode,
        serializeError: (err)=>$32578012b727878c$var$serializeError(err, serverMode)
    };
    let handleDocumentRequestFunction = build.entry.module.default;
    try {
        return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
    } catch (error) {
        handleError(error);
        let errorForSecondRender = error;
        if ($32578012b727878c$var$isResponse(error)) try {
            let data2 = await $32578012b727878c$var$unwrapResponse(error);
            errorForSecondRender = new $32578012b727878c$export$f2680fa305b734ca(error.status, error.statusText, data2);
        } catch (e) {}
        context = $32578012b727878c$var$getStaticContextFromError(staticHandler.dataRoutes, context, errorForSecondRender);
        if (context.errors) context.errors = $32578012b727878c$var$sanitizeErrors(context.errors, serverMode);
        let state2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $32578012b727878c$var$serializeErrors2(context.errors, serverMode)
        };
        entryContext = {
            ...entryContext,
            staticHandlerContext: context,
            serverHandoffString: $32578012b727878c$var$createServerHandoffString({
                basename: build.basename,
                future: build.future,
                isSpaMode: build.isSpaMode
            }),
            serverHandoffStream: $32578012b727878c$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {}
        };
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error2) {
            handleError(error2);
            return $32578012b727878c$var$returnLastResortErrorResponse(error2, serverMode);
        }
    }
}
async function $32578012b727878c$var$handleResourceRequest(serverMode, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let response = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext
        });
        $32578012b727878c$var$invariant3($32578012b727878c$var$isResponse(response), "Expected a Response to be returned from resource route handler");
        return response;
    } catch (error) {
        if ($32578012b727878c$var$isResponse(error)) {
            error.headers.set("X-Remix-Catch", "yes");
            return error;
        }
        if ($32578012b727878c$export$972111febbeef05b(error)) {
            if (error) handleError(error);
            return $32578012b727878c$var$errorResponseToJson(error, serverMode);
        }
        handleError(error);
        return $32578012b727878c$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $32578012b727878c$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($32578012b727878c$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText,
        headers: {
            "X-Remix-Error": "yes"
        }
    });
}
function $32578012b727878c$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $32578012b727878c$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $32578012b727878c$var$flash(name) {
    return `__flash_${name}__`;
}
var $32578012b727878c$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($32578012b727878c$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $32578012b727878c$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($32578012b727878c$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $32578012b727878c$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $32578012b727878c$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $32578012b727878c$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $32578012b727878c$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $32578012b727878c$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $32578012b727878c$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $32578012b727878c$var$warnOnceAboutSigningSessionCookie(cookie) {
    $32578012b727878c$var$warnOnce(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://remix.run/utils/cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $32578012b727878c$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $32578012b727878c$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $32578012b727878c$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $32578012b727878c$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $32578012b727878c$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $32578012b727878c$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $32578012b727878c$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/dom/ssr/errors.ts
function $32578012b727878c$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $32578012b727878c$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}





var $acw62 = parcelRequire("acw62");
function $ef03f1e36d447ce4$var$CheckIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m4.5 12.75 6 6 9-13.5"
    }));
}
const $ef03f1e36d447ce4$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($ef03f1e36d447ce4$var$CheckIcon);
var $ef03f1e36d447ce4$export$2e2bcd8739ae039 = $ef03f1e36d447ce4$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
function $288db5f145d66c42$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
        clipRule: "evenodd"
    }));
}
const $288db5f145d66c42$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($288db5f145d66c42$var$XMarkIcon);
var $288db5f145d66c42$export$2e2bcd8739ae039 = $288db5f145d66c42$var$ForwardRef;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


"use client";
function $b00d3e7401eac195$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$b00d3e7401eac195$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $b00d3e7401eac195$var$L = (t)=>typeof t == "number" && !isNaN(t), $b00d3e7401eac195$var$N = (t)=>typeof t == "string", $b00d3e7401eac195$var$P = (t)=>typeof t == "function", $b00d3e7401eac195$var$mt = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$L(t), $b00d3e7401eac195$var$B = (t)=>$b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) ? t : null, $b00d3e7401eac195$var$pt = (t, o)=>t === !1 || $b00d3e7401eac195$var$L(t) && t > 0 ? t : o, $b00d3e7401eac195$var$z = (t)=>(0, $acw62.isValidElement)(t) || $b00d3e7401eac195$var$N(t) || $b00d3e7401eac195$var$P(t) || $b00d3e7401eac195$var$L(t);
function $b00d3e7401eac195$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $b00d3e7401eac195$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $acw62.useRef)(0);
        return (0, $acw62.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $acw62.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $b00d3e7401eac195$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, a);
    };
}
function $b00d3e7401eac195$var$J(t, o) {
    return {
        content: $b00d3e7401eac195$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $b00d3e7401eac195$var$tt(t, o, e = !1) {
    return (0, $acw62.isValidElement)(t) && !$b00d3e7401eac195$var$N(t.type) ? (0, $acw62.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $b00d3e7401eac195$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $b00d3e7401eac195$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $b00d3e7401eac195$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $b00d3e7401eac195$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $b00d3e7401eac195$var$Xt = 1, $b00d3e7401eac195$var$at = ()=>`${$b00d3e7401eac195$var$Xt++}`;
function $b00d3e7401eac195$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($b00d3e7401eac195$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $b00d3e7401eac195$var$B(n.className || d.toastClassName),
                progressClassName: $b00d3e7401eac195$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $b00d3e7401eac195$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($b00d3e7401eac195$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $b00d3e7401eac195$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $b00d3e7401eac195$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $b00d3e7401eac195$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $b00d3e7401eac195$var$I = new Map, $b00d3e7401eac195$var$F = [], $b00d3e7401eac195$var$st = new Set, $b00d3e7401eac195$var$Vt = (t)=>$b00d3e7401eac195$var$st.forEach((o)=>o(t)), $b00d3e7401eac195$var$bt = ()=>$b00d3e7401eac195$var$I.size > 0;
function $b00d3e7401eac195$var$Qt() {
    $b00d3e7401eac195$var$F.forEach((t)=>$b00d3e7401eac195$var$nt(t.content, t.options)), $b00d3e7401eac195$var$F = [];
}
var $b00d3e7401eac195$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $b00d3e7401eac195$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $b00d3e7401eac195$var$X(t, o) {
    var r;
    if (o) return !!((r = $b00d3e7401eac195$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $b00d3e7401eac195$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $b00d3e7401eac195$var$ht(t) {
    if (!$b00d3e7401eac195$var$bt()) {
        $b00d3e7401eac195$var$F = $b00d3e7401eac195$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $b00d3e7401eac195$var$mt(t)) $b00d3e7401eac195$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $b00d3e7401eac195$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $b00d3e7401eac195$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $b00d3e7401eac195$var$Ct = (t = {})=>{
    $b00d3e7401eac195$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $b00d3e7401eac195$var$nt(t, o) {
    $b00d3e7401eac195$var$z(t) && ($b00d3e7401eac195$var$bt() || $b00d3e7401eac195$var$F.push({
        content: t,
        options: o
    }), $b00d3e7401eac195$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $b00d3e7401eac195$var$xt(t) {
    var o;
    (o = $b00d3e7401eac195$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $b00d3e7401eac195$var$rt(t, o) {
    $b00d3e7401eac195$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $b00d3e7401eac195$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $b00d3e7401eac195$var$_t(o, t, $b00d3e7401eac195$var$Vt);
            $b00d3e7401eac195$var$I.set(o, r);
            let s = r.observe(e);
            return $b00d3e7401eac195$var$Qt(), ()=>{
                s(), $b00d3e7401eac195$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $b00d3e7401eac195$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $b00d3e7401eac195$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $b00d3e7401eac195$var$Pt(t) {
    return $b00d3e7401eac195$var$st.add(t), ()=>{
        $b00d3e7401eac195$var$st.delete(t);
    };
}
function $b00d3e7401eac195$var$Wt(t) {
    return t && ($b00d3e7401eac195$var$N(t.toastId) || $b00d3e7401eac195$var$L(t.toastId)) ? t.toastId : $b00d3e7401eac195$var$at();
}
function $b00d3e7401eac195$var$U(t, o) {
    return $b00d3e7401eac195$var$nt(t, o), o.toastId;
}
function $b00d3e7401eac195$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $b00d3e7401eac195$var$Wt(o)
    };
}
function $b00d3e7401eac195$var$Q(t) {
    return (o, e)=>$b00d3e7401eac195$var$U(o, $b00d3e7401eac195$var$V(t, e));
}
function $b00d3e7401eac195$export$b410431fab84fa58(t, o) {
    return $b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", o));
}
$b00d3e7401eac195$export$b410431fab84fa58.loading = (t, o)=>$b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $b00d3e7401eac195$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $b00d3e7401eac195$var$N(o) ? $b00d3e7401eac195$export$b410431fab84fa58.loading(o, s) : $b00d3e7401eac195$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $b00d3e7401eac195$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $b00d3e7401eac195$var$N(g) ? {
            render: g
        } : g;
        return l ? $b00d3e7401eac195$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $b00d3e7401eac195$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $b00d3e7401eac195$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$b00d3e7401eac195$export$b410431fab84fa58.promise = $b00d3e7401eac195$var$Gt;
$b00d3e7401eac195$export$b410431fab84fa58.success = $b00d3e7401eac195$var$Q("success");
$b00d3e7401eac195$export$b410431fab84fa58.info = $b00d3e7401eac195$var$Q("info");
$b00d3e7401eac195$export$b410431fab84fa58.error = $b00d3e7401eac195$var$Q("error");
$b00d3e7401eac195$export$b410431fab84fa58.warning = $b00d3e7401eac195$var$Q("warning");
$b00d3e7401eac195$export$b410431fab84fa58.warn = $b00d3e7401eac195$export$b410431fab84fa58.warning;
$b00d3e7401eac195$export$b410431fab84fa58.dark = (t, o)=>$b00d3e7401eac195$var$U(t, $b00d3e7401eac195$var$V("default", {
        theme: "dark",
        ...o
    }));
function $b00d3e7401eac195$var$qt(t) {
    $b00d3e7401eac195$var$ht(t);
}
$b00d3e7401eac195$export$b410431fab84fa58.dismiss = $b00d3e7401eac195$var$qt;
$b00d3e7401eac195$export$b410431fab84fa58.clearWaitingQueue = $b00d3e7401eac195$var$Ct;
$b00d3e7401eac195$export$b410431fab84fa58.isActive = $b00d3e7401eac195$var$X;
$b00d3e7401eac195$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $b00d3e7401eac195$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $b00d3e7401eac195$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $b00d3e7401eac195$var$U(a, l);
    }
};
$b00d3e7401eac195$export$b410431fab84fa58.done = (t)=>{
    $b00d3e7401eac195$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$b00d3e7401eac195$export$b410431fab84fa58.onChange = $b00d3e7401eac195$var$Pt;
$b00d3e7401eac195$export$b410431fab84fa58.play = (t)=>$b00d3e7401eac195$var$rt(!0, t);
$b00d3e7401eac195$export$b410431fab84fa58.pause = (t)=>$b00d3e7401eac195$var$rt(!1, t);
function $b00d3e7401eac195$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $acw62.useRef)($b00d3e7401eac195$var$Et(t)).current;
    r(t);
    let s = (a = (0, $acw62.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $b00d3e7401eac195$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $b00d3e7401eac195$var$At(t) {
    let [o, e] = (0, $acw62.useState)(!1), [r, s] = (0, $acw62.useState)(!1), l = (0, $acw62.useRef)(null), a = (0, $acw62.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $b00d3e7401eac195$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $acw62.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $b00d3e7401eac195$var$Ot = typeof window != "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $b00d3e7401eac195$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $b00d3e7401eac195$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $b00d3e7401eac195$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $b00d3e7401eac195$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $b00d3e7401eac195$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $b00d3e7401eac195$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $b00d3e7401eac195$export$4f13f83fd8bb1dac = {
    info: $b00d3e7401eac195$var$so,
    warning: $b00d3e7401eac195$var$ao,
    success: $b00d3e7401eac195$var$no,
    error: $b00d3e7401eac195$var$ro,
    spinner: $b00d3e7401eac195$var$io
}, $b00d3e7401eac195$var$lo = (t)=>t in $b00d3e7401eac195$export$4f13f83fd8bb1dac;
function $b00d3e7401eac195$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($b00d3e7401eac195$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $acw62.isValidElement)(r) ? s = (0, $acw62.cloneElement)(r, l) : e ? s = $b00d3e7401eac195$export$4f13f83fd8bb1dac.spinner() : $b00d3e7401eac195$var$lo(o) && (s = $b00d3e7401eac195$export$4f13f83fd8bb1dac[o](l))), s;
}
var $b00d3e7401eac195$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $b00d3e7401eac195$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $b00d3e7401eac195$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(D, E), ft = $b00d3e7401eac195$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($b00d3e7401eac195$var$P(a) ? H = a(j) : (0, $acw62.isValidElement)(a) ? H = (0, $acw62.cloneElement)(a, j) : H = $b00d3e7401eac195$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $b00d3e7401eac195$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $b00d3e7401eac195$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $b00d3e7401eac195$export$d20e79fdc3899e95 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("bounce", !0)), $b00d3e7401eac195$export$d8dc01b5c85a37b9 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("slide", !0)), $b00d3e7401eac195$export$65cfd44a2050f99 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("zoom")), $b00d3e7401eac195$export$4d2fae537bd90431 = $b00d3e7401eac195$export$3ff7dc44d332d222($b00d3e7401eac195$var$K("flip"));
var $b00d3e7401eac195$var$_o = {
    position: "top-right",
    transition: $b00d3e7401eac195$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $b00d3e7401eac195$export$f2815235e76a62b9(t) {
    let o = {
        ...$b00d3e7401eac195$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $acw62.useState)(!0), l = (0, $acw62.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $b00d3e7401eac195$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $b00d3e7401eac195$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(p, $b00d3e7401eac195$var$B(T));
    }
    function E() {
        e && (s(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
    }
    return $b00d3e7401eac195$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $acw62.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $b00d3e7401eac195$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $b00d3e7401eac195$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b00d3e7401eac195$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}





parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




const $c4b3f247e841d90c$export$59c172d1de7514a4 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (creative)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/content_variants', {
                creative: creative
            }).then((0, $647d702c229b8211$export$887bad18d4e1e94a)),
        ...args
    });
};
const $c4b3f247e841d90c$export$656fd34a246c19f9 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/content_variants/${id}`),
        ...args
    });
};




const $ac3e639a16f09c99$export$7012850773d85ce3 = (id, args = {})=>{
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            'creatives',
            id
        ],
        queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).get(`/creatives/${id}`).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $ac3e639a16f09c99$export$ee494ffeec4bd736 = (query, args = {})=>{
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            'creatives',
            query
        ],
        queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/creatives', query).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $ac3e639a16f09c99$export$d4d396eb2c0a833c = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/creatives/${id}`),
        onSuccess: ()=>{
            queryClient.invalidateQueries('creatives');
        },
        ...args
    });
};
const $ac3e639a16f09c99$export$55a01692e57364f2 = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    if ('onSuccess' in args) {
        const onSuccess = args.onSuccess;
        args.onSuccess = ()=>{
            queryClient.invalidateQueries('creatives');
            onSuccess();
        };
    } else args.onSuccess = ()=>{
        queryClient.invalidateQueries('creatives');
    };
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post(`/creatives/${id}/duplicate`, {}).then((0, $647d702c229b8211$export$887bad18d4e1e94a)),
        ...args
    });
};
const $ac3e639a16f09c99$export$fbe1e8284300e19b = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    if ('onSuccess' in args) {
        const onSuccess = args.onSuccess;
        args.onSuccess = (data)=>{
            queryClient.invalidateQueries([
                'creatives',
                data.id
            ]);
            onSuccess();
        };
    } else args.onSuccess = (data)=>{
        queryClient.invalidateQueries([
            'creatives',
            data.id
        ]);
    };
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(`/creatives/${id}/reconcile`, {}).then((0, $647d702c229b8211$export$887bad18d4e1e94a)).then((_)=>({
                    id: id
                })),
        ...args
    });
};




const $00f460ddb596a095$export$55dd908b31935d23 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (e)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/exports', (0, $647d702c229b8211$export$7daef87da786a8bf)(e)).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};




const $3205bad321c9d9e6$export$dedb17a472ec9063 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (field)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/fields', (0, $647d702c229b8211$export$7daef87da786a8bf)(field)).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $3205bad321c9d9e6$export$68dc441545c63e86 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (field)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).put(`/fields/${field.id}`, (0, $647d702c229b8211$export$7daef87da786a8bf)(field)).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $3205bad321c9d9e6$export$39416e8dff3fda6f = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/fields/${id}`),
        ...args
    });
};
const $3205bad321c9d9e6$export$5d7d793a29913d45 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (fieldValue)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/field_values', (0, $647d702c229b8211$export$7daef87da786a8bf)(fieldValue)).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $3205bad321c9d9e6$export$12bf8cc8fd0d0ea9 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (data)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).put(`/field_values/${data.id}`, {
                value: data.value
            }).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};




const $1232e344916108aa$export$6cb05837d2a9a681 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (file)=>new Promise((resolve)=>{
                (async ()=>{
                    const updates = new FormData();
                    updates.append('file', file);
                    (0, $647d702c229b8211$export$7d6f1c8842f9f527).upload('/font_files', 'POST', updates, ()=>{}, (response)=>resolve(response));
                })();
            }),
        ...args
    });
};
const $1232e344916108aa$export$8241329de5df3c0f = (fonts, options)=>{
    const uniqueFonts = [
        ...new Map(fonts.map((font)=>[
                font.fontFile.file,
                font
            ])).values()
    ]; // Remove duplicates
    return (0, $990eb380e3560bcc$export$408667c6c87da1e5)(uniqueFonts.map((font)=>{
        const url = font.fontFile.file;
        return {
            queryKey: [
                'font-urls',
                url
            ],
            queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).getFile(url, 'font/*').then((res)=>res.arrayBuffer()).then((file)=>{
                    return {
                        url: url,
                        font: font,
                        file: file
                    };
                }),
            staleTime: Number.POSITIVE_INFINITY,
            cacheTime: Number.POSITIVE_INFINITY,
            ...options
        };
    }));
};




const $98e5698f5c571300$export$b38a330f0ab1cd0a = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (layer)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/linked_layers', (0, $647d702c229b8211$export$7daef87da786a8bf)(layer)).then((0, $647d702c229b8211$export$887bad18d4e1e94a)),
        ...args
    });
};
const $98e5698f5c571300$export$33896a2e5f59f05e = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/linked_layers/${id}`),
        ...args
    });
};




const $4856298da5031936$export$aec46e5bb7a508cb = (urls, options)=>{
    return (0, $990eb380e3560bcc$export$408667c6c87da1e5)(urls.map((url)=>({
            queryKey: [
                'svg_files',
                url
            ],
            queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).getFile(url, 'image/svg+xml').then((res)=>res.text()).then((file)=>{
                    return {
                        url: url,
                        file: file
                    };
                }),
            staleTime: Number.POSITIVE_INFINITY,
            cacheTime: Number.POSITIVE_INFINITY,
            ...options
        })));
};




const $35340290a6a27606$export$7ea88a09033402a2 = (args = {})=>{
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            'tags'
        ],
        queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/tags').then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $35340290a6a27606$export$b62c4ec00e56f561 = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/tags/${id}`),
        onSuccess: ()=>{
            queryClient.invalidateQueries('tags');
        },
        ...args
    });
};
const $35340290a6a27606$export$d2f036f27e89d9f4 = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    if ('onSuccess' in args) {
        const onSuccess = args.onSuccess;
        args.onSuccess = (data)=>{
            queryClient.invalidateQueries('tags');
            onSuccess(data);
        };
    } else args.onSuccess = (data)=>{
        queryClient.invalidateQueries('tags');
    };
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (name)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post('/tags', (0, $647d702c229b8211$export$7daef87da786a8bf)({
                name: name
            })).then((data)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(data)),
        ...args
    });
};




const $181035219bfd394d$export$b6557d05127509d7 = (id, args = {})=>{
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            'templates',
            id
        ],
        queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).get(`/templates/${id}`).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $181035219bfd394d$export$2f5885556d0225e8 = (query, args = {})=>{
    return (0, $369f47a093b8c0cf$export$dd0a697e1782aedd)({
        queryKey: [
            'templates',
            query
        ],
        queryFn: ()=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).get('/templates', query).then((d)=>(0, $647d702c229b8211$export$887bad18d4e1e94a)(d)),
        ...args
    });
};
const $181035219bfd394d$export$79b62a94a6821975 = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/templates/${id}`),
        onSuccess: ()=>{
            queryClient.invalidateQueries('templates');
        },
        ...args
    });
};
const $181035219bfd394d$export$fe8b509dc1873566 = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    if ('onSuccess' in args) {
        const onSuccess = args.onSuccess;
        args.onSuccess = ()=>{
            queryClient.invalidateQueries('templates');
            onSuccess();
        };
    } else args.onSuccess = ()=>{
        queryClient.invalidateQueries('templates');
    };
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).post(`/templates/${id}/duplicate`, {}).then((0, $647d702c229b8211$export$887bad18d4e1e94a)),
        ...args
    });
};
const $181035219bfd394d$export$436c7386a3e8362d = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: ({ id: id, data: data })=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(`/templates/${id}`, data).then((0, $647d702c229b8211$export$887bad18d4e1e94a)),
        ...args
    });
};
const $181035219bfd394d$export$b0413934fb19e7d1 = (args = {})=>{
    const queryClient = (0, $ccb8f828cefd6075$export$22e77b9572c4fded)();
    if ('onSuccess' in args) {
        const onSuccess = args.onSuccess;
        args.onSuccess = (data)=>{
            queryClient.invalidateQueries([
                'templates',
                data.id
            ]);
            onSuccess();
        };
    } else args.onSuccess = (data)=>{
        queryClient.invalidateQueries([
            'templates',
            data.id
        ]);
    };
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).patch(`/templates/${id}/publish`, {}).then((0, $647d702c229b8211$export$887bad18d4e1e94a)).then((data)=>({
                    id: id,
                    ...data
                })),
        ...args
    });
};




const $b9d442414baa9d07$export$646aa5fa861e2f37 = (args = {})=>{
    return (0, $0bcdd0ea2a5866d5$export$609860bf8b0084c)({
        mutationFn: (id)=>(0, $647d702c229b8211$export$7d6f1c8842f9f527).delete(`/variants/${id}`),
        ...args
    });
};





parcelRequire("acw62");

parcelRequire("acw62");
const $add1ea09e8fc02e1$export$754bff847b02c54b = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Activity Indicator"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_5293_7504)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10 5V2.5",
                        stroke: "#ffffff",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#ffffff;#323840;#323840;#323840;#323840;#323840;#323840;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.543 6.45964L15.3346 4.66797",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#ffffff;#323840;#323840;#323840;#323840;#323840;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15 10H17.5",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#323840;#ffffff;#323840;#323840;#323840;#323840;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.543 13.543L15.3346 15.3346",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#323840;#323840;#ffffff;#323840;#323840;#323840;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10 15V17.5",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#323840;#323840;#323840;#ffffff;#323840;#323840;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.45964 13.543L4.66797 15.3346",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#323840;#323840;#323840;#323840;#ffffff;#323840;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5 10H2.5",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#323840;#323840;#323840;#323840;#323840;#ffffff;#323840",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.45964 6.45964L4.66797 4.66797",
                        stroke: "#323840",
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animate", {
                            attributeName: "stroke",
                            values: "#323840;#323840;#323840;#323840;#323840;#323840;#323840;#ffffff",
                            dur: "2s",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_5293_7504",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};


var $962788b972601ad7$export$d3d950cd69e1ac66 = /*#__PURE__*/ function(ButtonType) {
    ButtonType["PRIMARY"] = "primary";
    ButtonType["SECONDARY"] = "secondary";
    return ButtonType;
}({});
var $962788b972601ad7$export$5dd2748b7940a2a0 = /*#__PURE__*/ function(ButtonSize) {
    ButtonSize["SMALL"] = "small";
    ButtonSize["LARGE"] = "large";
    return ButtonSize;
}({});
const $962788b972601ad7$export$353f5b6fc5456de1 = ({ title: title, buttonType: buttonType, buttonSize: buttonSize, leading: leading, trailing: trailing, disabled: disabled, isLoading: isLoading, onClick: onClick, type: type, className: className })=>{
    const getButtonBgColor = ()=>{
        if (disabled || isLoading) return buttonType === "primary" ? 'bg-gray-60' : 'bg-transparent';
        return buttonType === "primary" ? 'bg-blue hover:bg-blue-80' : 'bg-transparent hover:bg-gray-150';
    };
    const getTextColor = ()=>{
        if (disabled || isLoading) return buttonType === "primary" ? 'text-gray-100' : 'text-gray-110';
        return buttonType === "primary" ? 'text-white' : 'text-white';
    };
    const border = `border-solid border-[1px] ${disabled ? 'bg-gray-120' : 'border-gray-100'}`;
    const height = buttonSize === "large" ? 'h-10' : 'h-8';
    const paddingX = buttonSize === "large" ? 'px-5' : 'px-3.5';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: type ? type : 'button',
        disabled: disabled || isLoading,
        className: `flex flex-col-3 ${height} flex-wrap gap-2 justify-center ${getButtonBgColor()} ${getTextColor()} ${buttonType === "secondary" ? border : ''} 
            ${paddingX} vertical-center items-center rounded-md text-sm font-normal ${disabled === true ? 'opacity-70' : 'opacity-100'} ${className}`,
        onClick: onClick,
        onKeyUp: onClick,
        children: [
            !isLoading && leading && leading,
            isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $add1ea09e8fc02e1$export$754bff847b02c54b), {
                className: "w-4 h-4"
            }),
            title && title,
            trailing && trailing
        ]
    });
};



const $297bc9fd20328fd0$export$533a00e25ce4cf63 = {
    success: (message)=>{
        (0, $b00d3e7401eac195$export$b410431fab84fa58).success(message, {
            closeButton: false,
            style: {
                backgroundColor: '#3A50FF',
                color: 'white',
                width: '25vw',
                minHeight: '44px'
            }
        });
    },
    error: (message)=>{
        (0, $b00d3e7401eac195$export$b410431fab84fa58).error(message, {
            closeButton: false,
            style: {
                backgroundColor: '#FE495F',
                color: 'white',
                width: '25vw',
                minHeight: '44px'
            }
        });
    }
};




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");

// Define z-index levels to make element layering easier
const $39e6c01191458113$export$f4d455029c4b5e98 = 50;
const $39e6c01191458113$export$cda00df1b02ce137 = $39e6c01191458113$export$f4d455029c4b5e98;
const $39e6c01191458113$export$e1c0d0fe83d3d53 = $39e6c01191458113$export$cda00df1b02ce137 + 50;
const $39e6c01191458113$export$fc1f05a49fe03882 = $39e6c01191458113$export$e1c0d0fe83d3d53 + 50;


const $e331d67b7935c065$export$2b77a92f1a5ad772 = ({ isOpen: isOpen, children: children })=>{
    return /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `fixed inset-0 flex ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
                        items-center justify-center
                        bg-black bg-opacity-50`,
        style: {
            zIndex: (0, $39e6c01191458113$export$e1c0d0fe83d3d53)
        },
        children: children
    }), document.body);
};



var $acw62 = parcelRequire("acw62");
function $9e33022247bf2fb5$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m19.5 8.25-7.5 7.5-7.5-7.5"
    }));
}
const $9e33022247bf2fb5$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($9e33022247bf2fb5$var$ChevronDownIcon);
var $9e33022247bf2fb5$export$2e2bcd8739ae039 = $9e33022247bf2fb5$var$ForwardRef;


var $acw62 = parcelRequire("acw62");
function $968d99013e9e02bc$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $968d99013e9e02bc$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($968d99013e9e02bc$var$XMarkIcon);
var $968d99013e9e02bc$export$2e2bcd8739ae039 = $968d99013e9e02bc$var$ForwardRef;



parcelRequire("acw62");
const $f87e2995c0ae886d$export$7dd004358974b05d = ({ className: className, size: size = 18, title: title = '' })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: size,
        height: size,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "4",
                width: "12",
                height: "12",
                rx: "1",
                fill: "#3A50FF"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 10L8.64645 11.6464C8.84171 11.8417 9.15829 11.8417 9.35355 11.6464L13 8",
                stroke: "white"
            })
        ]
    });
};



parcelRequire("acw62");
const $430181ea01cc3dc6$export$30d0dc241a918823 = ({ className: className, size: size = 18, title: title = '' })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: size,
        height: size,
        className: className,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "4",
                y: "4",
                width: "12",
                height: "12",
                rx: "1",
                stroke: "#B4B4B4",
                strokeLinejoin: "round"
            })
        ]
    });
};



const $995cc5f8453164b0$export$ad6c01082be780ea = ({ isOpen: isOpen, setIsOpen: setIsOpen, onConfirm: onConfirm, exportCount: exportCount })=>{
    const exportFormats = [
        {
            name: 'PNG',
            value: 'png'
        },
        {
            name: 'JPEG',
            value: 'jpeg'
        }
    ];
    const [isSelectOpen, setIsSelectOpen] = (0, $acw62.useState)(false);
    const [selectedFormats, setSelectedFormats] = (0, $acw62.useState)([]);
    const ref = (0, $acw62.useRef)(null);
    const parentRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const toggleMenu = (e)=>{
        e.stopPropagation();
        setIsSelectOpen((prev)=>!prev);
    };
    const toggleSelect = (value)=>{
        setSelectedFormats((prev)=>{
            if (prev.includes(value)) return prev.filter((item)=>item !== value);
            return [
                ...prev,
                value
            ];
        });
    };
    const getPosition = ()=>{
        const rect = ref.current?.getBoundingClientRect();
        return {
            top: (rect?.bottom ?? 0) + 10,
            left: rect?.left
        };
    };
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) setIsSelectOpen(false);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute w-[40vw] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row p-3 justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl text-white",
                            children: "Select the file format for export"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100 w-full"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-row items-center p-4 w-full",
                    ref: parentRef,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "relative inline-block w-full",
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-white text-sm",
                                        children: "Export Format"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        className: "w-full",
                                        onClick: toggleMenu,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row justify-between items-center w-full p-3 bg-gray-100 rounded-md",
                                            children: [
                                                selectedFormats.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-gray-50",
                                                    children: "Click to select file type"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex flex-row gap-2",
                                                    children: selectedFormats.map((item, index)=>{
                                                        const format = exportFormats.find((format)=>format.value === item);
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-row justify-between text-sm text-white bg-gray-80 py-1 px-2 rounded w-24",
                                                            children: [
                                                                format?.name,
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                    type: "button",
                                                                    className: "flex items-center",
                                                                    onClick: (e)=>{
                                                                        e.stopPropagation();
                                                                        toggleSelect(item);
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                                                        className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30"
                                                                    })
                                                                })
                                                            ]
                                                        }, item);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e33022247bf2fb5$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4 text-white"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isSelectOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "absolute bg-gray-100 shadow-xl rounded-md transition-all duration-100 ease-in-out max-h-[200px] overflow-y-scroll opacity-100 visible p-1",
                                style: {
                                    zIndex: (0, $39e6c01191458113$export$fc1f05a49fe03882),
                                    ...getPosition(),
                                    position: 'absolute',
                                    width: 'calc(40vw - 32px)'
                                },
                                ref: menuRef,
                                children: exportFormats.map((item)=>{
                                    const isSelected = selectedFormats.includes(item.value);
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "flex flex-row gap-1.5 w-full px-2 py-3 border-gray-120 border-b-[1px] text-white text-gray-700 hover:bg-gray-80 rounded-md text-xs text-left items-center",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            toggleMenu(e);
                                            toggleSelect(item.value);
                                        },
                                        children: [
                                            isSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f87e2995c0ae886d$export$7dd004358974b05d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $430181ea01cc3dc6$export$30d0dc241a918823), {}),
                                            item.name
                                        ]
                                    }, item.value);
                                })
                            }), document.body)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100 w-full mt-2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Cancel",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: ()=>setIsOpen(false)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: `Export ${exportCount} Asset${exportCount > 1 ? 's' : ''}`,
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: async ()=>{
                                setIsOpen(false);
                                onConfirm(selectedFormats);
                            }
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");
const $0d9bddfe2f0bb60b$export$d59d68c5c4589499 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Intaglio Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.4797 16.1823V23.8918H11.7812V10.5564H15.3061V12.9092H15.4624C15.7575 12.1336 16.2524 11.5201 16.9469 11.0687C17.6415 10.6114 18.4836 10.3828 19.4734 10.3828C20.3994 10.3828 21.2068 10.5854 21.8956 10.9905C22.5844 11.3957 23.1197 11.9745 23.5017 12.7269C23.8837 13.4735 24.0747 14.3649 24.0747 15.4009V23.8918H20.3763V16.0607C20.3821 15.2446 20.1737 14.608 19.7512 14.1507C19.3287 13.6877 18.747 13.4562 18.0061 13.4562C17.5084 13.4562 17.0685 13.5633 16.6865 13.7774C16.3103 13.9916 16.0151 14.3041 15.8009 14.7151C15.5926 15.1202 15.4855 15.6093 15.4797 16.1823Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.75924 6.10938V23.8898H5V6.10938H8.75924Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "30",
                height: "30",
                rx: "6.7347",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.6226 15.976C17.6358 15.3386 16.374 15.097 14.9803 14.8982C14.3429 14.8071 13.5865 14.638 13.0476 14.2292C12.3229 13.6531 11.8583 12.7611 11.8583 11.7762C11.8583 10.048 13.2706 8.65423 14.9803 8.65423C16.6899 8.65423 18.1023 10.0666 18.1023 11.7762C18.1023 12.7611 17.5615 13.6977 16.8368 14.2738C17.7287 14.4968 18.6412 14.8239 19.3102 15.307C20.0907 14.3407 20.611 13.1142 20.611 11.7762C20.611 8.67281 18.0837 6.16406 14.9989 6.16406C11.914 6.16406 9.38672 8.69139 9.38672 11.7762C9.38672 13.1328 9.88847 14.3407 10.6875 15.307C10.892 15.5486 11.1335 15.7716 11.3565 15.976C12.3229 16.8309 13.6181 17.1951 14.9989 17.3884C15.8946 17.5129 16.5599 17.6114 17.1174 17.9459C17.7306 18.3175 18.1209 18.8193 18.1209 19.3768C18.1209 20.4174 16.6528 21.3652 14.9989 21.3652C13.345 21.3652 11.8769 20.4546 11.8769 19.3768C11.8769 18.8378 12.2671 18.3361 12.8804 17.9459C12.0255 17.6485 11.245 17.2025 10.5946 16.5893C9.8513 17.3512 9.38672 18.2989 9.38672 19.3582C9.38672 21.8669 11.8583 23.8367 14.9989 23.8367C18.1394 23.8367 20.611 21.8669 20.611 19.3582C20.611 18.2989 20.1316 17.3419 19.3882 16.5986C19.1466 16.3756 18.9088 16.16 18.6226 15.976Z",
                fill: "black"
            })
        ]
    });
};



parcelRequire("acw62");
var $b3f317f73d7705c5$export$9baf8232abef7d17 = /*#__PURE__*/ function(NavbarType) {
    NavbarType["LIGHT"] = "light";
    NavbarType["DARK"] = "dark";
    return NavbarType;
}({});
const $b3f317f73d7705c5$export$42cfbb80f7861e77 = ({ leading: leading, trailing: trailing, center: center, type: type })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex flex-col-3 max-w-full min-h-[56px] max-h-[56px] justify-between ${type === "light" ? 'bg-gray-160' : 'bg-black-50'} px-6 py-2 vertical-center items-center`,
        children: [
            leading ? leading : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
            center ? center : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
            trailing ? trailing : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {})
        ]
    });
};






var $acw62 = parcelRequire("acw62");
const $804ccb50967d1658$export$930e29e5f9ad1dcf = ({ isOpen: isOpen, setIsOpen: setIsOpen, src: src })=>{
    const modalRef = (0, $acw62.useRef)(null);
    const downloadLinkRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (modalRef.current && !modalRef.current.contains(event.target)) setIsOpen(false);
        };
        if (isOpen) document.addEventListener('mousedown', handleClickOutside);
        else document.removeEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isOpen,
        setIsOpen
    ]);
    const handleDownload = ()=>{
        downloadLinkRef.current?.click();
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            ref: modalRef,
            className: "flex flex-col justify-between absolute min-w-96 w-[50vw] h-[80vh] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out p-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row justify-end items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Download",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: handleDownload
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            ref: downloadLinkRef,
                            href: src,
                            download: true,
                            className: "hidden",
                            children: "Download Image"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-full chess h-[68vh] p-2",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: src,
                        alt: "Asset",
                        className: "rounded object-contain h-full w-full aspect-square"
                    })
                })
            ]
        })
    });
};


const $4d5f0db46b599107$export$4a070b22cd5acf55 = ()=>{
    const params = (0, $32578012b727878c$export$99eaa27ddbbb95ef)();
    const creativeId = Number.parseInt(params.creativeId || '');
    if (Number.isNaN(creativeId)) {
        console.error('Invalid params ID in url params:', params.creativeId);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
            to: "/creatives",
            replace: true
        });
    }
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [exports, setExports] = (0, $acw62.useState)([]);
    const [currentImageSrc, setCurrentImageSrc] = (0, $acw62.useState)(null);
    const [creative, setCreative] = (0, $acw62.useState)();
    const [exportCount, setExportCount] = (0, $acw62.useState)(0);
    const [isExportModalOpen, setIsExportModalOpen] = (0, $acw62.useState)(false);
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    const { mutate: createExport } = (0, $00f460ddb596a095$export$55dd908b31935d23)();
    const fetchCreativesExports = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        setExports(await (0, $c31e9b81d8391e7c$export$1811d82788a05bc9).getExports(creativeId));
        setIsLoading(false);
    }, [
        creativeId
    ]);
    creativeId;
    const { refetch: refetchCreative } = (0, $ac3e639a16f09c99$export$7012850773d85ce3)(creativeId, {
        onSuccess: async (creative)=>{
            setCreative(creative);
            setExportCount((creative?.contentVariants.length || 0) * (creative?.creativeVariants.length || 0));
        },
        staleTime: Number.POSITIVE_INFINITY,
        cacheTime: 0
    });
    (0, $acw62.useEffect)(()=>{
        fetchCreativesExports();
    }, [
        fetchCreativesExports
    ]);
    const handleExport = (exportFormats)=>{
        createExport({
            creative: creativeId,
            formats: exportFormats
        }, {
            onSuccess: ()=>{
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success("Export has been requested. You will receive an email with the download link once it's ready.");
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col h-screen w-screen bg-black-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                type: (0, $b3f317f73d7705c5$export$9baf8232abef7d17).LIGHT,
                leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {})
                }),
                center: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "text-base text-white",
                    children: "Untitled Creative"
                }),
                trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                    title: `Export ${exportCount} Asset${exportCount === 1 ? '' : 's'}`,
                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                    onClick: ()=>setIsExportModalOpen(true)
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "z-10 -mt-3 h-14 w-full flex flex-col items-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-4 bg-[#FFD08A] rounded-full py-3 px-8 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm",
                            children: "Opened in view only mode."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            className: "bg-[#FFE6C8] px-3 py-1 rounded-md text-sm",
                            onClick: ()=>{
                                navigate(`/creatives/generate/${creativeId}`);
                            },
                            children: "Edit Content"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "overflow-y-auto p-5 space-y-8 w-full",
                children: exports.map((exportItem, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-base font-semibold mb-4 text-white",
                                children: [
                                    "Version ",
                                    exports.length - index
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-row gap-4 overflow-x-auto no-scrollbar",
                                children: exportItem.exportedAssets?.map((asset, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col max-w-[42vw] aspect-square",
                                        onClick: ()=>setCurrentImageSrc(asset.file),
                                        onKeyUp: (e)=>{
                                            if (e.key === 'Enter' || e.key === ' ') setCurrentImageSrc(asset.file);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-row justify-between items-center mb-2 w-[24vw]",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-row gap-2 items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-xs text-white truncate max-w-[15vw]",
                                                                children: asset.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-xs text-gray-60 flex flex-row gap-2 items-center",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-xl",
                                                                        children: "\xb7"
                                                                    }),
                                                                    asset.format
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "text-xs text-gray-60",
                                                        children: [
                                                            asset.width,
                                                            " x ",
                                                            asset.height
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-row justify-center p-1 w-[24vw] aspect-square bg-gray-200 rounded-md overflow-hidden bg-gray-150 chess",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: asset.file,
                                                    alt: "Asset",
                                                    className: "object-contain"
                                                })
                                            })
                                        ]
                                    }, asset.id))
                            })
                        ]
                    }, exportItem.id))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $804ccb50967d1658$export$930e29e5f9ad1dcf), {
                src: currentImageSrc ?? '',
                isOpen: !!currentImageSrc,
                setIsOpen: (isOpen)=>{
                    if (!isOpen) setCurrentImageSrc(null);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $995cc5f8453164b0$export$ad6c01082be780ea), {
                isOpen: isExportModalOpen,
                setIsOpen: setIsExportModalOpen,
                exportCount: (creative?.contentVariants.length || 0) * (creative?.creativeVariants.length || 0),
                onConfirm: handleExport
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");




var $4e6833270179d7a4$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType["ADMIN"] = "admin";
    UserType["DESIGNER"] = "designer";
    UserType["MEMBER"] = "member";
    return UserType;
}({});






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
function $ca6349d0f67ac97f$var$ExclamationCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
    }));
}
const $ca6349d0f67ac97f$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($ca6349d0f67ac97f$var$ExclamationCircleIcon);
var $ca6349d0f67ac97f$export$2e2bcd8739ae039 = $ca6349d0f67ac97f$var$ForwardRef;


parcelRequire("acw62");
var $75939bf917d0aeac$export$f1dd0e7fe1bbaedf = /*#__PURE__*/ function(TextFieldType) {
    TextFieldType["Email"] = "email";
    TextFieldType["Text"] = "text";
    return TextFieldType;
}({});
const $75939bf917d0aeac$export$2c73285ae9390cec = ({ id: id, className: className, type: type, value: value, placeholder: placeholder, required: required, onChange: onChange, hasError: hasError, maxLength: maxLength, errorMessage: errorMessage })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex flex-col gap-2 ${className}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                maxLength: maxLength,
                id: id,
                type: type,
                value: value,
                onChange: (e)=>onChange?.(e.target.value),
                className: `${hasError ? 'border-red-50 border-2 border-solid' : 'border-none outline-none'} rounded-md bg-gray-100 w-full px-3 py-2.5 text-white text-sm ${required ? 'required' : ''} ${className ? className : ''}`,
                placeholder: placeholder
            }),
            hasError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                className: "flex flex-row gap-2 text-red-50 text-xs font-normal items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca6349d0f67ac97f$export$2e2bcd8739ae039), {
                        className: "w-5 h-5"
                    }),
                    errorMessage
                ]
            })
        ]
    });
};



parcelRequire("acw62");
const $94b315f23341d3ba$export$8df90684a752ef81 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Upload Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5.33203 17.0667V24.5333C5.33203 25.7115 6.28716 26.6666 7.46536 26.6666H24.532C25.7102 26.6666 26.6654 25.7115 26.6654 24.5333V17.0667",
                strokeWidth: "2.13333"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.668 10.6667L16.0013 5.33341L21.3346 10.6667",
                strokeWidth: "2.13333",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16 5.33327L16 20.2666",
                stroke: "white",
                strokeWidth: "2.13333"
            })
        ]
    });
};


const $ee9165ed7aac49d0$export$2ec38366d6add659 = ({ onAccountUpdated: onAccountUpdated, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [name, setName] = (0, $acw62.useState)('');
    const [email, setEmail] = (0, $acw62.useState)('');
    const [picture, setPicture] = (0, $acw62.useState)('');
    const [pickedPicture, setPickedPicture] = (0, $acw62.useState)(null);
    const [user, setUser] = (0, $acw62.useState)(null);
    const fileInputRef = (0, $acw62.useRef)(null);
    const fetchUser = (0, $acw62.useCallback)(async ()=>{
        try {
            const user = await (0, $c0753412de87ef15$export$86659b0ff913db80).getCurrentUser();
            setUser(user);
            setName(`${user.firstName} ${user.lastName}`);
            setEmail(user.email);
            setPicture(user.profilePicture);
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to fetch user data');
        }
    }, []);
    const updateUser = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const splittedName = name.split(' ');
            const firstName = splittedName.slice(0, -1).join(' ').trim();
            const lastName = splittedName[splittedName.length - 1].trim();
            await (0, $c0753412de87ef15$export$86659b0ff913db80).updateUser(firstName, lastName, email, pickedPicture, ()=>{
                onAccountUpdated?.();
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Account updated successfully');
            });
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to update account');
        } finally{
            setIsLoading(false);
        }
    }, [
        onAccountUpdated,
        name,
        email,
        pickedPicture
    ]);
    const handleFileChange = (event)=>{
        const file = event?.target?.files?.[0];
        if (file) {
            const validTypes = [
                'image/jpeg',
                'image/png'
            ];
            if (validTypes.includes(file.type)) setPickedPicture(file);
            else (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Please select a JPEG or PNG file');
        }
    };
    const closeModal = ()=>{
        setIsOpen(false);
        setPickedPicture(null);
    };
    (0, $acw62.useEffect)(()=>{
        fetchUser();
    }, [
        fetchUser
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[40vw] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row p-3 justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl text-white",
                            children: "Account Settings"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                            onClick: ()=>closeModal()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100 w-full"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col px-4 w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "ml-1 mb-1 text-white text-sm",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                    id: "name",
                                    required: true,
                                    type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                    value: name,
                                    placeholder: "Name",
                                    onChange: (value)=>{
                                        setName(value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            id: "picture",
                            type: "file",
                            accept: "image/jpeg, image/png",
                            ref: fileInputRef,
                            onChange: handleFileChange,
                            multiple: false,
                            style: {
                                display: 'none'
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col px-4 py-2 gap-2 w-36",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-gray-50",
                                    children: "Profile Picture"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative w-[72px] h-[72px] rounded-full overflow-hidden bg-gray-100 group",
                                    children: [
                                        (picture || pickedPicture) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: pickedPicture ? URL.createObjectURL(pickedPicture) : picture,
                                            alt: "Profile",
                                            className: "w-full h-full object-cover"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "absolute inset-0",
                                            onClick: ()=>fileInputRef.current?.click(),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `absolute inset-0 ${picture || pickedPicture ? 'bg-black bg-opacity-80 opacity-0' : ''} flex items-center justify-center transition-opacity duration-300 group-hover:opacity-100`,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94b315f23341d3ba$export$8df90684a752ef81), {
                                                    className: "h-5 w-5 stroke-white"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col px-4 pb-4 w-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "ml-1 mb-1 text-white text-sm",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                            id: "email",
                            required: true,
                            type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Email,
                            value: email,
                            placeholder: "Email",
                            onChange: (value)=>{
                                setEmail(value);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100 w-full mt-2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Cancel",
                            className: "hover:bg-gray-160",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isLoading,
                            onClick: ()=>closeModal()
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Done",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isLoading,
                            onClick: async ()=>{
                                await updateUser();
                                closeModal();
                            }
                        })
                    ]
                })
            ]
        })
    });
};







var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
const $b390e3f7de4a2019$export$5fbd0a1d429f9ad7 = ({ firstName: firstName, lastName: lastName, className: className })=>{
    function map(value, start1, stop1, start2, stop2) {
        return (value - start1) / (stop1 - start1) * (stop2 - start2) + start2;
    }
    const getByteLength = (string)=>{
        return new TextEncoder().encode(string[0])[0];
    };
    const minCharByteValue = getByteLength('a');
    const maxCharByteValue = getByteLength('z');
    const minRange = minCharByteValue / maxCharByteValue;
    const maxRange = 1;
    const colorByUser = ({ firstName: firstName, lastName: lastName })=>{
        if (!firstName && !lastName) return '';
        const userValue = getByteLength(firstName[0]?.toLowerCase()) / getByteLength(lastName[0]?.toLowerCase());
        return `hsl(${map(userValue, minRange, maxRange, 0, 360)}, 50%, 50%)`;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `w-9 h-9 rounded-full col-span-1 ${className}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "w-full h-full mx-auto rounded-full flex place-content-center",
            style: {
                backgroundColor: firstName || lastName ? colorByUser({
                    firstName: firstName || '',
                    lastName: lastName || ''
                }) : 'white'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "block text-white my-auto text-sm font-medium",
                children: [
                    firstName ? firstName.slice(0, 1) : '',
                    lastName ? lastName.slice(0, 1) : ''
                ]
            })
        })
    });
};




var $acw62 = parcelRequire("acw62");
function $dd88e2148a16500e$var$EllipsisVerticalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    }));
}
const $dd88e2148a16500e$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($dd88e2148a16500e$var$EllipsisVerticalIcon);
var $dd88e2148a16500e$export$2e2bcd8739ae039 = $dd88e2148a16500e$var$ForwardRef;



var $acw62 = parcelRequire("acw62");


const $ac8e38bb87a65c17$export$d9b273488cd8ce6f = ({ items: items, icon: icon, onMenuStateChanged: onMenuStateChanged })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const toggleMenu = (e)=>{
        e.stopPropagation();
        setIsOpen((prev)=>!prev);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        onMenuStateChanged?.(!isOpen);
    }, [
        onMenuStateChanged,
        isOpen
    ]);
    const getPosition = ()=>{
        const menuRect = ref.current?.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const bottom = menuRect?.bottom ?? 0;
        const height = 200;
        const width = 144;
        const heightOverflow = bottom + height - windowHeight;
        let left = menuRect?.left ?? 0;
        let top = menuRect?.bottom ?? 0;
        if (bottom + height > windowHeight) top = top - heightOverflow;
        if (left + width > windowWidth) left = left - width;
        return {
            top: top,
            left: left
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative inline-block",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: toggleMenu,
                children: icon ? icon : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd88e2148a16500e$export$2e2bcd8739ae039), {
                    className: "h-11 w-7 text-white text-left"
                })
            }),
            isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute w-40 bg-gray-100 shadow-xl rounded-md transition-all duration-100 ease-in-out max-h-[200px] overflow-y-scroll opacity-100 visible",
                style: {
                    zIndex: (0, $39e6c01191458113$export$fc1f05a49fe03882),
                    ...getPosition()
                },
                ref: menuRef,
                children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: `flex flex-row gap-1.5 w-full px-3 py-2 text-${item.color ? item.color : 'white'} text-gray-700 hover:bg-gray-80 rounded-md text-xs text-left items-center`,
                        onClick: (e)=>{
                            e.stopPropagation();
                            toggleMenu(e);
                            item.onClick();
                        },
                        children: [
                            item.icon ? item.icon : '',
                            item.name
                        ]
                    }, item.id))
            }), document.body)
        ]
    });
};





const $4096c6d546e14db9$export$ab5bd7780c936eb2 = ({ onAccountUpdated: onAccountUpdated, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [organizationName, setOrganizationName] = (0, $acw62.useState)('');
    const [inviteEmail, setInviteEmail] = (0, $acw62.useState)('');
    const [picture, setPicture] = (0, $acw62.useState)('');
    const [pickedPicture, setPickedPicture] = (0, $acw62.useState)(null);
    const [user, setUser] = (0, $acw62.useState)(null);
    const fileInputRef = (0, $acw62.useRef)(null);
    const [organizationUsers, setOrganizationUsers] = (0, $acw62.useState)([]);
    const [selectedInviteType, setSelectedInviteType] = (0, $acw62.useState)(null);
    const [invitations, setInvitations] = (0, $acw62.useState)([]);
    const fetchUser = (0, $acw62.useCallback)(async ()=>{
        try {
            const user = await (0, $c0753412de87ef15$export$86659b0ff913db80).getCurrentUser();
            setUser(user);
            setOrganizationName(user.organization.name);
            setPicture(user.organization.logo);
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to fetch user data');
        }
    }, []);
    const fetchOrganizationUsers = (0, $acw62.useCallback)(async ()=>{
        try {
            const users = await (0, $c0753412de87ef15$export$86659b0ff913db80).getOrganizationUsers();
            setOrganizationUsers(users.results);
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to fetch organization users');
        }
    }, []);
    const fetchInvitations = (0, $acw62.useCallback)(async ()=>{
        try {
            setInvitations((await (0, $ee0b2042adda2a3b$export$5ffdd261dd91a68a).getInvitations()).results);
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to fetch invitations');
        }
    }, []);
    const handleFileChange = (event)=>{
        const file = event?.target?.files?.[0];
        if (file) {
            const validTypes = [
                'image/jpeg',
                'image/png'
            ];
            if (validTypes.includes(file.type)) setPickedPicture(file);
            else (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Please select a JPEG or PNG file');
        }
    };
    const updateOrganization = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            await (0, $a74acb8e10f991c3$export$7cae0ceb639f991d).updateOrganization(organizationName, pickedPicture, ()=>{
                onAccountUpdated?.();
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Account updated successfully');
            });
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to update account');
        } finally{
            setIsLoading(false);
        }
    }, [
        onAccountUpdated,
        organizationName,
        pickedPicture
    ]);
    const updateUserType = (0, $acw62.useCallback)(async (userId, type)=>{
        try {
            await (0, $c0753412de87ef15$export$86659b0ff913db80).updateUserType(userId, type);
            fetchOrganizationUsers();
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to update user type');
        }
    }, [
        fetchOrganizationUsers
    ]);
    const updateInvitationType = (0, $acw62.useCallback)(async (invitationId, type)=>{
        try {
            await (0, $ee0b2042adda2a3b$export$5ffdd261dd91a68a).updateInvitationType(invitationId, type);
            fetchInvitations();
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to update user type');
        }
    }, [
        fetchInvitations
    ]);
    const deleteUser = (0, $acw62.useCallback)(async (userId)=>{
        try {
            await (0, $c0753412de87ef15$export$86659b0ff913db80).deleteUser(userId);
            fetchOrganizationUsers();
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to delete user');
        }
    }, [
        fetchOrganizationUsers
    ]);
    const sendInvite = (0, $acw62.useCallback)(async ()=>{
        try {
            setIsLoading(true);
            await (0, $ee0b2042adda2a3b$export$5ffdd261dd91a68a).createInvitation(inviteEmail, selectedInviteType || '');
            await fetchInvitations();
            setSelectedInviteType(null);
            setInviteEmail('');
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to send invite');
        } finally{
            setIsLoading(false);
        }
    }, [
        fetchInvitations,
        inviteEmail,
        selectedInviteType
    ]);
    const resendInvite = (0, $acw62.useCallback)(async (invitationId)=>{
        try {
            setIsLoading(true);
            await (0, $ee0b2042adda2a3b$export$5ffdd261dd91a68a).resendInvitation(invitationId);
            await fetchInvitations();
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Invite resent successfully');
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to resend invite');
        } finally{
            setIsLoading(false);
        }
    }, [
        fetchInvitations
    ]);
    const revokeInvite = (0, $acw62.useCallback)(async (invitationId)=>{
        try {
            setIsLoading(true);
            await (0, $ee0b2042adda2a3b$export$5ffdd261dd91a68a).deleteInvitation(invitationId);
            await fetchInvitations();
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Invite revoked successfully');
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to revoke invite');
        } finally{
            setIsLoading(false);
        }
    }, [
        fetchInvitations
    ]);
    const closeModal = ()=>{
        setIsOpen(false);
        setPickedPicture(null);
        setSelectedInviteType(null);
        setInviteEmail('');
    };
    (0, $acw62.useEffect)(()=>{
        fetchUser();
        fetchOrganizationUsers();
        fetchInvitations();
    }, [
        fetchUser,
        fetchOrganizationUsers,
        fetchInvitations
    ]);
    const getInvitationTile = (invitation)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-row items-center space-between w-full p-2.5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row items-center gap-3 w-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "border-[1px] border-blue-40 rounded-full w-9 h-9"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-60",
                            children: invitation.email
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-60",
                            children: "\u2022"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: `text-sm ${invitation.isExpired ? 'text-red-30' : 'text-gray-60'}`,
                            children: invitation.isExpired ? 'Expired' : 'Invited'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                    items: [
                        ...invitation.userType !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN ? [
                            {
                                name: 'Admin',
                                id: 'inv-admin',
                                onClick: ()=>updateInvitationType(invitation.id, (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN)
                            }
                        ] : [],
                        ...invitation.userType !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER ? [
                            {
                                name: 'Designer',
                                id: 'inv-designer',
                                onClick: ()=>updateInvitationType(invitation.id, (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER)
                            }
                        ] : [],
                        ...invitation.userType !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER ? [
                            {
                                name: 'Member',
                                id: 'inv-member',
                                onClick: ()=>updateInvitationType(invitation.id, (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER)
                            }
                        ] : [],
                        {
                            name: 'Resend',
                            id: 'inv-opt-resend',
                            onClick: ()=>resendInvite(invitation.id),
                            color: 'red-50'
                        },
                        {
                            name: 'Revoke',
                            id: 'inv-opt-revoke',
                            onClick: ()=>revokeInvite(invitation.id),
                            color: 'red-50'
                        }
                    ],
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center w-full min-w-32 justify-end",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-blue-30 capitalize",
                                children: invitation.userType
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e33022247bf2fb5$export$2e2bcd8739ae039), {
                                className: "text-blue-30 h-4 w-4"
                            })
                        ]
                    })
                })
            ]
        });
    };
    const getMemberTile = (user)=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-row items-center space-between w-full p-2.5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row items-center gap-3 w-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b390e3f7de4a2019$export$5fbd0a1d429f9ad7), {
                            firstName: user.firstName,
                            lastName: user.lastName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-sm text-white",
                                    children: [
                                        user.firstName,
                                        " ",
                                        user.lastName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-gray-110",
                                    children: user.email
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                    items: [
                        ...user.type !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN ? [
                            {
                                name: 'Admin',
                                id: 'mem-admin',
                                onClick: ()=>updateUserType(user.id, (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN)
                            }
                        ] : [],
                        ...user.type !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER ? [
                            {
                                name: 'Designer',
                                id: 'mem-designer',
                                onClick: ()=>updateUserType(user.id, (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER)
                            }
                        ] : [],
                        ...user.type !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER ? [
                            {
                                name: 'Member',
                                id: 'mem-member',
                                onClick: ()=>updateUserType(user.id, (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER)
                            }
                        ] : [],
                        {
                            name: 'Remove User',
                            id: 'opt-remove',
                            onClick: ()=>deleteUser(user.id),
                            color: 'red-50'
                        }
                    ],
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center w-full min-w-32 justify-end",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-blue-30 capitalize",
                                children: user.type
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e33022247bf2fb5$export$2e2bcd8739ae039), {
                                className: "text-blue-30 h-4 w-4"
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[45vw] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row p-3 justify-between items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl text-white",
                            children: "Admin Controls"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100 w-full"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col p-4 w-full gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "ml-1 text-white text-sm",
                                    children: "Organization Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                    id: "organization-name",
                                    required: true,
                                    type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                    value: organizationName,
                                    placeholder: "Organization Name",
                                    onChange: (value)=>{
                                        setOrganizationName(value);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "logo",
                                    type: "file",
                                    accept: "image/jpeg, image/png",
                                    ref: fileInputRef,
                                    onChange: handleFileChange,
                                    multiple: false,
                                    style: {
                                        display: 'none'
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "ml-1 text-white text-sm",
                                    children: "Invite Members"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-row gap-2 bg-gray-100 rounded-lg items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                            id: "email",
                                            className: "w-full",
                                            required: true,
                                            type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Email,
                                            value: inviteEmail,
                                            placeholder: "Email",
                                            onChange: (value)=>{
                                                setInviteEmail(value);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                                                items: [
                                                    {
                                                        name: 'Admin',
                                                        id: 'inv-admin',
                                                        onClick: ()=>setSelectedInviteType((0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN)
                                                    },
                                                    {
                                                        name: 'Designer',
                                                        id: 'inv-designer',
                                                        onClick: ()=>setSelectedInviteType((0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER)
                                                    },
                                                    {
                                                        name: 'Member',
                                                        id: 'inv-member',
                                                        onClick: ()=>setSelectedInviteType((0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER)
                                                    }
                                                ],
                                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row gap-2 items-center w-full min-w-32 justify-end p-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-sm text-white capitalize",
                                                            children: selectedInviteType ? selectedInviteType : 'Select Role'
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e33022247bf2fb5$export$2e2bcd8739ae039), {
                                                            className: "text-white h-4 w-4"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-2 px-3 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative w-[72px] h-[72px] rounded-full overflow-hidden bg-gray-100 group",
                                    children: [
                                        (picture || pickedPicture) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: pickedPicture ? URL.createObjectURL(pickedPicture) : picture,
                                            alt: "logo",
                                            className: "w-full h-full object-cover"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            className: "absolute inset-0",
                                            onClick: ()=>fileInputRef.current?.click(),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: `absolute inset-0 ${picture || pickedPicture ? 'bg-black bg-opacity-80 opacity-0' : ''} flex items-center justify-center transition-opacity duration-300 group-hover:opacity-100`,
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94b315f23341d3ba$export$8df90684a752ef81), {
                                                    className: "h-5 w-5 stroke-white"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-gray-50",
                                    children: "Company Icon"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Send Invite",
                                    className: "w-32",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: isLoading || !inviteEmail || !selectedInviteType,
                                    onClick: ()=>sendInvite()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col w-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white px-4 py-2",
                            children: "Members"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "max-h-56 overflow-auto no-scrollbar w-full",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col w-full",
                                children: [
                                    invitations.map((invitation, index)=>{
                                        const addSeparator = index !== organizationUsers.length - 1;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col w-full",
                                            children: [
                                                getInvitationTile(invitation),
                                                addSeparator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                                    className: "bg-gray-140 border-gray-140 w-full mt-1"
                                                })
                                            ]
                                        }, invitation.id);
                                    }),
                                    organizationUsers.map((user, index)=>{
                                        const addSeparator = index !== organizationUsers.length - 1;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col w-full",
                                            children: [
                                                getMemberTile(user),
                                                addSeparator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                                    className: "bg-gray-140 border-gray-140 w-full mt-1"
                                                })
                                            ]
                                        }, user.id);
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100 w-full mt-2"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Cancel",
                            className: "hover:bg-gray-160",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isLoading,
                            onClick: ()=>closeModal()
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Done",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isLoading,
                            onClick: async ()=>{
                                await updateOrganization();
                                closeModal();
                            }
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");
const $5b0e2b9e347c28dd$export$a245117220b0b0f2 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        viewBox: "0 0 14 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "All Templates Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M1 2.16732C1 1.9463 1.0878 1.73434 1.24408 1.57806C1.40036 1.42178 1.61232 1.33398 1.83333 1.33398H5.16667C5.38768 1.33398 5.59964 1.42178 5.75592 1.57806C5.9122 1.73434 6 1.9463 6 2.16732V5.50065C6 5.72166 5.9122 5.93363 5.75592 6.08991C5.59964 6.24619 5.38768 6.33398 5.16667 6.33398H1.83333C1.61232 6.33398 1.40036 6.24619 1.24408 6.08991C1.0878 5.93363 1 5.72166 1 5.50065V2.16732Z",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 2.16732C8 1.9463 8.0878 1.73434 8.24408 1.57806C8.40036 1.42178 8.61232 1.33398 8.83333 1.33398H12.1667C12.3877 1.33398 12.5996 1.42178 12.7559 1.57806C12.9122 1.73434 13 1.9463 13 2.16732V5.50065C13 5.72166 12.9122 5.93363 12.7559 6.08991C12.5996 6.24619 12.3877 6.33398 12.1667 6.33398H8.83333C8.61232 6.33398 8.40036 6.24619 8.24408 6.08991C8.0878 5.93363 8 5.72166 8 5.50065V2.16732Z",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M1 10.4993C1 10.2783 1.0878 10.0664 1.24408 9.91009C1.40036 9.75381 1.61232 9.66602 1.83333 9.66602H5.16667C5.38768 9.66602 5.59964 9.75381 5.75592 9.91009C5.9122 10.0664 6 10.2783 6 10.4993V13.8327C6 14.0537 5.9122 14.2657 5.75592 14.4219C5.59964 14.5782 5.38768 14.666 5.16667 14.666H1.83333C1.61232 14.666 1.40036 14.5782 1.24408 14.4219C1.0878 14.2657 1 14.0537 1 13.8327V10.4993Z",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 10.4993C8 10.2783 8.0878 10.0664 8.24408 9.91009C8.40036 9.75381 8.61232 9.66602 8.83333 9.66602H12.1667C12.3877 9.66602 12.5996 9.75381 12.7559 9.91009C12.9122 10.0664 13 10.2783 13 10.4993V13.8327C13 14.0537 12.9122 14.2657 12.7559 14.4219C12.5996 14.5782 12.3877 14.666 12.1667 14.666H8.83333C8.61232 14.666 8.40036 14.5782 8.24408 14.4219C8.0878 14.2657 8 14.0537 8 13.8327V10.4993Z",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};



parcelRequire("acw62");
const $dd5d46306eb83dc9$export$d7db36bc683573 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "200",
        height: "196",
        viewBox: "0 0 200 196",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Empty Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M199.882 0.302734H53.1523V129.522H199.882V0.302734Z",
                fill: "#11161C"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M199.882 129.521C199.881 128.523 199.834 78.0655 199.763 0.302049L199.882 0.42046C157.679 0.42638 107.237 0.433912 53.1656 0.441985H53.1527L53.2927 0.302049C53.2867 47.2687 53.2808 91.491 53.276 129.521L53.1522 129.398C140.724 129.471 198.811 129.52 199.882 129.521C198.812 129.523 140.724 129.572 53.1522 129.645H53.0284V129.521C53.0236 91.491 53.0182 47.2687 53.0117 0.302049V0.162109H53.1517H53.1646C107.236 0.170183 157.678 0.17718 199.881 0.183639H200V0.302049C199.929 78.066 199.882 128.524 199.882 129.521Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M76.585 49.3006H68.2602C67.6849 49.3006 67.2188 48.8345 67.2188 48.2591V36.7368C67.2188 36.1614 67.6849 35.6953 68.2602 35.6953H73.5397L77.6264 39.9075V48.2591C77.6264 48.8339 77.1603 49.3006 76.585 49.3006Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M73.5391 35.6953V38.9381C73.5391 39.4731 73.9729 39.9069 74.5079 39.9069L77.6258 39.9075L73.5391 35.6953Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5862 39.2266C73.5862 39.2266 73.5453 40.0129 74.4404 40.2718C74.4743 40.2815 74.5087 40.2885 74.5432 40.2949C74.9501 40.3676 77.6304 40.8445 77.6304 40.7831C77.6304 40.7164 77.6304 39.9117 77.6304 39.9117H74.5125C74.5125 39.9117 73.7337 39.8848 73.5862 39.2266Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5391 35.6953V38.9381C73.5391 39.4731 73.9729 39.9069 74.5079 39.9069L77.6258 39.9075L73.5391 35.6953Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M72.8437 38.8C72.8437 38.8414 71.9815 38.8753 70.918 38.8753C69.8544 38.8753 68.9922 38.8414 68.9922 38.8C68.9922 38.7585 69.8544 38.7246 70.918 38.7246C71.9815 38.7241 72.8437 38.758 72.8437 38.8Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.3309 40.63C75.3309 40.6715 73.9121 40.7054 72.1618 40.7054C70.4109 40.7054 68.9922 40.6715 68.9922 40.63C68.9922 40.5886 70.4109 40.5547 72.1618 40.5547C73.9121 40.5547 75.3309 40.5886 75.3309 40.63Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 42.1613C75.9014 42.2027 74.3545 42.2366 72.4471 42.2366C70.5385 42.2366 68.9922 42.2027 68.9922 42.1613C68.9922 42.1199 70.5385 42.0859 72.4471 42.0859C74.3545 42.0854 75.9014 42.1193 75.9014 42.1613Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 43.6125C75.9014 43.6539 74.3545 43.6878 72.4471 43.6878C70.5385 43.6878 68.9922 43.6539 68.9922 43.6125C68.9922 43.571 70.5385 43.5371 72.4471 43.5371C74.3545 43.5371 75.9014 43.571 75.9014 43.6125Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 45.0509C75.9014 45.0924 74.3545 45.1263 72.4471 45.1263C70.5385 45.1263 68.9922 45.0924 68.9922 45.0509C68.9922 45.0095 70.5385 44.9756 72.4471 44.9756C74.3545 44.9756 75.9014 45.0095 75.9014 45.0509Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 46.5031C75.9014 46.5445 74.3545 46.5784 72.4471 46.5784C70.5385 46.5784 68.9922 46.5445 68.9922 46.5031C68.9922 46.4616 70.5385 46.4277 72.4471 46.4277C74.3545 46.4277 75.9014 46.4616 75.9014 46.5031Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M84.7039 37.1333C84.8805 37.1333 85.0527 37.1704 85.1679 37.2522L85.0242 37.6381C84.9461 37.5848 84.8476 37.5477 84.7411 37.5477C84.5274 37.5477 84.4171 37.6666 84.4171 37.9008V38.0321H85.0204V38.4428H84.4332V40.2087H83.9197V38.4428H83.5586V38.0321H83.9197V37.8927C83.9197 37.433 84.1948 37.1333 84.7039 37.1333ZM85.6238 37.3469C85.6238 37.1747 85.7632 37.0391 85.9521 37.0391C86.141 37.0391 86.2804 37.1661 86.2804 37.3346C86.2804 37.5154 86.1453 37.6548 85.9521 37.6548C85.7632 37.6548 85.6238 37.5192 85.6238 37.3469ZM85.6937 38.0159H86.2072V40.2087H85.6937V38.0159Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M86.8828 37.1611H87.3963V40.208H86.8828V37.1611Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.1214 39.2769H88.4007C88.4621 39.5972 88.729 39.8028 89.1112 39.8028C89.3577 39.8028 89.5504 39.7247 89.7065 39.5649L89.9815 39.8808C89.7845 40.1149 89.4766 40.2382 89.0983 40.2382C88.3631 40.2382 87.8867 39.7656 87.8867 39.1133C87.8867 38.4604 88.3674 37.9922 89.0197 37.9922C89.6602 37.9922 90.1284 38.44 90.1284 39.1257C90.1295 39.1661 90.1252 39.2274 90.1214 39.2769ZM88.3964 38.9357H89.6408C89.5994 38.6198 89.3572 38.4018 89.0208 38.4018C88.6881 38.4023 88.4459 38.616 88.3964 38.9357Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M92.7854 38.9535V40.2097H92.272V39.0191C92.272 38.6289 92.0793 38.44 91.7504 38.44C91.385 38.44 91.1385 38.6617 91.1385 39.1009V40.2097H90.625V38.0169H91.1137V38.3C91.2822 38.0988 91.5491 37.9922 91.8694 37.9922C92.3958 37.9922 92.7854 38.2925 92.7854 38.9535Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M95.2766 38.9249V40.2102H94.7922V39.9433C94.6689 40.1322 94.431 40.2387 94.1022 40.2387C93.6011 40.2387 93.2852 39.9637 93.2852 39.5816C93.2852 39.2161 93.5317 38.9287 94.1964 38.9287H94.7631V38.8959C94.7631 38.5961 94.5828 38.4195 94.2168 38.4195C93.9703 38.4195 93.7157 38.5013 93.5516 38.637L93.3508 38.2635C93.5844 38.0826 93.9256 37.9922 94.2787 37.9922C94.9106 37.9927 95.2766 38.2931 95.2766 38.9249ZM94.7631 39.5251V39.2705H94.2335C93.8847 39.2705 93.79 39.4018 93.79 39.5622C93.79 39.7468 93.9461 39.8663 94.2088 39.8663C94.459 39.8657 94.6765 39.7506 94.7631 39.5251Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M99.6016 38.9535V40.2097H99.0881V39.0191C99.0881 38.6289 98.9078 38.44 98.5951 38.44C98.2587 38.44 98.0241 38.6617 98.0241 39.0972V40.2097H97.5106V39.0191C97.5106 38.6289 97.3303 38.44 97.0181 38.44C96.6774 38.44 96.4471 38.6617 96.4471 39.0972V40.2097H95.9336V38.0169H96.4223V38.2963C96.5865 38.0993 96.841 37.9922 97.1408 37.9922C97.4611 37.9922 97.728 38.1117 97.8798 38.3576C98.0564 38.1321 98.3524 37.9922 98.7012 37.9922C99.2324 37.9922 99.6016 38.2925 99.6016 38.9535Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M102.335 39.2769H100.614C100.676 39.5972 100.943 39.8028 101.325 39.8028C101.571 39.8028 101.764 39.7247 101.921 39.5649L102.196 39.8808C101.999 40.1149 101.69 40.2382 101.313 40.2382C100.577 40.2382 100.102 39.7656 100.102 39.1133C100.102 38.4604 100.582 37.9922 101.235 37.9922C101.875 37.9922 102.343 38.44 102.343 39.1257C102.343 39.1661 102.34 39.2274 102.335 39.2769ZM100.611 38.9357H101.855C101.814 38.6198 101.571 38.4018 101.235 38.4018C100.902 38.4023 100.66 38.616 100.611 38.9357Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M83.6758 43.5934C83.6758 42.9502 84.165 42.4766 84.827 42.4766C85.1467 42.4766 85.4358 42.5831 85.6301 42.7968L85.4826 42.9443C85.3034 42.7624 85.0843 42.6838 84.833 42.6838C84.3028 42.6838 83.9045 43.0729 83.9045 43.5934C83.9045 44.1138 84.3028 44.503 84.833 44.503C85.0838 44.503 85.3034 44.4244 85.4826 44.2392L85.6301 44.3867C85.4358 44.5999 85.1468 44.7102 84.8238 44.7102C84.165 44.7102 83.6758 44.2366 83.6758 43.5934Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M85.8359 43.8678C85.8359 43.3785 86.1939 43.0303 86.6766 43.0303C87.16 43.0303 87.5147 43.3785 87.5147 43.8678C87.5147 44.3575 87.16 44.709 86.6766 44.709C86.1933 44.7085 85.8359 44.3575 85.8359 43.8678ZM87.2881 43.8678C87.2881 43.4818 87.0276 43.2246 86.6761 43.2246C86.3246 43.2246 86.0614 43.4818 86.0614 43.8678C86.0614 44.2537 86.3246 44.5109 86.6761 44.5109C87.0276 44.5109 87.2881 44.2537 87.2881 43.8678Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.6922 43.734V44.691H90.4693V43.7561C90.4693 43.4079 90.2939 43.2286 89.9957 43.2286C89.6572 43.2286 89.4435 43.4482 89.4435 43.8245V44.6905H89.2207V43.7556C89.2207 43.4073 89.0447 43.2281 88.7438 43.2281C88.4079 43.2281 88.1916 43.4477 88.1916 43.8239V44.6899H87.9688V43.0397H88.1824V43.3411C88.2981 43.1436 88.5118 43.0273 88.7879 43.0273C89.0608 43.0273 89.2739 43.1436 89.3746 43.3756C89.4935 43.1624 89.7293 43.0273 90.0275 43.0273C90.4284 43.0284 90.6922 43.2604 90.6922 43.734Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M92.9647 43.8672C92.9647 44.3694 92.6132 44.7085 92.1428 44.7085C91.8791 44.7085 91.6536 44.5954 91.5153 44.3823V45.3016H91.293V43.0427H91.5061V43.3688C91.6407 43.1492 91.8699 43.0303 92.1428 43.0303C92.6127 43.0297 92.9647 43.3683 92.9647 43.8672ZM92.7419 43.8672C92.7419 43.4845 92.4749 43.224 92.1267 43.224C91.7752 43.224 91.5115 43.4845 91.5115 43.8672C91.5115 44.2531 91.7752 44.5104 92.1267 44.5104C92.4749 44.5104 92.7419 44.2531 92.7419 43.8672Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.418 42.3643H93.6408V44.6921H93.418V42.3643Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M95.6966 43.9372H94.3166C94.3413 44.2822 94.6051 44.5115 94.9657 44.5115C95.1664 44.5115 95.3451 44.4394 95.4711 44.2951L95.5965 44.4393C95.449 44.6153 95.2203 44.709 94.9598 44.709C94.4452 44.709 94.0938 44.3575 94.0938 43.8678C94.0938 43.3785 94.4355 43.0303 94.9 43.0303C95.3645 43.0303 95.6998 43.372 95.6998 43.8678C95.6998 43.8871 95.6966 43.9124 95.6966 43.9372ZM94.3166 43.7709H95.4867C95.4587 43.4479 95.2235 43.2219 94.9 43.2219C94.5798 43.2219 94.3446 43.4479 94.3166 43.7709Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M97.0244 44.5904C96.9367 44.669 96.8048 44.7066 96.6762 44.7066C96.3656 44.7066 96.1934 44.5306 96.1934 44.2265V43.2287H95.8984V43.0403H96.1934V42.6797H96.4162V43.0403H96.9184V43.2287H96.4162V44.2136C96.4162 44.4085 96.5163 44.515 96.7015 44.515C96.7924 44.515 96.8834 44.487 96.9464 44.4305L97.0244 44.5904Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.8021 43.9372H97.422C97.4468 44.2822 97.7105 44.5115 98.0717 44.5115C98.2724 44.5115 98.4511 44.4394 98.5765 44.2951L98.7019 44.4393C98.5545 44.6153 98.3257 44.709 98.0652 44.709C97.5507 44.709 97.1992 44.3575 97.1992 43.8678C97.1992 43.3785 97.541 43.0303 98.0055 43.0303C98.47 43.0303 98.8053 43.372 98.8053 43.8678C98.8053 43.8871 98.8021 43.9124 98.8021 43.9372ZM97.4215 43.7709H98.5916C98.5636 43.4479 98.3284 43.2219 98.0049 43.2219C97.6852 43.2219 97.45 43.4479 97.4215 43.7709Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M179.354 48.2753H83.6088C83.1153 48.2753 82.7148 47.8749 82.7148 47.3813C82.7148 46.8878 83.1153 46.4873 83.6088 46.4873H179.354C179.848 46.4873 180.248 46.8878 180.248 47.3813C180.249 47.8749 179.848 48.2753 179.354 48.2753Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.202 45.775C185.257 45.8299 184.675 46.5 183.903 47.2724C183.131 48.0447 182.461 48.626 182.406 48.5716C182.351 48.5167 182.933 47.8466 183.705 47.0743C184.477 46.3019 185.147 45.7206 185.202 45.775Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.14 48.5712C185.085 48.6261 184.415 48.0442 183.643 47.2724C182.87 46.5001 182.289 45.83 182.343 45.7751C182.398 45.7202 183.068 46.302 183.841 47.0743C184.613 47.8456 185.194 48.5163 185.14 48.5712Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M171.486 44.0598C171.486 44.4269 171.219 44.7095 170.689 44.7095C170.372 44.7095 170.068 44.5997 169.898 44.4269L170.008 44.2482C170.149 44.3957 170.403 44.5023 170.689 44.5023C171.053 44.5023 171.254 44.3327 171.254 44.0598C171.254 43.7961 171.069 43.6239 170.661 43.6239H170.504V43.4576L171.113 42.6949H169.989V42.4941H171.401V42.654L170.78 43.435C171.25 43.4608 171.486 43.7084 171.486 44.0598Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M175.097 42.4941V44.6901H174.875V42.9333L174.012 44.4113H173.902L173.039 42.943V44.6906H172.816V42.4947H173.008L173.962 44.1228L174.906 42.4947L175.097 42.4941Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M177.644 44.1034C177.644 44.4764 177.368 44.6901 176.819 44.6901H175.809V42.4941H176.756C177.246 42.4941 177.528 42.7014 177.528 43.0587C177.528 43.3096 177.394 43.4759 177.193 43.5577C177.475 43.6201 177.644 43.8058 177.644 44.1034ZM176.041 42.6858V43.4823H176.741C177.092 43.4823 177.296 43.3472 177.296 43.084C177.296 42.8203 177.092 42.6858 176.741 42.6858H176.041ZM177.412 44.0846C177.412 43.7993 177.202 43.6734 176.816 43.6734H176.042V44.4985H176.816C177.202 44.499 177.412 44.3731 177.412 44.0846Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M76.585 70.9949H68.2602C67.6849 70.9949 67.2188 70.5288 67.2188 69.9535V58.4311C67.2188 57.8558 67.6849 57.3896 68.2602 57.3896H73.5397L77.6264 61.6018V69.9535C77.6264 70.5288 77.1603 70.9949 76.585 70.9949Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M73.5391 57.3896V60.6325C73.5391 61.1675 73.9729 61.6013 74.5079 61.6013L77.6258 61.6018L73.5391 57.3896Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5862 60.9209C73.5862 60.9209 73.5453 61.7072 74.4404 61.9661C74.4743 61.9758 74.5087 61.9828 74.5432 61.9893C74.9501 62.0619 77.6304 62.5388 77.6304 62.4774C77.6304 62.4107 77.6304 61.6061 77.6304 61.6061H74.5125C74.5125 61.6061 73.7337 61.5791 73.5862 60.9209Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5391 57.3896V60.6325C73.5391 61.1675 73.9729 61.6013 74.5079 61.6013L77.6258 61.6018L73.5391 57.3896Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M72.8437 60.5119C72.8437 60.5533 71.9815 60.5872 70.918 60.5872C69.8544 60.5872 68.9922 60.5533 68.9922 60.5119C68.9922 60.4704 69.8544 60.4365 70.918 60.4365C71.9815 60.436 72.8437 60.4699 72.8437 60.5119Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.3309 62.341C75.3309 62.3824 73.9121 62.4163 72.1618 62.4163C70.4109 62.4163 68.9922 62.3824 68.9922 62.341C68.9922 62.2995 70.4109 62.2656 72.1618 62.2656C73.9121 62.2656 75.3309 62.2995 75.3309 62.341Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 63.8722C75.9014 63.9137 74.3545 63.9476 72.4471 63.9476C70.5385 63.9476 68.9922 63.9137 68.9922 63.8722C68.9922 63.8308 70.5385 63.7969 72.4471 63.7969C74.3545 63.7969 75.9014 63.8308 75.9014 63.8722Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 65.3117C75.9014 65.3531 74.3545 65.387 72.4471 65.387C70.5385 65.387 68.9922 65.3531 68.9922 65.3117C68.9922 65.2702 70.5385 65.2363 72.4471 65.2363C74.3545 65.2358 75.9014 65.2697 75.9014 65.3117Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 66.7619C75.9014 66.8033 74.3545 66.8372 72.4471 66.8372C70.5385 66.8372 68.9922 66.8033 68.9922 66.7619C68.9922 66.7204 70.5385 66.6865 72.4471 66.6865C74.3545 66.6865 75.9014 66.7204 75.9014 66.7619Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 68.2013C75.9014 68.2428 74.3545 68.2767 72.4471 68.2767C70.5385 68.2767 68.9922 68.2428 68.9922 68.2013C68.9922 68.1599 70.5385 68.126 72.4471 68.126C74.3545 68.126 75.9014 68.1599 75.9014 68.2013Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M84.7039 58.8432C84.8805 58.8432 85.0527 58.8798 85.1679 58.9622L85.0242 59.3481C84.9461 59.2948 84.8476 59.2576 84.7411 59.2576C84.5274 59.2576 84.4171 59.3766 84.4171 59.6107V59.7421H85.0204V60.1527H84.4332V61.9186H83.9197V60.1527H83.5586V59.7421H83.9197V59.6021C83.9197 59.143 84.1948 58.8432 84.7039 58.8432ZM85.6238 59.0569C85.6238 58.8847 85.7632 58.749 85.9521 58.749C86.141 58.749 86.2804 58.8766 86.2804 59.045C86.2804 59.2253 86.1453 59.3653 85.9521 59.3653C85.7632 59.3647 85.6238 59.2297 85.6238 59.0569ZM85.6937 59.7264H86.2072V61.9192H85.6937V59.7264Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M86.8828 58.8711H87.3963V61.918H86.8828V58.8711Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.1214 60.9869H88.4007C88.4621 61.3071 88.729 61.5127 89.1112 61.5127C89.3577 61.5127 89.5504 61.4347 89.7065 61.2748L89.9815 61.5908C89.7845 61.8249 89.4766 61.9476 89.0983 61.9476C88.3631 61.9476 87.8867 61.4756 87.8867 60.8227C87.8867 60.1699 88.3674 59.7021 89.0197 59.7021C89.6602 59.7021 90.1284 60.1494 90.1284 60.8351C90.1295 60.876 90.1252 60.9379 90.1214 60.9869ZM88.3964 60.6462H89.6408C89.5994 60.3303 89.3572 60.1123 89.0208 60.1123C88.6881 60.1123 88.4459 60.3254 88.3964 60.6462Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M92.7854 60.6629V61.9196H92.272V60.7291C92.272 60.3389 92.0793 60.15 91.7504 60.15C91.385 60.15 91.1385 60.3717 91.1385 60.8109V61.9196H90.625V59.7269H91.1137V60.01C91.2822 59.8087 91.5491 59.7021 91.8694 59.7021C92.3958 59.7021 92.7854 60.0019 92.7854 60.6629Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M95.2766 60.6338V61.9191H94.7922V61.6521C94.6689 61.8411 94.431 61.9476 94.1022 61.9476C93.6011 61.9476 93.2852 61.6726 93.2852 61.2905C93.2852 60.925 93.5317 60.6376 94.1964 60.6376H94.7631V60.6048C94.7631 60.305 94.5828 60.1284 94.2168 60.1284C93.9703 60.1284 93.7157 60.2108 93.5516 60.3464L93.3508 59.9729C93.5844 59.792 93.9256 59.7021 94.2787 59.7021C94.9106 59.7016 95.2766 60.0014 95.2766 60.6338ZM94.7631 61.2334V60.9788H94.2335C93.8847 60.9788 93.79 61.1101 93.79 61.2705C93.79 61.4552 93.9461 61.5741 94.2088 61.5741C94.459 61.5741 94.6765 61.4589 94.7631 61.2334Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M99.6016 60.6623V61.9191H99.0881V60.7285C99.0881 60.3383 98.9078 60.1494 98.5951 60.1494C98.2587 60.1494 98.0241 60.3712 98.0241 60.8066V61.9191H97.5106V60.7285C97.5106 60.3383 97.3303 60.1494 97.0181 60.1494C96.6774 60.1494 96.4471 60.3712 96.4471 60.8066V61.9191H95.9336V59.7264H96.4223V60.0057C96.5865 59.8087 96.841 59.7021 97.1408 59.7021C97.4611 59.7021 97.728 59.8211 97.8798 60.0676C98.0564 59.8421 98.3524 59.7021 98.7012 59.7021C99.2324 59.7016 99.6016 60.0014 99.6016 60.6623Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M102.335 60.9869H100.614C100.676 61.3071 100.943 61.5127 101.325 61.5127C101.571 61.5127 101.764 61.4347 101.921 61.2748L102.196 61.5908C101.999 61.8249 101.69 61.9476 101.313 61.9476C100.577 61.9476 100.102 61.4756 100.102 60.8227C100.102 60.1699 100.582 59.7021 101.235 59.7021C101.875 59.7021 102.343 60.1494 102.343 60.8351C102.343 60.876 102.34 60.9379 102.335 60.9869ZM100.611 60.6462H101.855C101.814 60.3303 101.571 60.1123 101.235 60.1123C100.902 60.1123 100.66 60.3254 100.611 60.6462Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M83.8711 64.2002H84.1031V66.1954H85.3329V66.3962H83.8711V64.2002Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M85.4766 65.5728C85.4766 65.0836 85.8345 64.7354 86.3173 64.7354C86.8006 64.7354 87.1553 65.0836 87.1553 65.5728C87.1553 66.0626 86.8006 66.4141 86.3173 66.4141C85.8345 66.4141 85.4766 66.0626 85.4766 65.5728ZM86.9292 65.5728C86.9292 65.1869 86.6687 64.9296 86.3173 64.9296C85.9658 64.9296 85.7026 65.1869 85.7026 65.5728C85.7026 65.9587 85.9658 66.216 86.3173 66.216C86.6687 66.216 86.9292 65.9593 86.9292 65.5728Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M88.8442 65.3758V66.3985H88.631V66.1412C88.5304 66.3107 88.3361 66.4141 88.0632 66.4141C87.6897 66.4141 87.4609 66.2198 87.4609 65.934C87.4609 65.6799 87.624 65.4668 88.0977 65.4668H88.6214V65.3667C88.6214 65.0841 88.4615 64.9302 88.1542 64.9302C87.941 64.9302 87.7397 65.0055 87.6052 65.1245L87.5045 64.9582C87.6709 64.8172 87.9152 64.7354 88.1757 64.7354C88.6031 64.7359 88.8442 64.9496 88.8442 65.3758ZM88.6214 65.9033V65.6337H88.1041C87.7839 65.6337 87.6805 65.7591 87.6805 65.9286C87.6805 66.1202 87.8345 66.2392 88.0977 66.2392C88.349 66.2386 88.5336 66.1197 88.6214 65.9033Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.9608 64.0693V66.3972H90.7477V66.071C90.6126 66.2938 90.3838 66.4133 90.1109 66.4133C89.6405 66.4133 89.2891 66.071 89.2891 65.5721C89.2891 65.0731 89.6405 64.7346 90.1109 64.7346C90.3747 64.7346 90.6002 64.8476 90.7385 65.0608V64.0693H90.9608ZM90.7412 65.5721C90.7412 65.1862 90.4775 64.9289 90.1292 64.9289C89.7778 64.9289 89.5146 65.1862 89.5146 65.5721C89.5146 65.958 89.7778 66.2152 90.1292 66.2152C90.4775 66.2152 90.7412 65.9585 90.7412 65.5721Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M91.5312 64.2265C91.5312 64.142 91.6034 64.0693 91.6943 64.0693C91.7853 64.0693 91.8574 64.1388 91.8574 64.2233C91.8574 64.3142 91.7885 64.3864 91.6943 64.3864C91.6034 64.3864 91.5312 64.3142 91.5312 64.2265ZM91.5813 64.7475H91.8041V66.3977H91.5813V64.7475Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.9402 65.442V66.399H93.7174V65.4641C93.7174 65.1159 93.5355 64.9367 93.2217 64.9367C92.867 64.9367 92.6442 65.1562 92.6442 65.5325V66.3985H92.4219V64.7483H92.635V65.0524C92.754 64.8516 92.9768 64.7354 93.2626 64.7354C93.6641 64.7359 93.9402 64.9679 93.9402 65.442Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M96.0771 64.7477V66.1972C96.0771 66.765 95.7983 67.0223 95.2521 67.0223C94.9512 67.0223 94.6562 66.9313 94.4835 66.7677L94.5965 66.5987C94.7531 66.7402 94.9915 66.8247 95.2456 66.8247C95.6627 66.8247 95.8543 66.6337 95.8543 66.2252V66.0153C95.7165 66.2252 95.4808 66.3355 95.2111 66.3355C94.7402 66.3355 94.3828 66.0061 94.3828 65.5319C94.3828 65.0583 94.7407 64.7354 95.2111 64.7354C95.4873 64.7354 95.7251 64.8484 95.8635 65.0647V64.7477H96.0771ZM95.8608 65.5319C95.8608 65.174 95.5971 64.9297 95.2332 64.9297C94.8694 64.9297 94.6089 65.1745 94.6089 65.5319C94.6089 65.8899 94.8688 66.1374 95.2332 66.1374C95.5971 66.1374 95.8608 65.8893 95.8608 65.5319Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M97.3789 66.2418C97.3789 66.1444 97.4543 66.0723 97.5452 66.0723C97.6362 66.0723 97.7148 66.1444 97.7148 66.2418C97.7148 66.3392 97.6367 66.4146 97.5452 66.4146C97.4543 66.4146 97.3789 66.3392 97.3789 66.2418Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.043 66.2418C98.043 66.1444 98.1183 66.0723 98.2093 66.0723C98.3002 66.0723 98.3788 66.1444 98.3788 66.2418C98.3788 66.3392 98.3002 66.4146 98.2093 66.4146C98.1183 66.4146 98.043 66.3392 98.043 66.2418Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.707 66.2418C98.707 66.1444 98.7824 66.0723 98.8733 66.0723C98.9643 66.0723 99.0429 66.1444 99.0429 66.2418C99.0429 66.3392 98.9648 66.4146 98.8733 66.4146C98.7824 66.4146 98.707 66.3392 98.707 66.2418Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M179.354 69.9823H83.6088C83.1153 69.9823 82.7148 69.5819 82.7148 69.0883C82.7148 68.5948 83.1153 68.1943 83.6088 68.1943H179.354C179.848 68.1943 180.248 68.5948 180.248 69.0883C180.249 69.5819 179.848 69.9823 179.354 69.9823Z",
                fill: "#C0C9D2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M139.555 69.9823H83.6088C83.1153 69.9823 82.7148 69.5819 82.7148 69.0883C82.7148 68.5948 83.1153 68.1943 83.6088 68.1943H139.555C140.048 68.1943 140.449 68.5948 140.449 69.0883C140.449 69.5819 140.049 69.9823 139.555 69.9823Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.202 67.4889C185.257 67.5438 184.675 68.2139 183.903 68.9863C183.131 69.7586 182.461 70.3399 182.406 70.2856C182.351 70.2307 182.933 69.5606 183.705 68.7882C184.477 68.0159 185.147 67.434 185.202 67.4889Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.14 70.285C185.085 70.3399 184.415 69.7581 183.643 68.9863C182.87 68.2139 182.289 67.5438 182.343 67.4889C182.398 67.434 183.068 68.0159 183.841 68.7882C184.613 69.5595 185.194 70.2301 185.14 70.285Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M171.532 66.1952V66.3959H169.992V66.236L170.905 65.3421C171.152 65.0972 171.2 64.9502 171.2 64.7995C171.2 64.5455 171.021 64.3883 170.685 64.3883C170.427 64.3883 170.23 64.4669 170.086 64.6332L169.926 64.4954C170.095 64.2947 170.368 64.1816 170.704 64.1816C171.149 64.1816 171.432 64.4077 171.432 64.7748C171.432 64.9852 171.366 65.1731 171.071 65.4621L170.324 66.1962H171.532V66.1952Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M171.801 65.2985C171.801 64.5988 172.168 64.1816 172.676 64.1816C173.185 64.1816 173.555 64.5988 173.555 65.2985C173.555 65.9982 173.185 66.4153 172.676 66.4153C172.168 66.4158 171.801 65.9982 171.801 65.2985ZM173.322 65.2985C173.322 64.7118 173.059 64.3889 172.676 64.3889C172.293 64.3889 172.03 64.7123 172.03 65.2985C172.03 65.8851 172.293 66.2081 172.676 66.2081C173.059 66.2086 173.322 65.8851 173.322 65.2985Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M175.456 65.5688L175.067 65.9268V66.3972H174.844V64.0693H175.067V65.6474L176.052 64.747H176.328L175.621 65.4214L176.393 66.3972H176.12L175.456 65.5688Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M178.398 65.5721C178.398 66.071 178.047 66.4133 177.576 66.4133C177.304 66.4133 177.074 66.2938 176.94 66.071V66.3972H176.727V64.0693H176.949V65.0608C177.087 64.8476 177.313 64.7346 177.576 64.7346C178.047 64.7346 178.398 65.0737 178.398 65.5721ZM178.175 65.5721C178.175 65.1862 177.909 64.9289 177.561 64.9289C177.209 64.9289 176.946 65.1862 176.946 65.5721C176.946 65.958 177.209 66.2152 177.561 66.2152C177.909 66.2152 178.175 65.9585 178.175 65.5721Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M76.585 93.0154H68.2602C67.6849 93.0154 67.2188 92.5493 67.2188 91.974V80.4516C67.2188 79.8763 67.6849 79.4102 68.2602 79.4102H73.5397L77.6264 83.6223V91.974C77.6264 92.5488 77.1603 93.0154 76.585 93.0154Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M73.5391 79.4102V82.653C73.5391 83.188 73.9729 83.6218 74.5079 83.6218L77.6258 83.6223L73.5391 79.4102Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5862 82.9414C73.5862 82.9414 73.5453 83.7278 74.4404 83.9866C74.4743 83.9963 74.5087 84.0033 74.5432 84.0098C74.9501 84.0824 77.6304 84.5593 77.6304 84.4979C77.6304 84.4312 77.6304 83.6266 77.6304 83.6266H74.5125C74.5125 83.6266 73.7337 83.5997 73.5862 82.9414Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5391 79.4102V82.653C73.5391 83.188 73.9729 83.6218 74.5079 83.6218L77.6258 83.6223L73.5391 79.4102Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M72.8437 82.5177C72.8437 82.5592 71.9815 82.5931 70.918 82.5931C69.8544 82.5931 68.9922 82.5592 68.9922 82.5177C68.9922 82.4763 69.8544 82.4424 70.918 82.4424C71.9815 82.4424 72.8437 82.4763 72.8437 82.5177Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.3309 84.3586C75.3309 84.4 73.9121 84.4339 72.1618 84.4339C70.4109 84.4339 68.9922 84.4 68.9922 84.3586C68.9922 84.3171 70.4109 84.2832 72.1618 84.2832C73.9121 84.2832 75.3309 84.3166 75.3309 84.3586Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 85.8898C75.9014 85.9318 74.3545 85.9652 72.4471 85.9652C70.5385 85.9652 68.9922 85.9313 68.9922 85.8898C68.9922 85.8484 70.5385 85.8145 72.4471 85.8145C74.3545 85.8145 75.9014 85.8484 75.9014 85.8898Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 87.3292C75.9014 87.3707 74.3545 87.4046 72.4471 87.4046C70.5385 87.4046 68.9922 87.3707 68.9922 87.3292C68.9922 87.2878 70.5385 87.2539 72.4471 87.2539C74.3545 87.2539 75.9014 87.2878 75.9014 87.3292Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 88.7677C75.9014 88.8092 74.3545 88.8431 72.4471 88.8431C70.5385 88.8431 68.9922 88.8092 68.9922 88.7677C68.9922 88.7263 70.5385 88.6924 72.4471 88.6924C74.3545 88.6924 75.9014 88.7263 75.9014 88.7677Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 90.2199C75.9014 90.2613 74.3545 90.2952 72.4471 90.2952C70.5385 90.2952 68.9922 90.2613 68.9922 90.2199C68.9922 90.1784 70.5385 90.1445 72.4471 90.1445C74.3545 90.1445 75.9014 90.1784 75.9014 90.2199Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M84.7039 80.853C84.8805 80.853 85.0527 80.8901 85.1679 80.9725L85.0242 81.3584C84.9461 81.3051 84.8476 81.2685 84.7411 81.2685C84.5274 81.2685 84.4171 81.3874 84.4171 81.621V81.7524H85.0204V82.1636H84.4332V83.9289H83.9197V82.1636H83.5586V81.7524H83.9197V81.613C83.9197 81.1528 84.1948 80.853 84.7039 80.853ZM85.6238 81.0666C85.6238 80.8944 85.7632 80.7588 85.9521 80.7588C86.141 80.7588 86.2804 80.8858 86.2804 81.0543C86.2804 81.2351 86.1453 81.3751 85.9521 81.3751C85.7632 81.3745 85.6238 81.2389 85.6238 81.0666ZM85.6937 81.7357H86.2072V83.9284H85.6937V81.7357Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M86.8828 80.8809H87.3963V83.9278H86.8828V80.8809Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.1214 82.9972H88.4007C88.4621 83.3174 88.729 83.523 89.1112 83.523C89.3577 83.523 89.5504 83.4445 89.7065 83.2846L89.9815 83.6011C89.7845 83.8352 89.4766 83.9585 89.0983 83.9585C88.3631 83.9585 87.8867 83.4859 87.8867 82.833C87.8867 82.1802 88.3674 81.7119 89.0197 81.7119C89.6602 81.7119 90.1284 82.1597 90.1284 82.8454C90.1295 82.8863 90.1252 82.9477 90.1214 82.9972ZM88.3964 82.656H89.6408C89.5994 82.34 89.3572 82.122 89.0208 82.122C88.6881 82.122 88.4459 82.3357 88.3964 82.656Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M92.7854 82.6721V83.9289H92.272V82.7378C92.272 82.3476 92.0793 82.1592 91.7504 82.1592C91.385 82.1592 91.1385 82.3809 91.1385 82.8207V83.9294H90.625V81.7367H91.1137V82.0198C91.2822 81.8185 91.5491 81.7119 91.8694 81.7119C92.3958 81.7114 92.7854 82.0117 92.7854 82.6721Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M95.2766 82.6447V83.9299H94.7922V83.663C94.6689 83.8524 94.431 83.959 94.1022 83.959C93.6011 83.959 93.2852 83.6834 93.2852 83.3018C93.2852 82.9358 93.5317 82.6484 94.1964 82.6484H94.7631V82.6156C94.7631 82.3158 94.5828 82.1393 94.2168 82.1393C93.9703 82.1393 93.7157 82.2211 93.5516 82.3567L93.3508 81.9832C93.5844 81.8023 93.9256 81.7119 94.2787 81.7119C94.9106 81.7119 95.2766 82.0122 95.2766 82.6447ZM94.7631 83.2437V82.9891H94.2335C93.8847 82.9891 93.79 83.1204 93.79 83.2808C93.79 83.4655 93.9461 83.5844 94.2088 83.5844C94.459 83.5849 94.6765 83.4698 94.7631 83.2437Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M99.6016 82.6726V83.9294H99.0881V82.7383C99.0881 82.3481 98.9078 82.1597 98.5951 82.1597C98.2587 82.1597 98.0241 82.3815 98.0241 82.8169V83.9294H97.5106V82.7383C97.5106 82.3481 97.3303 82.1597 97.0181 82.1597C96.6774 82.1597 96.4471 82.3815 96.4471 82.8169V83.9294H95.9336V81.7367H96.4223V82.0155C96.5865 81.8185 96.841 81.7119 97.1408 81.7119C97.4611 81.7119 97.728 81.8314 97.8798 82.0779C98.0564 81.8519 98.3524 81.7119 98.7012 81.7119C99.2324 81.7119 99.6016 82.0122 99.6016 82.6726Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M102.335 82.9972H100.614C100.676 83.3174 100.943 83.523 101.325 83.523C101.571 83.523 101.764 83.4445 101.921 83.2846L102.196 83.6011C101.999 83.8352 101.69 83.9585 101.313 83.9585C100.577 83.9585 100.102 83.4859 100.102 82.833C100.102 82.1802 100.582 81.7119 101.235 81.7119C101.875 81.7119 102.343 82.1597 102.343 82.8454C102.343 82.8863 102.34 82.9477 102.335 82.9972ZM100.611 82.656H101.855C101.814 82.34 101.571 82.122 101.235 82.122C100.902 82.122 100.66 82.3357 100.611 82.656Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M83.8711 86.2148H84.1031V88.21H85.3329V88.4108H83.8711V86.2148Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M85.4766 87.5875C85.4766 87.0982 85.8345 86.75 86.3173 86.75C86.8006 86.75 87.1553 87.0977 87.1553 87.5875C87.1553 88.0773 86.8006 88.4287 86.3173 88.4287C85.8345 88.4287 85.4766 88.0773 85.4766 87.5875ZM86.9292 87.5875C86.9292 87.2016 86.6687 86.9448 86.3173 86.9448C85.9658 86.9448 85.7026 87.2021 85.7026 87.5875C85.7026 87.9728 85.9658 88.2307 86.3173 88.2307C86.6687 88.2312 86.9292 87.9734 86.9292 87.5875Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M88.8442 87.391V88.4137H88.631V88.1564C88.5304 88.3254 88.3361 88.4293 88.0632 88.4293C87.6897 88.4293 87.4609 88.235 87.4609 87.9492C87.4609 87.6946 87.624 87.4814 88.0977 87.4814H88.6214V87.3808C88.6214 87.0988 88.4615 86.9448 88.1542 86.9448C87.941 86.9448 87.7397 87.0202 87.6052 87.1391L87.5045 86.9723C87.6709 86.8313 87.9152 86.75 88.1757 86.75C88.6031 86.7516 88.8442 86.9642 88.8442 87.391ZM88.6214 87.9185V87.6488H88.1041C87.7839 87.6488 87.6805 87.7737 87.6805 87.9438C87.6805 88.1348 87.8345 88.2543 88.0977 88.2543C88.349 88.2543 88.5336 88.1349 88.6214 87.9185Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.9608 86.0845V88.4124H90.7477V88.0862C90.6126 88.309 90.3838 88.4285 90.1109 88.4285C89.6405 88.4285 89.2891 88.0862 89.2891 87.5872C89.2891 87.0883 89.6405 86.7498 90.1109 86.7498C90.3747 86.7498 90.6002 86.8623 90.7385 87.0754V86.084H90.9608V86.0845ZM90.7412 87.5872C90.7412 87.2013 90.4775 86.9446 90.1292 86.9446C89.7778 86.9446 89.5146 87.2019 89.5146 87.5872C89.5146 87.9726 89.7778 88.2304 90.1292 88.2304C90.4775 88.231 90.7412 87.9732 90.7412 87.5872Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M91.5312 86.2411C91.5312 86.1561 91.6034 86.084 91.6943 86.084C91.7853 86.084 91.8574 86.1529 91.8574 86.2379C91.8574 86.3289 91.7885 86.401 91.6943 86.401C91.6034 86.401 91.5312 86.3289 91.5312 86.2411ZM91.5813 86.7616H91.8041V88.4118H91.5813V86.7616Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.9402 87.4562V88.4126H93.7174V87.4777C93.7174 87.13 93.5355 86.9513 93.2217 86.9513C92.867 86.9513 92.6442 87.1704 92.6442 87.5471V88.4126H92.4219V86.7624H92.635V87.0665C92.754 86.8657 92.9768 86.75 93.2626 86.75C93.6641 86.7505 93.9402 86.982 93.9402 87.4562Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M96.0771 86.7624V88.2118C96.0771 88.7797 95.7983 89.0369 95.2521 89.0369C94.9512 89.0369 94.6562 88.946 94.4835 88.7823L94.5965 88.6128C94.7531 88.7544 94.9915 88.8389 95.2456 88.8389C95.6627 88.8389 95.8543 88.6478 95.8543 88.2398V88.0294C95.7165 88.2398 95.4808 88.3496 95.2111 88.3496C94.7402 88.3496 94.3828 88.0202 94.3828 87.5466C94.3828 87.0724 94.7407 86.75 95.2111 86.75C95.4873 86.75 95.7251 86.8625 95.8635 87.0789V86.7618H96.0771V86.7624ZM95.8608 87.5471C95.8608 87.1892 95.5971 86.9448 95.2332 86.9448C94.8694 86.9448 94.6089 87.1892 94.6089 87.5471C94.6089 87.9045 94.8688 88.1526 95.2332 88.1526C95.5971 88.1526 95.8608 87.9045 95.8608 87.5471Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M97.3789 88.2565C97.3789 88.159 97.4543 88.0869 97.5452 88.0869C97.6362 88.0869 97.7148 88.1596 97.7148 88.2565C97.7148 88.3539 97.6367 88.4287 97.5452 88.4287C97.4543 88.4292 97.3789 88.3539 97.3789 88.2565Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.043 88.2565C98.043 88.159 98.1183 88.0869 98.2093 88.0869C98.3002 88.0869 98.3788 88.1596 98.3788 88.2565C98.3788 88.3539 98.3002 88.4287 98.2093 88.4287C98.1183 88.4292 98.043 88.3539 98.043 88.2565Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.707 88.2565C98.707 88.159 98.7824 88.0869 98.8733 88.0869C98.9643 88.0869 99.0429 88.1596 99.0429 88.2565C99.0429 88.3539 98.9648 88.4287 98.8733 88.4287C98.7824 88.4292 98.707 88.3539 98.707 88.2565Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M179.354 91.995H83.6088C83.1153 91.995 82.7148 91.5946 82.7148 91.101C82.7148 90.6075 83.1153 90.207 83.6088 90.207H179.354C179.848 90.207 180.248 90.6075 180.248 91.101C180.249 91.5946 179.848 91.995 179.354 91.995Z",
                fill: "#C0C9D2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M104.842 91.995H83.6088C83.1153 91.995 82.7148 91.5946 82.7148 91.101C82.7148 90.6075 83.1153 90.207 83.6088 90.207H104.842C105.336 90.207 105.736 90.6075 105.736 91.101C105.736 91.5946 105.336 91.995 104.842 91.995Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.202 89.4928C185.257 89.5477 184.675 90.2178 183.903 90.9902C183.131 91.7626 182.461 92.3438 182.406 92.2895C182.351 92.2346 182.933 91.5645 183.705 90.7921C184.477 90.0198 185.147 89.4379 185.202 89.4928Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.14 92.2889C185.085 92.3438 184.415 91.762 183.643 90.9902C182.87 90.2178 182.289 89.5477 182.343 89.4928C182.398 89.4379 183.068 90.0198 183.841 90.7921C184.613 91.5639 185.194 92.2346 185.14 92.2889Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M171.486 87.78C171.486 88.1476 171.219 88.4296 170.689 88.4296C170.372 88.4296 170.068 88.3198 169.898 88.1476L170.008 87.9684C170.149 88.1159 170.403 88.223 170.689 88.223C171.053 88.223 171.254 88.054 171.254 87.7805C171.254 87.5173 171.069 87.3446 170.661 87.3446H170.504V87.1777L171.113 86.4156H169.989V86.2148H171.401V86.3747L170.78 87.1557C171.25 87.1804 171.486 87.4285 171.486 87.78Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M173.286 88.2109V88.4116H171.746V88.2518L172.659 87.3572C172.906 87.1129 172.954 86.9654 172.954 86.8147C172.954 86.5601 172.775 86.4035 172.439 86.4035C172.182 86.4035 171.984 86.4821 171.84 86.6484L171.68 86.5101C171.849 86.3093 172.122 86.1963 172.458 86.1963C172.903 86.1963 173.186 86.4224 173.186 86.7894C173.186 86.9999 173.12 87.1877 172.825 87.4762L172.078 88.2103H173.286V88.2109Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M176.86 86.2148V88.4108H176.637V86.654L175.774 88.1315H175.664L174.801 86.6632V88.4108H174.578V86.2148H174.77L175.723 87.843L176.668 86.2148H176.86Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M179.41 87.8241C179.41 88.1971 179.133 88.4108 178.584 88.4108H177.574V86.2148H178.522C179.011 86.2148 179.294 86.4221 179.294 86.7794C179.294 87.0308 179.159 87.1966 178.959 87.2784C179.24 87.3408 179.41 87.526 179.41 87.8241ZM177.806 86.4059V87.2025H178.506C178.857 87.2025 179.061 87.0674 179.061 86.8042C179.061 86.541 178.857 86.4059 178.506 86.4059H177.806ZM179.177 87.8053C179.177 87.52 178.967 87.3941 178.581 87.3941H177.807V88.2192H178.581C178.967 88.2192 179.177 88.0938 179.177 87.8053Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M76.585 115.034H68.2602C67.6849 115.034 67.2188 114.568 67.2188 113.993V102.47C67.2188 101.895 67.6849 101.429 68.2602 101.429H73.5397L77.6264 105.641V113.993C77.6264 114.568 77.1603 115.034 76.585 115.034Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M73.5391 101.429V104.672C73.5391 105.207 73.9729 105.64 74.5079 105.64L77.6258 105.641L73.5391 101.429Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.2",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5862 104.944C73.5862 104.944 73.5453 105.731 74.4404 105.99C74.4743 105.999 74.5087 106.006 74.5432 106.013C74.9501 106.085 77.6304 106.562 77.6304 106.501C77.6304 106.434 77.6304 105.63 77.6304 105.63H74.5125C74.5125 105.63 73.7337 105.602 73.5862 104.944Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M73.5391 101.429V104.672C73.5391 105.207 73.9729 105.64 74.5079 105.64L77.6258 105.641L73.5391 101.429Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M72.8437 104.533C72.8437 104.575 71.9815 104.609 70.918 104.609C69.8544 104.609 68.9922 104.575 68.9922 104.533C68.9922 104.492 69.8544 104.458 70.918 104.458C71.9815 104.458 72.8437 104.492 72.8437 104.533Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.3309 106.362C75.3309 106.404 73.9121 106.438 72.1618 106.438C70.4109 106.438 68.9922 106.404 68.9922 106.362C68.9922 106.321 70.4109 106.287 72.1618 106.287C73.9121 106.287 75.3309 106.32 75.3309 106.362Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 107.894C75.9014 107.936 74.3545 107.969 72.4471 107.969C70.5385 107.969 68.9922 107.935 68.9922 107.894C68.9922 107.852 70.5385 107.818 72.4471 107.818C74.3545 107.818 75.9014 107.852 75.9014 107.894Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 109.345C75.9014 109.386 74.3545 109.42 72.4471 109.42C70.5385 109.42 68.9922 109.386 68.9922 109.345C68.9922 109.303 70.5385 109.27 72.4471 109.27C74.3545 109.27 75.9014 109.303 75.9014 109.345Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 110.784C75.9014 110.826 74.3545 110.86 72.4471 110.86C70.5385 110.86 68.9922 110.826 68.9922 110.784C68.9922 110.743 70.5385 110.709 72.4471 110.709C74.3545 110.709 75.9014 110.743 75.9014 110.784Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.9014 112.236C75.9014 112.277 74.3545 112.311 72.4471 112.311C70.5385 112.311 68.9922 112.277 68.9922 112.236C68.9922 112.194 70.5385 112.16 72.4471 112.16C74.3545 112.16 75.9014 112.194 75.9014 112.236Z",
                fill: "#FAFAFA"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M84.7039 102.864C84.8805 102.864 85.0527 102.901 85.1679 102.984L85.0242 103.37C84.9461 103.316 84.8476 103.28 84.7411 103.28C84.5274 103.28 84.4171 103.399 84.4171 103.632V103.764H85.0204V104.175H84.4332V105.94H83.9197V104.175H83.5586V103.764H83.9197V103.624C83.9197 103.164 84.1948 102.864 84.7039 102.864ZM85.6238 103.078C85.6238 102.906 85.7632 102.771 85.9521 102.771C86.141 102.771 86.2804 102.898 86.2804 103.066C86.2804 103.247 86.1453 103.387 85.9521 103.387C85.7632 103.386 85.6238 103.251 85.6238 103.078ZM85.6937 103.747H86.2072V105.94H85.6937V103.747Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M86.8828 102.893H87.3963V105.939H86.8828V102.893Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.1253 105.009H88.4046C88.466 105.329 88.733 105.535 89.1151 105.535C89.3616 105.535 89.5543 105.456 89.7104 105.296L89.9854 105.613C89.7884 105.847 89.4805 105.97 89.1022 105.97C88.367 105.97 87.8906 105.498 87.8906 104.845C87.8906 104.192 88.3713 103.724 89.0236 103.724C89.6641 103.724 90.1323 104.171 90.1323 104.858C90.1334 104.898 90.1291 104.959 90.1253 105.009ZM88.4003 104.668H89.6447C89.6033 104.352 89.3611 104.134 89.0247 104.134C88.692 104.134 88.4498 104.347 88.4003 104.668Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M92.7854 104.684V105.941H92.272V104.749C92.272 104.359 92.0793 104.171 91.7504 104.171C91.385 104.171 91.1385 104.393 91.1385 104.832V105.941H90.625V103.748H91.1137V104.031C91.2822 103.83 91.5491 103.724 91.8694 103.724C92.3958 103.723 92.7854 104.023 92.7854 104.684Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M95.2766 104.653V105.939H94.7922V105.672C94.6689 105.861 94.431 105.968 94.1022 105.968C93.6011 105.968 93.2852 105.692 93.2852 105.311C93.2852 104.945 93.5317 104.657 94.1964 104.657H94.7631V104.624C94.7631 104.325 94.5828 104.148 94.2168 104.148C93.9703 104.148 93.7157 104.23 93.5516 104.365L93.3508 103.992C93.5844 103.811 93.9256 103.721 94.2787 103.721C94.9106 103.721 95.2766 104.022 95.2766 104.653ZM94.7631 105.253V104.998H94.2335C93.8847 104.998 93.79 105.13 93.79 105.29C93.79 105.475 93.9461 105.594 94.2088 105.594C94.459 105.594 94.6765 105.479 94.7631 105.253Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M99.6016 104.684V105.941H99.0881V104.749C99.0881 104.359 98.9078 104.171 98.5951 104.171C98.2587 104.171 98.0241 104.393 98.0241 104.828V105.941H97.5106V104.749C97.5106 104.359 97.3303 104.171 97.0181 104.171C96.6774 104.171 96.4471 104.393 96.4471 104.828V105.941H95.9336V103.748H96.4223V104.027C96.5865 103.83 96.841 103.724 97.1408 103.724C97.4611 103.724 97.728 103.843 97.8798 104.09C98.0564 103.864 98.3524 103.724 98.7012 103.724C99.2324 103.723 99.6016 104.023 99.6016 104.684Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M102.335 105.009H100.614C100.676 105.329 100.943 105.535 101.325 105.535C101.571 105.535 101.764 105.456 101.921 105.296L102.196 105.613C101.999 105.847 101.69 105.97 101.313 105.97C100.577 105.97 100.102 105.498 100.102 104.845C100.102 104.192 100.582 103.724 101.235 103.724C101.875 103.724 102.343 104.171 102.343 104.858C102.343 104.898 102.34 104.959 102.335 105.009ZM100.611 104.668H101.855C101.814 104.352 101.571 104.134 101.235 104.134C100.902 104.134 100.66 104.347 100.611 104.668Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M83.8711 108.229H84.1031V110.224H85.3329V110.424H83.8711V108.229Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M85.4766 109.597C85.4766 109.108 85.8345 108.76 86.3173 108.76C86.8006 108.76 87.1553 109.107 87.1553 109.597C87.1553 110.086 86.8006 110.438 86.3173 110.438C85.8345 110.438 85.4766 110.086 85.4766 109.597ZM86.9292 109.597C86.9292 109.211 86.6687 108.955 86.3173 108.955C85.9658 108.955 85.7026 109.212 85.7026 109.597C85.7026 109.983 85.9658 110.24 86.3173 110.24C86.6687 110.24 86.9292 109.983 86.9292 109.597Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M88.8442 109.4V110.423H88.631V110.166C88.5304 110.335 88.3361 110.439 88.0632 110.439C87.6897 110.439 87.4609 110.244 87.4609 109.958C87.4609 109.704 87.624 109.491 88.0977 109.491H88.6214V109.391C88.6214 109.109 88.4615 108.955 88.1542 108.955C87.941 108.955 87.7397 109.03 87.6052 109.149L87.5045 108.982C87.6709 108.841 87.9152 108.76 88.1757 108.76C88.6031 108.76 88.8442 108.973 88.8442 109.4ZM88.6214 109.927V109.658H88.1041C87.7839 109.658 87.6805 109.782 87.6805 109.952C87.6805 110.144 87.8345 110.263 88.0977 110.263C88.349 110.263 88.5336 110.144 88.6214 109.927Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M90.9608 108.095V110.423H90.7477V110.096C90.6126 110.319 90.3838 110.438 90.1109 110.438C89.6405 110.438 89.2891 110.096 89.2891 109.597C89.2891 109.098 89.6405 108.76 90.1109 108.76C90.3747 108.76 90.6002 108.872 90.7385 109.085V108.094H90.9608V108.095ZM90.7412 109.598C90.7412 109.212 90.4775 108.955 90.1292 108.955C89.7778 108.955 89.5146 109.212 89.5146 109.598C89.5146 109.983 89.7778 110.241 90.1292 110.241C90.4775 110.241 90.7412 109.983 90.7412 109.598Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M91.5312 108.251C91.5312 108.166 91.6034 108.094 91.6943 108.094C91.7853 108.094 91.8574 108.163 91.8574 108.248C91.8574 108.339 91.7885 108.411 91.6943 108.411C91.6034 108.411 91.5312 108.339 91.5312 108.251ZM91.5813 108.771H91.8041V110.422H91.5813V108.771Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.9402 109.466V110.423H93.7174V109.488C93.7174 109.14 93.5355 108.961 93.2217 108.961C92.867 108.961 92.6442 109.18 92.6442 109.557V110.422H92.4219V108.772H92.635V109.076C92.754 108.875 92.9768 108.76 93.2626 108.76C93.6641 108.76 93.9402 108.992 93.9402 109.466Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M96.0771 108.772V110.222C96.0771 110.789 95.7983 111.047 95.2521 111.047C94.9512 111.047 94.6562 110.956 94.4835 110.792L94.5965 110.623C94.7531 110.764 94.9915 110.849 95.2456 110.849C95.6627 110.849 95.8543 110.658 95.8543 110.25V110.039C95.7165 110.25 95.4808 110.359 95.2111 110.359C94.7402 110.359 94.3828 110.03 94.3828 109.556C94.3828 109.082 94.7407 108.76 95.2111 108.76C95.4873 108.76 95.7251 108.872 95.8635 109.089V108.772H96.0771V108.772ZM95.8608 109.557C95.8608 109.199 95.5971 108.955 95.2332 108.955C94.8694 108.955 94.6089 109.199 94.6089 109.557C94.6089 109.914 94.8688 110.162 95.2332 110.162C95.5971 110.162 95.8608 109.914 95.8608 109.557Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M97.3789 110.266C97.3789 110.169 97.4543 110.097 97.5452 110.097C97.6362 110.097 97.7148 110.169 97.7148 110.266C97.7148 110.364 97.6367 110.438 97.5452 110.438C97.4543 110.438 97.3789 110.364 97.3789 110.266Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.043 110.266C98.043 110.169 98.1183 110.097 98.2093 110.097C98.3002 110.097 98.3788 110.169 98.3788 110.266C98.3788 110.364 98.3002 110.438 98.2093 110.438C98.1183 110.438 98.043 110.364 98.043 110.266Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M98.707 110.266C98.707 110.169 98.7824 110.097 98.8733 110.097C98.9643 110.097 99.0429 110.169 99.0429 110.266C99.0429 110.364 98.9648 110.438 98.8733 110.438C98.7824 110.438 98.707 110.364 98.707 110.266Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M179.354 114.007H83.6088C83.1153 114.007 82.7148 113.606 82.7148 113.113C82.7148 112.619 83.1153 112.219 83.6088 112.219H179.354C179.848 112.219 180.248 112.619 180.248 113.113C180.249 113.606 179.848 114.007 179.354 114.007Z",
                fill: "#C0C9D2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M165.75 114.007H83.6088C83.1153 114.007 82.7148 113.606 82.7148 113.113C82.7148 112.619 83.1153 112.219 83.6088 112.219H165.75C166.243 112.219 166.644 112.619 166.644 113.113C166.644 113.606 166.244 114.007 165.75 114.007Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.202 111.508C185.257 111.563 184.675 112.233 183.903 113.006C183.131 113.778 182.461 114.359 182.406 114.305C182.351 114.25 182.933 113.58 183.705 112.808C184.477 112.035 185.147 111.454 185.202 111.508Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M185.14 114.305C185.085 114.359 184.415 113.778 183.643 113.006C182.87 112.233 182.289 111.563 182.343 111.508C182.398 111.454 183.068 112.035 183.841 112.808C184.613 113.58 185.194 114.25 185.14 114.305Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M170.642 108.226V110.422H170.416V108.426H169.898V108.226H170.642Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M172.655 109.775C172.655 110.149 172.395 110.44 171.858 110.44C171.541 110.44 171.24 110.331 171.07 110.158L171.18 109.979C171.322 110.127 171.572 110.234 171.855 110.234C172.228 110.234 172.426 110.052 172.426 109.785C172.426 109.503 172.251 109.327 171.692 109.327H171.225L171.338 108.226H172.539V108.426H171.535L171.459 109.126H171.742C172.404 109.126 172.655 109.386 172.655 109.775Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M176.235 108.226V110.422H176.012V108.665L175.149 110.142H175.039L174.176 108.674V110.422H173.953V108.226H174.145L175.098 109.854L176.043 108.226H176.235Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M178.781 109.835C178.781 110.208 178.505 110.422 177.956 110.422H176.945V108.226H177.893C178.382 108.226 178.665 108.433 178.665 108.79C178.665 109.042 178.53 109.207 178.33 109.289C178.611 109.352 178.781 109.537 178.781 109.835ZM177.177 108.417V109.214H177.877C178.228 109.214 178.432 109.079 178.432 108.815C178.432 108.552 178.228 108.417 177.877 108.417H177.177ZM178.548 109.816C178.548 109.531 178.338 109.405 177.952 109.405H177.177V110.23H177.952C178.338 110.23 178.548 110.105 178.548 109.816Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M63.2344 12.4552V10.6543H63.687V12.4374C63.687 13.1387 64.0083 13.4558 64.5783 13.4558C65.1483 13.4558 65.4745 13.1393 65.4745 12.4374V10.6543H65.9131V12.4552C65.9131 13.374 65.411 13.8578 64.5735 13.8578C63.7414 13.8578 63.2344 13.374 63.2344 12.4552Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M69.2652 12.6222C69.2652 13.3601 68.7538 13.8482 68.0525 13.8482C67.7135 13.8482 67.4147 13.7169 67.2156 13.4591V14.6992H66.7812V11.423H67.1973V11.803C67.3916 11.536 67.6995 11.4004 68.0525 11.4004C68.7533 11.4004 69.2652 11.8891 69.2652 12.6222ZM68.826 12.6222C68.826 12.1157 68.4777 11.7804 68.0159 11.7804C67.559 11.7804 67.2107 12.1152 67.2107 12.6222C67.2107 13.1335 67.559 13.4683 68.0159 13.4683C68.4777 13.4683 68.826 13.1335 68.826 12.6222Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M69.8672 10.4629H70.3015V13.8203H69.8672V10.4629Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M70.9062 12.6222C70.9062 11.9069 71.4359 11.4004 72.1555 11.4004C72.8745 11.4004 73.3998 11.9069 73.3998 12.6222C73.3998 13.3375 72.8745 13.8482 72.1555 13.8482C71.4359 13.8482 70.9062 13.3375 70.9062 12.6222ZM72.9607 12.6222C72.9607 12.1109 72.6167 11.7804 72.1555 11.7804C71.6937 11.7804 71.3454 12.1109 71.3454 12.6222C71.3454 13.1335 71.6942 13.4683 72.1555 13.4683C72.6167 13.4683 72.9607 13.1335 72.9607 12.6222Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M75.883 12.3735V13.8213H75.4713V13.5049C75.3265 13.7218 75.0596 13.8488 74.6839 13.8488C74.1408 13.8488 73.7969 13.5592 73.7969 13.1426C73.7969 12.7583 74.0455 12.4413 74.7608 12.4413H75.4487V12.3552C75.4487 11.9887 75.2361 11.7761 74.806 11.7761C74.5208 11.7761 74.2312 11.8756 74.0455 12.0339L73.8647 11.7083C74.1134 11.5091 74.4713 11.4004 74.8556 11.4004C75.5122 11.4004 75.883 11.7174 75.883 12.3735ZM75.4487 13.0883V12.7535H74.7786C74.3491 12.7535 74.2269 12.9209 74.2269 13.1243C74.2269 13.3644 74.4261 13.5135 74.756 13.5135C75.0822 13.5135 75.34 13.3644 75.4487 13.0883Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M78.9644 10.4629V13.8203H78.5483V13.4404C78.354 13.7116 78.0462 13.8473 77.6931 13.8473C76.9918 13.8473 76.4805 13.3542 76.4805 12.6212C76.4805 11.8881 76.9918 11.3994 77.6931 11.3994C78.0322 11.3994 78.3314 11.5259 78.53 11.7842V10.4629H78.9644ZM78.5343 12.6212C78.5343 12.1099 78.1861 11.7794 77.7291 11.7794C77.2674 11.7794 76.9191 12.1099 76.9191 12.6212C76.9191 13.1325 77.2679 13.4673 77.7291 13.4673C78.1861 13.4673 78.5343 13.1325 78.5343 12.6212Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M81.8638 10.4354C82.0494 10.4354 82.2303 10.4812 82.3525 10.5759L82.2211 10.9064C82.1307 10.8386 82.0129 10.7934 81.8864 10.7934C81.6286 10.7934 81.4972 10.9381 81.4972 11.2142V11.4225H82.1937V11.7799H81.5058V13.8209H81.0715V11.7799H80.6641V11.4225H81.0715V11.2099C81.072 10.7433 81.3524 10.4354 81.8638 10.4354ZM82.8912 10.6798C82.8912 10.5216 83.0177 10.3945 83.1851 10.3945C83.3525 10.3945 83.479 10.5167 83.479 10.6706C83.479 10.8337 83.3568 10.9602 83.1851 10.9602C83.0177 10.9607 82.8912 10.8386 82.8912 10.6798ZM82.9682 11.422H83.4026V13.8203H82.9682V11.422Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M84.2305 10.4629H84.6648V13.8203H84.2305V10.4629Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M87.6496 12.7669H85.7039C85.7582 13.1878 86.0979 13.4683 86.5726 13.4683C86.853 13.4683 87.0882 13.373 87.2653 13.1787L87.5048 13.4591C87.2879 13.7126 86.9574 13.8482 86.5591 13.8482C85.7852 13.8482 85.2695 13.3369 85.2695 12.6222C85.2695 11.9117 85.7809 11.4004 86.473 11.4004C87.1657 11.4004 87.6587 11.8982 87.6587 12.6356C87.6587 12.6717 87.6539 12.7266 87.6496 12.7669ZM85.7033 12.4548H87.2421C87.1964 12.0516 86.8934 11.7669 86.4725 11.7669C86.0564 11.7669 85.7486 12.0473 85.7033 12.4548Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M87.9609 13.5678L88.1418 13.2239C88.3452 13.3687 88.6714 13.4726 88.9836 13.4726C89.3862 13.4726 89.5535 13.3504 89.5535 13.1469C89.5535 12.6082 88.0379 13.0748 88.0379 12.12C88.0379 11.69 88.4227 11.4004 89.0379 11.4004C89.3501 11.4004 89.7032 11.4817 89.9115 11.6173L89.7258 11.9612C89.5083 11.8207 89.2683 11.7712 89.0331 11.7712C88.6531 11.7712 88.4674 11.9117 88.4674 12.1017C88.4674 12.6674 89.9879 12.2056 89.9879 13.1378C89.9879 13.5721 89.5896 13.8482 88.9518 13.8482C88.5541 13.8482 88.1606 13.7261 87.9609 13.5678Z",
                fill: "#F1F5F8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M199.88 20.8353C199.88 20.9128 167.009 20.9752 126.469 20.9752C85.9154 20.9752 53.0508 20.9122 53.0508 20.8353C53.0508 20.7577 85.9154 20.6953 126.469 20.6953C167.009 20.6948 199.88 20.7577 199.88 20.8353Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M128.501 195.447C91.7241 195.447 36.8116 195.447 0.0351608 195.447C0.0351608 195.447 -1.47618 165.22 25.2247 163.205C25.2247 163.205 29.6527 137.644 59.4822 137.511C95.2511 137.352 95.693 168.488 95.693 168.488C95.693 168.488 124.974 165.724 128.501 195.447Z",
                fill: "#D5DDE6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M128.501 195.451C128.501 195.451 128.484 195.378 128.459 195.235C128.435 195.085 128.4 194.873 128.353 194.594C128.308 194.309 128.252 193.958 128.186 193.542C128.125 193.123 128.049 192.639 127.916 192.101C127.795 191.559 127.661 190.954 127.513 190.29C127.322 189.635 127.112 188.921 126.886 188.151C126.634 187.388 126.317 186.583 125.993 185.722C125.802 185.303 125.604 184.871 125.4 184.426C125.297 184.204 125.193 183.979 125.087 183.751C124.965 183.531 124.842 183.308 124.717 183.081C124.458 182.634 124.232 182.152 123.928 181.699C123.63 181.244 123.325 180.777 123.011 180.3C122.664 179.846 122.309 179.383 121.945 178.909C121.57 178.445 121.146 178.004 120.736 177.536C119.035 175.717 116.899 174.023 114.376 172.635C111.863 171.229 108.963 170.144 105.808 169.446C104.231 169.095 102.59 168.839 100.899 168.691C99.2106 168.547 97.464 168.484 95.704 168.612L95.577 168.621L95.5721 168.494C95.5022 166.736 95.2228 164.934 94.8262 163.132C94.4247 161.328 93.8816 159.516 93.1765 157.73C91.7615 154.168 89.7179 150.667 86.8879 147.698C85.4729 146.221 83.9018 144.847 82.1606 143.665C81.7311 143.361 81.2699 143.103 80.8237 142.819L80.1471 142.401L79.441 142.032C78.9668 141.79 78.5023 141.525 78.0163 141.3C77.5254 141.086 77.033 140.871 76.5394 140.656C76.0523 140.425 75.5345 140.265 75.0259 140.08C74.513 139.907 74.0092 139.699 73.4844 139.554C72.4317 139.275 71.3907 138.927 70.3057 138.735C69.7669 138.623 69.2271 138.51 68.6862 138.398C68.1393 138.318 67.5909 138.238 67.0413 138.159C65.945 137.974 64.8308 137.899 63.714 137.811C61.39 137.638 59.074 137.643 56.7892 137.74C56.2192 137.79 55.6509 137.839 55.0841 137.888L54.2348 137.962L53.3935 138.082C52.8338 138.164 52.2751 138.247 51.7186 138.329C51.1674 138.443 50.6179 138.557 50.07 138.67C47.8929 139.177 45.7577 139.799 43.7636 140.691C41.7635 141.565 39.8728 142.617 38.1354 143.836C34.6498 146.269 31.8435 149.394 29.7181 152.739C28.6508 154.413 27.7664 156.156 27.0296 157.914C26.2949 159.669 25.7083 161.456 25.3423 163.23L25.3234 163.322L25.2341 163.328C21.8217 163.581 18.5902 164.352 15.7495 165.623C12.912 166.894 10.4539 168.624 8.55124 170.641C6.62978 172.642 5.18464 174.83 4.0915 176.962C2.99513 179.098 2.24754 181.184 1.69963 183.096C0.610796 186.932 0.292166 190.066 0.137695 192.186C0.0655727 193.249 0.0429655 194.066 0.0397362 194.617C0.0348922 195.167 0.0359686 195.452 0.0359686 195.452C0.0359686 195.452 0.0101357 195.168 0.00260052 194.617C-0.00601109 194.066 0.00475168 193.248 0.0655712 192.182C0.197437 190.057 0.494538 186.914 1.56722 183.059C2.10706 181.137 2.84874 179.039 3.94241 176.887C5.0334 174.738 6.48015 172.53 8.41184 170.506C10.3242 168.467 12.8005 166.714 15.6607 165.425C18.524 164.136 21.7814 163.352 25.2158 163.091L25.1076 163.19C25.4768 161.382 26.063 159.592 26.8009 157.819C27.5399 156.048 28.4285 154.291 29.5017 152.603C31.639 149.23 34.4657 146.075 37.9804 143.617C39.7323 142.386 41.6387 141.323 43.6549 140.441C45.6657 139.54 47.8175 138.912 50.0097 138.401C50.5614 138.286 51.1152 138.171 51.6701 138.056C52.2304 137.973 52.7929 137.89 53.3564 137.807L54.2036 137.685L55.0577 137.611C55.6283 137.561 56.1998 137.512 56.7731 137.462C59.0718 137.364 61.398 137.358 63.7345 137.532C64.8572 137.621 65.9773 137.696 67.0806 137.882C67.6334 137.963 68.1851 138.043 68.7357 138.123C69.2804 138.237 69.824 138.35 70.3659 138.463C71.458 138.656 72.5076 139.007 73.5673 139.288C74.0959 139.435 74.6034 139.645 75.1206 139.819C75.633 140.006 76.1546 140.167 76.646 140.4C77.1438 140.618 77.6401 140.834 78.1352 141.05C78.6256 141.277 79.0938 141.545 79.5723 141.789L80.2849 142.162L80.9674 142.584C81.4173 142.871 81.8829 143.132 82.3156 143.439C84.0724 144.633 85.658 146.021 87.0849 147.513C89.9391 150.513 91.9967 154.046 93.4171 157.637C94.1249 159.437 94.669 161.263 95.0711 163.079C95.4677 164.897 95.746 166.7 95.8144 168.491L95.6825 168.372C97.4726 168.246 99.2192 168.313 100.921 168.461C102.621 168.614 104.271 168.874 105.858 169.231C109.029 169.94 111.947 171.04 114.473 172.463C117.01 173.868 119.156 175.581 120.862 177.419C121.273 177.893 121.697 178.338 122.073 178.807C122.437 179.285 122.792 179.753 123.14 180.211C123.453 180.692 123.757 181.163 124.056 181.622C124.359 182.078 124.585 182.564 124.842 183.015C124.967 183.244 125.09 183.469 125.211 183.69C125.316 183.92 125.419 184.147 125.522 184.37C125.724 184.818 125.92 185.253 126.11 185.674C126.43 186.541 126.742 187.351 126.991 188.118C127.211 188.893 127.416 189.61 127.603 190.267C127.745 190.935 127.874 191.542 127.99 192.086C128.117 192.628 128.187 193.113 128.242 193.533C128.302 193.951 128.351 194.303 128.392 194.589C128.429 194.869 128.458 195.082 128.479 195.233C128.497 195.377 128.501 195.451 128.501 195.451Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M57.918 108.441L57.9174 108.44V108.441L33.8867 130.214H48.3973V161.027H57.3727H58.4626H67.4381V130.214H81.9492L57.918 108.441Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M40.8655 150.508C49.3081 148.383 54.7974 150.767 58.6958 156.231C62.0382 150.481 69.7461 148.902 75.918 151.381L79.8007 166.086L56.1618 169.18L36.4062 165.555L40.8655 150.508Z",
                fill: "#D5DDE6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M74.0477 150.908C74.037 150.937 73.5805 150.748 72.7275 150.516C71.8754 150.282 70.5896 150.086 69.0062 150.186C68.2134 150.227 67.356 150.39 66.4512 150.62C65.5626 150.903 64.6105 151.228 63.6982 151.759C61.8548 152.762 60.0743 154.395 58.9548 156.573L58.8407 156.796L58.7067 156.578C58.55 156.322 58.3816 156.048 58.212 155.772C57.5016 154.716 56.6689 153.772 55.7351 153.009C54.7938 152.263 53.8217 151.607 52.8072 151.156C50.8071 150.185 48.7909 149.841 47.1214 149.782C45.4416 149.738 44.0885 149.995 43.1853 150.252C42.2854 150.524 41.7999 150.727 41.7891 150.699C41.7854 150.69 41.9038 150.634 42.1336 150.538C42.3667 150.451 42.6977 150.278 43.1541 150.148C44.0556 149.856 45.4206 149.565 47.1262 149.584C48.8205 149.618 50.8749 149.947 52.9175 150.922C53.9531 151.375 54.9477 152.038 55.9111 152.798C56.867 153.573 57.7206 154.537 58.4478 155.619C58.6211 155.902 58.7933 156.183 58.9537 156.444L58.7056 156.448C59.8574 154.21 61.6901 152.546 63.5771 151.537C64.5114 151.002 65.4845 150.678 66.392 150.401C67.3156 150.176 68.1897 150.023 68.9959 149.993C70.6068 149.918 71.9056 150.147 72.7571 150.415C73.1919 150.521 73.503 150.686 73.7237 150.762C73.9401 150.849 74.0515 150.899 74.0477 150.908Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M104.215 102.467C103.105 98.9097 103.568 92.9381 106.019 89.9966C108.469 87.0552 112.714 85.3501 116.514 84.8846C117.149 84.8065 117.827 84.7769 118.392 85.0773C118.957 85.3776 119.332 86.1182 119.028 86.6812C119.819 86.2807 120.628 85.8749 121.507 85.7543C122.385 85.6343 123.36 85.8507 123.938 86.5235C124.515 87.1963 124.511 88.368 123.788 88.882C124.862 88.5962 126.088 89.0036 126.776 89.8761C127.465 90.748 127.578 92.0349 127.052 93.0139C126.548 93.9515 125.565 94.9602 124.719 95.606C123.873 96.2519 123.677 96.9839 123.711 98.0474",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M105.683 96.2584L102.806 117.17C102.316 120.726 104.902 123.967 108.478 124.281C111.815 124.573 114.794 122.191 115.247 118.872C115.462 117.298 115.644 115.985 115.677 115.825C115.677 115.825 121.069 116.057 122.179 110.841C122.715 108.321 123.396 103.039 123.958 98.2536C124.561 93.1146 121.109 88.3755 116.035 87.362L115.531 87.2614C110.027 86.4912 106.3 90.7356 105.683 96.2584Z",
                fill: "#E1E8EE"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M115.695 115.746C115.695 115.746 112.337 115.354 109.266 112.446C109.266 112.446 110.125 116.531 115.436 117.103L115.695 115.746Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M105.335 100.233C105.253 100.177 101.954 98.453 101.354 102.05C100.754 105.648 104.49 105.508 104.513 105.406C104.537 105.304 105.335 100.233 105.335 100.233Z",
                fill: "#D5DDE6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M103.642 103.836C103.628 103.822 103.572 103.869 103.458 103.9C103.347 103.93 103.163 103.933 102.988 103.832C102.631 103.629 102.412 102.972 102.502 102.321C102.548 101.992 102.669 101.692 102.827 101.453C102.981 101.208 103.182 101.052 103.379 101.05C103.577 101.038 103.693 101.175 103.72 101.284C103.752 101.393 103.717 101.46 103.735 101.47C103.744 101.48 103.822 101.422 103.818 101.269C103.815 101.195 103.787 101.103 103.714 101.02C103.639 100.935 103.519 100.878 103.383 100.87C103.102 100.844 102.81 101.057 102.635 101.319C102.445 101.58 102.302 101.916 102.251 102.285C102.153 103.014 102.411 103.754 102.906 103.992C103.148 104.1 103.372 104.059 103.495 103.992C103.621 103.921 103.653 103.844 103.642 103.836Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M127.384 91.8483C127.023 96.5826 120.953 97.5664 118.869 94.5362C117.906 93.1352 117.141 91.457 115.645 90.6481C114.638 90.1034 113.4 90.0969 112.309 90.4435C112.298 90.4468 112.287 90.4506 112.276 90.4543C110.666 90.9764 109.502 92.5453 108.995 94.1611C108.289 96.4136 108.317 98.5089 107.364 100.526C107.227 100.815 107.07 101.126 106.783 101.267C106.295 101.508 105.713 101.127 105.421 100.668C104.954 99.933 104.9 99.0143 104.917 98.1434C104.956 96.1595 105.304 94.1654 106.11 92.3521C106.916 90.5388 108.196 88.9118 109.871 87.8488C111.964 86.5199 114.602 86.1404 117.026 86.6641C119.449 87.1873 121.65 88.5765 123.298 90.429C124.063 91.2886 124.728 92.2762 124.988 93.3963",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M146.154 152.514C142.868 156.181 137.125 156.175 133.846 152.504L124.33 141.85L124.217 157.03L127.574 166.767L94.2106 172.554L92.7956 146.229L90.3941 126.012C90.0997 123.534 91.513 121.17 93.8339 120.256L103.015 116.641L115.947 119.013L121.149 120.99C123.333 121.82 125.28 123.174 126.818 124.933L141.408 141.618",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M124.525 156.379C124.603 156.378 124.623 151.119 124.57 144.634C124.517 138.147 124.411 132.89 124.332 132.891C124.254 132.891 124.235 138.149 124.287 144.636C124.341 151.121 124.447 156.379 124.525 156.379Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M123.3 160.238L103.141 152.122C101.515 151.468 100.402 149.948 100.268 148.2L98.7928 128.872C98.7928 128.872 98.9672 120.652 93.8331 120.252L90.9121 121.402C87.137 123.407 86.2021 128.903 86.7156 133.147C87.4454 139.177 87.75 147.71 88.5671 152.943C89.2355 157.223 91.6877 160.989 95.8772 162.092L120.707 167.467L123.3 160.238Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M99.0832 131.826C99.0924 131.826 99.1139 131.978 99.1467 132.269C99.179 132.584 99.2221 133.009 99.2764 133.543C99.3792 134.676 99.5246 136.27 99.7027 138.23C99.8733 140.218 100.076 142.572 100.3 145.184C100.355 145.838 100.412 146.509 100.469 147.194C100.529 147.879 100.571 148.581 100.726 149.262C100.874 149.946 101.202 150.585 101.729 151.073C102.251 151.562 102.906 151.92 103.589 152.23C109.148 154.636 114.271 156.622 117.989 158.015C119.836 158.695 121.338 159.248 122.405 159.641C122.908 159.827 123.308 159.974 123.605 160.084C123.879 160.187 124.021 160.246 124.018 160.255C124.015 160.264 123.867 160.222 123.588 160.135C123.287 160.037 122.881 159.906 122.37 159.74C121.315 159.39 119.794 158.867 117.924 158.194C114.183 156.845 109.052 154.889 103.477 152.476C102.784 152.16 102.103 151.791 101.544 151.268C100.98 150.748 100.619 150.035 100.469 149.322C100.308 148.606 100.27 147.9 100.212 147.216C100.158 146.531 100.105 145.86 100.053 145.205C99.8497 142.591 99.6667 140.234 99.5122 138.245C99.3696 136.282 99.2538 134.685 99.1715 133.55C99.1387 133.015 99.1118 132.589 99.0924 132.273C99.0773 131.981 99.0741 131.827 99.0832 131.826Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M87.5302 142.328C87.5398 142.328 87.5522 142.417 87.57 142.588C87.5883 142.789 87.6098 143.035 87.6367 143.334C87.6965 144.022 87.7772 144.949 87.8757 146.076C87.986 147.233 88.1265 148.61 88.3273 150.131C88.5345 151.65 88.7794 153.326 89.2374 155.028C89.4543 155.887 89.7589 156.68 90.2213 157.362C90.6836 158.049 91.1966 158.666 91.7272 159.212C92.7935 160.302 93.9313 161.102 94.9534 161.633C97.0158 162.705 98.5153 162.72 98.4938 162.792C98.4933 162.801 98.4029 162.799 98.2317 162.786C98.06 162.774 97.8065 162.754 97.4857 162.69C96.8431 162.577 95.9189 162.325 94.8662 161.803C93.8156 161.286 92.6454 160.488 91.5502 159.388C91.0049 158.836 90.4775 158.211 90.0022 157.511C89.52 156.809 89.1927 155.96 88.9774 155.101C88.5124 153.374 88.2756 151.692 88.0808 150.165C87.8929 148.636 87.7718 147.255 87.6857 146.094C87.6007 144.933 87.556 143.992 87.5318 143.341C87.5253 143.041 87.5199 142.794 87.5156 142.591C87.5156 142.419 87.521 142.329 87.5302 142.328Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M96.1533 155.851C96.1258 155.843 96.2114 155.412 96.5203 154.777C96.8255 154.142 97.3906 153.323 98.213 152.617C99.0381 151.915 99.9364 151.485 100.611 151.283C101.287 151.077 101.726 151.061 101.729 151.089C101.737 151.134 101.314 151.218 100.673 151.463C100.033 151.706 99.184 152.146 98.388 152.822C97.5952 153.502 97.0284 154.272 96.6882 154.866C96.3459 155.461 96.1969 155.866 96.1533 155.851Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                opacity: "0.3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M117.506 157.93C115.351 156.713 113.241 155.778 110.988 154.753C108.734 153.729 106.526 152.414 105.051 150.425C102.269 146.676 102.586 141.264 99.7383 137.563C99.924 140.052 100.11 142.54 100.296 145.028C100.467 147.309 100.117 149.564 101.586 151.113C102.823 152.419 105.236 153.42 106.945 153.984C110.377 155.116 114.073 156.798 117.506 157.93Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M102.223 117.556L103.209 113.86L115.735 116.806C116.438 116.971 116.858 117.692 116.654 118.385L115.693 121.648L111.172 127.45L106.042 126.534L102.223 123.603L102.223 117.556Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M115.969 119.229C115.972 119.249 115.815 119.284 115.527 119.332C115.24 119.383 114.82 119.426 114.299 119.451C113.258 119.504 111.803 119.427 110.248 119.057C108.694 118.682 107.362 118.09 106.459 117.571C106.005 117.312 105.651 117.083 105.418 116.907C105.184 116.734 105.06 116.631 105.071 116.615C105.097 116.576 105.634 116.929 106.552 117.396C107.469 117.865 108.787 118.416 110.313 118.784C111.84 119.148 113.265 119.255 114.295 119.253C115.325 119.254 115.963 119.182 115.969 119.229Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M152.441 186.386C152.441 186.386 169.308 191.054 169.985 191.292C171.001 191.65 170.831 195.373 169.249 195.315C168.501 195.287 156.293 195.77 154.751 195.673C153.208 195.577 148.555 193.743 148.555 193.743L152.441 186.386Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M159.565 192.772C159.65 192.784 159.764 191.892 160.308 190.961C160.84 190.022 161.554 189.476 161.501 189.408C161.471 189.343 160.634 189.818 160.064 190.82C159.484 191.816 159.494 192.779 159.565 192.772Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M157.804 191.985C157.887 192 158.057 191.202 158.506 190.321C158.947 189.435 159.485 188.823 159.425 188.766C159.379 188.71 158.719 189.262 158.254 190.194C157.783 191.123 157.732 191.981 157.804 191.985Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M156.158 191.533C156.243 191.527 156.179 190.685 156.553 189.751C156.911 188.81 157.53 188.235 157.472 188.173C157.438 188.109 156.681 188.631 156.29 189.648C155.888 190.661 156.09 191.557 156.158 191.533Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M156.455 189.353C156.485 189.361 156.635 188.89 156.636 188.098C156.635 187.704 156.59 187.232 156.465 186.722C156.403 186.468 156.32 186.205 156.214 185.939C156.16 185.805 156.098 185.651 155.944 185.526C155.787 185.385 155.501 185.414 155.365 185.555C155.211 185.689 155.162 185.879 155.14 186.031C155.123 186.186 155.114 186.331 155.118 186.477C155.122 186.767 155.16 187.046 155.222 187.303C155.347 187.818 155.548 188.249 155.741 188.592C156.134 189.277 156.475 189.627 156.499 189.608C156.538 189.581 156.255 189.188 155.918 188.5C155.753 188.156 155.58 187.734 155.476 187.246C155.424 187.003 155.395 186.743 155.395 186.475C155.402 186.217 155.398 185.892 155.55 185.768C155.63 185.701 155.703 185.697 155.773 185.749C155.847 185.806 155.91 185.921 155.958 186.044C156.063 186.296 156.148 186.545 156.214 186.788C156.347 187.273 156.411 187.724 156.437 188.105C156.486 188.869 156.409 189.347 156.455 189.353Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M156.434 189.186C156.441 189.156 156.034 189.016 155.346 189.011C155.003 189.01 154.592 189.046 154.149 189.158C153.93 189.217 153.696 189.273 153.46 189.412C153.229 189.529 152.987 189.85 153.078 190.182C153.151 190.496 153.42 190.716 153.686 190.785C153.955 190.86 154.215 190.833 154.443 190.783C154.906 190.676 155.266 190.448 155.539 190.244C156.079 189.82 156.343 189.495 156.323 189.471C156.293 189.435 155.974 189.713 155.425 190.08C155.148 190.257 154.802 190.448 154.39 190.528C154.185 190.567 153.964 190.58 153.765 190.519C153.566 190.465 153.401 190.313 153.354 190.118C153.306 189.93 153.42 189.757 153.605 189.647C153.786 189.536 154.009 189.471 154.217 189.409C154.634 189.29 155.024 189.235 155.354 189.21C156.013 189.164 156.427 189.232 156.434 189.186Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M162.158 192.955C162.242 192.945 162.159 192.225 162.491 191.433C162.807 190.636 163.37 190.178 163.317 190.113C163.289 190.044 162.584 190.444 162.229 191.327C161.866 192.206 162.091 192.985 162.158 192.955Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M150.387 193.735C150.379 193.753 150.611 193.861 151.039 194.042C151.473 194.205 152.107 194.435 152.917 194.624C154.53 195.03 156.829 195.261 159.356 195.234C161.884 195.206 164.162 195.091 165.814 195.025C166.596 194.984 167.251 194.949 167.769 194.922C168.23 194.891 168.485 194.865 168.484 194.845C168.484 194.826 168.227 194.815 167.765 194.812C167.247 194.816 166.591 194.821 165.808 194.826C164.099 194.859 161.846 194.903 159.355 194.952C156.84 194.978 154.567 194.781 152.961 194.429C151.348 194.098 150.406 193.683 150.387 193.735Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M134.631 181.686C134.631 181.686 118.669 192.136 118.097 192.568C117.238 193.218 118.224 196.311 119.712 195.775C120.417 195.522 133.81 191.796 135.251 191.236C136.691 190.676 140.568 187.515 140.568 187.515L134.631 181.686Z",
                fill: "#708090"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M129.89 189.955C129.96 189.941 129.677 189.02 128.822 188.247C127.975 187.466 127.033 187.268 127.024 187.339C126.995 187.419 127.841 187.723 128.632 188.455C129.434 189.177 129.813 189.993 129.89 189.955Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M131.325 188.659C131.392 188.633 131.083 187.831 130.352 187.089C129.625 186.342 128.83 186.017 128.802 186.084C128.762 186.157 129.461 186.577 130.15 187.287C130.846 187.99 131.251 188.698 131.325 188.659Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M132.761 187.732C132.834 187.734 132.754 186.819 132.063 185.976C131.381 185.126 130.503 184.859 130.49 184.93C130.452 185.006 131.217 185.366 131.844 186.154C132.484 186.93 132.678 187.753 132.761 187.732Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M131.815 185.757C131.857 185.736 131.639 185.304 131.454 184.562C131.364 184.191 131.287 183.741 131.267 183.239C131.256 182.988 131.262 182.724 131.284 182.452C131.293 182.321 131.317 182.192 131.371 182.115C131.422 182.044 131.492 182.027 131.589 182.065C131.772 182.138 131.867 182.448 131.952 182.692C132.033 182.948 132.085 183.204 132.109 183.451C132.158 183.947 132.122 184.402 132.068 184.78C131.956 185.538 131.806 185.998 131.851 186.012C131.879 186.023 132.097 185.586 132.264 184.815C132.344 184.43 132.405 183.957 132.367 183.428C132.348 183.164 132.3 182.888 132.215 182.61C132.174 182.47 132.122 182.335 132.059 182.192C131.993 182.054 131.889 181.888 131.7 181.806C131.529 181.713 131.246 181.772 131.139 181.955C131.031 182.121 131.019 182.286 131.008 182.43C130.987 182.715 130.988 182.991 131.006 183.253C131.042 183.776 131.142 184.239 131.261 184.615C131.504 185.369 131.789 185.773 131.815 185.757Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M131.782 185.589C131.802 185.63 132.176 185.44 132.819 185.283C133.14 185.206 133.528 185.14 133.962 185.127C134.179 185.123 134.412 185.117 134.618 185.169C134.827 185.217 134.989 185.347 134.999 185.541C135.013 185.741 134.902 185.936 134.73 186.047C134.558 186.165 134.344 186.221 134.136 186.246C133.719 186.295 133.331 186.218 133.014 186.133C132.379 185.951 131.991 185.783 131.973 185.826C131.962 185.855 132.311 186.084 132.955 186.324C133.278 186.436 133.69 186.543 134.163 186.504C134.395 186.482 134.651 186.429 134.885 186.276C135.118 186.13 135.307 185.839 135.281 185.518C135.267 185.173 134.939 184.941 134.684 184.899C134.417 184.839 134.176 184.857 133.95 184.867C133.494 184.895 133.091 184.986 132.765 185.09C132.11 185.305 131.765 185.562 131.782 185.589Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M127.475 190.916C127.549 190.923 127.527 190.113 126.914 189.386C126.308 188.653 125.515 188.486 125.509 188.56C125.478 188.638 126.154 188.903 126.697 189.567C127.253 190.22 127.393 190.933 127.475 190.916Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M138.926 188.076C138.912 188.06 138.668 188.239 138.225 188.558C137.776 188.869 137.116 189.304 136.257 189.764C135.398 190.224 134.339 190.703 133.131 191.155C131.922 191.605 130.567 192.031 129.133 192.446C126.262 193.273 123.662 194.029 121.786 194.593C120.887 194.869 120.14 195.098 119.568 195.274C119.046 195.441 118.76 195.542 118.766 195.561C118.771 195.58 119.067 195.514 119.598 195.38C120.176 195.227 120.932 195.026 121.841 194.785C123.731 194.27 126.337 193.545 129.212 192.717C130.649 192.301 132.01 191.866 133.223 191.398C134.436 190.929 135.498 190.427 136.353 189.939C137.209 189.451 137.858 188.986 138.29 188.646C138.717 188.298 138.937 188.089 138.926 188.076Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M139.518 188.29C139.526 188.258 139.023 188.073 138.166 187.93C137.323 187.798 136.044 187.729 134.812 188.34C134.201 188.643 133.716 189.104 133.376 189.573C133.029 190.042 132.8 190.512 132.627 190.909C132.291 191.708 132.153 192.222 132.184 192.235C132.225 192.252 132.432 191.758 132.808 190.994C133.187 190.251 133.787 189.164 134.939 188.592C136.087 188.02 137.307 188.047 138.141 188.128C138.987 188.217 139.509 188.334 139.518 188.29Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M167.803 156.199C167.803 156.199 172.591 157.909 172.612 163.278C172.651 173.562 151.832 184.899 151.832 184.899L124.127 166.542L122.391 165.84C122.391 165.84 159.789 151.791 167.803 156.199Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M138.161 175.809C138.172 175.825 138.429 175.65 138.882 175.32C139.337 174.991 139.984 174.502 140.777 173.889C142.364 172.663 144.522 170.925 146.843 168.933C149.165 166.939 151.209 165.068 152.661 163.685C153.387 162.994 153.968 162.428 154.362 162.029C154.756 161.63 154.968 161.404 154.955 161.389C154.941 161.375 154.704 161.575 154.286 161.949C153.834 162.357 153.241 162.893 152.525 163.539C151.04 164.882 148.978 166.727 146.659 168.718C144.341 170.708 142.206 172.468 140.653 173.733C139.907 174.342 139.288 174.847 138.815 175.233C138.382 175.589 138.148 175.793 138.161 175.809Z",
                fill: "#56626F"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M159.982 160.052C159.992 159.983 158.757 159.862 157.313 160.294C155.865 160.716 154.893 161.488 154.939 161.54C154.985 161.614 155.995 160.97 157.393 160.565C158.786 160.147 159.983 160.139 159.982 160.052Z",
                fill: "#56626F"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M157.596 158.427C157.572 158.36 156.683 158.751 155.954 159.662C155.216 160.568 155.021 161.518 155.091 161.528C155.172 161.556 155.475 160.694 156.173 159.84C156.861 158.978 157.64 158.5 157.596 158.427Z",
                fill: "#56626F"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M161.43 139.392L151.562 164.405L109.075 165.097L108.289 162.798L123.179 162.258L130.335 140.069L161.43 139.392Z",
                fill: "#8FA0B1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M141.588 150.223C142.133 149.854 143.141 150.002 143.631 150.441C144.121 150.881 144.28 151.641 144.031 152.251C143.782 152.861 143.153 153.288 142.496 153.323C141.797 153.361 141.068 152.923 140.873 152.252C140.678 151.58 140.895 150.577 141.588 150.223Z",
                fill: "#EBEBEB"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M154.452 186.144C154.452 186.144 115.309 160.469 113.707 159.934C112.104 159.4 108.23 156.862 104.357 157.931C100.483 158.999 97.0108 162.472 95.2745 167.548C94.2826 170.447 93.8138 175.395 93.5942 179.105C93.3315 183.542 94.7045 187.964 97.6067 191.331C98.9269 192.862 100.556 194.194 102.487 194.796C102.895 194.923 103.318 195.032 103.752 195.126C111.153 196.731 118.758 193.409 122.917 187.08L123.83 185.689C123.83 185.689 149.436 195.097 149.837 194.963L154.452 186.144Z",
                fill: "#323840"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M106.027 179.085C106.027 179.085 106.098 179.121 106.242 179.18C106.397 179.241 106.609 179.326 106.883 179.434C107.46 179.657 108.293 179.977 109.364 180.39C111.541 181.21 114.682 182.393 118.587 183.864C122.505 185.326 127.197 187.063 132.462 188.979C137.727 190.893 143.562 192.994 149.793 195.104L149.906 195.142L149.962 195.036C150.94 193.168 151.972 191.196 153.02 189.196C153.554 188.175 154.084 187.163 154.579 186.218L154.639 186.102L154.531 186.034C142.777 178.572 132.261 171.897 124.672 167.079C120.883 164.689 117.825 162.761 115.703 161.422C114.652 160.767 113.834 160.256 113.267 159.902C112.995 159.736 112.784 159.607 112.631 159.513C112.487 159.427 112.41 159.389 112.41 159.389C112.41 159.389 112.477 159.442 112.616 159.537C112.766 159.636 112.972 159.772 113.238 159.948C113.798 160.312 114.608 160.838 115.647 161.512C117.757 162.868 120.799 164.822 124.568 167.243C132.144 172.079 142.643 178.78 154.377 186.27L154.329 186.087C153.834 187.032 153.303 188.045 152.77 189.065C151.723 191.065 150.691 193.037 149.714 194.906L149.882 194.838C143.654 192.734 137.816 190.643 132.546 188.744C127.285 186.829 122.584 185.119 118.651 183.687C114.734 182.25 111.584 181.095 109.4 180.293C108.322 179.901 107.483 179.596 106.901 179.384C106.624 179.286 106.408 179.21 106.251 179.154C106.104 179.104 106.027 179.085 106.027 179.085Z",
                fill: "#56626F"
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
var $ae78cd9e765d6623$export$af3435520bc7eae6 = /*#__PURE__*/ function(FloatingPanelType) {
    FloatingPanelType["LIGHT"] = "light";
    FloatingPanelType["DARK"] = "dark";
    return FloatingPanelType;
}({});
const $ae78cd9e765d6623$export$cbfa8a8d33d01a14 = ({ children: children, className: className, omitSeperator: omitSeperator, type: type, width: width })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        style: {
            width: width || undefined
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: `flex flex-col h-full w-full gap-2 ${type === "light" ? 'bg-gray-150' : 'bg-black-50'} py-4 rounded-md`,
            children: (0, $acw62.Children).map(children, (child, index)=>{
                const lastChild = index === children.length - 1;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        child,
                        !lastChild && !omitSeperator && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "mt-2 bg-gray-100 border-gray-100"
                        })
                    ]
                });
            })
        })
    });
};
const $ae78cd9e765d6623$export$b5a557b20f0498cb = ({ children: children, className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `${className}`,
        children: children
    });
};






var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
const $6a49f7933f652214$export$ea4109706c07d076 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "29",
        height: "30",
        viewBox: "0 0 29 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Envelope Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_4836_20088)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24.2849 23.5748V12.8795C24.2849 12.418 24.062 11.985 23.6866 11.7168L15.1136 5.59321C14.6168 5.23835 13.9494 5.23835 13.4526 5.59321L4.87959 11.7168C4.5041 11.985 4.28125 12.418 4.28125 12.8795V23.5748C4.28125 24.3639 4.92096 25.0036 5.71008 25.0036H22.8561C23.6452 25.0036 24.2849 24.3639 24.2849 23.5748Z",
                        stroke: "white",
                        strokeWidth: "1.42883"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M24.2849 12.1445L14.8459 16.1898C14.4865 16.3438 14.0797 16.3438 13.7202 16.1898L4.28125 12.1445",
                        stroke: "white",
                        strokeWidth: "1.42883"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_4836_20088",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "28.5766",
                        height: "28.5766",
                        fill: "white",
                        transform: "translate(0 0.710938)"
                    })
                })
            })
        ]
    });
};




parcelRequire("acw62");
const $77d77fa6175b0345$export$f713256e8ad1586 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Help Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_2632_9222)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.9985 17.5H4.9987C4.55667 17.5 4.13275 17.3244 3.82019 17.0118C3.50763 16.6993 3.33203 16.2754 3.33203 15.8333V4.16667C3.33203 3.72464 3.50763 3.30072 3.82019 2.98816C4.13275 2.67559 4.55667 2.5 4.9987 2.5H14.9987C15.4407 2.5 15.8646 2.67559 16.1772 2.98816C16.4898 3.30072 16.6654 3.72464 16.6654 4.16667V9.16667",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 15H11.6667",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15.832 17.5V17.51",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.582 12.084C14.8227 11.7997 15.1525 11.6051 15.5177 11.5321C15.883 11.459 16.2622 11.5116 16.5937 11.6815C16.9255 11.8531 17.1901 12.1311 17.3452 12.471C17.5003 12.8109 17.5369 13.193 17.4492 13.5561C17.3614 13.9192 17.1544 14.2424 16.8612 14.4739C16.568 14.7055 16.2056 14.8319 15.832 14.8331V15.9031",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_2632_9222",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};



parcelRequire("acw62");
var $bb912889052584b4$exports = {};
$bb912889052584b4$exports = new URL("create-template.4960343d.png", import.meta.url).toString();


const $78901cc0c2f66d68$export$d8a7d9507b749a7b = ()=>{
    const createTemplateImage = new URL($bb912889052584b4$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Creating a template"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Click \u201CCreate a Template\u201D and upload SVG files for your designs. Upload a separate SVG file for each style or size variant you want to add to your template."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: createTemplateImage,
                alt: "create-template"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Next, create Text and Image fields by selecting text or image layers in each frame, and assigning them to a new or existing field."
            })
        ]
    });
};



parcelRequire("acw62");
var $d30b2560b685b7db$exports = {};
$d30b2560b685b7db$exports = new URL("frames.9d882bf0.png", import.meta.url).toString();


const $c54c6030b3589bd4$export$3501ba6949a5bdc7 = ()=>{
    const framesImage = new URL($d30b2560b685b7db$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Frames"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Each SVG file you upload to your template creates a new Frame. Frames can contain style variations of the same design, size variations, or multiple design options within a single template that has similar content."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: framesImage,
                alt: "frames"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Frames can be created by importing SVG files generated from any design tool like Figma, or Adobe Suite."
            })
        ]
    });
};



parcelRequire("acw62");
var $9449dc66ea73b66f$exports = {};
$9449dc66ea73b66f$exports = new URL("multi-layer.51c2107f.png", import.meta.url).toString();


const $d797779a5c81448b$export$1012ee7fe3adfe5a = ()=>{
    const multiLayerImage = new URL($9449dc66ea73b66f$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Adding Multiple Layers"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Fields can contain one text layer for each frame in your template. For example, you can connect a Headline field across multiple frames to the same field. This allows template users to create multiple sizes or variants of the same content by entering content only once."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "When you have an existing text field, click on a text layer in any frame and click \u201CLink to a Text Field\u201D in the Text Layer panel. Next, select the field you want to link the layer to."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: multiLayerImage,
                alt: "multi-layer"
            })
        ]
    });
};



parcelRequire("acw62");
var $45c1b30b65be950b$exports = {};
$45c1b30b65be950b$exports = new URL("organization.cd8f5da8.png", import.meta.url).toString();


const $0c36ddbc17d34b2c$export$f3a6aa388b70f149 = ()=>{
    const organizationImage = new URL($45c1b30b65be950b$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Organization"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "You can invite team members to your organization on Intaglio as Designers, Publishers, or Administrators."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-bold",
                        children: "Designers:"
                    }),
                    " Can create and edit design templates. They can also publish creative assets using templates.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-bold",
                        children: "Publishers:"
                    }),
                    " Can publish creative assets using templates. Publishers cannot create or edit template designs.",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-bold",
                        children: "Administrators:"
                    }),
                    " Can do everything designers can do, and also add or remove members from the organization."
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: organizationImage,
                alt: "organization"
            })
        ]
    });
};



parcelRequire("acw62");
var $d4f4fc30186a6b9d$exports = {};
$d4f4fc30186a6b9d$exports = new URL("overview.5e43ba7d.png", import.meta.url).toString();


const $20339c491937c5fe$export$d7a9e6ef755e50e3 = ()=>{
    const overviewImage = new URL($d4f4fc30186a6b9d$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Overview of Templates"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Templates turn commonplace designs like social media posts, ads, business cards, and more into self serve layouts that team members can create customized assets from."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Each template is a collection of designs that contain fields for team members to customize content. Currently, only Text and Images layers can be turned into fields"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: overviewImage,
                alt: "overview"
            })
        ]
    });
};



parcelRequire("acw62");
var $4d2be2ca1ed74e7c$exports = {};
$4d2be2ca1ed74e7c$exports = new URL("publish-a.78969d2d.png", import.meta.url).toString();


var $14bf8f1dc10084d4$exports = {};
$14bf8f1dc10084d4$exports = new URL("publish-b.d88a6c84.png", import.meta.url).toString();


const $436e91651e95805e$export$ef93098ddcf670ac = ()=>{
    const publishAImage = new URL($4d2be2ca1ed74e7c$exports).toString();
    const publishBImage = new URL($14bf8f1dc10084d4$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Publish Template"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: 'When you click "Publish Template", the template will be added to your team\'s creative section, making it accessible to everyone on your team. This allows all members to use the same template in their own projects, helping maintain consistency and streamline the design process across the workspace.'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: publishAImage,
                alt: "publish-a"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "After a template is published, you can easily share it by copying its link or sending it directly via email."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: publishBImage,
                alt: "publish-b"
            })
        ]
    });
};



parcelRequire("acw62");
var $37a01d116d8b1907$exports = {};
$37a01d116d8b1907$exports = new URL("text-fields-a.0af48e87.png", import.meta.url).toString();


var $5cd98c129c5884ae$exports = {};
$5cd98c129c5884ae$exports = new URL("text-fields-b.f0dea3e1.png", import.meta.url).toString();


const $4a9fb380047cbeb7$export$6aae1fc59ecdac3b = ()=>{
    const textFieldAImage = new URL($37a01d116d8b1907$exports).toString();
    const textFieldBImage = new URL($5cd98c129c5884ae$exports).toString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-white flex flex-col gap-4 pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-2xl",
                children: "Text Fields"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Text fields allow template users to modify text in any text layer on a design across multiple sizes or variations."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Click on a text layer in any frame to find the \u201CCreate New Text Field\u201D button in the Text Layer panel. You can also click \u201C+\u201D on the \u201CContent Fields\u201D panel when no layer is selected to create a Text Field."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: textFieldAImage,
                alt: "text-field-a"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "You can control character limits and enable or disable text scaling for any text field to ensure content does not break design principles."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: textFieldBImage,
                alt: "text-field-b"
            })
        ]
    });
};


var $6c75eb4c4478911c$var$QuickHelpPages = /*#__PURE__*/ function(QuickHelpPages) {
    QuickHelpPages["OVERVIEW"] = "Overview of templates";
    QuickHelpPages["CREATING_TEMPLATE"] = "Creating a Template";
    QuickHelpPages["FRAMES"] = "Frames";
    QuickHelpPages["TEXT_FIELDS"] = "Text Fields";
    QuickHelpPages["MULTIPLE_LAYERS"] = "Adding multiple Layers";
    QuickHelpPages["PUBLISH_TEMPLATE"] = "Publish Template";
    QuickHelpPages["ORGANIZATION"] = "Organization";
    return QuickHelpPages;
}($6c75eb4c4478911c$var$QuickHelpPages || {});
const $6c75eb4c4478911c$export$c6aea0e298dc6482 = ()=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [currentPage, setCurrentPage] = (0, $acw62.useState)("Overview of templates");
    const ref = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const toggleMenu = (e)=>{
        e.stopPropagation();
        setIsOpen((prev)=>!prev);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const getContentTile = ()=>{
        switch(currentPage){
            case "Overview of templates":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20339c491937c5fe$export$d7a9e6ef755e50e3), {});
            case "Creating a Template":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78901cc0c2f66d68$export$d8a7d9507b749a7b), {});
            case "Frames":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c54c6030b3589bd4$export$3501ba6949a5bdc7), {});
            case "Text Fields":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4a9fb380047cbeb7$export$6aae1fc59ecdac3b), {});
            case "Adding multiple Layers":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d797779a5c81448b$export$1012ee7fe3adfe5a), {});
            case "Publish Template":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $436e91651e95805e$export$ef93098ddcf670ac), {});
            case "Organization":
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c36ddbc17d34b2c$export$f3a6aa388b70f149), {});
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
        }
    };
    const getPosition = ()=>{
        const menuRect = ref.current?.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const width = 900;
        const iconWidth = 100;
        let left = menuRect?.left ?? 0;
        const top = menuRect?.bottom ?? 0;
        if (left + width > windowWidth) left = left - width;
        return {
            top: top + 10,
            left: left + iconWidth
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative inline-block",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: toggleMenu,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-1",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77d77fa6175b0345$export$f713256e8ad1586), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-white text-sm font-normal",
                            children: "Quick Help"
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "z-[999] absolute w-[900px] h-2/3 bg-gray-150 flex flex-row shadow-xl rounded-md transition-all duration-100 ease-in-out overflow-y-scroll opacity-100 visible",
                style: getPosition(),
                ref: menuRef,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        className: "px-4 h-full w-[250px] flex-shrink-0 overflow-y-auto",
                        omitSeperator: true,
                        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4 my-2 flex flex-col gap-2 items-start",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Overview of templates"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Overview of templates" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Overview of templates"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Creating a Template"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Creating a Template" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Creating a Template"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Frames"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Frames" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Frames"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Text Fields"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Text Fields" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Text Fields"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Adding multiple Layers"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Adding multiple Layers" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Adding multiple Layers"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Publish Template"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Publish Template" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Publish Template"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "button",
                                        onClick: ()=>setCurrentPage("Organization"),
                                        className: `hover:text-gray-10 text-base ${currentPage === "Organization" ? 'text-white' : 'text-gray-50'}`,
                                        children: "Organization"
                                    })
                                ]
                            }, 'quick-help-item'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4 my-2 h-full",
                                children: []
                            }, 'quick-help-content-space'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4 my-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "pr-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                            className: "bg-gray-100 border-gray-100 w-full mb-4"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                        className: "px-8",
                                        buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                        buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                        title: "Reach Out",
                                        leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a49f7933f652214$export$ea4109706c07d076), {}),
                                        onClick: ()=>{
                                            window.location.href = 'mailto:contact@frontmatter.io';
                                        }
                                    })
                                ]
                            }, 'quick-help-content')
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 overflow-auto no-scrollbar",
                        children: getContentTile()
                    })
                ]
            }), document.body)
        ]
    });
};








var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");


const $cf75ffe8f2f40040$export$ed892eca4290463a = ({ title: title, thumbnail: thumbnail, size: size, onClick: onClick, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2.5 aspect-square cursor-pointer",
        onClick: onClick,
        onKeyUp: (e)=>e.key === 'Enter' && onClick && onClick(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row justify-between items-center overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center max-w-[70%]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex-shrink-0",
                                children: isSelected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f87e2995c0ae886d$export$7dd004358974b05d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $430181ea01cc3dc6$export$30d0dc241a918823), {})
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-xs text-white truncate",
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-110 truncate max-w-[30%] text-right",
                        children: size
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${isSelected ? 'border-solid border-blue border-[1px]' : ''} bg-gray-160 rounded w-full h-full p-3`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: thumbnail,
                    alt: "thumbnail",
                    className: "w-full h-full rounded object-contain"
                })
            })
        ]
    });
};


const $128555b314748f01$export$652e388e958caf8 = ({ onDone: onDone, isOpen: isOpen, setIsOpen: setIsOpen, templateId: templateId, creativeId: creativeId, initiallySelectedSizes: initiallySelectedSizes })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [templateDetails, setTemplateDetails] = (0, $acw62.useState)(null);
    const [selectedSizes, setSelectedSizes] = (0, $acw62.useState)(initiallySelectedSizes ?? []);
    const [removedSizes, setRemovedSizes] = (0, $acw62.useState)([]);
    const fetchTemplateDetails = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            setTemplateDetails(await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).getTemplate(templateId));
        } catch (error) {
            console.error('Error fetching template:', error);
        } finally{
            setIsLoading(false);
        }
    }, [
        templateId
    ]);
    const updateORCreateCreative = (0, $acw62.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            if (creativeId) {
                const to_add = selectedSizes.filter((id)=>!initiallySelectedSizes?.includes(id));
                const to_remove = removedSizes.filter((id)=>!selectedSizes.includes(id));
                await (0, $c31e9b81d8391e7c$export$1811d82788a05bc9).updateCreative(creativeId, {
                    creative_variants: {
                        to_add: to_add,
                        to_remove: to_remove
                    }
                });
                onDone?.(creativeId);
                setIsOpen(false);
            } else {
                const creative = await (0, $c31e9b81d8391e7c$export$1811d82788a05bc9).createCreative({
                    name: 'Untitled Creative',
                    template: templateId,
                    template_version: templateDetails?.publishedVersion?.id ?? 1,
                    creative_variants: selectedSizes.map((id)=>({
                            variant: id
                        }))
                });
                onDone?.(creative.id);
                setIsOpen(false);
            }
        } catch (error) {
            console.error('Error updating/creating creative:', error);
        } finally{
            setSelectedSizes([]);
            setIsLoading(false);
        }
    }, [
        creativeId,
        templateId,
        onDone,
        selectedSizes,
        templateDetails,
        initiallySelectedSizes,
        removedSizes,
        setIsOpen
    ]);
    const updateSizes = (variant)=>{
        setSelectedSizes((prev)=>prev.includes(variant.id) ? prev.filter((id)=>id !== variant.id) : [
                ...prev,
                variant.id
            ]);
        setRemovedSizes((prev)=>initiallySelectedSizes?.includes(variant.id) ? [
                ...prev,
                variant.id
            ] : prev.filter((id)=>id !== variant.id));
    };
    (0, $acw62.useEffect)(()=>{
        if (initiallySelectedSizes) setSelectedSizes(initiallySelectedSizes);
    }, [
        initiallySelectedSizes
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOpen) fetchTemplateDetails();
        else {
            setTemplateDetails(null);
            setSelectedSizes([]);
            setRemovedSizes([]);
        }
    }, [
        isOpen,
        fetchTemplateDetails
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[45vw] max-w-[900px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row justify-between p-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-white text-xl",
                            children: "Select sizes for your creative"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                            onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "h-[50vh] overflow-y-scroll no-scrollbar p-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-3 gap-y-5 gap-x-5",
                        children: templateDetails?.publishedVersion?.variants.map((variant)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf75ffe8f2f40040$export$ed892eca4290463a), {
                                isSelected: selectedSizes.includes(variant.id),
                                title: variant.name,
                                thumbnail: variant.thumbnail,
                                size: `${variant.svgFile.width}x${variant.svgFile.height}`,
                                onClick: ()=>updateSizes(variant)
                            }, variant.id))
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-100"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-4",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Cancel",
                            className: "hover:bg-gray-160",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isLoading,
                            onClick: ()=>{
                                setIsOpen(false);
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Done",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isLoading || selectedSizes.length === 0,
                            onClick: updateORCreateCreative
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");
// Various utility functions. It's unclear what the best way to break them up is,
// so for now they are all in one file.
const $80cc0c4c52b399e2$export$63ad841d70774900 = (num, decimal = 0)=>{
    const factor = 10 ** decimal;
    return Math.round((num + Number.EPSILON) * factor) / factor;
};
function $80cc0c4c52b399e2$export$9b9f695373d1284f(dateString) {
    const now = new Date();
    const past = new Date(dateString);
    const secondsAgo = Math.floor((now.getTime() - past.getTime()) / 1000);
    const intervals = [
        {
            label: 'year',
            seconds: 31536000
        },
        {
            label: 'month',
            seconds: 2592000
        },
        {
            label: 'day',
            seconds: 86400
        },
        {
            label: 'hour',
            seconds: 3600
        },
        {
            label: 'minute',
            seconds: 60
        },
        {
            label: 'second',
            seconds: 1
        }
    ];
    for (const interval of intervals){
        const count = Math.floor(secondsAgo / interval.seconds);
        if (count >= 1) return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`;
    }
    return 'Just now';
}
function $80cc0c4c52b399e2$export$9fe2dde95a9fb521(font) {
    return `${font.family.toLowerCase()}-${font.style.toLowerCase()}-${font.weight}`;
}
const $80cc0c4c52b399e2$var$loadedFonts = [];
function $80cc0c4c52b399e2$export$f546da154e07664d(font, file) {
    const id = font.id;
    if ($80cc0c4c52b399e2$var$loadedFonts.includes(id)) return Promise.resolve(true);
    $80cc0c4c52b399e2$var$loadedFonts.push(id);
    const fontFace = new FontFace(font.family, file, {
        style: font.style,
        weight: font.weight.toString()
    });
    return fontFace.load().then((loadedFont)=>{
        document.fonts.add(loadedFont);
        return true;
    }).catch((error)=>{
        console.error('Error loading font:', font, error);
        return false;
    });
}
function $80cc0c4c52b399e2$export$61fc7d43ac8f84b0(func, delay) {
    let timeoutId = null;
    return (...args)=>{
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            func(...args);
        }, delay);
    };
}



parcelRequire("acw62");
const $115490f100597f79$export$385cd24c05318684 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "149",
        height: "128",
        viewBox: "0 0 149 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Bin Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M117.59 0.0132728C117.099 0.0547213 116.623 0.203416 116.196 0.448867C115.768 0.694319 115.4 1.03054 115.117 1.43382L27.5692 122.654C27.0459 123.38 26.8323 124.283 26.9754 125.166C27.1184 126.049 27.6064 126.84 28.332 127.363C29.0576 127.886 29.9614 128.1 30.8445 127.957C31.7276 127.814 32.5176 127.326 33.0409 126.6L44.1948 111.184H140.158C144.576 111.184 148.158 107.603 148.158 103.184V86.2458L112.802 56.6248L72.8689 90.1918C72.3023 90.6545 71.6006 90.9202 70.8697 90.9486C70.1388 90.9771 69.4184 90.7668 68.8177 90.3496L62.3989 85.9827L66.2922 80.511L70.5013 83.4047L110.645 49.6798C111.15 49.2457 111.773 48.971 112.434 48.8907C112.886 48.8449 113.343 48.8912 113.777 49.0268C114.211 49.1625 114.613 49.3846 114.959 49.6798L148.158 77.5121V24.902C148.158 20.4837 144.576 16.902 140.158 16.902H112.276L120.589 5.37979C120.977 4.85864 121.206 4.23624 121.249 3.58769C121.291 2.93914 121.145 2.29215 120.828 1.72479C120.511 1.15743 120.037 0.693945 119.462 0.390249C118.887 0.0865538 118.237 -0.0443708 117.59 0.0132728ZM8.00001 16.902C3.58173 16.902 0 20.4837 0 24.902V87.8242L36.829 62.9383C37.3876 62.5583 38.0475 62.3552 38.7231 62.3552C39.3986 62.3552 40.0586 62.5583 40.6172 62.9383L55.2962 72.9874L95.7555 16.902H8.00001ZM40.4067 28.6873C46.9155 28.6873 52.192 33.9638 52.192 40.4726C52.192 46.9814 46.9155 52.2579 40.4067 52.2579C33.8979 52.2579 28.6214 46.9814 28.6214 40.4726C28.6214 33.9638 33.8979 28.6873 40.4067 28.6873ZM38.7757 69.778L0 95.9792V103.184C0 107.603 3.58172 111.184 8 111.184H27.6744L51.3502 78.4065L38.7757 69.778Z",
                fill: "#323840"
            })
        ]
    });
};



parcelRequire("acw62");
const $026ef5e4a357dace$export$5a7f9a6004988d01 = ({ title: title, leading: leading, trailing: trailing, active: active, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
        type: "button",
        className: `inline-flex items-center justify-center text-white ${active ? 'bg-blue-600' : 'bg-gray-100'} px-4 py-1.5 rounded-3xl text-xs font-light whitespace-nowrap`,
        onClick: onClick,
        onKeyUp: onClick,
        children: [
            leading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: leading
            }),
            leading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-2"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: title
            }),
            trailing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-2"
            }),
            trailing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: trailing
            })
        ]
    });
};



const $90a2ffb9ba471d3e$export$16a9184edda9e700 = ({ title: title, createdAt: createdAt, hideCreatedAt: hideCreatedAt, showFrameCount: showFrameCount, frameCount: frameCount, tags: tags, thumbnail: thumbnail, menuItems: menuItems, isDraft: isDraft, isRenaming: isRenaming, onRename: onRename, onClick: onClick })=>{
    const displayedTags = tags.slice(0, 3);
    const remainingTags = tags.slice(3);
    const remainingTagsCount = remainingTags.length;
    const [isRemainingTagsVisible, setRemainingTagsVisible] = (0, $acw62.useState)(false);
    const remainingTagsRef = (0, $acw62.useRef)(null);
    const [titleValue, setTitleValue] = (0, $acw62.useState)(title);
    const [thumbnailLoadFailed, setThumbnailLoadFailed] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!isRenaming) setTitleValue(title);
    }, [
        isRenaming,
        title
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col w-full border-gray-130 border-[1px] border-solid rounded-lg relative",
        onClick: onClick,
        onKeyUp: isRenaming ? ()=>{} : (e)=>e.key === 'Enter' && onClick && onClick(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "chess p-2",
                children: thumbnailLoadFailed || !thumbnail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "w-full aspect-video flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $115490f100597f79$export$385cd24c05318684), {
                        className: "w-2/3 h-2/3"
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: thumbnail,
                    alt: "thumbnail",
                    className: "w-full aspect-video object-scale-down",
                    onError: (e)=>{
                        setThumbnailLoadFailed(true);
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pl-4 py-2 w-full flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row justify-between items-center h-11",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-row gap-2 items-center max-w-[90%]",
                                children: [
                                    !isDraft && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-row gap-2 overflow-y-scroll no-scrollbar items-center",
                                        children: displayedTags.map((tag)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $026ef5e4a357dace$export$5a7f9a6004988d01), {
                                                title: tag.tag.name
                                            }, tag.tag.id))
                                    }),
                                    !isDraft && remainingTagsCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        ref: remainingTagsRef,
                                        className: "text-xs text-gray-110 cursor-pointer relative",
                                        onMouseEnter: ()=>setRemainingTagsVisible(true),
                                        onMouseLeave: ()=>setRemainingTagsVisible(false),
                                        children: [
                                            "+",
                                            remainingTagsCount,
                                            isRemainingTagsVisible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-col gap-1 absolute left-0 mt-2 p-2 bg-gray-100 text-white text-xs rounded shadow-lg z-10",
                                                children: remainingTags.map((tag)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: tag.tag.name
                                                    }, tag.tag.id))
                                            })
                                        ]
                                    }),
                                    isDraft && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-red-50 text-sm bg-red-05 bg-opacity-20 px-3 py-1 rounded ",
                                        children: "Draft"
                                    })
                                ]
                            }),
                            menuItems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                                items: menuItems
                            })
                        ]
                    }),
                    isRenaming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        className: "mr-4 text-white bg-transparent border-none outline-none text-base truncate w-full overflow-hidden whitespace-nowrap",
                        onKeyUp: (e)=>e.key === 'Enter' && onRename?.(titleValue),
                        value: titleValue,
                        onChange: (e)=>setTitleValue(e.target.value),
                        onClick: (e)=>e.stopPropagation(),
                        // biome-ignore lint/a11y/noAutofocus: <explanation>
                        autoFocus: true
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-white text-base truncate w-full overflow-hidden whitespace-nowrap pr-4",
                        children: title
                    }),
                    !hideCreatedAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "flex flex-row gap-1 text-white text-xs w-full text-ellipsis",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-gray-60",
                                children: "Created"
                            }),
                            `${(0, $80cc0c4c52b399e2$export$9b9f695373d1284f)(createdAt)}`
                        ]
                    }),
                    showFrameCount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-gray-110 text-xs",
                        children: [
                            frameCount,
                            " Frame",
                            frameCount !== 1 ? 's' : ''
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");
const $353605cb782fa915$export$b1f22795a41806ac = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Avatar Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "6.5",
                stroke: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.9333 14V14C12.9333 13.2341 12.5708 12.5135 11.9559 12.0569L8.71667 9.65217L8.6574 9.60084C7.22221 8.35778 8.10133 6 10 6V6C11.8987 6 12.7778 8.35778 11.3426 9.60084L11.2833 9.65217L8.04413 12.0569C7.4292 12.5135 7.06667 13.2341 7.06667 14V14",
                stroke: "white"
            })
        ]
    });
};



parcelRequire("acw62");
const $b3afdaf27b366033$export$2c9e30524eeaa42e = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Logout Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 15H2.66667C2.22464 15 1.80072 14.8361 1.48816 14.5444C1.17559 14.2527 1 13.857 1 13.4444V2.55556C1 2.143 1.17559 1.74733 1.48816 1.45561C1.80072 1.16389 2.22464 1 2.66667 1H6",
                stroke: "#FF6577",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.543 12.4436L14.9874 7.99913L10.543 3.55469",
                stroke: "#FF6577",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.3398 8H6.33984",
                stroke: "#FF6577",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};



parcelRequire("acw62");
const $6d1ba49d39d7992a$export$8a496f5a1e4249b1 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "40",
        height: "40",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Organization Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_1965_3559)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.33203 22.5002V10.0002C8.33203 9.16683 9.16536 8.3335 9.9987 8.3335H14.1654C14.9987 8.3335 15.832 9.16683 15.832 10.0002V22.5002",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.332 11.6665H19.9987C20.832 11.6665 21.6654 12.4998 21.6654 13.3332V22.4998",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 22.5H22.5",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.3008 12H10.8008",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.3984 12H13.8984",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.3008 15.3335H10.8008",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.3984 15.3335H13.8984",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.3008 18.667H10.8008",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.3984 18.667H13.8984",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.3008 15.3398H18.8008",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M18.3008 18.6733H18.8008",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_1965_3559",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(5 5)"
                    })
                })
            })
        ]
    });
};



parcelRequire("acw62");
const $0d707626623cf067$export$ac4e8b8ca2b79f39 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Settings Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_2839_8959)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477 4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897 15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512 15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974 13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789 11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348 7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479 4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648 4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29417 4.99167 8.37417 4.54333 8.60417 3.5975Z",
                        stroke: "white",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10Z",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_2839_8959",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};



const $22923ec698324d83$export$72d0b49a56703654 = ({ user: user, onLogout: onLogout, onAccountSettings: onAccountSettings, onOrganizationSettings: onOrganizationSettings })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const toggleMenu = (e)=>{
        e.stopPropagation();
        setIsOpen((prev)=>!prev);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const getPosition = ()=>{
        const menuRect = ref.current?.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const width = 256;
        const iconWidth = 40;
        let left = menuRect?.left ?? 0;
        const top = menuRect?.bottom ?? 0;
        if (left + width > windowWidth) left = left - width;
        return {
            top: top + 10,
            left: left + iconWidth
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative inline-block",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: toggleMenu,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "rounded-full bg-blue-60 hover:bg-opacity-75 h-10 w-10 content-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-white text-center",
                        children: [
                            user?.firstName?.charAt(0).toUpperCase(),
                            user?.lastName?.charAt(0).toUpperCase()
                        ]
                    })
                })
            }),
            isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute w-64 bg-gray-100 shadow-xl rounded-md transition-all duration-100 ease-in-out overflow-y-scroll opacity-100 visible",
                style: {
                    zIndex: (0, $39e6c01191458113$export$fc1f05a49fe03882),
                    ...getPosition()
                },
                ref: menuRef,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-3 flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xxs text-gray-60",
                                children: "PROFILE"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "rounded-full bg-blue-60 h-10 w-10 content-center",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-white text-center",
                                            children: [
                                                user?.firstName?.charAt(0).toUpperCase(),
                                                user?.lastName?.charAt(0).toUpperCase()
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col pl-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-sm text-white",
                                                children: [
                                                    user?.firstName,
                                                    " ",
                                                    user?.lastName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-gray-50",
                                                children: user?.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: "flex flex-row items-center justify-center gap-1 w-full py-2 text-white border-[1px] border-gray-80 hover:bg-gray-90 text-xs rounded-md",
                                onClick: ()=>{
                                    setIsOpen(false);
                                    onAccountSettings?.();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $353605cb782fa915$export$b1f22795a41806ac), {}),
                                    "Account Settings"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "bg-gray-80 border-gray-80 opacity-20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-3 flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xxs text-gray-60",
                                children: "COMPANY"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-row",
                                children: [
                                    user?.organization?.logo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: user?.organization.logo,
                                        alt: "Organization Logo",
                                        className: "h-10 w-10 rounded-full"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d1ba49d39d7992a$export$8a496f5a1e4249b1), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col pl-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-white",
                                                children: user?.organization?.name ?? ''
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: "text-xs text-gray-50",
                                                children: [
                                                    "Role: ",
                                                    user?.type
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            user?.type === (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: "flex flex-row items-center justify-center gap-1 w-full py-2 text-white border-[1px] border-gray-80 hover:bg-gray-90 text-xs rounded-md",
                                onClick: ()=>{
                                    setIsOpen(false);
                                    onOrganizationSettings?.();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d707626623cf067$export$ac4e8b8ca2b79f39), {}),
                                    "Admin Controls"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                        className: "bg-gray-80 border-gray-80 opacity-20"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-3 hover:bg-gray-90",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            type: "button",
                            className: "flex flex-row items-center gap-1.5 w-full py-2 text-red-50 text-xs",
                            onClick: onLogout,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3afdaf27b366033$export$2c9e30524eeaa42e), {}),
                                "Logout"
                            ]
                        })
                    })
                ]
            }), document.body)
        ]
    });
};


const $aceb3606056ef313$export$c493c0fa1aa3b46 = ()=>{
    const [selectedTag, setSelectedTag] = (0, $acw62.useState)(null);
    const [selectedTemplate, setSelectedTemplate] = (0, $acw62.useState)(null);
    const [isSelectSizeModalOpen, setIsSelectSizeModalOpen] = (0, $acw62.useState)(false);
    const [isAccountSettingsOpen, setIsAccountSettingsOpen] = (0, $acw62.useState)(false);
    const [isAdminControlsOpen, setIsAdminControlsOpen] = (0, $acw62.useState)(false);
    const [templateList, setTemplateList] = (0, $acw62.useState)([]);
    const [count, setCount] = (0, $acw62.useState)(0);
    const [templateTags, setTemplateTags] = (0, $acw62.useState)([]);
    const [user, setUser] = (0, $acw62.useState)(null);
    const [query, setQuery] = (0, $acw62.useState)({
        draft: false
    });
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    const updateSelectedTag = (tag)=>{
        setSelectedTag(tag);
    };
    const { refetch: refetchTemplateList } = (0, $181035219bfd394d$export$2f5885556d0225e8)(query, {
        onSuccess: (data)=>{
            setTemplateList(data.results);
            setCount(data.totalCount - data.draftCount);
            setTemplateTags(data.tags);
        }
    });
    const fetchUser = (0, $acw62.useCallback)((refetch)=>{
        (0, $c0753412de87ef15$export$86659b0ff913db80).getCurrentUser(refetch).then((response)=>{
            setUser(response);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (selectedTemplate) setIsSelectSizeModalOpen(true);
    }, [
        selectedTemplate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isSelectSizeModalOpen) setSelectedTemplate(null);
    }, [
        isSelectSizeModalOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchUser(false);
    }, [
        fetchUser
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedTag) setQuery((prev)=>({
                ...prev,
                tag: selectedTag?.id
            }));
        else setQuery({
            draft: false
        });
    }, [
        selectedTag
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col h-screen w-screen bg-black-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {})
                }),
                trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-2.5 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c75eb4c4478911c$export$c6aea0e298dc6482), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "h-6 border-gray-100 border-l-[1px]"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22923ec698324d83$export$72d0b49a56703654), {
                            user: user,
                            onLogout: ()=>{
                                (0, $e1959a6d31579a72$export$a0973bcfe11b05c9)();
                                navigate('/login', {
                                    replace: true
                                });
                            },
                            onAccountSettings: ()=>setIsAccountSettingsOpen(true),
                            onOrganizationSettings: ()=>setIsAdminControlsOpen(true)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-white text-3xl font-normal text-center",
                children: "What do you want to create?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-h-0 flex-row h-full mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        omitSeperator: true,
                        className: "px-4 h-full w-[250px] flex-shrink-0 overflow-y-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        onClick: count > 0 ? ()=>updateSelectedTag(null) : ()=>{},
                                        onKeyUp: count > 0 ? (e)=>{
                                            if (e.key === 'Enter') updateSelectedTag(null);
                                        } : ()=>{},
                                        className: `flex flex-row justify-between items-center rounded-md px-2.5 py-2 ${selectedTag ? '' : 'bg-gray-100'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-row gap-2 items-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b0e2b9e347c28dd$export$a245117220b0b0f2), {
                                                        className: "w-4 h-4 stroke-white"
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-white text-sm font-normal",
                                                        children: "All Templates"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: `flex h-6 w-6 bg-gray-100 rounded-md ${count > 0 ? 'text-white' : 'text-gray-110'} text-xs text-center justify-center items-center`,
                                                children: count
                                            })
                                        ]
                                    }),
                                    templateTags.filter((tag)=>tag.count > 0).map((templateTag, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            onClick: ()=>updateSelectedTag(templateTag),
                                            onKeyUp: (e)=>e.key === 'Enter' && updateSelectedTag(templateTag),
                                            className: `flex flex-row justify-between items-center rounded-md px-2.5 py-2 ${selectedTag?.id !== templateTag.id ? '' : 'bg-gray-100'}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row gap-2 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "w-4 h-4"
                                                        }),
                                                        ' ',
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: "text-white text-sm font-normal",
                                                            children: templateTag.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: `flex h-6 w-6 bg-gray-100 rounded-md ${templateTag.count > 0 ? 'text-white' : 'text-gray-110'} text-xs text-center justify-center items-center`,
                                                    children: templateTag.count
                                                })
                                            ]
                                        }, templateTag.id))
                                ]
                            }, "all-templates")
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "border-r-[1px] border-gray-120 h-[65vh]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col flex-grow overflow-hidden",
                        children: [
                            templateList.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex flex-col items-center justify-center flex-grow",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd5d46306eb83dc9$export$d7db36bc683573), {
                                    className: "h-32 w-28"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "min-h-0 overflow-y-scroll flex-1 no-scrollbar px-4 pb-4",
                                children: templateList.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "mt-5 no-scrollbar",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "grid gap-6 justify-stretch grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] max-sm:grid-cols-1",
                                        children: templateList.map((template)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a2ffb9ba471d3e$export$16a9184edda9e700), {
                                                title: template.name,
                                                hideCreatedAt: true,
                                                showFrameCount: true,
                                                frameCount: template.variantCount,
                                                createdAt: template.createdAt,
                                                tags: template.tags,
                                                thumbnail: template.publishedVersion.thumbnail,
                                                onClick: ()=>setSelectedTemplate(template)
                                            }, template.id))
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $128555b314748f01$export$652e388e958caf8), {
                isOpen: isSelectSizeModalOpen,
                setIsOpen: setIsSelectSizeModalOpen,
                templateId: selectedTemplate?.id ?? -1,
                onDone: (creativeId)=>{
                    setIsSelectSizeModalOpen(false);
                    navigate(`/creatives/generate/${creativeId}`);
                }
            }),
            user?.type === (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4096c6d546e14db9$export$ab5bd7780c936eb2), {
                isOpen: isAdminControlsOpen,
                setIsOpen: setIsAdminControlsOpen,
                onAccountUpdated: ()=>fetchUser(true)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee9165ed7aac49d0$export$2ec38366d6add659), {
                isOpen: isAccountSettingsOpen,
                setIsOpen: setIsAccountSettingsOpen,
                onAccountUpdated: ()=>fetchUser(true)
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
function $bd820b171ebe1162$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4.5v15m7.5-7.5h-15"
    }));
}
const $bd820b171ebe1162$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($bd820b171ebe1162$var$PlusIcon);
var $bd820b171ebe1162$export$2e2bcd8739ae039 = $bd820b171ebe1162$var$ForwardRef;



var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");


var $d6fbad6cc0f9b3f8$export$b71090edac4832f0 = /*#__PURE__*/ function(ConfirmationModalType) {
    ConfirmationModalType["WARN"] = "WARN";
    ConfirmationModalType["DEFAULT"] = "DEFAULT";
    return ConfirmationModalType;
}({});
const $d6fbad6cc0f9b3f8$export$1f33f980da756c46 = ({ onCancel: onCancel, onConfirm: onConfirm, confirmText: confirmText, cancelText: cancelText, message: message, subMessage: subMessage, isOpen: isOpen, setIsOpen: setIsOpen, type: type })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[38vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col p-4 gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl text-white",
                            children: message
                        }),
                        subMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white",
                            children: subMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: cancelText,
                            className: "px-5",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: ()=>{
                                setIsOpen(false);
                                onCancel?.();
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: confirmText,
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            className: `${type === "DEFAULT" ? 'bg-blue-60' : 'bg-red-50'} text-white px-8`,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: ()=>{
                                setIsOpen(false);
                                onConfirm?.();
                            }
                        })
                    ]
                })
            ]
        })
    });
};








var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");
const $0ea415cf0d608da9$export$9f8870621d779f41 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "17",
        viewBox: "0 0 20 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Bin Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7 5.99999H13V4.5C13 3.94771 12.5523 3.5 12 3.5H8C7.44772 3.5 7 3.94771 7 4.5V5.99999Z",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M5 6L5.91379 15.5948C5.96267 16.108 6.39373 16.5 6.90929 16.5H13.0907C13.6063 16.5 14.0373 16.108 14.0862 15.5948L15 6"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4 6H16"
            })
        ]
    });
};




const $7c4a2f417ac728b7$export$8b9b55c785b7377d = ({ index: index, title: title, thumbnail: thumbnail, size: size, onClick: onClick, isActive: isActive, onDelete: onDelete })=>{
    const [thumbnailLoadFailed, setThumbnailLoadFailed] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-2 relative group",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `w-full h-[175px] flex items-center justify-center chess-sm transition-opacity ${isActive ? 'bg-gray-100' : 'bg-black-50 hover:opacity-80 cursor-pointer'} rounded p-2 relative`,
                onClick: onClick,
                onKeyUp: (e)=>e.key === 'Enter' && onClick?.(),
                children: [
                    onDelete && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onDelete,
                        style: {
                            zIndex: (0, $39e6c01191458113$export$f4d455029c4b5e98)
                        },
                        className: "absolute top-2 right-2 text-white bg-gray-100 bg-opacity-70 transition-colors rounded-sm w-6 h-6 items-center justify-center text-xs hidden group-hover:flex",
                        title: "Delete",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                            className: "stroke-red"
                        })
                    }),
                    thumbnailLoadFailed || !thumbnail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $115490f100597f79$export$385cd24c05318684), {
                        className: "w-2/3 h-2/3"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: thumbnail,
                        alt: "thumbnail",
                        className: "w-full h-full rounded object-contain aspect-square",
                        onError: (e)=>{
                            setThumbnailLoadFailed(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center min-w-0 relative",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: `h-5 w-5 bg-gray-90 rounded-md text-xs ${isActive ? 'text-white' : 'text-gray-50'} text-center`,
                                children: index
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "relative group/title max-w-[120px]",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: `text-xs truncate ${isActive ? 'text-white' : 'text-gray-50'}`,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        style: {
                                            wordBreak: 'break-word'
                                        },
                                        className: "absolute z-10 top-6 bg-gray-100 text-white text-xs px-2 py-1 rounded shadow-lg opacity-0 group-hover/title:opacity-100 transition delay-200 pointer-events-none",
                                        children: title
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-110",
                        children: size
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");
var $7d9bc89b6f6789c6$exports = {};

$parcel$export($7d9bc89b6f6789c6$exports, "spinner", () => $7d9bc89b6f6789c6$export$641374ffb95bc399, (v) => $7d9bc89b6f6789c6$export$641374ffb95bc399 = v);
$parcel$export($7d9bc89b6f6789c6$exports, "spinner_anim", () => $7d9bc89b6f6789c6$export$4122a467c21964dd, (v) => $7d9bc89b6f6789c6$export$4122a467c21964dd = v);
var $7d9bc89b6f6789c6$export$641374ffb95bc399;
var $7d9bc89b6f6789c6$export$4122a467c21964dd;
$7d9bc89b6f6789c6$export$641374ffb95bc399 = `UhblkW_spinner`;
$7d9bc89b6f6789c6$export$4122a467c21964dd = `UhblkW_spinner_anim`;
$7d9bc89b6f6789c6$export$4122a467c21964dd;


const $34d8235af5e46636$export$b936c55164dcf1db = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Loading Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z",
                opacity: ".25"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7d9bc89b6f6789c6$exports))).spinner
            })
        ]
    });
};





var $968174007839e703$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["CreateSession"] = "create-session";
    MessageType["DestroySession"] = "destroy-session";
    MessageType["LoadFont"] = "load-font";
    MessageType["RenderText"] = "render-text";
    return MessageType;
}({});


const $44052192468fac4a$var$cbMap = new Map();
var $07b8d204926cf493$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $07b8d204926cf493$var$url = new URL("worker.b9129586.js", import.meta.url);
$07b8d204926cf493$exports = $56b621a6dd25b2cb$exports($07b8d204926cf493$var$url.toString(), $07b8d204926cf493$var$url.origin, true);


const $44052192468fac4a$var$worker = new Worker($07b8d204926cf493$exports);
$44052192468fac4a$var$worker.addEventListener('message', $44052192468fac4a$var$handleMessages);
function $44052192468fac4a$var$handleMessages(event) {
    const { id: id, payload: payload } = event.data;
    const callback = $44052192468fac4a$var$cbMap.get(id);
    if (callback) {
        callback(payload);
        $44052192468fac4a$var$cbMap.delete(id);
    }
}
function $44052192468fac4a$var$sendMessage(type, payload, callback) {
    const id = Math.random().toString(36);
    if (callback) $44052192468fac4a$var$cbMap.set(id, callback);
    $44052192468fac4a$var$worker.postMessage({
        id: id,
        type: type,
        payload: payload
    });
}
function $44052192468fac4a$export$f7c62c73429afa28(callback) {
    $44052192468fac4a$var$sendMessage((0, $968174007839e703$export$80edbf15fa61a4db).CreateSession, null, callback);
}
function $44052192468fac4a$export$d855ee81853de6d2(sessionId, callback) {
    $44052192468fac4a$var$sendMessage((0, $968174007839e703$export$80edbf15fa61a4db).DestroySession, {
        sessionId: sessionId
    }, callback);
}
function $44052192468fac4a$export$672089c3debc1182(sessionId, font, callback) {
    $44052192468fac4a$var$sendMessage((0, $968174007839e703$export$80edbf15fa61a4db).LoadFont, {
        sessionId: sessionId,
        font: font
    }, callback);
}
function $44052192468fac4a$export$482c90f94eb9717c(sessionId, text, properties, bounds, callback) {
    $44052192468fac4a$var$sendMessage((0, $968174007839e703$export$80edbf15fa61a4db).RenderText, {
        sessionId: sessionId,
        text: text,
        properties: properties,
        bounds: bounds
    }, callback);
}








var $acw62 = parcelRequire("acw62");
const $cb50cfb588d020e2$export$d4b7c69927f72773 = ({ dataColumns: dataColumns, dataRows: dataRows, setDataRows: setDataRows, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [rows, setRows] = (0, $acw62.useState)([
        ...dataRows,
        new Array(dataColumns.length).fill('')
    ]);
    const tableBodyRef = (0, $acw62.useRef)(null);
    const dynamicWidth = Math.min(dataColumns.length * 20, 50);
    (0, $acw62.useEffect)(()=>{
        if (rows.length < 10) setRows((prevRows)=>{
            const newRows = [
                ...prevRows
            ];
            const rowsToAdd = 10 - newRows.length;
            for(let i = 0; i < rowsToAdd; i++)newRows.push(new Array(dataColumns.length).fill(''));
            return newRows;
        });
    }, [
        dataColumns.length,
        rows.length
    ]);
    const handleInputChange = (e, rowIndex, colIndex)=>{
        const value = e.target.value;
        setRows((prevRows)=>{
            const newRows = [
                ...prevRows
            ];
            newRows[rowIndex] = [
                ...newRows[rowIndex]
            ];
            newRows[rowIndex][colIndex] = value;
            if (rowIndex === newRows.length - 1 && newRows[rowIndex].every((cell)=>cell !== '')) newRows.push(new Array(dataColumns.length).fill(''));
            return newRows;
        });
    };
    const handleSave = ()=>{
        setDataRows(rows.filter((row)=>row.some((cell)=>cell.trim() !== '')));
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out overflow-hidden",
            style: {
                width: `${dynamicWidth}vw`,
                maxWidth: '50vw',
                maxHeight: '80vh'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row justify-between p-4 items-center bg-gray-900 rounded-t-xl",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-white text-xl",
                            children: "Add Bulk Content"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                            onClick: ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "overflow-x-auto max-w-full",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-y-auto p-3 no-scrollbar",
                        style: {
                            maxHeight: '60vh'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "border text-center border-gray-100 border-collapse min-w-max w-full rounded-lg overflow-hidden outline outline-1 outline-gray-100",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-100 rounded-t-lg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "p-2 rounded-tl-lg border text-white border-gray-100"
                                            }),
                                            dataColumns.map((col, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                    className: `w-[20vw] text-white text-sm font-normal text-left p-2 border border-gray-100 ${index === dataColumns.length - 1 ? 'rounded-tr-lg' : ''}`,
                                                    children: col
                                                }, col))
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    ref: tableBodyRef,
                                    className: "bg-gray-800",
                                    children: rows.map((row, rowIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("td", {
                                                    className: "text-xs text-white font-normal border border-gray-100 px-2",
                                                    children: [
                                                        rowIndex + 1,
                                                        "."
                                                    ]
                                                }),
                                                row.map((cell, colIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                        className: "border border-gray-100 px-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                            type: "text",
                                                            className: "w-full bg-transparent text-white border-none outline-none p-1",
                                                            value: cell,
                                                            onChange: (e)=>handleInputChange(e, rowIndex, colIndex)
                                                        })
                                                    }, `col-${colIndex + 1}`))
                                            ]
                                        }, `row-${rowIndex + 1}`))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Cancel",
                            className: "hover:bg-gray-160",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: ()=>setIsOpen(false)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Yes",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: handleSave
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");


const $6e8cf1572ce78567$export$2108acd8032f65c2 = ({ index: index, fields: fields, fieldValues: fieldValues, onChange: onChange, className: className, isSelected: isSelected, onDelete: onDelete, onClick: onClick })=>{
    const [isError, setIsError] = (0, $acw62.useState)(false);
    const [texts, setTexts] = (0, $acw62.useState)(fieldValues.reduce((acc, fieldValue)=>{
        acc[fieldValue.field] = fieldValue.value;
        return acc;
    }, {}));
    const handleTextChange = (value, fieldId)=>{
        setTexts((prevTexts)=>({
                ...prevTexts,
                [fieldId]: value
            }));
        if (value !== '') {
            const fieldValue = fieldValues.find((fv)=>fv.field === fieldId);
            onChange(value, fieldId, fieldValue?.id);
            setIsError(false);
        } else setIsError(true);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex flex-col gap-2 ${className}`,
        onClick: onClick,
        onKeyDown: (e)=>e.key === 'Enter' && onClick && onClick(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row justify-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "text-sm text-gray-100",
                        children: [
                            "Version ",
                            index + 1
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: onDelete,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                            className: "stroke-red-50 hover:opacity-70"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `bg-gray-130 rounded p-3 flex flex-col gap-5 ${isSelected && !isError ? 'border-blue-60 border-solid border-[1px]' : isError ? 'border-red-50 border-solid border-[1px]' : ''}`,
                children: fields.map((field)=>{
                    const fieldId = field.id;
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-row justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-white",
                                        children: field.name
                                    }),
                                    field.properties.charLimit > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                        className: "text-sm text-gray-110",
                                        children: [
                                            field.properties.charLimit - (texts[fieldId] || '').length,
                                            " characters left"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                className: "mt-1",
                                id: "text-f",
                                type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                value: texts[fieldId] || '',
                                maxLength: field.properties.charLimit > 0 ? field.properties.charLimit : undefined,
                                onChange: (value)=>handleTextChange(value, fieldId),
                                placeholder: "Enter Text"
                            })
                        ]
                    }, field.id);
                })
            })
        ]
    });
};



parcelRequire("acw62");

parcelRequire("acw62");
const $a11906f52e293a19$export$a55cbd7077614be3 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        viewBox: "0 0 200 200",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Circular Loading Animation"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                id: "a12",
                cx: ".66",
                fx: ".66",
                cy: ".3125",
                fy: ".3125",
                gradientTransform: "scale(1.5)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "0",
                        stopColor: "#3A50FF"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".3",
                        stopColor: "#3A50FF",
                        stopOpacity: ".9"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".6",
                        stopColor: "#3A50FF",
                        stopOpacity: ".6"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: ".8",
                        stopColor: "#3A50FF",
                        stopOpacity: ".3"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "1",
                        stopColor: "#3A50FF",
                        stopOpacity: "0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                "transform-origin": "center",
                fill: "none",
                stroke: "url(#a12)",
                strokeWidth: "15",
                strokeLinecap: "round",
                strokeDasharray: "200 1000",
                strokeDashoffset: "0",
                cx: "100",
                cy: "100",
                r: "70",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("animateTransform", {
                    type: "rotate",
                    attributeName: "transform",
                    calcMode: "spline",
                    dur: "2",
                    values: "360;0",
                    keyTimes: "0;1",
                    keySplines: "0 0 1 1",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                "transform-origin": "center",
                fill: "none",
                opacity: ".2",
                stroke: "#3A50FF",
                strokeWidth: "15",
                strokeLinecap: "round",
                cx: "100",
                cy: "100",
                r: "70"
            })
        ]
    });
};






parcelRequire("acw62");
const $b4c7625211ce832c$export$8f31e4c4a37b8e9c = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `${className} animate-pulse bg-gray-90 rounded-full`
    });
};


const $7a8e6792b42d25b8$export$e2b0760399e6dece = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col min-h-0 h-screen w-full bg-black-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                type: (0, $b3f317f73d7705c5$export$9baf8232abef7d17).LIGHT,
                leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                            className: "w-32 h-5"
                        })
                    ]
                }),
                center: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-blue-60 h-9 w-28 rounded"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-h-0 flex-row h-full max-w-full min-w-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        className: "pl-4 py-4 h-full w-64 flex-shrink-0 flex-grow-0",
                        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col gap-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-40 h-5 mt-1"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: " px-4 flex flex-col gap-2 h-full max-h-full min-h-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-20 h-5 mt-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-full bg-black-50 h-40 rounded "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-row items-center justify-between",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                            className: "w-24 h-5"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "w-full h-full flex flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a11906f52e293a19$export$a55cbd7077614be3), {
                                className: "w-16 h-16"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-60 text-2xl",
                                children: "Loading creative..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        className: "pr-4 py-4 h-full w-80 flex-shrink-0 flex-grow-0",
                        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                        width: 360,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-row items-center justify-between",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-32 h-5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "flex flex-col items-center justify-center gap-2 h-full max-h-full min-h-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-[80%] h-5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-[60%] h-5"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");



parcelRequire("acw62");
const $f59acfd5294da285$export$f7dc499a72baa103 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Warning Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 6L10 11",
                stroke: "#FE9549",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10 12L10 14",
                stroke: "#FE9549",
                strokeWidth: "1.11111"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "9.99956",
                cy: "10.0035",
                rx: "7.22222",
                ry: "7.22222",
                stroke: "#FE9549",
                strokeWidth: "1.11111"
            })
        ]
    });
};


const $f04a709768d59d66$export$538b5176caa38d01 = ({ onCancel: onCancel, onConfirm: onConfirm, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[42vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-2 p-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f59acfd5294da285$export$f7dc499a72baa103), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-lg text-orange-60",
                            children: "You May Lose Content"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col px-4 py-6 gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-base text-gray-50 font-normal",
                            children: "The template used in this creative has been updated by the designer. You may lose some or all of your previously entered content."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-lg text-white",
                            children: "Do you wish to continue editing this creative?"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full flex flex-row justify-end gap-3 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Cancel",
                            className: "px-5",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: ()=>{
                                setIsOpen(false);
                                onCancel?.();
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Continue to Edit",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            onClick: ()=>{
                                setIsOpen(false);
                                onConfirm?.();
                            }
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $af9e91ea6e32034a$exports = {};
'use strict';
var $daecaa38e3584fd1$exports = {};

$parcel$export($daecaa38e3584fd1$exports, "createStore", () => $daecaa38e3584fd1$export$f51a9068ac82ea43, (v) => $daecaa38e3584fd1$export$f51a9068ac82ea43 = v);
var $daecaa38e3584fd1$export$f51a9068ac82ea43;
'use strict';
const $daecaa38e3584fd1$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $daecaa38e3584fd1$var$createStore = (createState)=>createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
$daecaa38e3584fd1$export$f51a9068ac82ea43 = $daecaa38e3584fd1$var$createStore;


var $63520617a3b9f74e$exports = {};

$parcel$export($63520617a3b9f74e$exports, "create", () => $63520617a3b9f74e$export$185802fd694ee1f5, (v) => $63520617a3b9f74e$export$185802fd694ee1f5 = v);
$parcel$export($63520617a3b9f74e$exports, "useStore", () => $63520617a3b9f74e$export$6ccbb43953eebf8, (v) => $63520617a3b9f74e$export$6ccbb43953eebf8 = v);
var $63520617a3b9f74e$export$185802fd694ee1f5;
var $63520617a3b9f74e$export$6ccbb43953eebf8;
'use strict';

var $acw62 = parcelRequire("acw62");

const $63520617a3b9f74e$var$identity = (arg)=>arg;
function $63520617a3b9f74e$var$useStore(api, selector = $63520617a3b9f74e$var$identity) {
    const slice = $acw62.useSyncExternalStore(api.subscribe, ()=>selector(api.getState()), ()=>selector(api.getInitialState()));
    $acw62.useDebugValue(slice);
    return slice;
}
const $63520617a3b9f74e$var$createImpl = (createState)=>{
    const api = $daecaa38e3584fd1$export$f51a9068ac82ea43(createState);
    const useBoundStore = (selector)=>$63520617a3b9f74e$var$useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $63520617a3b9f74e$var$create = (createState)=>createState ? $63520617a3b9f74e$var$createImpl(createState) : $63520617a3b9f74e$var$createImpl;
$63520617a3b9f74e$export$185802fd694ee1f5 = $63520617a3b9f74e$var$create;
$63520617a3b9f74e$export$6ccbb43953eebf8 = $63520617a3b9f74e$var$useStore;


Object.keys($daecaa38e3584fd1$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($af9e91ea6e32034a$exports, k)) Object.defineProperty($af9e91ea6e32034a$exports, k, {
        enumerable: true,
        get: function() {
            return $daecaa38e3584fd1$exports[k];
        }
    });
});
Object.keys($63520617a3b9f74e$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($af9e91ea6e32034a$exports, k)) Object.defineProperty($af9e91ea6e32034a$exports, k, {
        enumerable: true,
        get: function() {
            return $63520617a3b9f74e$exports[k];
        }
    });
});


var $5ec635760157368f$export$1be1fc439b849fdf;
var $5ec635760157368f$export$95a3b7b12ab518f9;
var $5ec635760157368f$export$6922d3b3a607469e;
var $5ec635760157368f$export$9a6132153fba2e0;
var $5ec635760157368f$export$4feba8a1bc8e9afd;
var $5ec635760157368f$export$5c593627aef9f076;
'use strict';
const $5ec635760157368f$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $5ec635760157368f$var$redux = $5ec635760157368f$var$reduxImpl;
const $5ec635760157368f$var$trackedConnections = /* @__PURE__ */ new Map();
const $5ec635760157368f$var$getTrackedConnectionState = (name)=>{
    const api = $5ec635760157368f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $5ec635760157368f$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $5ec635760157368f$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5ec635760157368f$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $5ec635760157368f$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $5ec635760157368f$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null ? undefined : connection.send(action, get());
                return r;
            }
            connection == null ? undefined : connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$5ec635760157368f$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null ? undefined : connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null ? undefined : connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5ec635760157368f$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? undefined : connection.init(api.getState());
                            return connection == null ? undefined : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null ? undefined : connection.init(api.getState());
                                return;
                            }
                            return connection == null ? undefined : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5ec635760157368f$var$parseJsonThen(message.state, (state)=>{
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null ? undefined : connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null ? undefined : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5ec635760157368f$var$parseJsonThen(message.state, (state)=>{
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? undefined : _a.state;
                                if (!lastComputedState) return;
                                if (store === undefined) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null ? undefined : connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $5ec635760157368f$var$devtools = $5ec635760157368f$var$devtoolsImpl;
const $5ec635760157368f$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
const $5ec635760157368f$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? undefined : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? undefined : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $5ec635760157368f$var$subscribeWithSelector = $5ec635760157368f$var$subscribeWithSelectorImpl;
const $5ec635760157368f$var$combine = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $5ec635760157368f$var$createJSONStorage(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? undefined : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? undefined : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $5ec635760157368f$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $5ec635760157368f$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $5ec635760157368f$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $5ec635760157368f$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $5ec635760157368f$var$createJSONStorage(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? undefined : _b.call(options, (_a = get()) != null ? _a : configResult)) || undefined;
            return $5ec635760157368f$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    undefined
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null ? undefined : postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null ? undefined : postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null ? undefined : storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $5ec635760157368f$var$persist = $5ec635760157368f$var$persistImpl;
$5ec635760157368f$export$1be1fc439b849fdf = $5ec635760157368f$var$combine;
$5ec635760157368f$export$95a3b7b12ab518f9 = $5ec635760157368f$var$createJSONStorage;
$5ec635760157368f$export$6922d3b3a607469e = $5ec635760157368f$var$devtools;
$5ec635760157368f$export$9a6132153fba2e0 = $5ec635760157368f$var$persist;
$5ec635760157368f$export$4feba8a1bc8e9afd = $5ec635760157368f$var$redux;
$5ec635760157368f$export$5c593627aef9f076 = $5ec635760157368f$var$subscribeWithSelector;


var $6901b3de930503c1$export$428de7ec69ac95c;
'use strict';
var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $5f9e38360d79f95a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $5f9e38360d79f95a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $5f9e38360d79f95a$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $5f9e38360d79f95a$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true));
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
function $5f9e38360d79f95a$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !$5f9e38360d79f95a$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}


const $6901b3de930503c1$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? $5f9e38360d79f95a$export$b46cabe22e78bc00(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $6901b3de930503c1$var$immer = $6901b3de930503c1$var$immerImpl;
$6901b3de930503c1$export$428de7ec69ac95c = $6901b3de930503c1$var$immer;


const $97fe04345e64e768$var$initState = {
    creative: null,
    currentVariantIndex: -1,
    etcherId: null,
    fontFiles: {},
    selectedContentVariantIndex: -1,
    svgFiles: {}
};
const $97fe04345e64e768$export$7c15f74b3e9fa2c7 = (0, $af9e91ea6e32034a$exports.create)()((0, $5ec635760157368f$export$5c593627aef9f076)((0, $6901b3de930503c1$export$428de7ec69ac95c)((set)=>({
        ...$97fe04345e64e768$var$initState,
        setCreative: (creative)=>set({
                creative: creative
            }),
        setCurrentVariantIndex: (index)=>set({
                currentVariantIndex: index
            }),
        setSelectedContentVariantIndex: (index)=>set({
                selectedContentVariantIndex: index
            }),
        setEtcherId: (id)=>set({
                etcherId: id
            }),
        addContentVariant: (variant)=>set((state)=>{
                if (state.creative) state.creative.contentVariants.push(variant);
                return state;
            }),
        removeContentVariant: (variantId)=>set((state)=>{
                if (state.creative) state.creative.contentVariants = state.creative.contentVariants.filter((variant)=>variant.id !== variantId);
                return state;
            }),
        setFieldValue: (variantId, fieldValue)=>set((state)=>{
                if (state.creative) {
                    const variant = state.creative.contentVariants.find((v)=>v.id === variantId);
                    if (variant) {
                        const existingIndex = variant.fieldValues.findIndex((fv)=>fv.id === fieldValue.id);
                        if (existingIndex >= 0) {
                            const newFieldValue = Object.assign({}, variant.fieldValues[existingIndex], fieldValue);
                            newFieldValue.value = fieldValue.value;
                            variant.fieldValues[existingIndex] = newFieldValue;
                        } else variant.fieldValues.push(fieldValue);
                    }
                }
                return state;
            }),
        removeFieldValue: (variantId, fieldValueId)=>set((state)=>{
                if (state.creative) {
                    const variant = state.creative.contentVariants.find((v)=>v.id === variantId);
                    if (variant) variant.fieldValues = variant.fieldValues.filter((fv)=>fv.id !== fieldValueId);
                }
                return state;
            }),
        addFontFile: (url, fontFile)=>set((state)=>{
                state.fontFiles = {
                    ...state.fontFiles,
                    [url]: fontFile
                };
                return state;
            }),
        addSvgFile: (url, svgFile)=>set((state)=>{
                state.svgFiles = {
                    ...state.svgFiles,
                    [url]: svgFile
                };
                return state;
            }),
        clear: ()=>set(()=>$97fe04345e64e768$var$initState)
    }))));


var $5456500df1d2a4be$export$58f0342b999de2f1 = /*#__PURE__*/ function(ReplacementLayerType) {
    ReplacementLayerType["Text"] = "text";
    return ReplacementLayerType;
}({});
const $5456500df1d2a4be$export$b89a827e9254211a = ({ variant: variant, replacementLayers: replacementLayers })=>{
    const etcherId = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.etcherId);
    const svgContent = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.svgFiles[variant.svgFile.file]);
    const [svgNode, setSvgNode] = (0, $acw62.useState)(null);
    const width = variant.svgFile.width;
    const height = variant.svgFile.height;
    const svgRef = (0, $acw62.useCallback)((node)=>{
        if (node) {
            const svg = node.querySelector('svg');
            svg.setAttribute('width', width.toString());
            svg.setAttribute('height', height.toString());
            setSvgNode(svg);
        }
    }, [
        width,
        height
    ]);
    (0, $acw62.useEffect)(()=>{
        if (replacementLayers && svgNode) {
            // Optimisitcally wait for etcher session to be created
            if (!etcherId) return;
            for (const layer of replacementLayers){
                const node = svgNode.querySelector(`[data-ntgl-layer-id="${layer.layerUuid}"]`);
                if (!node) return;
                (0, $44052192468fac4a$export$482c90f94eb9717c)(etcherId, layer.props.text, {
                    font_family: layer.props.fontFamily,
                    font_style: layer.props.fontStyle,
                    font_weight: layer.props.fontWeight.toString(),
                    font_stretch: 'normal',
                    font_size: layer.props.fontSize,
                    line_height: layer.props.lineHeight,
                    color: layer.props.fill
                }, {
                    width: layer.rect.width,
                    height: layer.rect.height
                }, (res)=>{
                    const g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                    g.setAttribute('data-ntgl-layer-id', layer.layerUuid);
                    g.setAttribute('transform', `translate(${layer.rect.x}, ${layer.rect.y})`);
                    g.innerHTML = res.path_data;
                    node.replaceWith(g);
                });
            }
        }
    }, [
        etcherId,
        replacementLayers,
        svgNode
    ]);
    return svgContent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col justify-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row mb-1 gap-2",
                style: {
                    width: `${width}px`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-white text-xs overflow-hidden whitespace-nowrap text-ellipsis flex-shrink-0 max-w-[60%]",
                        title: variant.name,
                        children: variant.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-gray-110 text-xs overflow-hidden whitespace-nowrap text-ellipsis max-w-[40%]",
                        title: `${width}x${height}`,
                        children: `${width}x${height}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: svgRef,
                className: "border border-gray-150 pointer-events-none",
                // biome-ignore lint/security/noDangerouslySetInnerHtml: will be updated to use a safer method
                dangerouslySetInnerHTML: {
                    __html: svgContent
                }
            })
        ]
    });
};



const $a8a7368584b71d9e$export$208cd1682bd0e4b6 = ()=>{
    const currentVariant = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>{
        const currentVariantIndex = s.currentVariantIndex;
        return currentVariantIndex >= 0 ? s.creative?.creativeVariants[currentVariantIndex].variant : null;
    });
    const fields = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.creative?.templateVersion.fields);
    const selectedContentVariant = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>{
        const selectedContentVariantIndex = s.selectedContentVariantIndex;
        return selectedContentVariantIndex >= 0 ? s.creative?.contentVariants[selectedContentVariantIndex] : null;
    });
    const [replacementLayers, setReplacementLayers] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState([]);
    (0, $acw62.useEffect)(()=>{
        const updatedReplacementLayers = [];
        for (const fieldValue of selectedContentVariant?.fieldValues || []){
            const field = fields?.find((f)=>f.id === fieldValue.field);
            const linkedLayer = field?.linkedLayers?.find((l)=>l.variant === currentVariant?.id);
            if (linkedLayer) updatedReplacementLayers.push({
                layerUuid: linkedLayer.layerUuid,
                type: (0, $5456500df1d2a4be$export$58f0342b999de2f1).Text,
                rect: {
                    x: linkedLayer.posX,
                    y: linkedLayer.posY,
                    width: linkedLayer.width,
                    height: linkedLayer.height
                },
                props: {
                    text: fieldValue.value,
                    fontSize: linkedLayer.fontSize,
                    fontFamily: linkedLayer.fontFamily,
                    fontWeight: linkedLayer.fontWeight,
                    fontStyle: linkedLayer.fontStyle,
                    lineHeight: linkedLayer.lineHeight,
                    fill: linkedLayer.fill,
                    autoScaling: field?.properties.autoTextScaling || false,
                    charLimit: field?.properties.charLimit || 0
                }
            });
        }
        setReplacementLayers(updatedReplacementLayers);
    }, [
        currentVariant,
        fields,
        selectedContentVariant?.fieldValues
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-row bg-gray-800 w-full h-full p-6 justify-around items-center gap-6 overflow-auto",
        children: currentVariant && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5456500df1d2a4be$export$b89a827e9254211a), {
            variant: currentVariant,
            replacementLayers: replacementLayers
        })
    });
};



const $1cc5cad0fc5518ab$var$FIELD_VALUE_DEBOUNCE_TIME = 2000;
const $1cc5cad0fc5518ab$export$3fcee1fdbf6e7703 = ()=>{
    const params = (0, $32578012b727878c$export$99eaa27ddbbb95ef)();
    const creativeId = Number.parseInt(params.creativeId || '');
    if (Number.isNaN(creativeId)) {
        console.error('Invalid params ID in url params:', params.creativeId);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
            to: "/creatives",
            replace: true
        });
    }
    const creative = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.creative);
    const currentVariantIndex = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.currentVariantIndex);
    const etcherId = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.etcherId);
    const selectedContentVariantIndex = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.selectedContentVariantIndex);
    const setCreative = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.setCreative);
    const setCurrentVariantIndex = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.setCurrentVariantIndex);
    const setSelectedContentVariantIndex = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.setSelectedContentVariantIndex);
    const setEtcherId = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.setEtcherId);
    const addContentVariant = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.addContentVariant);
    const removeContentVariant = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.removeContentVariant);
    const setFieldValue = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.setFieldValue);
    const removeFieldValue = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.removeFieldValue);
    const addFontFile = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.addFontFile);
    const addSvgFile = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.addSvgFile);
    const clearStore = (0, $97fe04345e64e768$export$7c15f74b3e9fa2c7)((s)=>s.clear);
    const [initFetchComplete, setInitFetchComplete] = (0, $acw62.useState)(false);
    const [isSelectSizeModalOpen, setSelectSizeModalOpen] = (0, $acw62.useState)(false);
    const [isSwitchToBulkConfirmationModalOpen, setSwitchToBulkConfirmationModalOpen] = (0, $acw62.useState)(false);
    const [isBulkDataModalOpen, setIsBulkDataModalOpen] = (0, $acw62.useState)(false);
    const [isExportModalOpen, setIsExportModalOpen] = (0, $acw62.useState)(false);
    const [isReconcileConfirmationModalOpen, setIsReconcileConfirmationModalOpen] = (0, $acw62.useState)(false);
    const [dataColumns, setDataColumns] = (0, $acw62.useState)([
        'Col 01',
        'Col 02',
        'Col 03'
    ]);
    const [dataRows, setDataRows] = (0, $acw62.useState)([
        [
            'Data 01',
            'Data 02',
            'Data 03'
        ]
    ]);
    const [exportCount, setExportCount] = (0, $acw62.useState)(0);
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    const { refetch: refetchCreative } = (0, $ac3e639a16f09c99$export$7012850773d85ce3)(creativeId, {
        onSuccess: async (creative)=>{
            setCreative(creative);
            setExportCount((creative?.contentVariants.length || 0) * (creative?.creativeVariants.length || 0));
            setCurrentVariantIndex(0);
            if (creative.contentVariants.length > 0) setSelectedContentVariantIndex(0);
            setIsReconcileConfirmationModalOpen(creative.shouldReconcile);
        },
        staleTime: Number.POSITIVE_INFINITY,
        cacheTime: 0
    });
    const { mutate: reconcileCreative } = (0, $ac3e639a16f09c99$export$fbe1e8284300e19b)();
    const { mutate: createFieldValue, isLoading: isCreateFieldValueLoading } = (0, $3205bad321c9d9e6$export$5d7d793a29913d45)();
    const { mutate: updateFieldValue, isLoading: isUpdateFieldValueLoading } = (0, $3205bad321c9d9e6$export$12bf8cc8fd0d0ea9)();
    const { mutate: createContentVariant, isLoading: isCreateContentVariantLoading } = (0, $c4b3f247e841d90c$export$59c172d1de7514a4)();
    const { mutate: deleteContentVariant, isLoading: isDeleteConentVariantLoading } = (0, $c4b3f247e841d90c$export$656fd34a246c19f9)();
    const { mutate: createExport } = (0, $00f460ddb596a095$export$55dd908b31935d23)();
    const fonts = creative?.templateVersion.variants.flatMap((v)=>v.svgFile.availableFonts) || [];
    const fontFileQueryResults = (0, $1232e344916108aa$export$8241329de5df3c0f)(fonts, {
        enabled: !!creative
    });
    const fontFilesLoaded = fontFileQueryResults.every((result)=>result.isSuccess);
    const svgFiles = creative?.creativeVariants.map((cv)=>cv.variant.svgFile.file) || [];
    const svgFileQueryResults = (0, $4856298da5031936$export$aec46e5bb7a508cb)(svgFiles, {
        enabled: !!creative
    });
    const svgFilesLoaded = svgFileQueryResults.every((result)=>result.isSuccess);
    const debouncedUpdateFieldValue = (0, $acw62.useCallback)((0, $80cc0c4c52b399e2$export$61fc7d43ac8f84b0)((fieldValue, origFieldValue)=>{
        updateFieldValue({
            id: fieldValue.id,
            value: fieldValue.value
        }, {
            onError: (data)=>{
                setFieldValue(fieldValue.contentVariant, origFieldValue);
            }
        });
    }, $1cc5cad0fc5518ab$var$FIELD_VALUE_DEBOUNCE_TIME), []);
    const handleContentVariantFieldChange = (text, fieldId, contentVariantId, fieldValueId)=>{
        if (!fieldValueId) createFieldValue({
            contentVariant: contentVariantId,
            field: fieldId,
            value: text
        }, {
            onSuccess: (data)=>{
                setFieldValue(contentVariantId, data);
            }
        });
        else {
            const fieldValue = creative?.contentVariants.find((cv)=>cv.id === contentVariantId)?.fieldValues.find((fv)=>fv.id === fieldValueId);
            if (fieldValue) {
                const newFieldValue = Object.assign({}, fieldValue);
                newFieldValue.value = text;
                setFieldValue(contentVariantId, newFieldValue);
                debouncedUpdateFieldValue(newFieldValue, fieldValue);
            } else console.error('Field value not found in content variant:', contentVariantId, fieldValueId);
        }
    };
    const handleDeleteContentVariant = (id)=>{
        deleteContentVariant(id, {
            onSuccess: ()=>{
                removeContentVariant(id);
            }
        });
    };
    const handleAddContentVariant = ()=>{
        createContentVariant(creativeId, {
            onSuccess: (data)=>{
                addContentVariant({
                    ...data,
                    fieldValues: []
                });
                setExportCount((prev)=>prev + (creative?.creativeVariants.length || 0));
            }
        });
    };
    const handleExport = (exportFormats)=>{
        createExport({
            creative: creativeId,
            formats: exportFormats
        }, {
            onSuccess: ()=>{
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success("Export has been requested. You will receive an email with the download link once it's ready.");
            }
        });
    };
    const isContentChanging = ()=>{
        return isCreateFieldValueLoading || isUpdateFieldValueLoading || isCreateContentVariantLoading || isDeleteConentVariantLoading;
    };
    (0, $acw62.useEffect)(()=>{
        if (creative && fontFilesLoaded && svgFilesLoaded) {
            const promises = [];
            for (const res of fontFileQueryResults){
                const { url: url, file: file, font: font } = res.data;
                addFontFile(url, file);
                const loadFontInEtcher = new Promise((resolve, reject)=>{
                    if (!etcherId) {
                        console.error('Etcher session not created timely');
                        reject();
                        return;
                    }
                    (0, $44052192468fac4a$export$672089c3debc1182)(etcherId, file, (loadedFont)=>{
                        resolve();
                    });
                });
                promises.push((0, $80cc0c4c52b399e2$export$f546da154e07664d)(font, file), loadFontInEtcher);
            }
            for (const res of svgFileQueryResults)addSvgFile(res.data.url, res.data.file);
            Promise.all(promises).then(()=>{
                setInitFetchComplete(true);
            });
        }
    }, [
        addFontFile,
        addSvgFile,
        creative,
        etcherId,
        fontFileQueryResults,
        fontFilesLoaded,
        svgFileQueryResults,
        svgFilesLoaded
    ]);
    (0, $acw62.useEffect)(()=>{
        // Use local variable to prevent biome from complaining and to prevent timing issues if View is
        // unmounted before session has been created
        let etcherId = null;
        (0, $44052192468fac4a$export$f7c62c73429afa28)((res)=>{
            etcherId = res.sessionId;
            setEtcherId(etcherId);
        });
        return ()=>{
            if (etcherId) (0, $44052192468fac4a$export$d855ee81853de6d2)(etcherId);
            clearStore();
        };
    }, [
        clearStore,
        setEtcherId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `flex flex-col min-h-0 h-screen w-full bg-black-50 ${initFetchComplete ? 'hidden' : ''}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a8e6792b42d25b8$export$e2b0760399e6dece), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `flex flex-col min-h-0 h-screen w-full bg-black-50 ${initFetchComplete ? '' : 'hidden'}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                        type: (0, $b3f317f73d7705c5$export$9baf8232abef7d17).LIGHT,
                        leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-white font-normal",
                                    children: "Produce Creative"
                                })
                            ]
                        }),
                        center: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-base text-white",
                            children: creative?.name
                        }),
                        trailing: creative && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            leading: isContentChanging() && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34d8235af5e46636$export$b936c55164dcf1db), {
                                className: "h-5 w-5 text-white"
                            }),
                            title: `Export ${exportCount} Asset${exportCount === 1 ? '' : 's'}`,
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                            disabled: isContentChanging(),
                            onClick: ()=>{
                                setIsExportModalOpen(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-h-0 flex-row h-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                                className: "pl-4 py-4 h-full w-[18%] flex-shrink-0",
                                type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "px-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-col gap-1",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-white text-sm font-normal",
                                                children: "Sizes"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "px-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                                    title: "Select Sizes",
                                                    className: "w-full hover:bg-gray-160",
                                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                                        className: "h-5 w-5 text-white"
                                                    }),
                                                    onClick: ()=>setSelectSizeModalOpen(true)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex flex-col gap-4 overflow-y-auto h-[calc(100vh-300px)] no-scrollbar",
                                                    children: creative?.creativeVariants.map((cv, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c4a2f417ac728b7$export$8b9b55c785b7377d), {
                                                            index: index + 1,
                                                            title: cv.variant.name,
                                                            thumbnail: cv.variant.thumbnail,
                                                            size: `${cv.variant.svgFile.width} x ${cv.variant.svgFile.height}`,
                                                            isActive: currentVariantIndex === index,
                                                            onClick: ()=>setCurrentVariantIndex(index)
                                                        }, cv.id))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex-grow flex-shrink h-full min-w-0 overflow-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col min-h-full min-w-full justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a8a7368584b71d9e$export$208cd1682bd0e4b6), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                                className: "pr-4 py-4 h-full flex-shrink-0 flex-grow-0",
                                type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                                width: 360,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "px-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row justify-between items-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-white font-medium",
                                                    children: "Content"
                                                }),
                                                creative && creative.contentVariants.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                                    title: "Add Content Variant",
                                                    className: "text-xs hover:bg-gray-160",
                                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).SMALL,
                                                    onClick: handleAddContentVariant
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "px-4 flex flex-col gap-2 h-full max-h-full min-h-0",
                                        children: creative?.contentVariants.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            title: "Add a Content Version",
                                            className: "w-full",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-white"
                                            }),
                                            onClick: handleAddContentVariant
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-col flex-grow gap-4 overflow-y-auto no-scrollbar",
                                            children: creative?.contentVariants.map((contentVariant, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e8cf1572ce78567$export$2108acd8032f65c2), {
                                                    index: index,
                                                    isSelected: selectedContentVariantIndex === index,
                                                    onClick: ()=>setSelectedContentVariantIndex(index),
                                                    fields: creative?.templateVersion.fields ?? [],
                                                    fieldValues: contentVariant.fieldValues,
                                                    onChange: (text, fieldId, fieldValueId)=>handleContentVariantFieldChange(text, fieldId, contentVariant.id, fieldValueId),
                                                    onDelete: ()=>{
                                                        handleDeleteContentVariant(contentVariant.id);
                                                    }
                                                }, contentVariant.id))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    creative && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $128555b314748f01$export$652e388e958caf8), {
                        templateId: creative.templateId,
                        isOpen: isSelectSizeModalOpen,
                        setIsOpen: setSelectSizeModalOpen,
                        onDone: ()=>refetchCreative(),
                        creativeId: creative.id,
                        initiallySelectedSizes: creative.creativeVariants.map((cv)=>cv.variant.id)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb50cfb588d020e2$export$d4b7c69927f72773), {
                        isOpen: isBulkDataModalOpen,
                        setIsOpen: setIsBulkDataModalOpen,
                        dataColumns: dataColumns,
                        dataRows: dataRows,
                        setDataRows: setDataRows
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fbad6cc0f9b3f8$export$1f33f980da756c46), {
                        isOpen: isSwitchToBulkConfirmationModalOpen,
                        setIsOpen: setSwitchToBulkConfirmationModalOpen,
                        type: (0, $d6fbad6cc0f9b3f8$export$b71090edac4832f0).WARN,
                        confirmText: "Yes",
                        cancelText: "Cancel",
                        message: "Are you sure you want to switch to Bulk Content?",
                        subMessage: "All manually entered data will be removed.",
                        onConfirm: ()=>setIsBulkDataModalOpen(true)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f04a709768d59d66$export$538b5176caa38d01), {
                        isOpen: isReconcileConfirmationModalOpen,
                        setIsOpen: setIsReconcileConfirmationModalOpen,
                        onCancel: ()=>navigate('/creatives'),
                        onConfirm: ()=>reconcileCreative(creativeId)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $995cc5f8453164b0$export$ad6c01082be780ea), {
                        isOpen: isExportModalOpen,
                        setIsOpen: setIsExportModalOpen,
                        exportCount: (creative?.contentVariants.length || 0) * (creative?.creativeVariants.length || 0),
                        onConfirm: handleExport
                    })
                ]
            })
        ]
    });
};


const $cb62b2fe07ca4069$export$bfac4771245e54dc = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $32578012b727878c$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                path: "/assets/:creativeId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d5f0db46b599107$export$4a070b22cd5acf55), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                path: "/create",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aceb3606056ef313$export$c493c0fa1aa3b46), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                path: "/generate/:creativeId",
                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1cc5cad0fc5518ab$export$3fcee1fdbf6e7703), {})
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");










parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

const $95625dc532e84cd0$export$4815dd42ca402041 = ({ thumbnail: thumbnail })=>{
    const [thumbnailLoadFailed, setThumbnailLoadFailed] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-16 chess-xs",
        children: thumbnailLoadFailed || !thumbnail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "w-full aspect-square flex items-center justify-center",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $115490f100597f79$export$385cd24c05318684), {
                className: "w-2/3 h-2/3"
            })
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
            alt: "Creative thumbnail",
            className: "w-16 aspect-square rounded-md p-1",
            src: thumbnail,
            onError: (e)=>{
                setThumbnailLoadFailed(true);
            }
        })
    });
};


const $319a4cd3fcd55cc6$export$3c024e82f9bae541 = ({ creatives: creatives, className: className, onDuplicate: onDuplicate, onDelete: onDelete })=>{
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `w-full flex flex-col flex-grow overflow-hidden ${className}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "overflow-y-auto flex-grow no-scrollbar",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                className: "w-full table-fixed",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                        className: "sticky top-0 bg-gray-150 p-3 text-left rounded-md",
                        style: {
                            zIndex: (0, $39e6c01191458113$export$f4d455029c4b5e98)
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "w-32 rounded-l-md"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "py-3 text-white text-sm font-normal",
                                    children: "Title"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "py-3 text-white text-sm font-normal",
                                    children: "Template"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "py-3 text-white text-sm font-normal",
                                    children: "Assets"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                    className: "py-3 w-36 text-white text-sm font-normal rounded-r-md",
                                    children: "Actions"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                        children: creatives.map((creative)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "flex flex-row justify-start w-32 mr-3 my-3",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95625dc532e84cd0$export$4815dd42ca402041), {
                                            thumbnail: creative.templateVersion.thumbnail
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-3 text-white text-sm",
                                        children: creative.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-3 text-white text-sm",
                                        children: creative.templateName
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: `py-3 text-sm ${creative.assetsCount === 0 ? 'text-red-50' : 'text-white'}`,
                                        children: creative.assetsCount === 0 ? 'Draft' : creative.assetsCount
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                        className: "py-3 w-36",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "border-gray-100 border-solid border-[1px] text-white text-sm h-8 px-4 rounded-md hover:bg-gray-160",
                                                    onClick: ()=>{
                                                        if (creative.assetsCount > 0) navigate(`/creatives/assets/${creative.id}`);
                                                        else navigate(`/creatives/generate/${creative.id}`);
                                                    },
                                                    children: "View"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex flex-row items-center border-gray-100 border-solid border-[1px] text-white text-sm h-8 px-2 rounded-md hover:bg-gray-160",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd88e2148a16500e$export$2e2bcd8739ae039), {
                                                            className: "text-white h-5 w-5"
                                                        })
                                                    }),
                                                    items: [
                                                        {
                                                            id: 'crtv-menu-edit',
                                                            name: 'Export Creative',
                                                            onClick: ()=>{
                                                                if (creative.assetsCount > 0) navigate(`/creatives/assets/${creative.id}`);
                                                                else navigate(`/creatives/generate/${creative.id}`);
                                                            }
                                                        },
                                                        {
                                                            id: 'crtv-menu-duplicate',
                                                            name: 'Duplicate Creative',
                                                            onClick: ()=>onDuplicate(creative.id)
                                                        },
                                                        {
                                                            id: 'crtv-menu-delete',
                                                            name: 'Delete Creative',
                                                            onClick: ()=>onDelete(creative.id),
                                                            color: 'red-50'
                                                        }
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, creative.id))
                    })
                ]
            })
        })
    });
};


var $69df7f0959bce31d$var$CreativeListMode = /*#__PURE__*/ function(CreativeListMode) {
    CreativeListMode["ALL"] = "ALL";
    CreativeListMode["DRAFT"] = "DRAFT";
    CreativeListMode["EXPORTED"] = "EXPORTED";
    return CreativeListMode;
}($69df7f0959bce31d$var$CreativeListMode || {});
const $69df7f0959bce31d$export$96a663cec1eeedf2 = ()=>{
    const [creativesList, setCreativesList] = (0, $acw62.useState)([]);
    const [creativeListModes, setCreativeListModes] = (0, $acw62.useState)("ALL");
    const [draftCount, setDraftCount] = (0, $acw62.useState)(0);
    const [exportedCount, setExportedCount] = (0, $acw62.useState)(0);
    const [allCount, setAllCount] = (0, $acw62.useState)(0);
    const [isCreativeDeleteConfirmationOpen, setIsCreativeDeleteConfirmationOpen] = (0, $acw62.useState)(false);
    const [creativeForDeletion, setCreativeForDeletion] = (0, $acw62.useState)(null);
    const [query, setQuery] = (0, $acw62.useState)({});
    const [isFetching, setIsFetching] = (0, $acw62.useState)(true);
    const { mutate: duplicateCreative } = (0, $ac3e639a16f09c99$export$55a01692e57364f2)();
    const { mutate: deleteCreative } = (0, $ac3e639a16f09c99$export$d4d396eb2c0a833c)();
    const { refetch: _ } = (0, $ac3e639a16f09c99$export$ee494ffeec4bd736)(query, {
        onSuccess: (data)=>{
            setCreativesList(data.results);
            setDraftCount(data.draftCount);
            setExportedCount(data.exportCount);
            setAllCount(data.totalCount);
            setIsFetching(false);
        }
    });
    const getEmptyStateMessage = ()=>{
        if (creativeListModes === "ALL") return 'Start with your first Project.';
        if (creativeListModes === "DRAFT") return 'No Draft Creatives.';
        if (creativeListModes === "EXPORTED") return 'No Exported Creatives.';
        return 'No Creatives Found.';
    };
    const getHeaderTitle = ()=>{
        if (creativeListModes === "ALL") return 'All Creatives';
        if (creativeListModes === "DRAFT") return 'Drafts';
        if (creativeListModes === "EXPORTED") return 'Exported Creatives';
        return '';
    };
    (0, $acw62.useEffect)(()=>{
        if (creativeForDeletion !== null) setIsCreativeDeleteConfirmationOpen(true);
    }, [
        creativeForDeletion
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isCreativeDeleteConfirmationOpen) setCreativeForDeletion(null);
    }, [
        isCreativeDeleteConfirmationOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (creativeListModes === "ALL") {
            setQuery({});
            return;
        }
        setQuery({
            draft: creativeListModes === "DRAFT"
        });
    }, [
        creativeListModes
    ]);
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex min-h-0 flex-row h-full",
        children: [
            isFetching ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full h-full flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a11906f52e293a19$export$a55cbd7077614be3), {
                        className: "w-16 h-16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-gray-60 text-2xl",
                        children: "Loading creatives ..."
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    allCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        className: "px-4 h-full w-[250px] flex-shrink-0 overflow-y-auto",
                        omitSeperator: true,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4 my-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                        className: "w-full",
                                        title: "New Creative",
                                        buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                        buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                        leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-white"
                                        }),
                                        onClick: ()=>navigate('/creatives/create')
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                        className: "bg-gray-100 border-gray-100 w-full mt-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "flex flex-col mt-2 px-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-col gap-2",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>{
                                                    setCreativeListModes("ALL");
                                                },
                                                onKeyUp: ()=>{
                                                    setCreativeListModes("ALL");
                                                },
                                                className: `flex flex-row justify-between items-center rounded-md px-2.5 py-1.5 hover:cursor-pointer hover:bg-gray-150 ${creativeListModes === "ALL" ? 'bg-gray-100' : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-row gap-2 items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b0e2b9e347c28dd$export$a245117220b0b0f2), {
                                                                className: `w-4 h-4 ${creativeListModes === "ALL" ? 'stroke-white' : 'stroke-gray-60'}`
                                                            }),
                                                            ' ',
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: `${creativeListModes === "ALL" ? 'text-white' : 'text-gray-60'} text-sm font-normal`,
                                                                children: "All Creative"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: `flex h-6 w-6 bg-gray-100 rounded-md ${creativeListModes === "ALL" ? 'text-white' : 'text-gray-60'} text-xs text-center justify-center items-center`,
                                                        children: allCount ?? 0
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-col gap-2 mt-1.5 ml-6",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>{
                                                    setCreativeListModes("DRAFT");
                                                },
                                                onKeyUp: ()=>{
                                                    setCreativeListModes("DRAFT");
                                                },
                                                className: `flex flex-row justify-between items-center rounded-md px-2.5 py-1.5 hover:cursor-pointer hover:bg-gray-150 ${creativeListModes === "DRAFT" ? 'bg-gray-100' : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `${creativeListModes === "DRAFT" ? 'text-white' : 'text-gray-60'} text-xs font-normal`,
                                                        children: "Drafts"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: `flex h-6 w-6 bg-gray-100 rounded-md ${creativeListModes === "DRAFT" ? 'text-white' : 'text-gray-60'} text-xs text-center justify-center items-center`,
                                                        children: draftCount ?? 0
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex flex-col gap-2 mt-1.5 ml-6",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                onClick: ()=>{
                                                    setCreativeListModes("EXPORTED");
                                                },
                                                onKeyUp: ()=>{
                                                    setCreativeListModes("EXPORTED");
                                                },
                                                className: `flex flex-row justify-between items-center rounded-md px-2.5 py-1.5 hover:cursor-pointer hover:bg-gray-150 ${creativeListModes === "EXPORTED" ? 'bg-gray-100' : ''}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: `${creativeListModes === "EXPORTED" ? 'text-white' : 'text-gray-60'} text-xs font-normal`,
                                                        children: "Exported Creative"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: `flex h-6 w-6 bg-gray-100 rounded-md ${creativeListModes === "EXPORTED" ? 'text-white' : 'text-gray-60'} text-xs text-center justify-center items-center`,
                                                        children: exportedCount ?? 0
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 p-5 flex flex-col flex-grow overflow-hidden",
                        children: [
                            allCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-white text-2xl font-normal items-start",
                                children: getHeaderTitle()
                            }),
                            creativesList.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col items-center justify-center flex-grow",
                                children: [
                                    creativeListModes === "ALL" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd5d46306eb83dc9$export$d7db36bc683573), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: `${creativeListModes === "ALL" ? 'text-white text-3xl' : 'text-gray-40 text-xl'} font-normal mt-10`,
                                        children: getEmptyStateMessage()
                                    }),
                                    creativeListModes === "ALL" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                        className: "mt-4",
                                        title: "New Creative",
                                        buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                        buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                        leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-white"
                                        }),
                                        onClick: ()=>navigate('/creatives/create')
                                    })
                                ]
                            }),
                            creativesList.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $319a4cd3fcd55cc6$export$3c024e82f9bae541), {
                                className: "mt-10",
                                creatives: creativesList,
                                onDelete: setCreativeForDeletion,
                                onDuplicate: (id)=>{
                                    duplicateCreative(id);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fbad6cc0f9b3f8$export$1f33f980da756c46), {
                isOpen: isCreativeDeleteConfirmationOpen,
                setIsOpen: setIsCreativeDeleteConfirmationOpen,
                type: (0, $d6fbad6cc0f9b3f8$export$b71090edac4832f0).WARN,
                confirmText: "Delete",
                cancelText: "Cancel",
                message: "Delete Creative",
                subMessage: "Are you sure you want to delete this creative?",
                onConfirm: ()=>{
                    deleteCreative(creativeForDeletion);
                }
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $beaa087bee1de3c0$export$144901db2ea8e967 = ({ children: children, autoPlay: autoPlay = true, interval: interval = 3000, slideTexts: slideTexts })=>{
    const [currentIndex, setCurrentIndex] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (autoPlay) {
            const timer = setInterval(()=>{
                setCurrentIndex((prevIndex)=>(prevIndex + 1) % children.length);
            }, interval);
            return ()=>clearInterval(timer);
        }
    }, [
        autoPlay,
        interval,
        children.length
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative w-full max-w-4xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative overflow-hidden rounded-lg",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex transition-transform duration-500 ease-in-out",
                    style: {
                        transform: `translateX(-${currentIndex * 100}%)`
                    },
                    children: children.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex-shrink-0 w-full flex flex-col justify-center items-center",
                            children: [
                                slideTexts[index] && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "mb-6 text-xl text-white w-1/2 text-center",
                                    children: slideTexts[index]
                                }),
                                item
                            ]
                        }, `slide-${item.key || undefined}`))
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "absolute -bottom-10 left-1/2 transform -translate-x-1/2 flex space-x-2",
                children: children.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `h-2  ${currentIndex === index ? "w-10" : "w-3"} rounded-full cursor-pointer bg-white ${currentIndex === index ? "opacity-100" : "opacity-40"}`,
                        onClick: ()=>setCurrentIndex(index),
                        onKeyUp: (e)=>e.key === "Enter" && setCurrentIndex(index),
                        tabIndex: 0,
                        role: "button",
                        "aria-label": `Go to slide ${index + 1}`
                    }, `dot-${item.key || undefined}`))
            })
        ]
    });
};



parcelRequire("acw62");
var $5993a338d2ee8153$exports = {};


(function(global, factory) {
    factory($5993a338d2ee8153$exports, (parcelRequire("5PFTV")), (parcelRequire("acw62")));
})($5993a338d2ee8153$exports, function(exports1, lottie, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[r] = t, e;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _objectWithoutProperties(e, t) {
        if (null == e) return {};
        var o, r, i = _objectWithoutPropertiesLoose(e, t);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
        }
        return i;
    }
    function _objectWithoutPropertiesLoose(r, e) {
        if (null == r) return {};
        var t = {};
        for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
            if (e.includes(n)) continue;
            t[n] = r[n];
        }
        return t;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r || "default");
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, 'LottiePlayer', {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});


const $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4 = ({ animData: animData })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5993a338d2ee8153$exports))), {
        animationData: animData,
        loop: true,
        autoplay: true
    });
};




parcelRequire("acw62");
const $94d85f23e314daf0$export$7cd68705ae4881ed = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "121",
        height: "40",
        viewBox: "0 0 121 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Intaglio Logo"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M80.3081 24.3448C78.4028 23.1142 75.9666 22.6477 73.2756 22.2638C72.0449 22.088 70.5846 21.7615 69.5441 20.9721C68.1448 19.8599 67.2478 18.1376 67.2478 16.236C67.2478 12.8992 69.9747 10.2082 73.2756 10.2082C76.5766 10.2082 79.3034 12.9351 79.3034 16.236C79.3034 18.1376 78.2593 19.946 76.86 21.0583C78.5822 21.4888 80.3439 22.1203 81.6356 23.0532C83.1426 21.1874 84.1472 18.8194 84.1472 16.236C84.1472 10.2441 79.2675 5.40031 73.3115 5.40031C67.3555 5.40031 62.4758 10.28 62.4758 16.236C62.4758 18.8552 63.4446 21.1874 64.9874 23.0532C65.3821 23.5196 65.8485 23.9502 66.2791 24.3448C68.1448 25.9953 70.6456 26.6986 73.3115 27.0717C75.0409 27.3121 76.3254 27.5023 77.4018 28.1481C78.5858 28.8657 79.3393 29.8344 79.3393 30.9108C79.3393 32.9201 76.5048 34.75 73.3115 34.75C70.1182 34.75 67.2837 32.9919 67.2837 30.9108C67.2837 29.8703 68.0372 28.9016 69.2212 28.1481C67.5707 27.574 66.0638 26.7129 64.808 25.5289C63.3728 26.9999 62.4758 28.8298 62.4758 30.875C62.4758 35.7187 67.2478 39.522 73.3115 39.522C79.3752 39.522 84.1472 35.7187 84.1472 30.875C84.1472 28.8298 83.2215 26.982 81.7863 25.5468C81.3199 25.1163 80.8606 24.7 80.3081 24.3448Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M109.909 26.3759C107.972 26.3759 106.178 25.9741 104.599 25.1668C103.056 24.3631 101.8 23.1898 100.903 21.6542C100.006 20.1544 99.5757 18.3245 99.5757 16.2004V15.5797C99.5757 13.4951 100.006 11.6258 100.903 10.126C101.8 8.59032 103.02 7.41706 104.599 6.61335C106.142 5.80965 107.936 5.40421 109.909 5.40421C111.882 5.40421 113.641 5.80606 115.183 6.61335C116.726 7.42065 117.982 8.59032 118.843 10.126C119.74 11.6258 120.171 13.4915 120.171 15.5797V16.2004C120.171 18.285 119.704 20.1544 118.843 21.6542C117.946 23.1539 116.762 24.3631 115.183 25.1668C113.641 25.9705 111.882 26.3759 109.909 26.3759ZM109.909 22.239C111.56 22.239 112.995 21.69 114.035 20.628C115.112 19.566 115.614 17.9944 115.614 16.0533V15.6515C115.614 13.7104 115.076 12.1388 114.035 11.0768C112.959 10.0148 111.595 9.4658 109.909 9.4658C108.223 9.4658 106.859 10.0148 105.783 11.0768C104.706 12.1388 104.204 13.6745 104.204 15.6515V16.0533C104.204 17.9944 104.742 19.5301 105.783 20.628C106.895 21.7259 108.259 22.239 109.909 22.239Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M0.331421 5.60864H5.17519V26.1319H0.331421V5.60864Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.22145 26.1318V5.60857H11.9935V8.47895H12.7111C13.0699 7.6896 13.7516 6.97199 14.6844 6.29027C15.6532 5.60856 17.0884 5.24977 19.0259 5.24977C20.6046 5.24977 22.0757 5.60857 23.2956 6.32616C24.5155 7.04376 25.4843 8.0125 26.2019 9.34005C26.8836 10.5958 27.2424 12.1387 27.2424 13.8609V26.1318H22.3986V14.2197C22.3986 12.5692 22.0039 11.3134 21.1428 10.4882C20.3176 9.69886 19.1694 9.26831 17.6266 9.26831C15.9402 9.26831 14.5409 9.84237 13.5722 10.9546C12.6034 12.0669 12.1011 13.6815 12.1011 15.7625V26.1318H7.22145Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M39.3688 5.60865V9.91422H34.0228V20.9652C34.0228 21.7904 34.3816 22.1851 35.1709 22.1851H39.3688V26.1319H33.5922C33.5922 26.1319 31.5471 26.2036 30.363 25.0196C29.6095 24.2302 29.179 23.1539 29.179 21.7546V0.513718H34.0228V5.60865H39.3688Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M85.9766 26.132V0.477982H90.8203V26.132H85.9766Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M92.9007 26.1316V5.68013H97.7444V26.1316H92.9007Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M56.3037 24.6968L56.2314 24.733V24.6607C56.2314 24.6968 56.2676 24.6968 56.2676 24.6968H56.3037Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M56.3037 24.6968L56.2314 24.733V24.6607C56.2314 24.6968 56.2676 24.6968 56.2676 24.6968H56.3037Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M59.4974 10.1257C58.7439 8.81606 57.6316 7.80066 56.3041 6.96108C56.1247 6.85344 56.017 6.70635 55.8018 6.59871C54.2589 5.79859 52.4649 5.40031 50.4915 5.40031C48.5182 5.40031 46.7242 5.76271 45.1813 6.59871C43.6026 7.39883 42.3468 8.56133 41.4498 10.0898C40.5528 11.6183 40.1223 13.4697 40.1223 15.5794V16.1966C40.1223 18.3063 40.5528 20.1577 41.4498 21.6503C42.3468 23.1429 43.5667 24.3413 45.1813 25.1414C46.7242 25.9774 48.554 26.3792 50.4915 26.3792C52.429 26.3792 54.2589 25.9415 55.8018 25.1414C55.9812 25.0696 56.2682 24.8508 56.2682 24.8508C57.5957 25.5432 59.1027 25.9415 60.7173 25.9415V23.8641C60.7173 21.4529 60.7962 19.0418 60.8572 16.6271C60.8572 16.4979 60.8608 16.3652 60.8608 16.236V15.583C60.8608 13.4733 60.3944 11.6577 59.4974 10.1293V10.1257ZM56.2682 16.0889C56.2682 18.0156 55.73 19.58 54.6536 20.6707C54.1154 21.2161 53.5413 21.6144 52.8596 21.8691H52.8237C52.142 22.1598 51.3527 22.3069 50.5274 22.3069C48.8411 22.3069 47.4418 21.7256 46.3654 20.6707C45.289 19.58 44.7508 18.0156 44.7508 16.0889V15.6906C44.7508 13.7639 45.289 12.1995 46.3654 11.1447C47.4418 10.0539 48.8052 9.50855 50.5274 9.50855C51.3527 9.50855 52.1061 9.65566 52.8237 9.90681C53.5054 10.1974 54.1154 10.5993 54.6536 11.1447C55.73 12.1995 56.2682 13.7244 56.2682 15.6906V16.0889Z",
                fill: "white"
            })
        ]
    });
};


var $fb253e3bb69c91eb$exports = {};
$fb253e3bb69c91eb$exports = JSON.parse("{\"v\":\"4.8.0\",\"meta\":{\"g\":\"LottieFiles AE 3.5.8\",\"a\":\"\",\"k\":\"\",\"d\":\"\",\"tc\":\"\"},\"fr\":29.9700012207031,\"ip\":179.000007290819,\"op\":811.000033032707,\"w\":436,\"h\":452,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[{\"id\":\"image_0\",\"w\":65,\"h\":104,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABoCAYAAACuVJ27AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADpklEQVR4nOWc3XXbMAxGL3v6nmxgb5Bs4GzQdoKoE7QbVBs0G1TZwCO4GzgbeARnAvSBdpOqkq0fkASp79FHBqFrSPpAU0REKpYuEdmJSJM6j6Q6QZBFg3gHQRZ7abQgLBNEB4TlgeiBcBSR+9S5xdKHns9vgN1SQPRBgDcQ60i5JNMlCOBBbEXkNkYyqXQNAsAdviKKBTEEApxABMwjqYZCALgr1VWOgQDwWCKIsRDAg3hSzyShpkAA+FaSq5wKAeBXKSDmQAAP4kEjkZSaCwG8mcraXmtAyL7P0IAAbyCydJVaECBjEJoQINM+QxsCeBBNgLjBFAICwKec7HUoCJBRnxESAngQ3wOPMVuhIQD8tG6vY0AA431GLAjgQZh0lTEhgFF7HRuCyT4jNgTwIBpLrjIFBDBmr1NBAEMgUkIADyL5pG1qCGDAXluAAImn8a1AgITT+JYgQCJ7bQ0CeBCfYw5oEQJ4MxXNVVqFENVeW4UAEZcLWYYAkZYLWYcAEex1DhDAg9iGCp4LBIBNKHudEwQI1GfkBgE8iFozYI4QAH5o2utcIYBin5EzBFCaxs8dAijY6xIgzO4zSoAAM+11KRAAVky01yVBgIl9RmkQYMJyoRIhwMjlQqVCgBF9RskQwIOorh1UOgQYYK+XAAGugFgKBICnPle5JAi99npJEKAHxNIgQMdyoSVCgJa9XioEePfW78e0eXTqhYD/MbQlIvcWIdw65+qYA1q8HFaxF2pYhABQxxzMKoRVzJdOrUKAiNWgDeEV+AL8Voi1ibWfiyaEV+DBObdFb5VqrRTnsnr2WRqrfftXE5GDQlxpxw0hjUp4wVfAofV5rRAboFKK0y+ZVwnNldga1XAUw2uWnp1z1ZVjmhnxz7oBwi7unFgJ1cDYt6dfcq4OIRmMrYRX4KtzrhlysHPuiM6TYjUU/CSNqIRJO/OdqkFDuwCnDwyvhPMTYD92gFM1PI/9Xoc2EspKD6iEvcy8O4vIWqkaGqXT/i/BSxDUltSKSKMEYq2RTzu5PgiN8jgPShBU8zon1wUhyOv+F4CPkb556kisUh3g37G0qqHWTuwMIcrmtOJvtHN10Mzp/Ig8t8GjH4ETZM88iciTRH5VV3Qaq0PMnNUlIpUCBJHcN78TncZqp5FLyolWjXvDRnLeV1rmt9nb7C8H+HtTHqPj6Tvr1LmrSYY3VnsxvEXRbMnlxqopouSvqaMaDiJSF1XyQyT+JrcruuSt6w/YqcfF7vpUCwAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_1\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_2\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_3\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_4\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_5\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_6\",\"w\":186,\"h\":80,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAABQCAYAAACu0W8VAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABUElEQVR4nO3SsVEbYRgA0e+HC80MpageVUEDDpWrCAqgBEpQKQROpXMT4JvxvlfBBrt+Xc7XNXMa+E89Zt62NXNa+/p47Ot2dBB8t7Xu17U/v24zM4993f78fv88uAm+3cvl/DX7zNPRIfAvGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5NgdBKMToLRSTA6CUYnwegkGJ0Eo5Owzcysdb++XM5fR8fADzjNzGyPmbe1P7/OfnQP/Iztvt3+AhLkHII3yuD2AAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_7\",\"w\":186,\"h\":50,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAAAyCAYAAADr7cFEAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA/0lEQVR4nO3SMXECURSG0XvDK8MMUlYPKjCQkh4RERAJkbBSKNKyLyYgO5P/HAVf8fX79XzrqqXgn9qqLqOrlp79tc1e9w6CZ+t+3HoeTqOqapu9/nx8fu/cBE93vJ7vNave9g6Bv2B0IhidCEYngtGJYHQiGJ0IRieC0YlgdCIYnQhGJ4LRiWB0IhidCEYngtGJYHQiGJ0IRieC0YlgdCIYnQhGJ4LRiWB0IhidCEYngtGJYHQiGJ0IRieC0YlgdCIYnQhGJ4LRiWB0IhidCEYngtGJYHQiGJ0IRieC0Ykwqqq6H7fj9XzfOwZeYKmqGlvVpefhVHPvHniN8RjrL1v4HEZM92eAAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_8\",\"w\":79,\"h\":56,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAAA4CAYAAAC8E6X/AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA7ElEQVR4nO3cMW0DQRhE4flzW8aSoRyeQ2ECKa83iAAwBEM4KC7S+jZFEESvWK30PgSjB2Dqc9/ulazRv5zJrVWyVq/H2esYPWgWVe979eXakuTsdfx8fT8Hb5rGZd9e6cnH6CEzMx5gPMB4gPEA4wHGA4wHGA8wHmA8wHiA8QDjAcYDjAcYDzAeYDzAeIDxAOMBxgOMBxgPMB5gPMB4gPEA4wHGA4wHGA8wHmA8wHiA8QDjAcYDjAcYDzAeYDzAeIDxAOMBxgOMBxgPMB5gPKAlf4cDl317jR4zkTVJ2pncqi/X9NF75tLe7fgFVJ8cUu5mRDwAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_9\",\"w\":101,\"h\":56,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAAA4CAYAAADkbDbmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA9UlEQVR4nO3cMQ0CQRhE4fm5LSFBCnpOBQYor0cEApCAhJNCQcstBSUC9iW8T8Ekr5/aL/O1klOEsCXnVsmpet23XuvoQf+u6n2tPh1bkmy91tfl9hi86e8dlvmZnuxGD9EvowAZBcgoQEYBMgqQUYCMAmQUIKMAGQXIKEBGATIKkFGAjAJkFCCjABkFyChARgEyCpBRgIwCZBQgowAZBcgoQEYBMgqQUYCMAmQUIKMAGQXIKEBGATIKkFGAjAJkFCCjABkFyChARgEyCpBRgIwCZBQgowAZBagl30PJwzI/R4/R9/W2bcm5+nRMH71HSdLebf0A+v4cUnQ2CAgAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_10\",\"w\":186,\"h\":43,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAAArCAYAAADPNJIXAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA7klEQVR4nO3dsXHCQBiE0f/MhWaGUlSPqqABh8opwgVQgktQKQRO0RHQAlgz3vcq2ODLt30u86VVTQX/1FZ17q1qaqNdt9HWvQfBq7V2v7RxOPWqqm209ffr+2fnTfByx2W+1aj62HsI/AWhE0HoRBA6EYROBKETQehEEDoRhE4EoRNB6EQQOhGETgShE0HoRBA6EYROBKETQehEEDoRhE4EoRNB6EQQOhGETgShE0HoRBA6EYROBKETQehEEDoRhE4EoRNB6EQQOhGETgShE6FXPb8Yj8t823sMvMFUVdW3qnMbh1ONvffAe/R7Xx8rvRw4edauRwAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_11\",\"w\":70,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAICAYAAABEfImYAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAB4ElEQVRIicWUYZGlMBCEv95aAU8CEpAQCUhAAhKQgIRIQAISkBAJOJj78TqP7Dte7e7V7V2qUsBk0tPdEyKAiEhAAgqwSjr4gRERq6Thh7AXYK/fkvIn+T3QX+VFxPIeEQMwABno/Ry8cXCxalTnmbkbCbACN8d7oEhaXWD0WjFOjSfv3xo+nXNXSeWFmKFylFQiogNG4/TAUvl5LRtzMO5uTphTaXhinTvQvwGTpFHSJmkBZpuSXXCwiGQSe93sorPJ1I4NETG5g9WU7JzRpizGXhrsZGLrC1OmxoTVHFd/V2Gdax6OV3M2m1U1VO6p4Xk0PHl/JmBXZ2CWtEUEnKejxna/HxGxmeDqtWLBN0mTReWmROLejM1iK3Z2bOR6JJOe+XgKNmAzDyzwMFar41FL0mSTAJKk3jwfTXkzaI6IW0SMFr1zduGS6MU9lCLixtnVIyIGH+n2XimfYb8YG/7NOX/Lwbynp9zDJ+pZR7nALQ3PVINvkmYDZO4dSb4jNjtYmlnNeFxyzftqjJt/ydGFZq8dwO7Lbjd2xfuAbbGpmb0xcY0saTd2bngcnovXCudpetR2/sHZpN94Prv3R6MK+GJuFxG79+SrfVfG/BWi/3pYbPeN/D4i5q+a+T/GLxJub8fqQBLRAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_12\",\"w\":121,\"h\":121,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_13\",\"w\":170,\"h\":171,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_14\",\"w\":220,\"h\":221,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_15\",\"w\":270,\"h\":272,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_16\",\"w\":226,\"h\":96,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOIAAABgCAYAAAAAaK4EAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAB1UlEQVR4nO3VTZETYRSF4dOtAAdIAAeMAmqigMQBUZI4SEYBP2MACRMnwUA3i4kF6jtV/Tyruzybt+6Uh9Pl9TlZ9pnXz1mnjwH+h79Z85bkT7Kcj4fdPUmmJDldfl0z5dvIdbA5U25ZlqfjYXefT5fXZxHCAGs+JfM5SeZk2Q+eA9v1eIJzkg+Dp8CmnS4/nubRI4D3jwgMJkQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQoIEQY721OpuvoFbBZa16Oh919Ph6+XrPmZfQe2Jwpt2T5/n4+nC6/98m6z5Qvw4bBFky5ZcnPZDkfD7v76DnAwz8ZxDK80c36uAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_17\",\"w\":170,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAAAGCAYAAABTqAUXAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAd0lEQVRIie3XQRGDMBQG4X1PARKQAgaYqYIOEnBQB8FB4oCpAyzUARJAAKEGWq7J4f8U7HUtxKUBn4EWkepYmsYhWYjvhPEsnSPy15V7x6+udIfIPe+cbFvpDJF7tjvkF3CUThH5yfjAmQwgxKVFMyUVmsbHCvAFPBsXWBhYihMAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_18\",\"w\":168,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAAAGCAYAAABXXdUqAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAc0lEQVRIie3XQRWDMBQF0flfARKQUgc9KCiRgAMcBAfBAacOkIAEJBQDSfeFrsPiXQWzHYtpacAnoEXkPtYhPEeL6T1jvGrXiJwUC46XR+0OkWuld7LttTNE/tgc8ggctUtEfhyQJwOIaWnRJMm9bEPoPl8b0BiHo4gsPQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_19\",\"w\":67,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAGCAYAAACYXyOsAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAb0lEQVQ4jeXUYQ2AIBgG4XuZAWwgETQKCRwRaGADbOBMoFGIYAQtAMb43HwS3K9T3o4e3Ap4/umGuqQYSgduRczWRaakEfDK+3nRNFj3mGt1clRd1h1fkGIoDuoCPNYxppoSgADydnh+PNAUQwF4AQs6Gw+LStD7AAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_20\",\"w\":95,\"h\":93,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_21\",\"w\":95,\"h\":93,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABdCAYAAADDhLr+AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAF5ElEQVR4nO2dvXLbRhDH/3uwZXdiniBMa2cmVBdWQbp0RkOZqXyh9QDnLl34CHCVxpahTpGL0G/AdOwMzcSuxc6l2MWyeZuCoD4ogsTHAaCI+1UcAjjs/HHYOxywu4QNpStVE/fQ1Bpu9Je7YvdLiBEy4RyEkKc4exv4YWFG5oSqNmBOR6oWCXgAXIBbAHbNtU7/ECNkgeHFFMNB4J+bazs7lYq//1x50PBA7MGo2KthondgDL5oDKq8EKWL35WqyQTFxBIlCh4L05FwEBy/8odln7o08bsHyp0yFDE/KeucaSDQWAP9t4d+UN45C6Z7oFyt0Qf4p6LPZYIyL0Jh4nelak4d+Jva09dBoDEJyCLdUSHi7/dUH2CFTfDpOWGid1+mkEUMzEbFj6aLAcA/mGx3A5iASJ689gcmGzUmfqenJIF9bEFvj4Xp6IKhTN0FRsTf/00FIH5moq3Nh06Fhncc+Ge5W8pzsCdVY0dguIVuZh0T1uTmXbpwsh5YY+EB4CERfn201/708f0o8wXIJH5HqtY9wSGAb7OeeAt4SID3aK89znoBUos/m9HwENs8sKYgzwVI5fNr7mpWIgT9nPaBLLH4Vvi1pB6ERdIddwi+FX4luyR46EnVSHpAIvGf9pSqzzw+F7s7AomfgtcOuB2pWiD+O59NtaL5eK9NH96Phut2XOnzPakaDwRCBtd5SpmJJAPwSrfzgNC3wmeDNYJ1+8S6ne6Bchn8p1GL6kVjnfuJ7flawy/EpFrBf3SlasZtXSp+p6eknVaaQRP6cduWii8Qf4AlJcTPugfKXbbplvidnpJ2kDXLlKGW/X9LfNvrzUPMT5b5/hvi7z9Xnu31xbDM998QnwFZljG1g9hbXPe5FL8rVfOufmNzR9i9P/sQ+JJL8Xlhg6UAKE5863IKh5ifXHc9ApgtoNmHqnK47nrE4h+WgqEF8YmThdxY8kPM7vz3zOcTWlUZU0N25w9c0YBr/X2ZaGfW2UXcoo+lQDgSf6rRrNiUOuICgCBY8atCgK345TOLTxMgK35VJP5izWIeK35FdA+Ua8WvECt+hVjxK8SKXxHTrzi34lfE28APrfgVIoixsWmwtpgJAAgmbETKq3pBITBbXrA9v2wYZwAgeDr7YSkRisTf5NSH24oQGAKX83z6p0Jbasd/XxH5/BnD6kypG3Q6z9cjgKvbwFI8xFdaCwCIQhYnFdlTK8i5CpK+esJlMpo/zLKUyfXY3CvxU4StWzKy0MEvxY8y51nXUyDCuRkYfWNhjZhubLSYg0DjxXQAC+LbwOei0EsCDW+Ifxz4Z2A6Ks2i+jD5om+PqbdDQZ31CRssaSF/WSLUW+Ifv/KHTPSuHKNqweQiJo/F0jdZznR5xLQlC8t7PRCT8uXfcHT+fav9DQg/FmvYdkOg8cmhHxtyFfsO9zOjDzvvzwWJ1RGeseIPAv8cRCsPtsRDTC9zpfk6ee0P7NQzPQQaR55jJWs/HblgKAKNjVhVE0gkqzSxVvxB4J9rDQ/W/yeCQC+SpvVNlMj6Yzj69Giv/Ylgg6VXwnR08sb/PenuibOIf3w/Ch/vtQkJaxTWDzo9eeP/kuaIVJ8Lnhz6fTsAL4NOL3T6Tpk6f/6HcDR43Gp/Z6PW58yEz1LEJlPlCHsB5mQXHshRM+VDOBrUewkin/CAgVJNUX2sN3nbuVPMZjUybzNG6mTVqY4KgV78degbeeNnrEKcJ1XjvoNgW5PkEWisNTyT37YaL0z5tKcUg/vYoruAmF5+ZvRNF6cspCroXS/HOqfosqyFFiOOChHfxUI3EwL1Tfn2OEopw93pKSlwJ6pQTADyLzRiX/2ZpNQC9PvPlQeG2rSS3NGSuf9ZIyhD9KvzVkBXqiYTFAhVJs6egGkgHARFltpeRSXiX6cjVUsQJBPcoscGAo2ZMYTAwHRV52z2bBCeVI0dB26UAM4loJnjzpgAFBIj1ITQ0RiaKCBsko0SP46OVC3nHhoAoOOWbgmhiGKKq3IjafkfzuYrXsqtcI8AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_22\",\"w\":76,\"h\":56,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAA4CAYAAABXJB78AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABH0lEQVR4nO3cwU3DQAAF0dmtgA6gE1IBCRUQl+AOQgWmA5sKIEoDUAodpIKYQyyUW/gnO9K8m29fI3lvu4VJ1x82cNoCd+hCGdrmafj7Auj6/UDhZbZNSzfy3TbrFUDt+sPGWFcUHrt+vwOo02+oa+q4Bah4Zv3PWO7hHEwBg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFjJYyGAhg4UMFqrAce4RN6GMP3C+kfs295abcCoDQG2b5y9GXmees2wj722z3sH0qgBA13+soG6Bh1lGLdMRyuflMwy/DBIoLpxw8iYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_23\",\"w\":88,\"h\":7,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAAHCAYAAACMTYoWAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAeklEQVRIie3SURHCMBAA0b2bCqgT4oA6YCohDogCgoJIiIQSJ60DcAAGEkyUuZnQp2A/VgBSLhGYOOzlCfUa/PweUi4R4WZd1Jkzog5wynHubzROKS9OUUbrlp4plYd1RJeELfh51eAvkcYdaS/rpk58aBRqnaxD/sIXJH4cbkI5VMIAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_24\",\"w\":88,\"h\":7,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAAHCAYAAACMTYoWAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAeklEQVRIie3SURHCMBAA0b2bCqgT4oA6YCohDogCgoJIiIQSJ60DcAAGEkyUuZnQp2A/VgBSLhGYOOzlCfUa/PweUi4R4WZd1Jkzog5wynHubzROKS9OUUbrlp4plYd1RJeELfh51eAvkcYdaS/rpk58aBRqnaxD/sIXJH4cbkI5VMIAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_25\",\"w\":60,\"h\":7,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAHCAYAAABUQS4cAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAa0lEQVQ4jd3RUQ2AMAwA0WsVIAkEEDIHTMIUMBSAA5AwHGABCRjZ+MUAa8JTcMkJwLIdEWj5NV2D75Ms2xERJuucKkrulN+ffdNRURrrjJqUTLKOqCfvGvwQKcxIua1zPiNcFHXBu9M6pboHbwYXMQBkpm4AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_26\",\"w\":170,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKoAAAAGCAYAAABTqAUXAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAd0lEQVRIie3XQRGDMBQG4X1PARKQAgaYqYIOEnBQB8FB4oCpAyzUARJAAKEGWq7J4f8U7HUtxKUBn4EWkepYmsYhWYjvhPEsnSPy15V7x6+udIfIPe+cbFvpDJF7tjvkF3CUThH5yfjAmQwgxKVFMyUVmsbHCvAFPBsXWBhYihMAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_27\",\"w\":168,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAAAGCAYAAABXXdUqAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAc0lEQVRIie3XQRWDMBQF0flfARKQUgc9KCiRgAMcBAfBAacOkIAEJBQDSfeFrsPiXQWzHYtpacAnoEXkPtYhPEeL6T1jvGrXiJwUC46XR+0OkWuld7LttTNE/tgc8ggctUtEfhyQJwOIaWnRJMm9bEPoPl8b0BiHo4gsPQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_28\",\"w\":67,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAGCAYAAACYXyOsAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAb0lEQVQ4jeXUYQ2AIBgG4XuZAWwgETQKCRwRaGADbOBMoFGIYAQtAMb43HwS3K9T3o4e3Ap4/umGuqQYSgduRczWRaakEfDK+3nRNFj3mGt1clRd1h1fkGIoDuoCPNYxppoSgADydnh+PNAUQwF4AQs6Gw+LStD7AAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_29\",\"w\":76,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAICAYAAABTXhlRAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAB60lEQVRIic2V4ZGcMAyFP91cAZRAB6EESnAJlEAJlEAHcQmUQAmkA0qgg5cf+5x1CJvdJHcz0QxjW5bfkyxZACCplzRJGiQ1fJJIWj4L+4KrkzQ/2LvUvyLvkhKQgAx0HpOkzvoNOGzf+stAb90CNNZ3wB4Rix0bvLcbp+h7n18rX1rbLhGxXwTZAEPBr9aHzxzG7YA1IjZJm88m4x/m7K4u4wkHEZHfgDEihohYI2IGJl9WNnhycL0Pb/46BzjZmdn6JGl0FstlZdsMDmo29lxh9yX4q2CA0XjJiViM3QDZl1L8y5IK38g98aP9eCSjx2S8muMrACULtfh5Js/Lc50cLJLW8nQ97yVNXreSFklrhTfbZj3hXGJfRVKdz5KaE/5eY1T69eTrVHCecMwXHBvAG7BUTgze2Lhli2r8SSLiOKn6qoRX4JCUnOlU2e3PsB9IT1UBQOPkdNzbRuc4ctWLN26V1pz8+B1HsW3N0QNfAN4jYnLZZoP37getm/TmIOHey+qqLPPFGLsxM7fnWkr7ALaIKMkp5Y7HH9gOru4zh7Gnimvz+gAG+1ziyF4Xm4l7Gzj+kuMbQPABUp5CRKwv2LZ2ZuRWYfl87iqYiPildfyL/CmHpDUi+o8ib30Rr9p3Vz3nfxb/aPgOblvcB3thB5IAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_30\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_31\",\"w\":307,\"h\":308,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATMAAAE0CAYAAABAXdTmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAEZ0lEQVR4nO3UwU0bYRgA0e+HPQaJUlyPq6CBHH13ERRACZTgUjjkam9qAEVaZfReBXOa9etyvq6Z0wD8px4zb9uaOa19fTz2dTs6COC71rpf1/78us3MPPZ1+/P7/fPgJoBve7mcv2afeTo6BOBfMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyAhG1mZq379eVy/jo6BuAHTjMz22Pmbe3Pr7Mf3QPwM9t9u/0F9cgeSlX35B4AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_32\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_33\",\"w\":77,\"h\":30,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAAeCAYAAABpE5PpAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAsklEQVRoge3ZsQ2DQBBE0VlzoZEohXqoggYcklOEC3AJLoFSCJxy68ANWJMcSP9VMPrpxH2Z1pBG4S9VmktIY2S8asbWetDZRRxrZDcUSaoZ2+fxfDfedHr9Mu1K6dZ6yBURzUA0A9EMRDMQzUA0A9EMRDMQzUA0A9EMRDMQzUA0A9EMRDMQzUA0A9EMRDMQzUA0A9EMRDMU6Xe398u0tx5zAaMklSrNkd2gbL3nGspRti+VKxwe+2uL8AAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_34\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_35\",\"w\":230,\"h\":39,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAAAnCAYAAAAb3jSqAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA6klEQVR4nO3dMXECUQCE4X3hyjCDFPSgAgMp6RERAZEQCSeFIi33UqSMgNsZvk/BNn+94/12uY/kHKDCllyXkZzHHF/bHOveg+DVjfG8j3k4LUmyzbH+fHx+77wJXt7xdnlkJm97DwH+EyYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUEiYUWpK/3/fj7fLYewyQc5IsW3Id83DK3HsPkCTLc1l/AZ3oHDAdCZ+IAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_36\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtUlEQVQokWPkaY2awMjAYMBABPjHwFDAAlVsT4wGxn9MAky4JPnYOBmmu6Uy5Bl7oYhj1cDHxsmw1CefwUVejyHXyJNBU1gGtwaY4idf3jIwMDAw3Hj7lOHp57dweRZsiq+9fQJXHL1lIsOnX98xbUBXrCUsg6EYRUOnQwxBxShO4mPjYtAUlmH4/PM7TsUoGlqOr2XgY+NkuP72CU7FKBquQ51DCLD8Y2AoYPzHJECU4r8sFwCLUEd5VzBEpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_37\",\"w\":257,\"h\":50,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQEAAAAyCAYAAABcdW5KAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABDklEQVR4nO3UMXHDUBQF0fdilfGMoQiPUJhASvUGEQCBEAiC4iKt9MNCKu45CLba/lyXV1fNBcQ5qp5TV809+ucYvV0dBJyne3/1uD2mqqpj9Pb39f17cRNwovu6vGtUfVwdAlzLBCCcCUA4E4BwJgDhTADCmQCEMwEIZwIQzgQgnAlAOBOAcCYA4UwAwpkAhDMBCGcCEM4EIJwJQDgTgHAmAOFMAMKZAIQzAQhnAhDOBCCcCUA4E4BwJgDhTADCmQCEMwEIZwIQzgQgnAlAOBOAcCYA4UwAwpkAhDMBCGcCEM4EIJwJQDgTgHAmAOGmqqru/XVfl/fVMcCp5qqq6ah69rg9alzdA5xt2qftH7CuHEbKSn3gAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_38\",\"w\":307,\"h\":308,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATMAAAE0CAYAAABAXdTmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAENUlEQVR4nO3UQW3DQAAAwdzJAAolDEKpUAKhUIrDrxLxORyaSlZXMwj2tWPf9+da634D+KfmnF/bWus+xnhcHQPwW+d5fs+rIwD+gpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQIKZAQlmBiSYGZBgZkCCmQEJZgYkmBmQYGZAgpkBCWYGJJgZkGBmQMI25/w8juPj6hCAN/y8AHGuFOBiOggVAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_39\",\"w\":17,\"h\":17,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAS0lEQVQ4jWN08Aow+PePaQIDGYCJgWHBgR3rFrD8/8d0gJGBgZ8cQ/4zMNgzMDAsYGIg0wA0F1EORg0ZNWQkGsLIwJBIrmZK9GIAALZ7DKIdG3kdAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_40\",\"w\":19,\"h\":19,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABKUlEQVQ4ja3UMU7DQBAF0P8nBZQ5gi25IKIgN2BLl1twAG5AboCvQRf6QCwhgcvhBnRJ4cI5Ah1pPBS2kYMcghP/btc7T6O1ZomOuNgHoPjS4Nv7AisAqmbP86467iDej7FlYsa7rsOtbEjO9O0p7cSc92P7EgVwdQBqFdujZsvbZj06Fqq5aRhNWOQrBQABAGyZ9IeqGHDv4hsHAOJiH/zjjv5MiTKpOqP4A2cPhsC1i30gv3//8REnw0AAgGBIDMNi1YgMQqkA1AGkT80WKvXQbk6RSJsD9Z2RnJ3SFc4sAerZLPLVOowuQoDTvhCldPqSFj9YBa7TMJoQgOsFvaYfzcao/bXIVxpGl+8GCwkEexHaA8/NNx014Z6C6rWFOOygopotdF/NNx34ZOCttfemAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_41\",\"w\":18,\"h\":18,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAtklEQVQ4ja3OsQ3CMBCF4XenSLSMkE0wXUoj0bMKI8AGDIBQOig9AmzCAMhJERFh47PNiWt9/u8D/jSUezTd5jSAdtMir93t7KRdliO2fUcAwMPvc0fFEEDBRwJWptuan0KxpkYliEJNjeorJGlKqoQorSmpglBJk1NForwmp5pDtRpJ9SGq00gq1mhSKtZoUirWamIVg9hqI7PK2iW76+UA4KEO0XB0ff9spqq3QNOqSovXHQBGsAhACD46sGsAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_42\",\"w\":206,\"h\":15,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM4AAAAPCAYAAACsq/DVAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA1ElEQVRoge3azU0DMRRF4fueIiEvEEwFtJIOkhKmlGkhHVACJVBCSnAqiCY/GiSkZzbJig1441g6XwVnc2UvnunmdFnGkI0C8IuZ5fCYhpSyJJkkzdevD0mblmFAB+aIsh2e06efLssoRgP8xYu7vUuS8z0D/uXteF7W3roC6BHDASowHKACwwEqMByggrvptXUE0BteHKCCF9m+dQTQlZWyh8ckaW7dAnShaDeklH1IKUeUraRD6ybgoRXt4vtpkm5HnnfH87Ju0QM8vJXy/TJakn4AAY4x++8gsaYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_43\",\"w\":235,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOsAAAAICAYAAAAY2gj5AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAp0lEQVRYhe3ZywnCUBBG4TNX8EGEmE60AzuwBC0lpWgHlpASLMEO9IKCSpJxEXcSXd4s/q+CsxmYYQzgcnstg7WlOwtEZDDMvMqzWQlgn0GtgDxplYj0sEOeTXYW748jsEmdIyL9Wg+roNVXZPhGNMuQOkJE/mucczDzKnWIiPwUqacnA4j35x58mzhIRL7F1sO6mI+7YYXufYM3ul9FhqSenorCrgBvNAMwuePjHlEAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_44\",\"w\":168,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAAAICAYAAABtV7RaAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAoklEQVRYhe3YwQnCUBBF0Ttf0EiEmE5iB3ZgCVpKStEOLCElpAQ70ICCSpJxEV0ouv4u3qngLgZmGAM4nu9FsL50Z45IZGZeZem0BLDncFZAFrVK5I3tsnSyseZy3QOr2Dkin3oPi6C1Lv9qRFeE2BEiv3TOIZh5FTtE5IuGNqkNoLnctuDryEEiL03vYZnPxsOAwvBqwjvdoxJfm9R5bieAB7HDMLnYD6lNAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_45\",\"w\":243,\"h\":245,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_46\",\"w\":343,\"h\":346,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVcAAAFaCAYAAACqrx7GAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAANdklEQVR4nO3dPXMcV3YG4HMblLRVDghnzohNbVcRjlyKCEd2pkkAIVMLZK72LxD2F+xsLmsn5K4CQdlmGmbKBAa7MfgPiCoHWpno6wAfBPFBzkfPdE/P80QYikBfMXjr4Nxzb6eAJdktq+2NB7EZEVHXsXPjP9/8PJOc4nXKcXz1OeJko4iTiIh4EyfPR8OTJp4DH5LaXgD9MCirzd88iO2zOrZSxFbk2IoUWxGxGZEft72+29KLiIiU4zineB0pjosUr59/Mxy3vDB6QrgylcsQrevYeRug+Unb62pSivQqR5ykHMeR4iQVcSx0mZZw5V77ZbVVb8R25NiOiJ2IvB0RD1teVmtSpFd1iuOU47goYixweR/hypXdstouitipU+wUObZz5Edtr6n70ss4by2MN+oY6+lySbiusethmnLeiTWuSpuSIr3KOcbCFuG6RgZltflREYOUYydSHoQwXYL0MuUY5yLGf/6f4VHbq2F5hGvPXVanOaLs5q79WjnNKY0jx9H/1XF0NBq+bntBLI5w7aHdstouUpSRYqBv2mXpRYo4SnUcaR/0j3Dtif2y2sopKoG6qtLLHDFU0faHcF1hg7La/KSI0q/8/ZJT+iFyHH337XDU9lqYnXBdQXtPq0GOKFPOn7W9FhbqNOU0qnOMvhsNjz/81+kS4boi9stqqy6iTBGlX/vXkbbBqhGuHbf/rNo5y1GpUrlwmnIapRxDm2DdJlw7avegKouIQ1Uq98kp/bCRYugYbjcJ1w4ZlNXmx0VUEbkKA/5M7LxlYAOsW4RrB1yOUeWUyxCqzChFelVHHArZbhCuLdovq606xWGk/EXba6E/Lq5MHP1ax9DmV3uEawuEKktyGpGGf/52eNj2QtaRcF2iQVltfpLiMKf8VdtrYX1oF7RDuC6BjSq6QMgul3BdsN2DqkyRhyFU6Yz0oiji0AjXYgnXBdl/Vu3kOkbmVOmqnNIPG2dROYywGMK1YftltXW2EUMnqlgd6XcmC5onXBu0d1AdRuSv214HTCtFepVTVN6W0Bzh2gAtAPojvSjqKLUK5idc5zAoq82PNmKkBUDPnKZIh3/6djhseyGrTLjOaO9pNYicR2EKgN5KL3MdpbtkZyNcp3Rxr+ooIj9pey2wHOl3TnlNT7hOQbXK+lLFTku4TkBvFS6pYiclXD9g/1m1U9f5KFSrcMFEwSSKthfQZZ9/WQ3rOv8YghWuyU/qIh/vPa0Gba+ky1Sud7jYtDryump4v5TTH/6e49DprtuE6w02rWBaNrvuoi1wzedfVsPI+fsQrDCF/DgVeaxN8C6Va1zdtzrWBoD5pJz+8Kc/Dqu219EFax+uu2W1nYo8DtUqNCS9+LWOwbr3Yde6LbB7UJWpyD+HYIUG5SefFHG8W1bbba+kTWsbrntfVqMU+Y9trwP6KEd+tO592LVrC1z0V4/cDQDLkSL99zresLXR9gKWab+stooi/hKR/73ttcAa+a9/2f70t389/mmtLuJem8rVxhW0bb02utai57r/rNoRrNC2/OTjIsaDstpseyXL0Ptw3T2oSvcDQFfkx+sySdDrtsDuQVWaCIBOOs112unzkdneVq6fH1SVYIXOepiKPO5zBdvLynXvy2oUKX/R9jqADzotijR4/s1w3PZCmta7ylWwwkp5WNf5x92Dqmx7IU3r1ZyrYIXVlCIG//xvn776288/9aYH25twFayw2voWsL0IV8EK/dCngF35DS3BCv1TFOk/Vn2Ta6U3tD7/shoKVuifus5Hqz6mtbKVqwMC0HsrfdBgJcNVsMLaWNmAXblwFaywXlKkV3+vY3vVbtNaqXB1bSCsq/Ty1zp2VilgV2ZDS7DCOsuPz98gsjpWYs51UFabD87/YR+1vRagNVur9EaDlahcPy5iHJEft70OoGUpf7F3UB22vYxJdL5yvTgk8J9trwPojJ1VOMXV6Q2tzw+qKkf+fdvrADqn8yNanQ3XvafVIHL+vu11AN3U9RGtTvZcd8tqO3Ietb0OoLty5Efn+zHd1Lmeq8kAYAr/9K/bn/7jX49/+kvbC7mpc5XrxymGJgOASeWUv+rimww61XO1gQXMqHMbXJ0J14sTWD+3vQ5gVXXriGwn2gKDstosVuxoG9A1+fF5W7EbOhGuH23EKEe2gQXMJ+UvutJ/bb0t4ApBoGGnRZ22n4+GJ20uotXKdb+stlLkzpTxQC88rDvQZmw1XC/+AVwhCDQsP277gpfWwvX8f9w8K7Ao+es2X3LYSs/V2BWwHO2NZ7VSuaYiRm08F1g3+fEnKQ7bePLSw1U7AFimnPJX+8+qnWU/d6nhet7/yF8v85kAdb38wwVLDVftAKAdy58eWNqGlktZgLYVdfrtsg4XLKVy3S+rrRz5cBnPArhPvcTfnpcSrmcbMQyHBYDW5SfLuntg4W2B/WfVTl3nHxf9HIAJnf5ap61Fz74uvHLNtU0soFMeLmP2daHhundQHbpKEOianPJXiz4au7BwHZTVZkSuFvXzAeaRisXOvi4sXC9uBLeJBXRUfrLIk1sLCdfdstqOlL9YxM8GaMoi94QWEq6LLrcBmpAjP1rUaFbjo1hGr4AVs5DRrMYr17pu53ovgBk9/LiIxjffG61cvWwQWFGNV6+NVq5FqFqBldR49dpYuO4eVKUDA8DqytX5fH4zGgtXVSuw4hqtXhsJV1Ur0A/NVa+NhKuqFeiJxqrXuacF9p5Wg8j5+yYWA9ABjUwOzF+55ubnwwBa1Ej1Ole4nl96kJ/MuwiALkkR5bw/Y65wPVO1Aj3UxJ0DM4frflltpZw/m+fhAF0170b9zOFaL+E1CQBtyZEfzXPf60zhOiirzUh5MOtDAVbBPK3PmcL1oyIG4S0DQM+lnD/bL6utWb53pnB1aABYFznNVr1OHa77z6odR12BdZFTLmf5vqnDtT6bf/4LYIU8nGUsa6pwvdjI8uJBYK3McqhgqnD9pFC1AusoP5l2Y2uqcM0NHAkDWEX1lMXlxOG6W1bbEfnx1CsC6IFpWwMTh2uRVK3A+pr2xNbkbYEUTmQBa22aaamJwnXvaTUw2wqsvSmO/U9WudaqVoCIeLj3tJooDycLV5e0AJybsNj8YLhepLRLWgAiJi42P1y5agkAXDdRa+DD4aolAPCuCYrO94br+cEBLQGAd0xQdL43XB0cALjTw4vi817vDdecYqfR5QD0xIeKz3vD9fwGGHcJANzlQ8XnveF6VqhaAe6XH7/vGsL72wLuEgB4r/cVofeGa8r53m8CICLlKcPVCBbABN4zknVnuKZCSwBgAveOZN3XFthZ3FoA+qO4p+96T7jmJwtcC0Bv1PeMZN0K12leYwCw7oock7UFcn33XwTgthz50V3zrrfC9b4SF4C73TXveitc7ytxAbjbXbn5Trjul9WWFxECTOeuewbeCdd6Q9UKML3bl1y92xbQEgCYyc1Jq5s9150AYGo3J61uhGtWuQLMIsfW9Y9X4Tooq81wWQvATHK6p3L9zQP9VoDZvXttwFW41rV+K8A8rp/UettzvdEvAGBKD97m6NtwTcIVYB7XOwDXpgVMCgDMJd9VuZoUAJhPuhGu7nAFaMLbDkAREVHn2GxvMQC9cdUBOG8LuFMAoBGXLywsIiKSyhWgERsPzvO0iLh9bAuA2Vxe4HLfq7UBmEGOa5WrV2kDNORi1lXlCtCki1nX4q5XwgIwn+L6RQMAzOu8zaotALAAxc33vgAwv+JybACAZuyW1ba2AEDDNh7EpnAFWIDC0VeA5hUubQFo1lkdW9oCAA1LIVwBFkK4AiyAcAVYAOEKsADCFWABhCvAAhQpXDkI0LQiR5y0vQiAvtEWAFgA4QqwAMIVYAGEK8ACCFeABRCuAAsgXAEWQLgCNC3FcZFyHLe9DoA+KVK8LnKK120vBKBvtAUAFkC4AjTtTZwUkfRcAZr0fDQ8KQo9V4DGaQsANChFehURUfzyRlsAoCmXd2QXR6OhtgBAwy7bAqetrgKgP8YRV+GatAYAGmRDC6BBVz3Xi8/j1lYC0CMbxbVwTWHWFaARb66Ha2EcC6AJz0fDk4iLcD17o3IFmF96eflVERHx3WiocgWY31WhejUtcHlkC4CZjS+/uArXy/EBAGZzPUevz7mOl74SgB65HMOKULkCNOb5N8Px5ddX4Xo9cQGYzs19q6twvZ64AEzn5m//N+4WeDujBcBUxtc/vBuu2UktgJnceB/hO+GavKwQYCbF2fvC1R0DALM4vbxT4NI74WpTC2AWt184cMdl2Ta1AKY0vvkHt8I1ZSe1AKZRFBOEa21TC2Aqv7y5nZsPbv7BP9Svn//yYPNkKSsCWHV1+t+j0e/diQ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAZ/w/J7MzvIfNhmMAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_47\",\"w\":443,\"h\":447,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_48\",\"w\":545,\"h\":550,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_49\",\"w\":58,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAICAYAAACoCeyOAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABnElEQVQ4jb2UYZGrQBCEv746AUhAQiQgAQlIQAISkLASVgISkIAEHPT7sbOVLV5I5X7cTVUqMJnp6e6djQBsD8AAHECWdPILYTtLGn8JewJ2SfslvwJ82x6BEUjAI75H24/I70AV3scnUYwByEAX+QdwSMrN8I5i4B61rbFbw6mP2izpuBEzRl0VswdH6uxrj6TZ9vYFzJImSZukFVhCZAoiY5AagCnA9wDugCWGr3Ww7TmcrCJT1Ewhcg3stcEeKIbmG5EzT+NrX4oZZ3C7D9v7i9wS7mF7iPclSGJ7s901z4PtJd4ftrPtrcFbo2a74LzEvuGZ4wAII5eWe+Vx07t9Adl2st3ZnqJ5bxx66dSLezyE+JFyWqft0XbPc72gnPBb7JvYKNvS8bw2R5jVUzbsNr4lLbEWiSJwkHTa7m3nyB1RX8W1W1Cfc2AcgZkoaz3Gbyflz6Kamhvco8UOMS3xU9IaW5NCdF3zOWoWirnDpW8Hdr1z4dOo4JK2D2r7huAEpGvfjdD/rtg7Lj/t+yji9Psf1D/ae/kX8Q+mY1YWFSJYugAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_50\",\"w\":11,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAUElEQVQYle3KMRGAMBBFwUfmBMUBVm4iAQWRgASkRULok/m00BwIYOtdylY9CScg6FO4JeGCNcoABjm9pbs/P7Kgf3jngGZTuEGO5oB27LVdOFMWBUJ0Z4IAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_51\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAqklEQVQokZWRzQ2DMAxGn80C3aR0kq4QIfWOmMBdoMoASE1HYANGYQQGANIDpOJQ8fNutl6cL7GwoqjMacSlOkIvEV97a1NPAFxpl0xogSv/acaIC956BdiRAe6Z4AGkqMxJ5L0h/9DITdeZ95gEp0dlAIH81IElFv2JK1qVOL/+CMNE0GUpze5w4Rm8dQowzj/12ZLrl9mcasWjtHwSnECeMg8TIXjrkvMFAE02FfKAdg8AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_52\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAjUlEQVQokY2NyxWCQBAEa2YIgBAMQa+eCIUQDGFDIAMNwQzk5hFCgDx8rAfFJ7P8+tY7vVWCS3kJeQbHF3S3KnT+rv7BhCoKDxNqfwMwRz+ocP3W/HQu+uZZt4sGE8J/lzjtE4Ojj0ksP4OnL1lshT5r0TX6nMU26IlFM6XcGAOg8bNTGbjv+TDIvl2SNxZeL7LV2H6mAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_53\",\"w\":104,\"h\":104,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_54\",\"w\":146,\"h\":148,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAACUCAYAAAB4InCTAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAInElEQVR4nO3dP3rbOBoG8PeDXExn3SCaE0S7U+00qzlBPN12ZvynDuwLDPYCDlMn9jI3ULotlWqm2sg3sG4Q9RaxhUhHkiWZfwWCfH+d/UgkivcBPoAgJOioS22GFuhDYQQA1mIgwCDXRQQTAIiBBxXj4RGYRqH5XnVbfSCuG1C3QJv+ETCEwshaDLEMy+sabzkXYGqBqRVMezGmH0MzrfF+jdDKIJ1rcwLBCMAI9YYmqzmAiRVM4hjjKDQPrhtUtVYEKdCmrxROxOIEwBvX7clgBmCsLKK29FZeB+ns2gQehWeXGYDxwiL0uafyLkiBNoOeQAMIABw7bk6lBPgaC6K7GxO5bkte3gTpQpuRXQbI594nq5kIoscYoS+zwMYH6UKbEQTGAv903RYH5iIIfQhUY4PU8QBtanygGhekpAYK0Y0hLK+5Fegm1lCNCVKgTf9IQVuLP1y3xQP3YqE/hWbiuiGpRgQpKaQjAK9ct8UzHxYWpgnDndMgBdr0ewID4J3LdnhuJhaB697JWZAutRnGgjHYC1Xlw+17o13d3EmQzq6NFov3Lu7dcvcLixMXK+QHDVIylEXgjKxOc1gEt6EZH/KmvUPd6FKboSyHMq4L1esnCP71y68j+d+fk8mhbnqQHimphyZo2bMxD3xeWOhDzOpqD1LyhP4/dd+HdrpfWIzqDlOtQWKIGqP2MNUWJIaocWoNUy1BYogaq7YwVR4khqjxaglTpUFiiLxReZgqCxJD5J1Kw6SquMilNkOxCKu4Fh3M62TfVyVKr2wH2gxE8Be42OijYVUr4KV7pN7ysQdD5Clr8ce5Nidlr1MqSOdXJkIz3mSlMgTRpTbDMpcoHKSzaxMAOC1zc2qM41gQBdr0i16gUJACbQYsrlvndbJbtZBCQWJd1FrvitZLuYN0cW0MWBe1V8EhLleQAm0GfF2o9Y6LrC/lCtLRcpsstd/phTajPF/IHKSzaxPw9enusDk7jUwr24E2fQX8F8BPRRpFXurnWfXO1CMdKWhwltY51kJnLbxfDFJSYDt78Y6cOs66tvRikJILsTfqrneBNoOXPrQ3SMkF+Bik47L0SnuDVGbJnFrl9KVeaWeQ2BvRqpc6lZ1BOlIIqm4Mee1k3wxuZ5A4U6MNx2pP57I1SMleI87UaI3s6Vy2BmnfF6jTXu3aZvIsSEmRzW0itJ0gW5CSn2cg2uV0W9G9bWgr/UYBtZtSzzOyFqTkTQIeDkp7Jb9ItWYtSLFw7YgyebM5vG0ObaPDtYV81tvIylOQOFujXDZmb09BUoq9EeUyWv3jKUhiGSTK5dXqjoDVGml08KaQ11ZHMQU81Uec9lMuq6OYAoAeUOokCuqsp9woABDFIFEhT7P8ZY3EQpsKSt/IVQBggYHLxpC/YrXMTjprY6FNhaikE1J5DwsgWpOURZUcj0ykwEcjVEJ6Qg17JKqEspYzNion0GaghFN/KukIGHBoo0owSFQJBokqwSBRJRgkqgSDRJVgkKgSDBJVgkGiSjBIVAkGiSqhIJi4bgT57VNoJuyRqBIqBh5cN4K8NgMApWIGiYqTpCNSj+yRqASbBikKzYPbppDPRJIgAYAAX522hvwVL2f96Zu2Dy7bQv5KS6NlkARTp60hX83T0kgBgIoZJMpP8CM3CliuTDprDflr5anIjzMkWXBTXvGWIPGZG+W1OpL9CFLMIFF2myPYU5CSdM0P3SDyUywYr/69+fR/crimkM96GyPYWpDsRsqIdph9DM3aktH6ryPFDBJl8iwna0GKQvMdwJeDNYe8pCyiZ//b/AeHN3rBs2EN2BKkuxsTgbM32sEKwm3/37Vnm70SbbWrjt4apIWFqbU15KvPuzZCbg1SFJoHPnujTbKlyE7tfB3J2u1jIXXW/b5dIjuDdBuaMZJXTYh2FdmpvS9IWmGtRACAWTKb32lvkJIvs1fquCwdyouvbLNX6rwXeyMgQ5DubkzEGVx3iUWQ5XPZDpHgulInCfA1637+TEFKLsaHuR0jFjrrZzMfa7NYXpTP4Lrjw7aHs7tkDlIUmgcW3p0xy/uYTPLe4fzKTLHyM93UQha/JwvSmeU+sU1lrOLJW1/yhggoEKSPoZlawVXe75EXZouCHUXuoS11cWUm6e+ZUjuIxW9FX98vfBjpo8UJOItrDRH8u8wZEIV7JAC41GYYC76VuQY1wpfb9+akzAVKHY+c1Etvy1yDnLsvWhet6pW9wLc/J9O//2P0M4Bh2WvRwc2VxcldBeeIlhraVrH49k+Z4npTZSf/J8X3fVXXo3pZwdsqD1irrEcCgECbfm95zhJXvhvMCt5m2WOUR6VBAhimpqsjREANQQIYpqaqK0RATUECGKamqTNEQI1BAhimpqg7REDNvyAZheb7wmIE7q50ZQ6L3+sOEVBzj7Tq/MpEAE4PdT/CXFmM8uxyLKP0ynZW3/6ajP/262gmQKlnOpTJ/cJiWMWKdVYH65FSyYPeMYBXh753R3y4fW8yb9qvysGDBDwV4RGANy7u31JzWARFdjdWwUmQUmfXRstyk/mxy3b4ToCvjxaByx9xdBokAAi0GRwJIj7wLWRuBebuxjg/gsh5kFLsnfJpQi+0qjFBAp5qpxBcJthnBgvtqhbapVFBSl1qM7SCkMPdmrkIwk83xrhuyDaNDFLqQpsRBKbjgZqLIHyMESYH6jdSo4OU6migvAhQyosgpZLFTI1211AzKzBxjLEPAUp5FaRUoE1fKQTJsSttWSH/LBaRr78v7GWQViW9VIDlMzzfQvXFCsa+9T7beB+kVZfaDK3CiV2+iNDEPVBzAGMrmLQhPKtaFaRVgTb9HjCCYCTA0FGhPgMwtYJJL8bkUFs6XGhtkLa51GYYAwNRGFqLoQB9u3yxs+xq+r0A3+0yNA8qxvQRmLapx3lJp4K0T6DN4AgY5PmOr4VxHf4Pzdf2ZwjPtlkAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_55\",\"w\":188,\"h\":190,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_56\",\"w\":231,\"h\":233,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_57\",\"w\":126,\"h\":131,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAACDCAYAAABLL69PAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABv0lEQVR4nO3RbXHCQAAG4fcOAY2ESsABDjrFAZEQJcFBcNAPBdRBJbQSMJDDxd2P3UfBzmxJknX7uiY5RgDltsxvt7Ju35eUto3OUTePtP21Ju19dIm6ekkOl5pkGl2i3tpUU3IanaH+6ugAjeF4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD1VT2v/oCPVXs5e/0RHqrya5j45Qb/tnTfZrksfoFHXS8rPM59+SJOv2MSU5Dk5SB8t8vifJEzn1IHE71gAyAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_58\",\"w\":131,\"h\":32,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAgCAYAAAAxFcsmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAuklEQVR4nO3bsQ3CQBBE0Vl8IUguxfW4CjdA6NxFUAAlUIJLcUDqWwKkaWGR+K+CCX46cV3nLaRJ+GtdWlpIU2Q8e8ZePQg1Is4tchibJPWM/X1/vIo3ochtnQ+ldKkegt9BDDBigBEDjBhgxAAjBhgxwIgBRgwwYoARA4wYYMQAIwYYMcCIAUYMMGKAEQOMGGDEACMGGDHAiAFGDDBigDXpe7y8rfNRPQZlJklqXVoih1FZvQeV2tn2Dx2lHCLzDjsGAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_59\",\"w\":121,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAAMCAYAAABGFRI7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAyklEQVRYhe3YTQ3CQBBA4TdzgDT8pQrAAUioA5BQCUhAAjgAB5WABJCAAqCUlJDAcqDFAGw2NPOdduf0kkn2sEIlL8r0iaSYvyfitoNOtPjcAc7XWwZMQ0WZ3xPYP+7tJI7lpHlRptiCG8fBWFu3OYDaE91k792qCKOwIcajIYDWB9NcGjrA+KfAIXSE8UuBXegI44fAHkAFWQduMb44twTQfqed4ViF7jG/Jpt+N1pD9eMFcLyUiYrMHEyCdZmvCeyezmVxL9rWsxewhSrYVcIVbQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_60\",\"w\":74,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAGCAYAAABkSghmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAdUlEQVQ4je3OUQ0CMRBF0fsmC2ETEsBBnYAEHGABCZWANCSsg7YfpIEQBgEI6HxwFByV4ntbv27unvj7IbjvtpvrZKtnBi7S6FJYx/bo1RDn0ZPo3HUyQR0diU6iGigDbXQmsPZxywIovSfepMGhmCaWwzwvX5efHk+NygGNAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_61\",\"w\":107,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAGCAYAAADE1WCIAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAeElEQVRIie3OQQ0CMRCG0e+fAIFwgHWwTkACDrBSCUhCAk7aHkgD2TAoWPZYDvMUPOXsR9u8b+4+Ev6S5PfDfpdWtn4l4Cr1LoV5OtVnwxCX3pWwzF1nE5TekbBMohgoAbV3JvxUP25JALm1kYmxcyjMmbaPYVD5AiAGH2D45vIEAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_62\",\"w\":51,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAGCAYAAABuFqY0AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAdklEQVQ4jdXO4QnCMBRG0fulEv8ENBtkBEdxE1foCF3BjbJJEhBaivS5gy2EngmOSrG78+tkZokTkqibuTEGn9U+y4R49U7t1Lb1mhzi2XtygBuX5eEEtffkEBqqA41A633ZR+8YfBZAmefEl9R59B8NNQafAX4APx9vmKy3TQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_63\",\"w\":99,\"h\":34,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAiCAYAAABLP2dcAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADnUlEQVRoge2Z0W3jRhCGvyGMy2PYgdVBmDebEBBeBd5UEHZw6uCUDnQVnDrIdhAdEFB+C90B0wHzGMHHycMObVqWbQEmLALeDxBEzXJ3h/vvDKmhYOROSyADWiJvRdrB6tpLc2fJna7mTouTufROKZymudNV7jQDQkREIU7LpdM1QAJkf3nZnNSbd47AJneanRHvEScngQZIk1M7ErknijEhohgTIooxIaIYEyKKMSGiGBMiijEhzsYeMHeaddA+KH49bC8TaPb/9c+dFh3MKi9rCHWb21C4vOMWmqfGPZZh6aeDVmEmUFZe3FPnD/16yf4aRo2MwmkK/J3A5pnTyg6KfaPZyv73LWQd/Dn8JIP2l8idLnOnj/wYjgesAPSZKsS+Xy/ZX8OokbEDB/wLnOdOs8pLDaEqTGhrgFl//p79wYJY5EjudAkUlZfC+mTAkhA19Qcod7BQmG29lH3RjbBYae500/ftSeBjH5n26qAdHJfmo6+8LIb9rH1oG7WUNPY9Y6HggX+wXXPpdGHHS0LEnA/snxRW1ufqyDk8kGpYlNkO1oAX+C13uhFwCksNczVJmPcB36HMnS4vnM4IC5/Z8VegNl9L8xG42wRfFWoN7bMj/T2a0cSwi/kJ8BrC3wHY4vjKy7rysgRurEsGfNt6WW29rIBvR85xDqQSxEiBK4vA34FfgMW1l0Ys2g5VpCXMXSShPwDJferMsI0kdg0Aau1bL+XWi8dS3JiMlqbkfvH/6G2XTp1CYxdP4TTd2Y6yxSrsPoPZm+fmuPbS5E4BNgn4DopBvi/s2xGi5UkSWAzSlDNb04XmtUIrkCnUcv8Q0fTXsPHSsvdwMQajRYbt1C+VF6m8CCECnIQdNMud1ruQAn60Lh5Id9Db08MjP+IL8KkL436Gu5SXKfwKXNkmaIHs0E38ECbODbAynz/LYHP8ENLezQ7q3GnN8Wn1aEaLjATKs7CoAHTgEkgrL/WF08wip5GwA9trL82F0yyx3a1QJwcE6WCdBOEAqLws5k79d8gENlsvteXzwo5/lnCen4dF2/fz456fd+N/gOI/KCS8m96Yj20CfuOlLZwWu/vU9WjsV2NPK5ETMndazJ0W8R/4hIhiTIgoxoSIYkyIKMaEiGJMiCjGhIhiTIgESPv6UOQ0dODOoE46WO0OlJkjb4OVctqNl1Z6g8JCQjW0Oa1774cu1Llae7WADBvzULiLKeuNOIPayvEA/A9xtYoe7OMXowAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_64\",\"w\":63,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAICAYAAABOICfKAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABrUlEQVQ4jY1UUZXDMAyTj8AKoRAKoRACoRAOQhncIIzBFUKOQSEUQhjoPiZvXpZs83t9SeRajuI4BhnJCQDMbEfDSM4ARjO7vMOFRTvM7GjxNvKM4suNPLWtAJKZlQ7PYmbrW5zkwasNnU2tJPMnOJ9treN6Jj428NpGktuL/c4dnkfcAZKF5BLws7CD5O4iSS7CHvBXSUgO2iwVM0loke8i/GYN8WuLX1weu4kv+hf5C8lci/fEF5K7sCSyb809cGrhH4jflGNWHhftB0hxXzSfG+KzDmyuxBXFzeLbQkEHje7fa/EliCGvV2r1gwi3IOu/EvBeO9Ti/QblSqznPAe+3rV/Eh+Ksct/KJf7b4cQiwoAXyQTgBOAHwC/ypUAFAAj7z2VNB4ATtQDCcDHd3boWwFkAH9aO29ip3+DZTNbq8fwcJ+4dwBbw+957vvVFdnC+qzTG3jvEz/NHHDy/kjGzThPXfmlijlX1SnCbpWs+Mh+z3urOHfq+G9vipNMvD7/vh6oftPcicZQbb8+SfFP1Y88ARs9JuSegm+u55XY5j4DV/J/Gv7Z/Y7/A4SBvfK22QlxAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_65\",\"w\":99,\"h\":34,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAiCAYAAABLP2dcAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA4UlEQVRoge3aTRHCQBBE4TerYKVEAhKQgAQkICESkBIJSEBCHDQHwo+CbFelv+PkMpVXlVym2Ei6ABOwEnvpwFxVz+9E0izpNGqjo5LUt3c/fQaXhBhL0h2gAVNVLUO3iUXS1Mg/wsET6G30FvGTGEYSw0hiGEkMI4lhJDGMJIaRxDCSGEYSw0hiGEkMI4lhJDGMJIaRxDCSGEYSw0hiGEkMI4lhJDGMJIaRxDDSgC6pj17k4M7AowEzcBu7y3FtF+hrVa31N7gCC++7z9jHmXeIG0D9P9mi5JO1n0dVfQ/PX+mrPiNbMjdsAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_66\",\"w\":74,\"h\":10,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAKCAYAAAATiMgdAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAACFElEQVRIie2W0XHbMBBEH9SA2UGYDlgCU0FYglKBWQJTgdmB1UGUDlgC0wFLoCvYfGhhnWlQ0U88+cjNaEgu7m4PuAUgsElqJDXsmKRW0vEe3LnqvVx/21zT9jdJqnb8a0nDXbikRRfbSzZImu7BXdQ74o8yvbda0vnG3FpJuoUfMgB8Al6ALjiOklZJywY/emHf4HtEkmY/x5gzKzjkW73IMt449hV3ziZ8Tzs74XuyATXwNaW0hpwqLZ5rmSWtwJDxg59H4BdwBnoHdMCjnXuT4aKegTHif7AJ+OZ8nfkW4ORCn+3TAdUmbi7gZz+/GD8VOFurvS3UMju2jrGhlhInuGO9pC5IdZA0B5/R3eu92hnf3XpbSbtTg98zV1ZdtcGbPG683fjP5lm22yYoLdeQY5pC7FrI/aYWgIOV8wA8AT/M1QErUAdp5i22AA9B7rsXQMHWwvuyydPu4JHnhUvXBy4K+VngmlJKQ0ppCljOOTl25qrOOJ7neuX0Pj2H79ErXel6PsTzI+PS9QKIxdxS1OshH8cknUKn1wKeeXLXj35f/ew3/FK4THa4cs7uRi3KeLIy1pTSYscKaFJK+TptuXR/AaqU0my/qDAy7rHGMWvOFfGU0hJ58mS4nAkzUJs/Y/n3BHx2fOOOT7n2uDDAUppTqKMG5ntr4V82q322OheFM/O/BfM2771lR+38D/oI+w3lz2kOwJ+8zgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_67\",\"w\":99,\"h\":34,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAiCAYAAABLP2dcAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA4UlEQVRoge3aTRHCQBBE4TerYKVEAhKQgAQkICESkBIJSEBCHDQHwo+CbFelv+PkMpVXlVym2Ei6ABOwEnvpwFxVz+9E0izpNGqjo5LUt3c/fQaXhBhL0h2gAVNVLUO3iUXS1Mg/wsET6G30FvGTGEYSw0hiGEkMI4lhJDGMJIaRxDCSGEYSw0hiGEkMI4lhJDGMJIaRxDCSGEYSw0hiGEkMI4lhJDGMJIaRxDDSgC6pj17k4M7AowEzcBu7y3FtF+hrVa31N7gCC++7z9jHmXeIG0D9P9mi5JO1n0dVfQ/PX+mrPiNbMjdsAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_68\",\"w\":72,\"h\":10,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAAKCAYAAAAXfRggAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAB7ElEQVRIid2U0XXbMAxFL71A1Q3UCapMUGUDZ4IoE9SdoMwG7gRVN3AmCLuBRtAI2uD1Q6ALM1T6E380OEfHNPge+AiACACSDkADpBBCktQDzyGEwBubpBYYCvcYQpivcJaA2xBCek1LCCFuxdhJGoEI9MCzpMEHsGSVgXtJjaTOMI3ztYZpalxnA0WiSo6L2xb+Lp9T07N1YAXXA9+z392586RkSULSYF+vS1sy0dbeHwt8tBge01XEJknJ/T+WnIqOyb5sg3EzJ9vo/P0rupPz9ZLG4qxmB4zAvaQZ6ICTu8ct8An4AOyBA7AAH4Eb83t7AI7AT+CX8RfzbZrW6n0tONFBbuz7DCz29J8KTDL/N7tP6/YiMFd0RwA3Su6BR+AOaM/xtbbdYJkdc+XcBZLL+LHiP+MrVZekpZKUcwdtcKaKjklStPXenSlJe4fLHZF/zzzbv+h88x0qGtLORI5AAibWYb1lE5CfYA98KQFuIP5grdYT/+ggiwtr9TLnVMEtG2uAqHUMRPs/u70Z2Nv+gaLzrYOz7gfWLv4NHHMl8vuc5d6+C5A7pdHfd7sYPlbwg4s5qTI49XIGveBs6bC1r37mZF2D8+fBPJe6DTM5nJ+DJ0vc/2/5gteIvbtG0Pdk7yVBj1zOnDezP4llTuovuc7tAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_69\",\"w\":99,\"h\":34,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAiCAYAAABLP2dcAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAA50lEQVRoge3bMQ3CUBSF4f/dgZVKwAE4oBJqAQdIqQQkVAIkpHMt4ABWQigDBRxwT9LzjZ1O8qfvTa8A1M1Y3WEP1MAW+4cLMAS0564cAcoU4gisM5fN3K7vyiGmP8IhcrV1M1bB+2iyXMsHbCJ7hf04hhDHEOIYQhxDiGMIcQwhjiHEMYQ4hhDHEOIYQhxDiGMIcQwhjiHEMYQ4hhDHEOIYQhxDiGMIcQwhjiHEMYQEsMoeYW8BDNkjDJ5wjYA2e4hx6rsyxPQ2YAfckgfN1WkBDUD5fKmbsXrAJm/T/Dzh2nfle028APhsJZt5MWtqAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_70\",\"w\":577,\"h\":453,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"comp_0\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 5\",\"parent\":12,\"refId\":\"image_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-81.5,-50.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":60.0000024438501,\"op\":960.000039101602,\"st\":60.0000024438501,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 13\",\"parent\":20,\"refId\":\"image_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-78.5,-26.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":90.0000036657751,\"op\":990.000040323527,\"st\":90.0000036657751,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 18\",\"parent\":24,\"refId\":\"image_3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-30.5,-34.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":120.0000048877,\"op\":1020.00004154545,\"st\":120.0000048877,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 24\",\"parent\":30,\"refId\":\"image_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-34.5,-27.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":150.000006109625,\"op\":1050.00004276738,\"st\":150.000006109625,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 29\",\"parent\":34,\"refId\":\"image_5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-71.5,-24.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":180.00000733155,\"op\":1080.0000439893,\"st\":180.00000733155,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 6\",\"parent\":12,\"refId\":\"image_6\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[6.5,-6.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[92.707,39.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":60.0000024438501,\"op\":960.000039101602,\"st\":60.0000024438501,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"Layer 14\",\"parent\":20,\"refId\":\"image_7\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[8.5,2.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[92.707,24.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":90.0000036657751,\"op\":990.000040323527,\"st\":90.0000036657751,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 20\",\"parent\":24,\"refId\":\"image_8\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[3,-1.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[39.207,27.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":120.0000048877,\"op\":1020.00004154545,\"st\":120.0000048877,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 28\",\"parent\":30,\"refId\":\"image_9\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[10,5.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[50.207,27.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":150.000006109625,\"op\":1050.00004276738,\"st\":150.000006109625,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"Layer 30\",\"parent\":34,\"refId\":\"image_10\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[15.5,2,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[92.707,21.207,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":180.00000733155,\"op\":1080.0000439893,\"st\":180.00000733155,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":2,\"nm\":\"Text\",\"refId\":\"image_11\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":10,\"s\":[0]},{\"t\":20.0000008146167,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[291.054,35.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[34.968,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":3,\"nm\":\"Null 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[211,174,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[211,124,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,177,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[309.906,128.039],[126.063,128.062],[126.063,205.039],[309.906,205.015]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":2,\"nm\":\"Layer 12\",\"parent\":12,\"refId\":\"image_16\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":5,\"s\":[0]},{\"t\":15.0000006109625,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[6.94,-6.976,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[112.655,47.523,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[81.839,82,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":3,\"nm\":\"Null 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[209,234,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[209,184,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":2,\"nm\":\"Line 1\",\"parent\":20,\"refId\":\"image_17\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":8,\"s\":[0]},{\"t\":18.000000733155,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[4.508,-10.358,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[84.848,2.731,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":2,\"nm\":\"Line 2\",\"parent\":20,\"refId\":\"image_18\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":11,\"s\":[0]},{\"t\":21.0000008553475,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[3.556,0.91,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[83.896,2.732,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":23,\"ty\":2,\"nm\":\"Line 3\",\"parent\":20,\"refId\":\"image_19\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":14,\"s\":[0]},{\"t\":24.00000097754,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-47.21,12.858,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[33.13,2.731,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":24,\"ty\":3,\"nm\":\"Null 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[161,304,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[161,254,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":25,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,175.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[201.999,275.465],[125.976,275.496],[125.984,330.594],[202.007,330.562]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":26,\"ty\":2,\"nm\":\"Layer 19\",\"parent\":24,\"refId\":\"image_22\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":11,\"s\":[0]},{\"t\":21.0000008553475,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[3.089,-1.543,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[37.587,27.953,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[102,99,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":30,\"ty\":3,\"nm\":\"Null 4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[250,297,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[250,247,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":31,\"ty\":2,\"nm\":\"Line 11\",\"parent\":30,\"refId\":\"image_23\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":11,\"s\":[0]},{\"t\":21.0000008553475,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[6.369,-10.05,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[43.669,3.007,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":32,\"ty\":2,\"nm\":\"Line 12\",\"parent\":30,\"refId\":\"image_24\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":14,\"s\":[0]},{\"t\":24.00000097754,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[6.369,0.976,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[43.669,3.007,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":33,\"ty\":2,\"nm\":\"Line 13\",\"parent\":30,\"refId\":\"image_25\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":17,\"s\":[0]},{\"t\":27.0000010997325,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-7.415,13.382,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[29.885,3.007,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":34,\"ty\":3,\"nm\":\"Null 5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":0,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[202,358,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":39.0000015885026,\"s\":[202,308,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":35,\"ty\":2,\"nm\":\"Line 21\",\"parent\":34,\"refId\":\"image_26\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":14,\"s\":[0]},{\"t\":24.00000097754,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[11.508,-10.656,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[84.848,2.731,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":36,\"ty\":2,\"nm\":\"Line 22\",\"parent\":34,\"refId\":\"image_27\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":17,\"s\":[0]},{\"t\":27.0000010997325,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[10.556,0.612,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[83.896,2.732,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":37,\"ty\":2,\"nm\":\"Line 23\",\"parent\":34,\"refId\":\"image_28\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":20,\"s\":[0]},{\"t\":30.0000012219251,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[-40.21,12.557,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[33.13,2.731,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_1\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 34\",\"refId\":\"image_12\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":29,\"s\":[-17.198,167.379,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":59.0000024031193,\"s\":[105.802,167.379,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[60.027,60.494,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 33\",\"refId\":\"image_13\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":26,\"s\":[-17.199,167.378,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":56.0000022809268,\"s\":[105.801,167.378,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[84.787,85.448,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 32\",\"refId\":\"image_14\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":23,\"s\":[-17.198,167.379,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":53.0000021587343,\"s\":[105.802,167.379,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[109.523,110.377,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 31\",\"refId\":\"image_15\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":20,\"s\":[-17.198,167.378,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":50.0000020365418,\"s\":[105.802,167.378,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[134.718,135.769,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_2\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 32\",\"refId\":\"image_20\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":28,\"s\":[64.064,303.53,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":58.0000023623884,\"s\":[114.064,303.53,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[47.152,46.299,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 31\",\"refId\":\"image_21\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":28,\"s\":[257.992,303.53,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":58.0000023623884,\"s\":[207.992,303.53,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[47.152,46.299,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_3\",\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 19\",\"refId\":\"image_29\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[333.298,36.206,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[37.544,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_30\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[70.5,36.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":150.000006109625,\"op\":1050.00004276738,\"st\":150.000006109625,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 2\",\"refId\":\"image_31\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,195.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[153.207,153.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":150.000006109625,\"op\":1050.00004276738,\"st\":150.000006109625,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_32\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[178.5,61.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":60.0000024438501,\"op\":960.000039101602,\"st\":60.0000024438501,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 4\",\"refId\":\"image_33\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[211,81.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[38.207,14.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":60.0000024438501,\"op\":960.000039101602,\"st\":60.0000024438501,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"Layer 6\",\"refId\":\"image_34\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[103.5,181.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":90.0000036657751,\"op\":990.000040323527,\"st\":90.0000036657751,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_35\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[212.5,205.493,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[114.707,19.207,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":90.0000036657751,\"op\":990.000040323527,\"st\":90.0000036657751,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_36\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[89.5,223.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.75,5.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":120.0000048877,\"op\":1020.00004154545,\"st\":120.0000048877,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_37\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[212,252.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[128.207,24.707,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":120.0000048877,\"op\":1020.00004154545,\"st\":120.0000048877,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"Mask\",\"td\":1,\"refId\":\"image_38\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218.018,195.452,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[153.268,153.702,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":2,\"nm\":\"Shape 1\",\"refId\":\"image_39\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[190.449,81.319,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[8.113,8.113,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":5,\"s\":[0,0,100]},{\"t\":25.0000010182709,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":2,\"nm\":\"Shape 2\",\"refId\":\"image_40\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[212.224,81.325,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[9.323,9.323,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":8,\"s\":[0,0,100]},{\"t\":28.0000011404634,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":2,\"nm\":\"Shape 3\",\"refId\":\"image_41\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[232.791,81.961,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[8.85,8.687,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":11,\"s\":[0,0,100]},{\"t\":31.0000012626559,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":2,\"nm\":\"Line 1\",\"refId\":\"image_42\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[211.5,206,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[102.75,7.25,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.338,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.669,0.333,0.333],\"y\":[0,0,0]},\"t\":7,\"s\":[0,100,100]},{\"t\":37.0000015070409,\"s\":[100,100,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":2,\"nm\":\"Line 2\",\"refId\":\"image_43\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[212,243.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[117.25,3.75,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.338,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.669,0.333,0.333],\"y\":[0,0,0]},\"t\":9,\"s\":[0,100,100]},{\"t\":39.0000015885026,\"s\":[100,100,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":2,\"nm\":\"Line 3\",\"refId\":\"image_44\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[211.5,262.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[83.75,3.75,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.338,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.669,0.333,0.333],\"y\":[0,0,0]},\"t\":12,\"s\":[0,100,100]},{\"t\":42.0000017106951,\"s\":[100,100,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[371,42.059],[65,42.059],[65,349],[371,349]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_4\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 17\",\"refId\":\"image_45\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[212.18,631.572,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":39.0000015885026,\"s\":[212.18,411.572,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[121.234,122.259,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 16\",\"refId\":\"image_46\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[212.182,631.569,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[212.182,411.569,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[171.345,172.795,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 15\",\"refId\":\"image_47\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[212.184,631.566,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[212.184,411.566,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[221.41,223.283,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 14\",\"refId\":\"image_48\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[212.182,631.569,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[212.182,411.569,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[272.403,274.709,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_5\",\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"text\",\"refId\":\"image_49\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":166,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":176,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[341.052,109.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[28.966,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 26\",\"parent\":18,\"refId\":\"image_50\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[21.158,27.909,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.159,5.158,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 25\",\"parent\":18,\"refId\":\"image_51\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[34.749,27.913,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.913,5.913,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 24\",\"parent\":18,\"refId\":\"image_52\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[47.587,28.31,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.618,5.516,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":0,\"nm\":\"Circle\",\"refId\":\"comp_6\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[353,138],[227.282,138],[227.25,269],[352.969,269]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":4,\"nm\":\"Layer 2 Outlines 2\",\"parent\":18,\"td\":1,\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[153.25,87.342,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[153.25,87.342,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-153,-87.092],[153,-87.092],[153,87.092],[-153,87.092]],\"c\":true},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.670588235294,0.713725490196,0.756862804936,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[153.25,87.342],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"box\",\"parent\":18,\"tt\":1,\"refId\":\"image_57\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[224.807,86.871,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[62.862,65.216,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"Box\",\"refId\":\"image_58\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"t\":588.000023949731,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[73.793,199.793,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.344,0.344,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":115,\"s\":[0,0,100]},{\"t\":145.000005905971,\"s\":[100,100,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":2,\"nm\":\"line 1\",\"parent\":18,\"refId\":\"image_59\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[13.181,99,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,6,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"line 2\",\"parent\":18,\"refId\":\"image_60\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[16.006,124,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,3,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":2,\"nm\":\"line 3\",\"parent\":18,\"refId\":\"image_61\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[16.006,136.905,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,3,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":2,\"nm\":\"line 4\",\"parent\":18,\"refId\":\"image_62\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[16.006,149.905,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,3,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":4,\"nm\":\"Layer 2 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,204.092,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[153.25,87.342,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ef\":[{\"ty\":21,\"nm\":\"Fill\",\"np\":9,\"mn\":\"ADBE Fill\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":10,\"nm\":\"Fill Mask\",\"mn\":\"ADBE Fill-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":0,\"ix\":1}},{\"ty\":7,\"nm\":\"All Masks\",\"mn\":\"ADBE Fill-0007\",\"ix\":2,\"v\":{\"a\":0,\"k\":0,\"ix\":2}},{\"ty\":2,\"nm\":\"Color\",\"mn\":\"ADBE Fill-0002\",\"ix\":3,\"v\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":164,\"s\":[0.670588254929,0.713725507259,0.75686275959,1]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":194,\"s\":[0.560784339905,0.627451002598,0.694117665291,1]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":361,\"s\":[0.560784339905,0.627451002598,0.694117665291,1]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":391,\"s\":[0.752941250801,0.788235366344,0.823529481888,1]},{\"i\":{\"x\":[0.342],\"y\":[1]},\"o\":{\"x\":[0.666],\"y\":[0]},\"t\":571,\"s\":[0.752941250801,0.788235366344,0.823529481888,1]},{\"t\":601.000024479232,\"s\":[0.670588254929,0.713725507259,0.75686275959,1]}],\"ix\":3}},{\"ty\":7,\"nm\":\"Invert\",\"mn\":\"ADBE Fill-0006\",\"ix\":4,\"v\":{\"a\":0,\"k\":0,\"ix\":4}},{\"ty\":0,\"nm\":\"Horizontal Feather\",\"mn\":\"ADBE Fill-0003\",\"ix\":5,\"v\":{\"a\":0,\"k\":0,\"ix\":5}},{\"ty\":0,\"nm\":\"Vertical Feather\",\"mn\":\"ADBE Fill-0004\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Opacity\",\"mn\":\"ADBE Fill-0005\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.336,\"y\":1},\"o\":{\"x\":0.673,\"y\":0},\"t\":164,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-153,-87.092],[153,-87.092],[153,87.092],[-153,87.092]],\"c\":true}]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.334,\"y\":0},\"t\":194,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-153,-161.53],[153,-161.53],[153,144.655],[-153,144.655]],\"c\":true}]},{\"i\":{\"x\":0.326,\"y\":1},\"o\":{\"x\":0.67,\"y\":0},\"t\":361,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-153,-161.53],[153,-161.53],[153,144.655],[-153,144.655]],\"c\":true}]},{\"i\":{\"x\":0.326,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":391,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-108,-161.53],[108.625,-161.53],[108.625,144.655],[-108,144.655]],\"c\":true}]},{\"i\":{\"x\":0.342,\"y\":1},\"o\":{\"x\":0.666,\"y\":0},\"t\":571,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-108,-161.53],[108.625,-161.53],[108.625,144.655],[-108,144.655]],\"c\":true}]},{\"t\":601.000024479232,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-153,-87.092],[153,-87.092],[153,87.092],[-153,87.092]],\"c\":true}]}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.670588235294,0.713725490196,0.756862804936,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[153.25,87.342],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":2,\"nm\":\"Layer 29\",\"parent\":22,\"refId\":\"image_63\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":75,\"s\":[4]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":85,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":176,\"s\":[100]},{\"t\":186.000007575935,\"s\":[1]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[31.51,3.469,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[49.25,16.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":1800.0000733155,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":2,\"nm\":\"Add text\",\"refId\":\"image_64\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":75,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":85,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":176,\"s\":[0]},{\"t\":186.000007575935,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[64.645,419.575,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[31.09,3.755,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":23,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_65\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":75,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":85,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":176,\"s\":[0]},{\"t\":186.000007575935,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[65,419.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[49.25,16.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":24,\"ty\":2,\"nm\":\"Add Image\",\"refId\":\"image_66\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[168.648,420.759,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[36.592,4.939,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":25,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_67\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[169,419.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[49.25,16.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":26,\"ty\":2,\"nm\":\"Share Template\",\"refId\":\"image_68\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[370.686,420.849,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[35.914,4.758,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":27,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_69\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[371,419.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[49.25,16.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_6\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 19\",\"refId\":\"image_53\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":198,\"s\":[342.5,255.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":208,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":597,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":627.000025538234,\"s\":[342.5,255.5,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[51.75,51.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 18\",\"refId\":\"image_54\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":198,\"s\":[342.5,255.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":208,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":594,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":624.000025416041,\"s\":[342.5,255.5,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[72.75,73.749,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 17\",\"refId\":\"image_55\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":198,\"s\":[342.5,255.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":208,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":591,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":621.000025293849,\"s\":[342.5,255.5,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[93.75,94.749,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 12\",\"refId\":\"image_56\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":176,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":186,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":588,\"s\":[0]},{\"t\":598.000024357039,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":198,\"s\":[342.5,255.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":208,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":588,\"s\":[437.5,356.5,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":618.000025171656,\"s\":[342.5,255.5,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[115.5,116.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_7\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_70\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[216.5,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[288.5,226.25,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]}],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.351,\"y\":1},\"o\":{\"x\":0.683,\"y\":0},\"t\":212,\"s\":[169.246,471.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.351,\"y\":0.351},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":242,\"s\":[73.246,432.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.351,\"y\":1},\"o\":{\"x\":0.685,\"y\":0},\"t\":264,\"s\":[73.246,432.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.351,\"y\":0.351},\"o\":{\"x\":0.686,\"y\":0.686},\"t\":289,\"s\":[80.371,209.94,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.686,\"y\":0},\"t\":294,\"s\":[80.371,209.94,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":299,\"s\":[91.246,210.94,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":304,\"s\":[131.871,220.69,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":309,\"s\":[170.996,229.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":314,\"s\":[193.621,234.69,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":319,\"s\":[204.996,237.19,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":324,\"s\":[208.871,238.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.346,\"y\":1},\"o\":{\"x\":0.68,\"y\":0},\"t\":329,\"s\":[208.871,238.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.346,\"y\":0.346},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":359,\"s\":[320.871,293.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.346,\"y\":1},\"o\":{\"x\":0.683,\"y\":0},\"t\":390,\"s\":[320.871,293.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.346,\"y\":0.346},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":420,\"s\":[212.871,89.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.586,\"y\":1},\"o\":{\"x\":0.375,\"y\":0},\"t\":430,\"s\":[212.871,89.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.586,\"y\":0.586},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":450,\"s\":[201.871,212.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.586,\"y\":1},\"o\":{\"x\":0.392,\"y\":0},\"t\":460,\"s\":[201.871,212.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.586,\"y\":0.586},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":480,\"s\":[229.871,261.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.586,\"y\":1},\"o\":{\"x\":0.443,\"y\":0},\"t\":490,\"s\":[229.871,261.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.372,\"y\":0.372},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":510,\"s\":[344.371,120.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.515,\"y\":1},\"o\":{\"x\":0.466,\"y\":0},\"t\":540,\"s\":[344.371,120.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.339,\"y\":1},\"o\":{\"x\":0.657,\"y\":0},\"t\":573,\"s\":[302.371,212.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.339,\"y\":0.339},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":603,\"s\":[229.371,122.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.565,\"y\":1},\"o\":{\"x\":0.433,\"y\":0},\"t\":613,\"s\":[229.371,122.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.565,\"y\":0.565},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":633,\"s\":[228.871,191.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.604,\"y\":1},\"o\":{\"x\":0.393,\"y\":0},\"t\":643,\"s\":[228.871,191.565,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.604,\"y\":0.604},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":663,\"s\":[167.871,261.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.604,\"y\":1},\"o\":{\"x\":0.397,\"y\":0},\"t\":673,\"s\":[167.871,261.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.604,\"y\":0.604},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":693,\"s\":[257.871,261.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.604,\"y\":1},\"o\":{\"x\":0.389,\"y\":0},\"t\":703,\"s\":[257.871,261.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.604,\"y\":0.604},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":723,\"s\":[213.871,314.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.334,\"y\":1},\"o\":{\"x\":0.675,\"y\":0},\"t\":767,\"s\":[213.871,314.065,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":797.000032462475,\"s\":[237.871,477.065,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[32.334,51.592,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.167]},\"t\":254,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,2.5]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":259,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":264,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,1.5]},\"t\":289,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":294,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":324,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":329,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":420,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":425,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":430,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":450,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":455,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":460,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":480,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":485,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":490,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":510,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":515,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":520,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":603,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":608,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":613,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":633,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":638,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":643,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":663,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":668,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":673,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":693,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":698,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":703,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":723,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":728,\"s\":[17,17,100]},{\"t\":733.000029855702,\"s\":[20,20,100]}],\"ix\":6}},\"ao\":0,\"ef\":[{\"ty\":21,\"nm\":\"Fill\",\"np\":9,\"mn\":\"ADBE Fill\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":10,\"nm\":\"Fill Mask\",\"mn\":\"ADBE Fill-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":0,\"ix\":1}},{\"ty\":7,\"nm\":\"All Masks\",\"mn\":\"ADBE Fill-0007\",\"ix\":2,\"v\":{\"a\":0,\"k\":0,\"ix\":2}},{\"ty\":2,\"nm\":\"Color\",\"mn\":\"ADBE Fill-0002\",\"ix\":3,\"v\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":3}},{\"ty\":7,\"nm\":\"Invert\",\"mn\":\"ADBE Fill-0006\",\"ix\":4,\"v\":{\"a\":0,\"k\":0,\"ix\":4}},{\"ty\":0,\"nm\":\"Horizontal Feather\",\"mn\":\"ADBE Fill-0003\",\"ix\":5,\"v\":{\"a\":0,\"k\":0,\"ix\":5}},{\"ty\":0,\"nm\":\"Vertical Feather\",\"mn\":\"ADBE Fill-0004\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Opacity\",\"mn\":\"ADBE Fill-0005\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}}]}],\"ip\":179.000007290819,\"op\":1079.00004394857,\"st\":179.000007290819,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"Scene 5\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":750,\"s\":[100]},{\"t\":760.000030955435,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":548.000022320498,\"op\":1448.00005897825,\"st\":548.000022320498,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":0,\"nm\":\"Scene 4\",\"refId\":\"comp_3\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":540,\"s\":[100]},{\"t\":550.000022401959,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":365.000014866755,\"op\":562.000022890729,\"st\":365.000014866755,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":0,\"nm\":\"Scene 2\",\"refId\":\"comp_5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":179.000007290819,\"op\":1079.00004394857,\"st\":179.000007290819,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":0,\"nm\":\"Bg\",\"refId\":\"comp_7\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[]}");


var $b4fcf6714a9caa92$exports = {};
$b4fcf6714a9caa92$exports = JSON.parse("{\"v\":\"4.8.0\",\"meta\":{\"g\":\"LottieFiles AE 3.5.8\",\"a\":\"\",\"k\":\"\",\"d\":\"\",\"tc\":\"\"},\"fr\":29.9700012207031,\"ip\":0,\"op\":420.000017106951,\"w\":436,\"h\":452,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[{\"id\":\"image_0\",\"w\":65,\"h\":104,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABoCAYAAACuVJ27AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADpklEQVR4nOWc3XXbMAxGL3v6nmxgb5Bs4GzQdoKoE7QbVBs0G1TZwCO4GzgbeARnAvSBdpOqkq0fkASp79FHBqFrSPpAU0REKpYuEdmJSJM6j6Q6QZBFg3gHQRZ7abQgLBNEB4TlgeiBcBSR+9S5xdKHns9vgN1SQPRBgDcQ60i5JNMlCOBBbEXkNkYyqXQNAsAdviKKBTEEApxABMwjqYZCALgr1VWOgQDwWCKIsRDAg3hSzyShpkAA+FaSq5wKAeBXKSDmQAAP4kEjkZSaCwG8mcraXmtAyL7P0IAAbyCydJVaECBjEJoQINM+QxsCeBBNgLjBFAICwKec7HUoCJBRnxESAngQ3wOPMVuhIQD8tG6vY0AA431GLAjgQZh0lTEhgFF7HRuCyT4jNgTwIBpLrjIFBDBmr1NBAEMgUkIADyL5pG1qCGDAXluAAImn8a1AgITT+JYgQCJ7bQ0CeBCfYw5oEQJ4MxXNVVqFENVeW4UAEZcLWYYAkZYLWYcAEex1DhDAg9iGCp4LBIBNKHudEwQI1GfkBgE8iFozYI4QAH5o2utcIYBin5EzBFCaxs8dAijY6xIgzO4zSoAAM+11KRAAVky01yVBgIl9RmkQYMJyoRIhwMjlQqVCgBF9RskQwIOorh1UOgQYYK+XAAGugFgKBICnPle5JAi99npJEKAHxNIgQMdyoSVCgJa9XioEePfW78e0eXTqhYD/MbQlIvcWIdw65+qYA1q8HFaxF2pYhABQxxzMKoRVzJdOrUKAiNWgDeEV+AL8Voi1ibWfiyaEV+DBObdFb5VqrRTnsnr2WRqrfftXE5GDQlxpxw0hjUp4wVfAofV5rRAboFKK0y+ZVwnNldga1XAUw2uWnp1z1ZVjmhnxz7oBwi7unFgJ1cDYt6dfcq4OIRmMrYRX4KtzrhlysHPuiM6TYjUU/CSNqIRJO/OdqkFDuwCnDwyvhPMTYD92gFM1PI/9Xoc2EspKD6iEvcy8O4vIWqkaGqXT/i/BSxDUltSKSKMEYq2RTzu5PgiN8jgPShBU8zon1wUhyOv+F4CPkb556kisUh3g37G0qqHWTuwMIcrmtOJvtHN10Mzp/Ig8t8GjH4ETZM88iciTRH5VV3Qaq0PMnNUlIpUCBJHcN78TncZqp5FLyolWjXvDRnLeV1rmt9nb7C8H+HtTHqPj6Tvr1LmrSYY3VnsxvEXRbMnlxqopouSvqaMaDiJSF1XyQyT+JrcruuSt6w/YqcfF7vpUCwAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_1\",\"w\":58,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAICAYAAACoCeyOAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABnElEQVQ4jb2UYZGrQBCEv746AUhAQiQgAQlIQAISkLASVgISkIAEHPT7sbOVLV5I5X7cTVUqMJnp6e6djQBsD8AAHECWdPILYTtLGn8JewJ2SfslvwJ82x6BEUjAI75H24/I70AV3scnUYwByEAX+QdwSMrN8I5i4B61rbFbw6mP2izpuBEzRl0VswdH6uxrj6TZ9vYFzJImSZukFVhCZAoiY5AagCnA9wDugCWGr3Ww7TmcrCJT1Ewhcg3stcEeKIbmG5EzT+NrX4oZZ3C7D9v7i9wS7mF7iPclSGJ7s901z4PtJd4ftrPtrcFbo2a74LzEvuGZ4wAII5eWe+Vx07t9Adl2st3ZnqJ5bxx66dSLezyE+JFyWqft0XbPc72gnPBb7JvYKNvS8bw2R5jVUzbsNr4lLbEWiSJwkHTa7m3nyB1RX8W1W1Cfc2AcgZkoaz3Gbyflz6Kamhvco8UOMS3xU9IaW5NCdF3zOWoWirnDpW8Hdr1z4dOo4JK2D2r7huAEpGvfjdD/rtg7Lj/t+yji9Psf1D/ae/kX8Q+mY1YWFSJYugAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_2\",\"w\":64,\"h\":31,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAfCAYAAABXscv8AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAEOklEQVRYhe1Z7XHcNhB9yPi/2UGug7ADwRWIqcBMBWEqCFVBzhWE6uBKgDqgOqA7oCp4+YFdcblH8E5j2aOJ9WY4JIDF28XiYwEwkEzYxghgCCGMhfJXA8kawFGS3Y/QaZXvYSYZf4AN0ej8bvpIJtHRa94vpvwewCd57gA8AfgI4PS9DHoTMJ7vXX5rymrJS/JEkoOMkE7KKpIdyRPJSd4dyWpDp5dr/AgQ/Ynk0dU9FvKjlI3yHI3dtdSZRcck6XbPAWfD0qRHX08asoXB8Q4bMrP5Vl29pJOrn3w+153leWvXFoveTgGP1nxPruw3AF+Qp0sSJ9xK2Z3kf5H0Z+OkCOCz5D8C+B3AHzs2XATJA4B/Nzh1CvfIC/onKQeW6T58MFxRDK0ARGkkADyGECan9z6E0Bkjevl8CCHod2IegjfCBwCN4WiUl3ma/HNFe7cQzbfnbABUIYRZ7JlFbgohJACwDriRx+LRKVBMLq31kstPjreW91fn1G8Je5ucIYQjltBahHXAA5YGzABG9dIbR+XeL4JdA1IIoZfn+MLGP8g7uvzoyrWnf5W5q6hRxg3XkcTLJnl/tJzMkSX5RdRjbxF8CVTJjazeup74qWH3FBr+WuSFymNysj3JEXlhsxidXEOyATCI/hnnaMXGqhgGt7Ana8KTx8nJHTdkbFiNInfgOjxS0pN8J8O5GwaNXO/K2w9Yhud0yQEXZBvk0BmRh+mI3PODFQohdCQnJ9diGR2zyE3ijA7AQXSeXD3lHIRT9c9SfrTnihBCzzyd9qbcO97xjp8IgfsXIimE8OLjMEnK553ZGr9NFMLHKlR8A2f/+ha/LkoXIn8hn6aA5aT1/0Spt9zmIpr8g2wo9OLhZDcbV3DqRUoSnsrJVFwuPaYduSi6R8NnT5sq14hO5RpWXDvGbl2I1DzfnSmaPU5uX4SQeXtrGz9eIdcUZMj1zm9vh1jtGesNqSRfGz8yO6g2crOpv+J0hnRSr9uQs3kt82izW2e94tLbp0lkrL3JdJZiELnGtGHwxpYwiNzBG2KcpYgFB2jvl84FyeVb/m6D3zqgUTsch+77J5evfPM1DhiuGE4WbcEBU6nCyphFz4nbUy3u2HKiiVgs31E+A1hfiNwjH1wOuLzyP1woL+Erdg5d4rC/JfkkekYAf1o5Ofwk5GN0g3xEvgVwSzKGEFoj/oS9GyffW5JnFyx7tbzqCSOfz9YFTsOXXL0D18Nd5/HJ5J3pZZ52zzqFZ7UWsTwFqpX9BQfY+Z5Mvl8ENWR5Z3kH2HncCX/kMjVOzgFJuCuuh7I6YDJyB3mSbTDPF8Ga60V7KjpgYxREQ1oKg8MFp5bC4PPvN55fWGi5t2MvDNrb6r11q1GhRP1Lcj5UtMw2pObyB2Yq1C1x2j9Cuik5OJmey1+cxDxSlM/HeO113ZBd2ghtbtx+avwHgD+WROqhYmYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_3\",\"w\":10,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAj0lEQVQokY2QUQ3DMAxEn6cCGIRBGINlTDoGhVAIhZAxGISWwSAEwhjcflwpixytJ1ly7JN8LyZpJdYbWM3sBYD+a2yNWVLymiR99kVrnOu7ksZql06dfAClfoRGSWdg+QE7AJOPUOfo9BO4A48wcUTtX7Xr2oUB5qpfukYzKx4F4CYpDcDmg9L4J+DiffoCvXzQ+18OIloAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_4\",\"w\":10,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAj0lEQVQYlYWQURHDMAxDn0Ogg1AIgVAIhVAIgzAIgxAIhVAIhVAIYaD9ODt3y7X6sU+WfbIMh6QFmIARqMAGFDOrBNFLfeySHk00h8EqaZK0RK4J304c3+0zXwESkH12nPzA6nWQlBPQrkTRH5J/R7jcMLfGzHZ+jBdJufuMGy+38QTx0+OpkjbPdrzy3cUHW5u+SQIyLkIAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_5\",\"w\":9,\"h\":10,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAZ0lEQVQYlcWNQRGAMAwEN0x9IIE6AClIQAJSKqESkFCc4OB4kDLtjx/7yWXnJjFJBw/JzJJnWh+A2ZcqK68f+MAPpdPzWqWkpS0FoAATMErKvm/dKUlR0qWe0uTdatHfRSADySdAugH1Ij6WqdIbGQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_6\",\"w\":9,\"h\":10,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAYklEQVQYlb2NTQ2FYAzAOoIAJCAFCUhCAhKQAg4+CUjAQTnwt/DyrvSypWuyUGcOJqABunMWYIiIDR+KvxS14SVHtVfn5LocXW9R2+SHioc7iog1eXL0l4+jGljOfX3dbr8DJolqizHG5ToAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_7\",\"w\":10,\"h\":14,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAj0lEQVQokY2RYQ2FMAyEvy0ImAQk4IBJeBKeBCQgBQmTMClIeA7u/emSwgLZJU3apuvddfAASYukarFMT4NAAtaWx5fBCyajScAGfKxfLTo9RT1Ol2ckba5RJGVJ++1Rxly1DcmxHH4wmjuAM4Twc4ouGoddR6BtmT01kO+Ox8yMnqd94Zf+4AXYrfYm3/EH4T7LYr/6ODcAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_8\",\"w\":9,\"h\":10,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAYklEQVQYlcWNQQ2AMADECkZAwhyAlElBAhKQMAmTgAQk4KB8tmTjxY++LpfmDnVXsxppKF1W4wgEYAFmepbaj3zgRynWoK5v6Sp5UpO6AambUoN623M2eRuqWO5CWTmateMBFLpL3g87AoQAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_9\",\"w\":10,\"h\":14,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAoklEQVQokY2SWxGDMBBFzzIVEAdYQAJVUCRVAnUQCeAACUiIhDi4/UjShscwnJ9k9nGzeycmaQQ6wAMOGEiswGhmAQBJixJBR4IkB9DwpwVm4Al8qpg/KFZNSJqK7F5xYctaNbmGe2wK+12yKxczC48q0UryefgeeOX4XN4vy8QTe2Kxp1Yc8zmQjJ8Ab2Zxr/i+2ubu1vcLTVKXZwq/D3DCFyzOhLh5CpiHAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_10\",\"w\":12,\"h\":16,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAnUlEQVQokb1RQRECMRBLmAqoA5BwEooSLCABCUiolJ6DSgAHoCA8oDd7LfT6Iq/NzKZJtpR0BTDhNyLJuDBJSdtYBK56bTbzAcD+M58k3UheVg51FknRuOQm0rcCVTS/65QtuNuYXYGkyfR4ksyuWgiGBgBnw1PToYMsyQPASIcZQCD5ANp/OFY8l8WClYBk2rIbifRngcP71n5U8AIcsqJY5G+oBQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_11\",\"w\":7,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAATklEQVQYlWP8////BAYGBgMGCAhgYGBogPIvMPz////AfwRAYbMwoAJ7BgaGjwwMDBew6VyArJIJTecEnJKMjIwX8OlkGGhJFgaIh7ECAOxaNSHNISIbAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_12\",\"w\":12,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAh0lEQVQokZ2RURGEMAxEN2cAJCABKScFKUhAAhJOQiVUAg7e/cCwLR1uuPeXZHeSbkM7wCBpkjTqJEuaIyLJAXog0WYDxjtxBuaqd5qAyQap2rzabD2aH2u+K8PgWyTppZJiQ0RkK7uW4Se1wSM9oi7559HPYjVTbv3aRez3AovFnPb6Kn7CF1cAFULuAu3QAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_13\",\"w\":12,\"h\":16,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAArUlEQVQokY2QURGDQAxEN0wFIAEJlYAEJCABCZWAhEpAAhIqAQnn4PXnaI89ZmC/Lpd9mWRDFwLW/R0RfdwAKIBorgBXBQA98LwkgRlI/JUy/FNpfnOuVAHAYKZXnjw5vQNL8TfbmpMDjaS28Cx2mtdVSltZRMRm/QrobKXW+mokpaLurT84IGC0MEagzenVsWZo4YYOuwLriWd04JHTSJJ6oMt3JEmfiNiAQ1JfLnAp3nXyY38AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_14\",\"w\":11,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAdElEQVQokdWRQRHCQBAEe6kIQUIkRAISIgEJSEACEk7CSYgEJMRB8zmora0UxZf+9uw8ZkPtDCJiIaHegfnjTFBQe3anGvjGP4ZRn2mQuTjrGlvyN/U8go+j5qs/kA/agW/1KdPIr8AFWIAd6BHR1BXo79IXO2iUcymHZeYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_15\",\"w\":11,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAnklEQVQokZWRURHDMAxDn3cFEAiBUAiDUAiDEAiFMAiFMAiBEAiFEAbaT9Z6vaW96ScnWzrZsdEgKQIJGNmRgcXMVpwwSCr6jSpp7AlXSUt7N8NHnFyxSAouMbveNACTm3E2s+p4cv16dEdOcAOC46EnBBgAHxuB4maOwKPRfLXgyy/Y+7rnobanN0M9Ocr9a3hJsR0jN0GWNG/X+xdvx+AJxlvwU6YAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_16\",\"w\":8,\"h\":15,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAPCAYAAADZCo4zAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAc0lEQVQYlcWRyw2DQAwFZ1EK2BIogQ6gBEqglJRECVsSHQyHGMmgROTGk6y1nmYtfwBQB7VFLCS94q3AGHnLQKdOwJC8Xp3Uj+dvNYCOfxQlD71PPdx9fgiod8AcU/Un98ui1iswq1sCNoBygSrpLqWUtgOs8HTtCFApWgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_17\",\"w\":12,\"h\":16,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAoklEQVQokZVRWxHCMBDcZSIgDogDLBQlVAISKgEJSKiE4qQ4iIPlp2WOayYJ93U32dw+jpIW1Gsm+fhO6qvnjg9u28v0EcBl62+SMsn7D4PXImk0z+tBUsmApGwg6dQwXNzwl6TgAIsZE4CzmecDQ0+sdFL2WO32N8lU9SApuXSGpmlJ0+EGjQ/RsYzVDyUWSbHn0quBTAHAtQQ0NWypAUD+AEdxSKWT4cWDAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_18\",\"w\":11,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAqElEQVQokX2RURXCMAxFbzn7ZxLqgEkYDuaASZiESZiESUBCcVAcIGEOHh9kh9BDd7+a5J0kLw0YkiIwAR1f7sAaQthwwlZS1n82SV1NmCXNkpLLvXbx5JKrWwFJq6uNDTC4epbUuzgBN3tHinFHpIZfHtTJZefuQMwJyC6eCoO9NUuShiCpNSMX0zz5fEYLjMDZ8te9Q7Tj11goRkZJi/OQ7M79kY8qb2j9/e5avrGdAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_19\",\"w\":4,\"h\":16,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAQCAYAAAAxtt7zAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAM0lEQVQYld3IMRXAIBAFsByvApCChEpCSiXh7HcpSyWQMZXkwYCquiVZ+UDzc1JcmOg7XqYGEFVXQLQvAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_20\",\"w\":11,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAqElEQVQokX2RURXCMAxFbzn7ZxLqgEkYDuaASZiESZiESUBCcVAcIGEOHh9kh9BDd7+a5J0kLw0YkiIwAR1f7sAaQthwwlZS1n82SV1NmCXNkpLLvXbx5JKrWwFJq6uNDTC4epbUuzgBN3tHinFHpIZfHtTJZefuQMwJyC6eCoO9NUuShiCpNSMX0zz5fEYLjMDZ8te9Q7Tj11goRkZJi/OQ7M79kY8qb2j9/e5avrGdAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_21\",\"w\":11,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAoklEQVQokXWRURWDMAxFX86ZACTgYEioBCQgAQmTMAlIQAISKqES6uDuJ2yhK++vyW3ykphcwCRpkTTpp0PSZmZFAVy4V/VCEjA2yQ14ATnE9hNOwBs4gCV0i0WqegIGL7DGdhFIwO7+ujrBuZPL/rm08B6gtbH0B8eph8baxcZDUpb0dGbzNY2SLl1ihd5gtbVh4dRrOHXx9zdmZqm76zt9APC8NZDbzo7JAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_22\",\"w\":11,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAApklEQVQokYWRURGEMBBD386cgEpAAg4OCZVwEpCABCRUAhIqAQlIwEH4Wbhlht7ls5tNsqnhkJSBDHR8sQDFzHYCsaiNEolDGOySJkmjpDW8DwAvYAi2s5lNLrIABVivaJLyg3IUuEPS1si7+OE3cudHtpaenXwxS6rR4RzOPqiS+rDUB/J2tpGA9/kJoddPMLyU04+s8r5TzJm8sur1rd7E2KzwHw5gbh69FpgDoAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_23\",\"w\":11,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAqklEQVQokX2RURHCMBBEX5j+Ewl1QCUUB3UAEiKhEiqhEpAQHAQHSKiD5YPrcJMhfV/J3c5e9hIwJPVAAgZ+PIA1hLDhhFFS0X82SUNLWCTNkrKrvXdxcsXVPQFJq+ulDphcv0ga3T0DNztHqnFH5A6IzulJm1I7DwdiTkBx91QFHM0sS5qCpGhBLqZ58f2MCNyBs9Wvu0Nvy2+xUI3sJS0uQ7Y9j0c5mnwAfz39/nf180EAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_24\",\"w\":104,\"h\":104,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_25\",\"w\":146,\"h\":148,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_26\",\"w\":188,\"h\":190,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_27\",\"w\":231,\"h\":233,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_28\",\"w\":126,\"h\":131,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH4AAACDCAYAAABLL69PAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABvUlEQVR4nO3RUVHDQAAG4f8OAURKHOCAaR0QCVGSOkgd0KKgOEACSKiBHC7uHnY/BTuzJUm2/X5JMkcA5bou79ey7V8fKW0fnaNunmnHXJN2Gl2irl6Tl1NNMo0uUW9tqil5G52h/uroAI3heCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA/leCjHQzkeyvFQjodyPJTjoRwP5Xgox0M5HsrxUI6HcjyU46EcD+V4KMdDOR7K8VCOh3I8lOOhHA9VU9rf6Aj1V3OU39ER6q8meYyOUG/HrSbHJclzdIo6aflel/NPSZJt/5ySzIOT1MG6nB9J8g9ZhSBxyCHdYgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_29\",\"w\":11,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAUElEQVQYle3KMRGAMBBFwUfmBMUBVm4iAQWRgASkRULok/m00BwIYOtdylY9CScg6FO4JeGCNcoABjm9pbs/P7Kgf3jngGZTuEGO5oB27LVdOFMWBUJ0Z4IAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_30\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAqklEQVQokZWRzQ2DMAxGn80C3aR0kq4QIfWOmMBdoMoASE1HYANGYQQGANIDpOJQ8fNutl6cL7GwoqjMacSlOkIvEV97a1NPAFxpl0xogSv/acaIC956BdiRAe6Z4AGkqMxJ5L0h/9DITdeZ95gEp0dlAIH81IElFv2JK1qVOL/+CMNE0GUpze5w4Rm8dQowzj/12ZLrl9mcasWjtHwSnECeMg8TIXjrkvMFAE02FfKAdg8AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_31\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAjUlEQVQokY2NyxWCQBAEa2YIgBAMQa+eCIUQDGFDIAMNwQzk5hFCgDx8rAfFJ7P8+tY7vVWCS3kJeQbHF3S3KnT+rv7BhCoKDxNqfwMwRz+ocP3W/HQu+uZZt4sGE8J/lzjtE4Ojj0ksP4OnL1lshT5r0TX6nMU26IlFM6XcGAOg8bNTGbjv+TDIvl2SNxZeL7LV2H6mAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_32\",\"w\":139,\"h\":59,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIsAAAA7CAYAAABL03mKAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABC0lEQVR4nO3SMXHDQBiE0f9uBMAcREB0wsKNScSNUMStIQSCAASEyxQeX5rUme2kzLzXbLvF1+aP97VaWwr+0F/jPFVryxh17622vQ9xWOvo7TRVVfVW29fb5XPnQxzUfLs+WlX1vY/wf4iFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhZhYiImFmFiIiYWYWIiJhdj0u+t8uz52fcKRLVVVU3+N8+jt1Pa+w6E9v6ftB/F6GSn5J5GYAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_33\",\"w\":121,\"h\":32,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAAgCAYAAAA2e9d2AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABCklEQVRoge3az00CQRiG8ef7DiL+wWwF2gGWQAdawpZgKdgBdrAlWAKUYAUKYpaYyHgQOXmTyacz7+80e3uTSfYweYyd1bpvt1iL/HvmdBcnx9P9N8DybdMBN2Gr5OAMFh/vg0nT2Iuv1n2LLrg4CcZ+tLkDcP2iS/Z1t27GVewQyegSwL8PUi6PHiD5OfAUPULycmAePULyMFgAuGGz4C2SS0pTAB+dDjoS99F75NDsYXQ2nMHuxQvg+bWfuNltguuwXfJrBvNtSl1zPnyM3iIiIiIiIiLyF+0fQ9R4lUONVyXUeFVAjVc11HjVQI1XLdR4VUCNVwXUeBVMjVcN1HiVTo1XsX5qvD4BVsVTr4szTtsAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_34\",\"w\":107,\"h\":32,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAgCAYAAAAVIIajAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABRklEQVRoge3a0W2CUBSH8e9cKWo0tWzACG5QN2g3cAVHYARH0A06QkdwBDoBktSoxHD6YN8a60PTnCue3wRfuPDAH6Sq9CmkzVJVc9wPApvJeLCw7gBIwsOxAOYi1inReq53++1kNCysQwLCq3VE7FRlZt0AEAS21hGxE4njGgWQAqitQyJWtxoK6wgAAaj2+5wTuXFLnBLKbDgsrTOcc84555xzN0POQ+5xBbxYx7hLZN026SIJabPEDypyOg/poQygM+sUd52qzAKwsQ5x14lIKdVnMw3SvgMT6yB3Ud0GnZ6H3EqfSA5T6yJ3wWmwyTKJ4jONc84555xz7qouDLkfgiweR/0365D/JvXuuAKdW4f8Ud02/bzrL45dGXIn97DAdGfIlV6nnyqA8P236Y3/kSvrbJx246b7xe0PudLb3sNBAXwBQ8Zfg52MzBQAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_35\",\"w\":307,\"h\":175,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATMAAACvCAYAAACRiznSAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAChklEQVR4nO3UMY1CQQAA0V2CAKTg4CwhBQkIoL76cHJCCEuDAkLyw+Q9BVPNvP7ezmuM4wD4Ums9TvvXyH62jgF419yNw27rCIBPMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEswMSDAzIMHMgAQzAxLMDEgwMyDBzIAEMwMSzAxIMDMgwcyABDMDEvZrzst8rL+tQwDedZ/j/wlKhhBtKojOxAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_36\",\"w\":163,\"h\":14,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKMAAAAOCAYAAABD7qywAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAArElEQVRoge3ZMQ3DMBCF4XdRAQRCIARCGJRKmTRQCsEQEgaBEAZ/hzpDLWWsXSnvW3y66Q0nWycHMEsa9e0VEbPMKur0GcRBUpK05PqZh9SsHiABqehtAI0i2UV1J/1FkoC+Yha7uFs+e2DK9STpLmmNiL1FKLuo/EyXNqBcasx+6rgZV0mPXC++Ea2FYxj3iEgtg5idLTBm1XkY7X8Ao5cVMzMzMysAw/Hh8gZ1A1Akhwb8owAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_37\",\"w\":5,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAASElEQVQImYXLUQmAQBQF0aPsv1VsYAUjWMUmG8UIRrCCCd7+PFFEcGC4MHC7iNiwpwtqwYQRA04QN7OLDIcHfe5n9BsL1ve9AXn+HTsRLxdNAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_38\",\"w\":8,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAbUlEQVQYlXWOQQ2FUAwEpyhAChKQgAQkIAUJXwISkIAEJDwHw4E2eSH5k/TQ7W62AaBOwApMQAPOiNipo9pyTvXy5VeGPYWFJI2qI5lodKhbGuYhO//TVay5j/UHX6Hq+kCUCdiAGbiBIyIOgAdLbH7A+4m+oQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_39\",\"w\":8,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAhElEQVQYlX2OURHCQAwF9zoVUAdUQh1goRIqASk44HCAhJNwEooDHCwfXJmUmfJ+Mslskk0cRC1A7Y8A4AzQ/QH4AuqsFj9Z1WUDenUCcuvvrd6iTG6bU5hd2qx0wAg8U0o1vH7sHIDTj9sYgbK9anUArtFhUKv7vDaHFLbmcDoDC7C+AZecYKgvsWz9AAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_40\",\"w\":7,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAXklEQVQImYWOSw2AQBDFOgQfIAEHiwQkIAEpSEAKEpAADnBQLgsJn4SeXqY9TKgzsETEQEYdAUog8aYBKD7Exa/cgPpxT6dcgUrt8jP9laidd3Z1VefIQQu0uZ/OfQBVnTEZa00nggAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_41\",\"w\":8,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAdElEQVQYlXWOWw2EQAxFTzGwIwUJSFgJSEACEpCAhJEwEpCAhHFw9mNLMj/cpEnT++gNAHUGVmAGOlAj4uQh1Z7T1Ms/9kdw5OFLQj3VqhbS1XnB9EaMggv4qOvwomWnglqGYk29c98AIh0F2IAlE1tEVIAf+YdrtDjDbzcAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_42\",\"w\":6,\"h\":10,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAATUlEQVQImY3OQRGAMBBD0R0UVUKlIAFJSFkJSMHB49LOwPZCjsn8JBERgR0ZVTihmqloBg3X8Dr6Qr2btmXwb5Cj8qgbDffnVbneJvEAWIZYdi6oo3UAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_43\",\"w\":8,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAhUlEQVQYlW2PQRHCQBAEe6n8OQfgAAvgJFKQEBxEQnAQCzg4CeegeXBU3SWZ127VzvRsqCt7LRExAeBPWX2qc51Vu4MuRS1qATgdxANk4AwwbJxXYARuwLtFbLWqqUV8gAfwqvscEWVXUk21YP5ju5LVNQEXdTx8s01R01DZpU1R70AC+ALHboTRd/dUKgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_44\",\"w\":8,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAcElEQVQYlWWPSw3EMAwFx1LvLYSFEAiFshAKJVACIRAWQiGEwfSwrhS1I/nyPPInANQCfIECDKBHROVuqiOrqad/jluoGRSSlAbAkmMBqsrEqpZlCjpvxmuFuuUtjSn4pdSfR0ZKn3xzB06gRUQDuAB3OXAkjs8djgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_45\",\"w\":2,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAALCAYAAABYpyyrAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAALElEQVQImWNgYGBg+P///4T///9PYGBgYGBhgAADKM3AxIAGBkgA5rAFMAEAIrgIAxM4BnoAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_46\",\"w\":8,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAcUlEQVQYlWWPQQ3DQAwEx1L+LYRCOAiBUgiFclAOQiAUQiAcg8mjGylqRvJnPdLaBaA24A00YAJbVXXOpTozQ9398TmFnqARIk2ABViTd5ULD7Ut6QTYuDNvFeoztwwuwTfS9n9kRXrlzRXYgVFVA+AA+UlxJLb+U9kAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_47\",\"w\":7,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAcUlEQVQImV2MQRGDQBAEe1MIwQFIQAISIiEOWCknIRKQcBKQgIPOZ1N1xXymZnt2AFA39aue5TsDUL3Upt6VV9Ssj/lRzikiUk2gqYx6qQ04gAs4ywGYgBUgIt41myPswKL2ui1/GNX+ADtwAw2Ygf4DawZeCPACnt8AAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_48\",\"w\":7,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAc0lEQVQImU2OQRHDMAwEV50CMIRCMIRQKINCCYRCEBRDCIRAMIPNI3Kn+9KcdKcLAHUHNm4OYI+Iifrx5lCz5gR4Aq9yfCMi1fHT1K7Ocpzl7izUVvErVrVRwlDbKlfL7b/QWUdTnQCPiEjgDYz6kkAHuACgmHrLijkoYAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_49\",\"w\":8,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAcElEQVQYlWWPSw3EMAwFx1LvLYSFEAiFshAKJVACIRAWQiGEwfSwrhS1I/nyPPInANQCfIECDKBHROVuqiOrqad/jluoGRSSlAbAkmMBqsrEqpZlCjpvxmuFuuUtjSn4pdSfR0ZKn3xzB06gRUQDuAB3OXAkjs8djgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_50\",\"w\":8,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAhUlEQVQYlW2PQRHCQBAEe6n8OQfgAAvgJFKQEBxEQnAQCzg4CeegeXBU3SWZ127VzvRsqCt7LRExAeBPWX2qc51Vu4MuRS1qATgdxANk4AwwbJxXYARuwLtFbLWqqUV8gAfwqvscEWVXUk21YP5ju5LVNQEXdTx8s01R01DZpU1R70AC+ALHboTRd/dUKgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_51\",\"w\":8,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAbUlEQVQYlXWOQQ2FUAwEpyhAChKQgAQkIAUJXwISkIAEJDwHw4E2eSH5k/TQ7W62AaBOwApMQAPOiNipo9pyTvXy5VeGPYWFJI2qI5lodKhbGuYhO//TVay5j/UHX6Hq+kCUCdiAGbiBIyIOgAdLbH7A+4m+oQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_52\",\"w\":7,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAV0lEQVQImY2OOxGAQBDFsgw+QAIOQMJJQAJSkIAUpCABB6E5bvgVpNp5SbGhzgARMZE5txroeNMBVB+i8Eu2j72/ykZN+ZmxJGryzq5u6ho5GIAh98t5H74GLklj8x+yAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_53\",\"w\":7,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAWklEQVQImX3MQQ2AMBAF0SlBCBKQggSkgBMkIKESKqES6mA40IZy6btsfibZoEYgARnYeMUQwoGfosZ6Vfc+rgDqUvfdYqKjZjVOdRf+MsDEwDDOwNnedC6AB1qKSxN2ZjdZAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_54\",\"w\":8,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAgUlEQVQYlX2PUQ2DUAxFDwQBOBgScDALSEDCpMzBmJMnAQlPAg7OPta3NCTs/jRtTntvOy6kFmAfrgDgDtD/AfgB6qIWv6rq2oBBnYEt+nfUVw6zxeacZo+YFdRdracPpgb0wAHcTtmmHLI0q6gj8MznxrDJOppFl7aWdHoDVqB+ADwYcZKyjwNkAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_55\",\"w\":7,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAXklEQVQImYWOSw2AQBDFOgQfIAEHiwQkIAEpSEAKEpAADnBQLgsJn4SeXqY9TKgzsETEQEYdAUog8aYBKD7Exa/cgPpxT6dcgUrt8jP9laidd3Z1VefIQQu0uZ/OfQBVnTEZa00nggAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_56\",\"w\":8,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAeklEQVQYlYWPSxGAMAxEX2sApCABCeAACeAACUhACjioBCTUwXIg7ZQZPu+0k9lsNk7SBgQgAi0XAZidcxHd2SQF00FSXRoG20bSarMuGSIFkhqbL55vYjJU5QlgzGXTiaLYYXoF8NkJPXCYnnJKeu+txF9JPLBb7CMnUoB8+stl7EkAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_57\",\"w\":122,\"h\":14,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAAAOCAYAAADg6ggzAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAEMElEQVRYhe1Yq47jShA9FY1WgYZGVwEXGBoGBgYGDgxceD9hPmHhwsDAQEPDQEODBQ0NFhgarFQX9KlJpeM4M9E8pN0tyXKnu97PdgAHqrpS1a2qFngBEHd7A+fpFs6fBvTzk6ouPkrmzAmfA1gBWABYfpQCnw2qmjNh8zfkuVHV9VvxewuYubVVcQ9goarZGAEdM3rmcK7S3wPkN38nHgVico/yv1N2CeBFiaOq8ykZqprdSsKU3nh6nIdEuQFABeAR0QFHR1wCWIMOUdWOR8METphQbo3YOfYi0pqCAP4D0IvId4djNIH4g6quEDvQTkQCz8/2VPUJQIvo9AzADkBw/LaIQQaArarC0Y7Kpp/WAGoRqXn2lfwrABuSLCg/iMjuihtKPibjICIN1zliHDL+HgBU7vzCNsbk0WyiPUcRqWbcyHjY0ul9YmTuDDjwAVzWcq5vSGs4U5loSeTHxBIxSY6quuTvgBigmjo+TvAcg4I61Xx7qAA0br0D0DnZTSJ7IyJH6rRid1sh2lkjOn5Hfh3X1Q3dzFcD6GMm/BbRF3ue9wA2SXWntlmQK9K1AJaq+q9VtGVV695LVc1FpMOprR9c9XUAviZCDacjzoArgRGRXlUbAKWqZiLSU49eRBpW2wBWMIDAhCxf2Uq7axUlIp2q9g4vUO+Csi0JAjjS+HuP2Hk2iEFumQCgngAwGL8JqJMKXvI951NTjwGn6l0gJtGFbWzXrTtvEOPyTxro3Amy/coMtCA7J3mlM9t3OG2Ck0JDGSu2xozGgTIDg2xgQXnNxSm8Atdgwfd27JCjo0Zs4cB01U5B59Zm59zJX43Q+CQPtnAzucCp6Ay+PDCwGc4z1gRboAPizFm4rE8vWz335xacW58PnIWBimWU+VwZuAyoyezcmddjrNKHkb1bEABkIvLNNnwBsKMsydu+Vg4XXO4HS4D0/pLjfPwMIzRHEXlOPMbg5wynGbkXkZ09iA6fs40F4qxVtSBx2pKt2re8BRY4ZfwUNDhlcesqOFD+hrNwiZh4VuVm2JI6Fbjvs9D4lO72GgBkTnaJOKaM/wYxwfaIfiqT/x560hd3fn0EcGZTpxyxu2yvEdh4w8kfmapuSJM/gAPdt1xCg5ippYjsVfVAAy3APVx2sU1bKzaFOtyoKM7jFc7bNkSktpmM02jpEJ1r3cDkmU6Nw30pBPI1ObsJ2RUDWiBWTuBdpUAMyjc6vMbJV7W36yXA0bDDZXAr3mWuwZ74vggbEfkhrM5+jAHPBne5svYBRMMv5rLHoSPyFCeRkSFebFoR2V85z7weybm11B4xqXLES8owZdsEn86NHpMNN7Km8Pzec6tN5V/Bv9jj/oLLMz434mY6jvrsU0BV1/rBfwf+iTC7jfJ+wKwv4T5t/sL7gHymcFWdAfgC4JeI/PpMXX53+B9cvPP18G75TAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_58\",\"w\":29,\"h\":9,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAJCAYAAADO1CeCAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABYElEQVQ4jZWTIZrbUAyE/+lnYFCwMNCgwDCoX2CgYY4QuLBH6RFyhMBCw0BDQ0PDQLMp2HGjLWqFbD3NvBlJT7Y7oOMVi6QFwPahnM2SnnuR7QE4SLrZPhc8ksbUtEAPvFXeJske2AmfAXTAFViTP9u+Sdr/O2BK3RlY6sW58Aq04TzbHiWNDXAAHiFfJW3BXYBJ0j0kV2AAbrbfglviYgXuQFtEnXL2U9Jm+whcbD+aHAxF4R2Yk5+K+KnUdcBT0mq7j4AfwS+SbsnNuwlJk+0L8LWJ9THJU4g/taq0vc13/1fNJOmeHXiPkJbXaGo0X4AxzkhRm4XZ4naPvpB0BTOHg7R25dXyfgdnJABbw8fsVtuPuNyJJ2CwTVSfgF9ZnLY4PQLHjKXOGuCUls58LNsq6am0ZCjqx30Z8hSOcT1LGutTSU1b8BvwkDTlrI/YQ+H+8+z+OWx/t/3tv4ElfgNpYb+AiE4AHAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_59\",\"w\":366,\"h\":45,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAW4AAAAtCAYAAACOGYH5AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADkUlEQVR4nO3cz2rjVhTH8XOl6LoSsq0MhZAmFJoU2uJs2xdol94EQpaTB+gLdPoAnSfoA3iWITCbLPsCzixCIVAXagoxIYQUclMZKZJzo26SNs0M09rKHwt/PytzreN7Vj/EkXyV3BFFUVQUxby1Nrj7HQDg8biumyilzowx5va6uvXZazabH1trP8jzvMjzvHjkHgEAt2itldZaua57cX5+figiI5F/gtsLw/DTPM8VgQ0A0+U6wIvhcPibiIxcEZFms/lJlmVzhDYATB9rrYiICsMwzLLszI2iKLLWPkvTlNAGgCllrRXP87wgCEZOURTz3GkDwPTL87woimLesdYGBDcATL88zwtrbeA8dSMAgPEQ3ABQMQQ3AFQMwQ0AFUNwA0DFENwAUDFzZX+g3W7XO53OS8/z6uPUjUajeGtr68Xu7m5ctgcAmCUqDMPWcDi8mqS43W7Xt7e3X6VpemSM+WWc2iiKvvB9f2lzc/M54Q0A/08Yhk6p4O73+98uLi5+EwTB+iT1SZK8Pj4+/ml1dfXHSeoBYNaEYeiUnnFfXl7++RS1ADCreDgJABVT6uFkmqZxrVZburt+cHDw3Pf9ehAEH4qIJEnyR5qm8dra2qt/bT431yizPwDMolLB3ev1eq1W66O7661W67s0TX/1PK+ulKonSdKr1+tf7uzs9DY2NvZurvN9/7P9/f2XZXoAgFnzIKOSOI7fdDqdF4eHh6+TJOk1Go2tOI7fnJ6eMtMGgJJKv8f9Lo1GY0tEpN/vf313DQBQDg8nAaBiCG4AqJgHC+5ut7u+vLy8HgTB591ud6I/6AAA3vYgM24RkcFgcLSysvKz4zh6MBgcPdQ+ADBrHiy4r1/72/vPCwEAY2HGDQAVcy/B3W63xzrSddIaAEDJY11FRE5OTn6IouirLMvGmmPXarUlY8zewsLC95PuDQCzpvSxrjduziYZp+ZdZ5cAAN7v3oIbAPA47uU8bgDA4yK4AaBiCG4AqBiCGwAqhuAGgIohuAGgYghuAKgYx3XdRGutnroRAMD7aa2V67qJo5Q6I7gBYPpprZVS6swxxhjXdS8IbwCYXtd32xfGGOOKiGRZNvR9/5mIKGvtE7cHALhNa6201kUcx7+LyJV7vX6V5/l5GIah53meiAgBDgBPS2utfN93tNbZdWiPRETeGo9EURQVRTFvrQ0evUsAwN9c102UUmfGGHN7/S+AAz6uNrID7gAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_60\",\"w\":13,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAUElEQVQokWO0CvifwMDAMJ+BOHCRjYHBgYmBgSGBSA0MDAwM+n8YGAyYSNAAB6Oaho6mCySo//iHgeEBIwMDA4NNwH8HYnT8YWB4cGID4wMABBYPEBMtjlYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_61\",\"w\":14,\"h\":14,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAYklEQVQoke3SsQ2AMAxE0R+cJlKGySgZgVEYhRE8CsNEcmWFJhWVRYn4/dM1lwDGmE2ETiB3tNZ0bQtpBAGIoGPMltfSWUo6ItBsIkLfokvPfvgNmN1REdRsRs3uTk/w7uQ3iKAjfJAkBmMAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_62\",\"w\":108,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAMCAYAAACHkliXAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADWElEQVRYhe1Y23XTQBC9w+EflaAOcAcRHTgdiA7cAeoA04GoIEoF2VSAUwGiAkQFl4+9a402K9txPuAjc46PpZ33Y2fGNpItgBpLGM2sxxVAcgNgb2bNCn4PAGa2u1BeDaAt4cysu8bGC/U1AAKA3szGV8hrAWzMbEey0/P2WnnvZVwNwBt1uFYggArAzQn85gp5jeOdsLT1ReADuEKSfB8A7ADsSNZmNl2pssbsc6XP1fBe332pWkk2iA7UUjT6atNtqgDAzMIKfxF3KZ2ZHaCEkQwAgreVZAUlUrRJ3tFWZ+ckWZucxvF9APDJzALJLYA78QyiqRWPMb95yQ9vSwa9o03FB8lb8Di/PBxAMuiqPgNGOHCGSYpAcsclHIN1hi8o8CC5Ee4Z3Yo9C1tJtrkNJCvRTXqu9Tzo3EOXya91Hkp2FPQFhxsy3F7nnfM3ZM9TxrNbicscm4ITpColC0JKRCfcRDJVXUpe4+gClwE7FIw+OPk1ydEH4YKEkWSfFUoneT5JI2PFLgK4omPrgjUy3rIURK9vq/fW4VLAB5K8IGEUb6U4jI4nFVySvQXmlvgd7rpiOcN69e9A8gnzPGkAJGNKfbkT38RYbV8KNB8B/ILaDc7PvyNwbj8bl4A/ABoz6xhn1Z3OP106g8xsYGx7W8QZdkfyFvNi1iU6AObsuQXQKrCpOJKNa/Do2viA5zGqkC2EKWHjiTnjkzdJeAXgB4AnOVAD+HrGuDUIWBbLS6FHwUYsHb1o0CvJrTbcXkH8jVicScfk6BvEBWiDWBz3iPFoEYvxWgiIyfup93ud4Z0OatfOGp6YI4le370ENQWava5zqtT7As0j5s0PiDetPaMbwHFB+SP6ETEpDwCS/R2Ab1D30K1JcCM//Rlkxw3JXkWZ1u8RCpj8qtX+HmR/krMXbXOJDyegl2/fAXw2s+2xQ7A8w4Jw9Nd6pQeT84KRz7AEfoZ4GZVwXk4eRGT6O/eeD+fBzwM9Jx2hwNMVdPR5LJztbaav13nN5ZLl43FqhgWntyOPc6/P5EzUDHsVyNDmBH5zKgGZnLN0Z/S86vdNQWazJpMrHUh2vPR3ZkkOOW+ZqeCGc3xv8I9ACRoZt++9btgOcFvOG/w/oG6zx7wsHf8s+Av1guI8D9DRjwAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_63\",\"w\":291,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_64\",\"w\":577,\"h\":453,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkEAAAHFCAYAAAD1zS3+AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAKqklEQVR4nO3cP29edx2H4d957JYkRCSINIlLUqf8mVhYUCWYuiGQgCIGJCRAQqywsHXmDbCyMFQqEojCwitAEYilCxsEu00bEgKkVQkQ4jwMIITAwY6d6PjJfV2jp89g6XvrHB9Pg4fm7Nmz5+5Nxz62tjY++8+fTCfHGM/OOgqAx8Vvx1i+M8YYOzvjJ4vlX39548aN63OPWmXT3ANW34XjT52fvjgtpm9Py7Ex9xoAOpbTuLa8t3zx979bfn+Mq3+Ze8+qEUGH8L6zFz+3vja9MvcOALi7s3zhDzde//HcO1aJCDqQC8fPbSx+OMb41NxLAOA//PT6tXtf8FRof0TQAzp16pn3vuvd41defQFwFC2nce1vfx4feeut1/4095ajTgQ9AAEEwCoQQvuzmHvAClk/dmK8JIAAOOqm5dg4dmK8NMZYn3vLUbY294BV8dT5i1+Zpulbc+8AgH368ImT79m6/c7br8495KjyOmwfzpw5s7H2xIk3594BAA9q5++3n7558+a1uXccRV6H7cO0fuybc28AgINww+7Pk6A9XTh+bmNxe+4VAHBQ16/dO+Gz+f/lSdAezpwfz829AQAOwy3bnQjawzTGJ+feAACH4ZbtTgTtYVosvjz3BgA4DLdsdyJoD/4vEACrzi3bnQgCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJC0PveAo25tbW3uCQDAIyCC9jAtPCwDgMeRCNrTcu4BAMAj4DEHAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJIAAgSQQBAEkiCABIEkEAQJIIAgCSRBAAkCSCAIAkEQQAJIkgACBJBAEASSIIAEgSQQBAkggCAJJEEACQJIIAgCQRBAAkiSAAIEkEAQBJIggASBJBAECSCAIAkkQQAJAkggCAJBEEACSJoD1NP5h7AQAcjlu2GxG0h2kaL8+9AQAOwy3bnQjaw9q4+/O5NwDAYbhluxNBe9je3r42xrg89w4AOKDL/7pl/BcRtA/TYvHi3BsA4CDcsPub5h6wIqb3P/OBn40xPj73EAB4AJffeO3KJ+YecVR5ErQ/yycW9z499wgAeBBu1/8ngvZpa2vr1rRYPD/3DgDYj2mxeH5ra+vW3DuOsrW5B6ySt2/9cevU6dNvjDF9Zu4tAHA/07T8+tXtKz+ae8dR52+CDuDC5gdfWC6XfrkAOHKmafr81e3fvDL3jlUggg5oc3Nz4+5y7RdjjItzbwGAMcbr69POcz6H3z8RdDjThc1nv7ZcTt+dewgAXdM0vnR1+8rLY4zl3FtWiQh6OKanNz/00bHc+eo0pm/MPQaAx99yLL8zprXvvbn961eH+DkQEfQIXLp06fQYY9y58+T6vSfvnJx7DwCr79gY//7Sy1dfD8c/AA2vtmJiPp69AAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"comp_0\",\"layers\":[{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[341.052,70.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[28.966,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":0,\"nm\":\"Text 4\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[117.75,167.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[459.5,177.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":919,\"h\":355,\"ip\":310.000012626559,\"op\":1210.00004928431,\"st\":310.000012626559,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":0,\"nm\":\"Text \",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[120,166.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[459.5,177.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":919,\"h\":355,\"ip\":160.000006516934,\"op\":310.000012626559,\"st\":160.000006516934,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[352.274,99.149],[227.449,99.043],[227.162,229.84],[351.987,229.946]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_28\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[289.557,164.622,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[62.862,65.216,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_29\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[85.908,99.66,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.159,5.158,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":2,\"nm\":\"Layer 10\",\"refId\":\"image_30\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[99.499,99.663,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.913,5.913,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"Layer 11\",\"refId\":\"image_31\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[112.337,100.06,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.618,5.516,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":2,\"nm\":\"Layer 12\",\"refId\":\"image_32\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[140.001,165,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[69.212,29.212,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":2,\"nm\":\"Layer 13\",\"refId\":\"image_33\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[137.969,166.649,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[60.038,15.899,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":160.000006516934,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":2,\"nm\":\"Layer 14\",\"refId\":\"image_34\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[134.203,214.453,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[53.447,15.702,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":2,\"nm\":\"Layer 15\",\"refId\":\"image_35\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,165.092,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[153.25,87.342,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":4,\"nm\":\"Shape Layer 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"t\":160,\"s\":[100],\"h\":1},{\"t\":175,\"s\":[0],\"h\":1},{\"t\":190,\"s\":[100],\"h\":1},{\"t\":225,\"s\":[100],\"h\":1},{\"t\":237,\"s\":[0],\"h\":1},{\"t\":249,\"s\":[100],\"h\":1},{\"t\":285,\"s\":[100],\"h\":1},{\"t\":297,\"s\":[0],\"h\":1},{\"t\":309,\"s\":[100],\"h\":1},{\"t\":340,\"s\":[100],\"h\":1},{\"t\":360,\"s\":[0],\"h\":1},{\"t\":380,\"s\":[100],\"h\":1},{\"t\":400,\"s\":[0],\"h\":1},{\"t\":420,\"s\":[100],\"h\":1},{\"t\":440,\"s\":[0],\"h\":1},{\"t\":460,\"s\":[100],\"h\":1},{\"t\":480,\"s\":[0],\"h\":1},{\"t\":500,\"s\":[100],\"h\":1},{\"t\":520,\"s\":[0],\"h\":1},{\"t\":540,\"s\":[100],\"h\":1},{\"t\":560,\"s\":[0],\"h\":1},{\"t\":580,\"s\":[100],\"h\":1},{\"t\":600,\"s\":[0],\"h\":1},{\"t\":620,\"s\":[100],\"h\":1},{\"t\":640,\"s\":[0],\"h\":1},{\"t\":660.000026882351,\"s\":[100],\"h\":1}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"t\":160,\"s\":[90.25,354.375,0],\"h\":1},{\"t\":190,\"s\":[99,354.375,0],\"h\":1},{\"t\":195,\"s\":[104,354.375,0],\"h\":1},{\"t\":200,\"s\":[112.75,354.375,0],\"h\":1},{\"t\":205,\"s\":[121.5,354.375,0],\"h\":1},{\"t\":210,\"s\":[129,354.375,0],\"h\":1},{\"t\":215,\"s\":[137.75,354.375,0],\"h\":1},{\"t\":220,\"s\":[143.5,354.375,0],\"h\":1},{\"t\":225,\"s\":[146.5,354.375,0],\"h\":1},{\"t\":249,\"s\":[146.5,354.375,0],\"h\":1},{\"t\":250,\"s\":[155.25,354.375,0],\"h\":1},{\"t\":255,\"s\":[163.125,354.375,0],\"h\":1},{\"t\":260,\"s\":[166.75,354.375,0],\"h\":1},{\"t\":265,\"s\":[174.25,354.375,0],\"h\":1},{\"t\":270,\"s\":[182.625,354.375,0],\"h\":1},{\"t\":275,\"s\":[189,354.375,0],\"h\":1},{\"t\":280,\"s\":[197.75,354.375,0],\"h\":1},{\"t\":285,\"s\":[201,354.375,0],\"h\":1},{\"t\":309,\"s\":[201,354.375,0],\"h\":1},{\"t\":310,\"s\":[209.75,354.375,0],\"h\":1},{\"t\":315,\"s\":[217.25,354.375,0],\"h\":1},{\"t\":320,\"s\":[226,354.375,0],\"h\":1},{\"t\":325,\"s\":[234.5,354.375,0],\"h\":1},{\"t\":330,\"s\":[242,354.375,0],\"h\":1},{\"t\":335,\"s\":[251.625,354.375,0],\"h\":1},{\"t\":340.000013848484,\"s\":[260.75,354.375,0],\"h\":1}],\"ix\":2},\"a\":{\"a\":0,\"k\":[-88.25,128.625,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0]],\"o\":[[0,0],[0,0]],\"v\":[[-88.25,121.25],[-88.25,136]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":2,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Shape 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":160.000006516934,\"op\":1060.00004317469,\"st\":160.000006516934,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":0,\"nm\":\"Text 2\",\"refId\":\"comp_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[173.25,356,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[459.5,177.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":919,\"h\":355,\"ip\":160.000006516934,\"op\":1060.00004317469,\"st\":160.000006516934,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":2,\"nm\":\"Layer 18\",\"refId\":\"image_57\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[139.24,355.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[60.848,6.58,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":160.000006516934,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":5,\"nm\":\"27\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"27\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":340.000013848484,\"op\":900.000036657752,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":22,\"ty\":5,\"nm\":\"28\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"28\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":335.00001364483,\"op\":340.000013848484,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":23,\"ty\":5,\"nm\":\"58\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"29\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":330.000013441176,\"op\":335.00001364483,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":24,\"ty\":5,\"nm\":\"57\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"30\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":325.000013237521,\"op\":330.000013441176,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":25,\"ty\":5,\"nm\":\"56\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"31\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":320.000013033867,\"op\":325.000013237521,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":26,\"ty\":5,\"nm\":\"55\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"32\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":315.000012830213,\"op\":320.000013033867,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":27,\"ty\":5,\"nm\":\"54\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"33\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":310.000012626559,\"op\":315.000012830213,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":28,\"ty\":5,\"nm\":\"53\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"34\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":285.000011608288,\"op\":310.000012626559,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":29,\"ty\":5,\"nm\":\"52\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"35\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":280.000011404634,\"op\":285.000011608288,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":30,\"ty\":5,\"nm\":\"36\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"36\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":275.00001120098,\"op\":280.000011404634,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":31,\"ty\":5,\"nm\":\"37\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"37\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":270.000010997325,\"op\":275.00001120098,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":32,\"ty\":5,\"nm\":\"38\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"38\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":265.000010793671,\"op\":270.000010997325,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":33,\"ty\":5,\"nm\":\"39\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"39\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":260.000010590017,\"op\":265.000010793671,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":34,\"ty\":5,\"nm\":\"40\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"40\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":255.000010386363,\"op\":260.000010590017,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":35,\"ty\":5,\"nm\":\"41\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"41\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":250.000010182709,\"op\":255.000010386363,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":36,\"ty\":5,\"nm\":\"42\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"42\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":225.000009164438,\"op\":250.000010182709,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":37,\"ty\":5,\"nm\":\"43\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"43\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":220.000008960784,\"op\":225.000009164438,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":38,\"ty\":5,\"nm\":\"44\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"44\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":215.00000875713,\"op\":220.000008960784,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":39,\"ty\":5,\"nm\":\"45\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"45\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":210.000008553475,\"op\":215.00000875713,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":40,\"ty\":5,\"nm\":\"46\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"46\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":205.000008349821,\"op\":210.000008553475,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":41,\"ty\":5,\"nm\":\"47\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"47\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":200.000008146167,\"op\":205.000008349821,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":42,\"ty\":5,\"nm\":\"48\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"48\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":195.000007942513,\"op\":200.000008146167,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":43,\"ty\":5,\"nm\":\"49\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"49\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":190.000007738859,\"op\":195.000007942513,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":44,\"ty\":5,\"nm\":\"51\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[362.911,353.467,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.286,-10.533,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[33,33,100],\"ix\":6}},\"ao\":0,\"t\":{\"d\":{\"k\":[{\"s\":{\"s\":30.0936603546143,\"f\":\"DMSans-SemiBold\",\"t\":\"50\",\"j\":2,\"tr\":0,\"lh\":36.1123924255371,\"ls\":0,\"fc\":[0.561,0.565,0.569]},\"t\":0}]},\"p\":{},\"m\":{\"g\":1,\"a\":{\"a\":0,\"k\":[0,0],\"ix\":2}},\"a\":[]},\"ip\":0,\"op\":190.000007738859,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":46,\"ty\":2,\"nm\":\"Layer 19\",\"refId\":\"image_58\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[371.376,353.66,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[14.15,4.35,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0.034,-0.735],[0,0],[0,0],[0,0],[0,0],[0,0.094]],\"o\":[[0,0],[0,0],[-0.219,4.719],[0,0],[0,0],[0,0],[0,0],[0,-0.094]],\"v\":[[17.274,-2.06],[13.055,-1.466],[12.743,2.19],[11.493,8.003],[11.18,10.284],[28.618,9.628],[29.805,4.94],[29.524,-0.466]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":47,\"ty\":2,\"nm\":\"Layer 20\",\"refId\":\"image_59\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,354.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[183,22.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":49,\"ty\":4,\"nm\":\"Shape Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[58.969,397.781,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[-159.031,171.781,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[-162,172],[-159.938,173.562],[-156.062,170]],\"c\":false},\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"st\",\"c\":{\"a\":0,\"k\":[1,1,1,1],\"ix\":3},\"o\":{\"a\":0,\"k\":100,\"ix\":4},\"w\":{\"a\":0,\"k\":1.5,\"ix\":5},\"lc\":1,\"lj\":1,\"ml\":4,\"bm\":0,\"nm\":\"Stroke 1\",\"mn\":\"ADBE Vector Graphic - Stroke\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Shape 1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false},{\"ty\":\"tm\",\"s\":{\"a\":0,\"k\":0,\"ix\":1},\"e\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":94,\"s\":[0]},{\"t\":104.000004236007,\"s\":[100]}],\"ix\":2},\"o\":{\"a\":0,\"k\":0,\"ix\":3},\"m\":1,\"ix\":2,\"nm\":\"Trim Paths 1\",\"mn\":\"ADBE Vector Filter - Trim\",\"hd\":false}],\"ip\":94.0000038286985,\"op\":994.00004048645,\"st\":94.0000038286985,\"bm\":0},{\"ddd\":0,\"ind\":50,\"ty\":2,\"nm\":\"Layer 25\",\"refId\":\"image_60\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[59,398,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[6.25,6.25,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":94.0000038286985,\"op\":994.00004048645,\"st\":94.0000038286985,\"bm\":0},{\"ddd\":0,\"ind\":51,\"ty\":2,\"nm\":\"Layer 21\",\"refId\":\"image_61\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[59,398,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[7,7,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":95.0000038694293,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":52,\"ty\":2,\"nm\":\"Layer 22\",\"refId\":\"image_62\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[129.389,399.042,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[53.665,5.992,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":53,\"ty\":2,\"nm\":\"Layer 23\",\"refId\":\"image_63\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[220.424,418.215,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[145.418,5.079,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":54,\"ty\":0,\"nm\":\"bg\",\"refId\":\"comp_5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_1\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[455.439,166.685,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[31.854,15.025,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[428.559,192.092,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.974,6.433,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[438.708,193.668,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.693,5.036,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":5.00000020365417,\"op\":905.000036861406,\"st\":5.00000020365417,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 6\",\"refId\":\"image_5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[449.052,193.697,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.298,4.947,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":10.0000004073083,\"op\":910.00003706506,\"st\":10.0000004073083,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_6\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[459.419,193.578,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.321,4.947,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":15.0000006109625,\"op\":915.000037268714,\"st\":15.0000006109625,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 4\",\"refId\":\"image_7\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[469.707,192.173,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.63,6.513,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":20.0000008146167,\"op\":920.000037472368,\"st\":20.0000008146167,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_8\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[480.464,193.697,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.298,4.947,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":25.0000010182709,\"op\":925.000037676022,\"st\":25.0000010182709,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 2\",\"refId\":\"image_9\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[491.134,195.316,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[4.627,6.685,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":30.0000012219251,\"op\":930.000037879677,\"st\":30.0000012219251,\"bm\":0}]},{\"id\":\"comp_2\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 15\",\"refId\":\"image_10\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[427.045,166.717,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.664,7.692,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":30.0000012219251,\"op\":930.000037879677,\"st\":30.0000012219251,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 14\",\"refId\":\"image_11\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[437.868,168.498,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.433,5.911,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":35.0000014255792,\"op\":935.000038083331,\"st\":35.0000014255792,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 13\",\"refId\":\"image_12\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[447.207,168.615,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.598,6.012,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":40.0000016292334,\"op\":940.000038286985,\"st\":40.0000016292334,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 12\",\"refId\":\"image_13\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[459.603,166.816,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.522,7.789,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":45.0000018328876,\"op\":945.000038490639,\"st\":45.0000018328876,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 11\",\"refId\":\"image_14\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[472.551,168.651,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.122,5.903,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":50.0000020365418,\"op\":950.000038694293,\"st\":50.0000020365418,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 10\",\"refId\":\"image_15\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[484.713,168.615,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.315,6.013,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":55.0000022401959,\"op\":955.000038897947,\"st\":55.0000022401959,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_16\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[494.406,167.327,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.56,7.254,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":60.0000024438501,\"op\":960.000039101602,\"st\":60.0000024438501,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_17\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[427.318,186.718,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.936,7.691,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":90.0000036657751,\"op\":990.000040323527,\"st\":90.0000036657751,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_18\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[439.377,188.615,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.442,6.013,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":95.0000038694293,\"op\":995.000040527181,\"st\":95.0000038694293,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"Layer 6\",\"refId\":\"image_19\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[448.109,186.717,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[1.566,7.691,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":100.000004073084,\"op\":1000.00004073083,\"st\":100.000004073084,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_20\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[456.843,188.615,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.442,6.013,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":105.000004276738,\"op\":1005.00004093449,\"st\":105.000004276738,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"Layer 4\",\"refId\":\"image_21\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[468.552,188.618,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.064,6.017,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":110.000004480392,\"op\":1010.00004113814,\"st\":110.000004480392,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_22\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[480.296,188.615,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.027,6.013,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":115.000004684046,\"op\":1015.0000413418,\"st\":115.000004684046,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":2,\"nm\":\"Layer 2\",\"refId\":\"image_23\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[491.955,188.615,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.442,6.013,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":120.0000048877,\"op\":1020.00004154545,\"st\":120.0000048877,\"bm\":0}]},{\"id\":\"comp_3\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 4\",\"refId\":\"image_24\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[342.5,216.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[51.75,51.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_25\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[342.5,216.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[72.75,73.749,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 6\",\"refId\":\"image_26\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[342.5,216.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[93.75,94.749,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_27\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[342.5,216.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[115.5,116.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_4\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"P\",\"refId\":\"image_36\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[456.747,176.97,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[81.114,6.69,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":30.0000012219251,\"op\":930.000037879677,\"st\":30.0000012219251,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"R\",\"refId\":\"image_37\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[386.115,176.718,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[2.28,3.862,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":35.0000014255792,\"op\":935.000038083331,\"st\":35.0000014255792,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"O\",\"refId\":\"image_38\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[392.446,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.75,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":40.0000016292334,\"op\":940.000038286985,\"st\":40.0000016292334,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"D\",\"refId\":\"image_39\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[400.953,175.375,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.876,5.374,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":45.0000018328876,\"op\":945.000038490639,\"st\":45.0000018328876,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"U\",\"refId\":\"image_40\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[409.587,176.886,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.456,3.862,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":50.0000020365418,\"op\":950.000038694293,\"st\":50.0000020365418,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"C\",\"refId\":\"image_41\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[417.839,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.645,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":55.0000022401959,\"op\":955.000038897947,\"st\":55.0000022401959,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"T\",\"refId\":\"image_42\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[424.542,175.92,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[2.56,4.66,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":60.0000024438501,\"op\":960.000039101602,\"st\":60.0000024438501,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"R\",\"refId\":\"image_43\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[435.435,175.43,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.638,5.15,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":90.0000036657751,\"op\":990.000040323527,\"st\":90.0000036657751,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"E\",\"refId\":\"image_44\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[443.186,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.659,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":95.0000038694293,\"op\":995.000040527181,\"st\":95.0000038694293,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"L\",\"refId\":\"image_45\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[448.851,175.29,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[0.95,5.29,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":100.000004073084,\"op\":1000.00004073083,\"st\":100.000004073084,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":2,\"nm\":\"E\",\"refId\":\"image_46\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[454.617,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.659,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":105.000004276738,\"op\":1005.00004093449,\"st\":105.000004276738,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"A\",\"refId\":\"image_47\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[462.465,176.803,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.372,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":110.000004480392,\"op\":1010.00004113814,\"st\":110.000004480392,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":2,\"nm\":\"S\",\"refId\":\"image_48\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[469.941,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.194,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":115.000004684046,\"op\":1015.0000413418,\"st\":115.000004684046,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":2,\"nm\":\"E\",\"refId\":\"image_49\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[477.667,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.659,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":120.0000048877,\"op\":1020.00004154545,\"st\":120.0000048877,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":2,\"nm\":\"R\",\"refId\":\"image_50\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[489.672,175.43,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.638,5.15,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":150.000006109625,\"op\":1050.00004276738,\"st\":150.000006109625,\"bm\":0},{\"ddd\":0,\"ind\":16,\"ty\":2,\"nm\":\"O\",\"refId\":\"image_51\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[497.515,176.802,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.75,3.946,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":155.000006313279,\"op\":1055.00004297103,\"st\":155.000006313279,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":2,\"nm\":\"U\",\"refId\":\"image_52\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[505.756,176.886,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.456,3.862,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":160.000006516934,\"op\":1060.00004317469,\"st\":160.000006516934,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":2,\"nm\":\"N\",\"refId\":\"image_53\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[514.091,176.718,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.463,3.862,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":165.000006720588,\"op\":1065.00004337834,\"st\":165.000006720588,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":2,\"nm\":\"D\",\"refId\":\"image_54\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[522.454,175.375,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.876,5.374,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":170.000006924242,\"op\":1070.00004358199,\"st\":170.000006924242,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":2,\"nm\":\"U\",\"refId\":\"image_55\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[531.09,176.886,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.456,3.862,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":175.000007127896,\"op\":1075.00004378565,\"st\":175.000007127896,\"bm\":0},{\"ddd\":0,\"ind\":21,\"ty\":2,\"nm\":\"P\",\"refId\":\"image_56\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[539.838,178.259,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[3.876,5.402,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":180.00000733155,\"op\":1080.0000439893,\"st\":180.00000733155,\"bm\":0}]},{\"id\":\"comp_5\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_64\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[216.5,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[288.5,226.25,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]}],\"fonts\":{\"list\":[{\"fName\":\"DMSans-SemiBold\",\"fFamily\":\"DM Sans\",\"fStyle\":\"SemiBold\",\"ascent\":71.9985961914062}]},\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.352,\"y\":1},\"o\":{\"x\":0.614,\"y\":0},\"t\":49,\"s\":[186.496,483.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.352,\"y\":0.352},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":79,\"s\":[65.496,410.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.646,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":130,\"s\":[65.496,410.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":150.000006109625,\"s\":[149.496,365.315,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[32.334,51.592,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.167]},\"t\":90,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,2.5]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":95,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":100,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":150,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":155,\"s\":[17,17,100]},{\"t\":160.000006516934,\"s\":[20,20,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":160.000006516934,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"Scene 1\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[],\"chars\":[{\"ch\":\"5\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":61.8,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.034,1.266],[-2.2,2.267],[-1.167,3.034],[0,3.6],[0.966,2.9],[1.933,2.2],[2.8,1.3],[3.666,0],[2.533,-1.066],[1.533,-1.666],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-2.234,1.434],[-3.134,0],[-1.934,-1.166],[-1.1,-2.133],[0,-2.866],[1.1,-2.233],[1.933,-1.3],[2.733,0],[2.4,1.967],[0.6,2.934],[0,0],[-2.067,-3.1],[-3.634,-1.766],[-5,0]],\"o\":[[3.033,-1.266],[2.2,-2.266],[1.166,-3.033],[0,-3.2],[-0.967,-2.9],[-1.934,-2.2],[-2.8,-1.3],[-3.267,0],[-2.534,1.067],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1,-2.133],[2.233,-1.433],[2.533,0],[1.933,1.167],[1.1,2.134],[0,2.8],[-1.1,2.234],[-1.934,1.3],[-3.6,0],[-2.4,-1.966],[0,0],[0.4,3.934],[2.066,3.1],[3.633,1.766],[3.733,0]],\"v\":[[41.85,-0.7],[49.7,-6],[54.75,-13.95],[56.5,-23.9],[55.05,-33.05],[50.7,-40.7],[43.6,-45.95],[33.9,-47.9],[25.2,-46.3],[19.1,-42.2],[22.3,-59.5],[51.9,-59.5],[51.9,-70],[13.3,-70],[7.5,-30.5],[19.1,-30.5],[23.95,-35.85],[32,-38],[38.7,-36.25],[43.25,-31.3],[44.9,-23.8],[43.25,-16.25],[38.7,-10.95],[31.7,-9],[22.7,-11.95],[18.2,-19.3],[6.5,-19.3],[10.2,-8.75],[18.75,-1.45],[31.7,1.2]],\"c\":true},\"ix\":2},\"nm\":\"5\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"5\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"0\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":69.8,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-4.5,3.034],[-2.434,5.434],[0,7.2],[2.433,5.434],[4.5,3.034],[6.266,0],[4.533,-3.033],[2.433,-5.433],[0,-7.2],[-2.434,-5.433],[-4.534,-3.033],[-6.334,0]],\"o\":[[4.5,-3.033],[2.433,-5.433],[0,-7.2],[-2.434,-5.433],[-4.5,-3.033],[-6.334,0],[-4.534,3.034],[-2.434,5.434],[0,7.2],[2.433,5.434],[4.533,3.034],[6.266,0]],\"v\":[[51.15,-3.35],[61.55,-16.05],[65.2,-35],[61.55,-53.95],[51.15,-66.65],[35,-71.2],[18.7,-66.65],[8.25,-53.95],[4.6,-35],[8.25,-16.05],[18.7,-3.35],[35,1.2]],\"c\":true},\"ix\":2},\"nm\":\"0\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.733,2.034],[1.5,3.8],[0,5.267],[-1.5,3.8],[-2.734,2.034],[-3.534,0],[-2.734,-2.033],[-1.5,-3.8],[0,-5.266],[1.5,-3.8],[2.733,-2.033],[3.533,0]],\"o\":[[-2.734,-2.033],[-1.5,-3.8],[0,-5.266],[1.5,-3.8],[2.733,-2.033],[3.533,0],[2.733,2.034],[1.5,3.8],[0,5.267],[-1.5,3.8],[-2.734,2.034],[-3.534,0]],\"v\":[[25.5,-12.65],[19.15,-21.4],[16.9,-35],[19.15,-48.6],[25.5,-57.35],[34.9,-60.4],[44.3,-57.35],[50.65,-48.6],[52.9,-35],[50.65,-21.4],[44.3,-12.65],[34.9,-9.6]],\"c\":true},\"ix\":2},\"nm\":\"0\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"0\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"4\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":63.8,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[50.9,0],[50.9,-13.3],[60.4,-13.3],[60.4,-23.8],[50.9,-23.8],[50.9,-70],[37.3,-70],[4.3,-22.9],[4.3,-13.3],[39,-13.3],[39,0]],\"c\":true},\"ix\":2},\"nm\":\"4\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0]],\"v\":[[39.7,-56.8],[39.7,-23.8],[17.2,-23.8]],\"c\":true},\"ix\":2},\"nm\":\"4\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"4\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"9\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":63.3,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-4.1,3.2],[-2.167,5.8],[0,7.734],[0.966,4],[2.133,3.234],[3.566,1.934],[5.266,0],[3.666,-2.2],[2,-3.6],[0,-4.2],[-2.067,-3.4],[-3.434,-1.833],[-3.867,0],[-2.367,0.867],[-1.8,1.534],[-1,1.867],[0,-0.2],[0,-0.133],[1.366,-3.7],[2.266,-1.833],[3.066,0],[2.1,1.7],[0.6,3.134],[0,0],[-1.867,-3.033],[-3.3,-1.833],[-4.734,0]],\"o\":[[4.1,-3.2],[2.166,-5.8],[0,-4.2],[-0.967,-4],[-2.134,-3.233],[-3.567,-1.933],[-4.8,0],[-3.667,2.2],[-2,3.6],[0,4.6],[2.066,3.4],[3.433,1.834],[2.733,0],[2.366,-0.866],[1.8,-1.533],[0,0.2],[0,0.2],[-0.134,5.6],[-1.367,3.7],[-2.267,1.834],[-3.334,0],[-2.1,-1.7],[0,0],[0.333,3.467],[1.866,3.034],[3.3,1.833],[5.866,0]],\"v\":[[45.45,-3.6],[54.85,-17.1],[58.1,-37.4],[56.65,-49.7],[52,-60.55],[43.45,-68.3],[30.2,-71.2],[17.5,-67.9],[9,-59.2],[6,-47.5],[9.1,-35.5],[17.35,-27.65],[28.3,-24.9],[35.95,-26.2],[42.2,-29.8],[46.4,-34.9],[46.4,-34.3],[46.4,-33.8],[44.15,-19.85],[38.7,-11.55],[30.7,-8.8],[22.55,-11.35],[18.5,-18.6],[7.4,-18.6],[10.7,-8.85],[18.45,-1.55],[30.5,1.2]],\"c\":true},\"ix\":2},\"nm\":\"9\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.033,1.067],[1.166,1.934],[0,2.6],[-1.167,1.9],[-2,1.134],[-2.6,0],[-2.034,-1.1],[-1.2,-1.966],[0,-2.533],[1.2,-1.966],[2.033,-1.1],[2.533,0]],\"o\":[[-2.034,-1.066],[-1.167,-1.933],[0,-2.533],[1.166,-1.9],[2,-1.133],[2.6,0],[2.033,1.1],[1.2,1.967],[0,2.4],[-1.2,1.967],[-2.034,1.1],[-2.6,0]],\"v\":[[24.15,-36.7],[19.35,-41.2],[17.6,-48],[19.35,-54.65],[24.1,-59.2],[31,-60.9],[37.95,-59.25],[42.8,-54.65],[44.6,-47.9],[42.8,-41.35],[37.95,-36.75],[31.1,-35.1]],\"c\":true},\"ix\":2},\"nm\":\"9\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"9\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"8\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":62.5,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.767,1.7],[-2.267,3.1],[0,4.2],[1.033,2.367],[1.833,1.8],[2.533,0.867],[-1.9,2.7],[0,3.2],[1.8,2.8],[3.466,1.734],[5.066,0],[3.5,-1.733],[1.8,-2.8],[0,-3.4],[-1.9,-2.633],[-3.267,-1.466],[1.866,-1.766],[1,-2.4],[0,-2.8],[-2.234,-3.1],[-3.8,-1.7],[-4.734,0]],\"o\":[[3.766,-1.7],[2.266,-3.1],[0,-2.8],[-1.034,-2.366],[-1.834,-1.8],[3.266,-1.4],[1.9,-2.7],[0,-3.4],[-1.8,-2.8],[-3.467,-1.733],[-5.067,0],[-3.5,1.734],[-1.8,2.8],[0,3.267],[1.9,2.634],[-2.467,0.867],[-1.867,1.767],[-1,2.4],[0,4.2],[2.233,3.1],[3.8,1.7],[4.733,0]],\"v\":[[44.05,-1.35],[53.1,-8.55],[56.5,-19.5],[54.95,-27.25],[50.65,-33.5],[44.1,-37.5],[51.85,-43.65],[54.7,-52.5],[52,-61.8],[44.1,-68.6],[31.3,-71.2],[18.45,-68.6],[10.5,-61.8],[7.8,-52.5],[10.65,-43.65],[18.4,-37.5],[11.9,-33.55],[7.6,-27.3],[6.1,-19.5],[9.45,-8.55],[18.5,-1.35],[31.3,1.2]],\"c\":true},\"ix\":2},\"nm\":\"8\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.3,2.167],[0,3.334],[-2.434,2.034],[-4.134,0],[-2.367,-2.033],[0,-3.733],[2.233,-2.166],[4.4,0]],\"o\":[[-2.3,-2.166],[0,-3.733],[2.433,-2.033],[4.133,0],[2.366,2.034],[0,3.334],[-2.234,2.167],[-4.4,0]],\"v\":[[21.25,-12.15],[17.8,-20.4],[21.45,-29.05],[31.3,-32.1],[41.05,-29.05],[44.6,-20.4],[41.25,-12.15],[31.3,-8.9]],\"c\":true},\"ix\":2},\"nm\":\"8\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":2,\"ty\":\"sh\",\"ix\":3,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.033,1.867],[0,2.934],[-2.034,1.767],[-3.6,0],[-2.034,-1.766],[0,-3.266],[2.033,-1.9],[3.6,0]],\"o\":[[-2.034,-1.866],[0,-3.266],[2.033,-1.766],[3.6,0],[2.033,1.767],[0,2.867],[-2.034,1.9],[-3.6,0]],\"v\":[[22.85,-44],[19.8,-51.2],[22.85,-58.75],[31.3,-61.4],[39.75,-58.75],[42.8,-51.2],[39.75,-44.05],[31.3,-41.2]],\"c\":true},\"ix\":2},\"nm\":\"8\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"8\",\"np\":6,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"7\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":53.6,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[24.4,0],[50.3,-61.4],[50.3,-70],[2.8,-70],[2.8,-59.7],[38,-59.7],[11.9,0]],\"c\":true},\"ix\":2},\"nm\":\"7\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"7\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"6\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":63.3,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.667,2.2],[-2,3.6],[0,4.2],[2.1,3.4],[3.366,1.834],[3.933,0],[2.366,-0.866],[1.8,-1.5],[1.066,-1.933],[0,0.1],[0,0.134],[-1.334,3.734],[-2.334,1.867],[-3,0],[-2.1,-1.7],[-0.6,-3.133],[0,0],[1.866,3],[3.3,1.834],[4.8,0],[4.1,-3.2],[2.2,-5.766],[0,-7.8],[-1,-4],[-2.134,-3.233],[-3.567,-1.933],[-5.2,0]],\"o\":[[3.666,-2.2],[2,-3.6],[0,-4.6],[-2.1,-3.4],[-3.367,-1.833],[-2.734,0],[-2.367,0.867],[-1.8,1.5],[0,-0.133],[0,-0.1],[0.2,-5.733],[1.333,-3.733],[2.333,-1.866],[3.333,0],[2.1,1.7],[0,0],[-0.4,-3.533],[-1.867,-3],[-3.3,-1.833],[-5.8,0],[-4.1,3.2],[-2.2,5.767],[0,4.2],[1,4],[2.133,3.234],[3.566,1.933],[4.866,0]],\"v\":[[45.8,-2.1],[54.3,-10.8],[57.3,-22.5],[54.15,-34.5],[45.95,-42.35],[35,-45.1],[27.35,-43.8],[21.1,-40.25],[16.8,-35.1],[16.8,-35.45],[16.8,-35.8],[19.1,-50],[24.6,-58.4],[32.6,-61.2],[40.75,-58.65],[44.8,-51.4],[56,-51.4],[52.6,-61.2],[44.85,-68.45],[32.7,-71.2],[17.85,-66.4],[8.4,-52.95],[5.1,-32.6],[6.6,-20.3],[11.3,-9.45],[19.85,-1.7],[33,1.2]],\"c\":true},\"ix\":2},\"nm\":\"6\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ind\":1,\"ty\":\"sh\",\"ix\":2,\"ks\":{\"a\":0,\"k\":{\"i\":[[2.033,1.134],[1.2,1.934],[0,2.534],[-1.2,1.934],[-2.034,1.1],[-2.534,0],[-2.034,-1.066],[-1.167,-1.933],[0,-2.6],[1.166,-1.933],[2,-1.133],[2.6,0]],\"o\":[[-2.034,-1.133],[-1.2,-1.933],[0,-2.466],[1.2,-1.933],[2.033,-1.1],[2.6,0],[2.033,1.067],[1.166,1.934],[0,2.467],[-1.167,1.934],[-2,1.134],[-2.6,0]],\"v\":[[25.35,-10.8],[20.5,-15.4],[18.7,-22.1],[20.5,-28.7],[25.35,-33.25],[32.2,-34.9],[39.15,-33.3],[43.95,-28.8],[45.7,-22],[43.95,-15.4],[39.2,-10.8],[32.3,-9.1]],\"c\":true},\"ix\":2},\"nm\":\"6\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"6\",\"np\":5,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"3\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":59.9,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[-3.567,1.933],[-1.834,3.234],[0,3.8],[1.166,2.367],[2.033,1.534],[2.6,0.534],[-1.7,1.434],[-1,2.134],[0,2.6],[1.7,2.8],[3.266,1.667],[4.733,0],[3.4,-1.666],[1.966,-3.1],[0.2,-4.2],[0,0],[-1.967,2],[-3.4,0],[-1.767,-1.666],[0,-2.733],[2.333,-1.7],[3.666,0],[0,0],[0,0],[0,0],[-2.2,-0.866],[-1.267,-1.7],[0,-2.6],[0.933,-1.733],[1.833,-1],[2.6,0],[1.933,1.1],[1.033,1.9],[0.066,2.334],[0,0],[-2.234,-3.366],[-3.734,-1.633],[-4.534,0]],\"o\":[[3.566,-1.933],[1.833,-3.233],[0,-3.133],[-1.167,-2.366],[-2.034,-1.533],[2.266,-0.666],[1.7,-1.433],[1,-2.133],[0,-3.333],[-1.7,-2.8],[-3.267,-1.666],[-4.534,0],[-3.4,1.667],[-1.967,3.1],[0,0],[0.2,-2.933],[1.966,-2],[3.266,0],[1.766,1.667],[0,3.267],[-2.334,1.7],[0,0],[0,0],[0,0],[2.8,0],[2.2,0.867],[1.266,1.7],[0,2.134],[-0.934,1.734],[-1.834,1],[-2.734,0],[-1.934,-1.1],[-1.034,-1.9],[0,0],[0.133,5.134],[2.233,3.367],[3.733,1.633],[5.2,0]],\"v\":[[42.95,-1.7],[51.05,-9.45],[53.8,-20],[52.05,-28.25],[47.25,-34.1],[40.3,-37.2],[46.25,-40.35],[50.3,-45.7],[51.8,-52.8],[49.25,-62],[41.8,-68.7],[29.8,-71.2],[17.9,-68.7],[9.85,-61.55],[6.6,-50.6],[18.4,-50.6],[21.65,-58],[29.7,-61],[37.25,-58.5],[39.9,-51.9],[36.4,-44.45],[27.4,-41.9],[22.2,-41.9],[22.2,-32],[27.4,-32],[34.9,-30.7],[40.1,-26.85],[42,-20.4],[40.6,-14.6],[36.45,-10.5],[29.8,-9],[22.8,-10.65],[18.35,-15.15],[16.7,-21.5],[4.9,-21.5],[8.45,-8.75],[17.4,-1.25],[29.8,1.2]],\"c\":true},\"ix\":2},\"nm\":\"3\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"3\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"2\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":57.7,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[-2.734,2.367],[-2.567,2.634],[-2.067,2.834],[-1.167,3.034],[0,3.134],[1.8,3.134],[3.333,1.734],[4.733,0],[3.533,-1.7],[2.066,-3.4],[0.133,-5.066],[0,0],[-0.867,1.9],[-1.767,1.134],[-2.534,0],[-1.567,-1.066],[-0.734,-1.733],[0,-2],[1.866,-3.333],[3.266,-3.466],[4.066,-3.533],[4.466,-3.533],[0,0]],\"o\":[[0,0],[0,0],[2.533,-2],[2.733,-2.366],[2.566,-2.633],[2.066,-2.833],[1.166,-3.033],[0,-4.266],[-1.8,-3.133],[-3.334,-1.733],[-4.4,0],[-3.534,1.7],[-2.067,3.4],[0,0],[0,-2.4],[0.866,-1.9],[1.766,-1.133],[2.6,0],[1.566,1.067],[0.733,1.734],[0,3.067],[-1.867,3.334],[-3.267,3.467],[-4.067,3.534],[0,0],[0,0]],\"v\":[[53.6,0],[53.6,-9.9],[22.3,-9.9],[30.2,-16.45],[38.15,-23.95],[45.1,-32.15],[49.95,-40.95],[51.7,-50.2],[49,-61.3],[41.3,-68.6],[29.2,-71.2],[17.3,-68.65],[8.9,-61],[5.6,-48.3],[17.2,-48.3],[18.5,-54.75],[22.45,-59.3],[28.9,-61],[35.15,-59.4],[38.6,-55.2],[39.7,-49.6],[36.9,-40],[29.2,-29.8],[18.2,-19.3],[5.4,-8.7],[5.4,0]],\"c\":true},\"ix\":2},\"nm\":\"2\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"2\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"},{\"ch\":\"1\",\"size\":30.0936603546143,\"style\":\"SemiBold\",\"w\":34.8,\"data\":{\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[27.8,0],[27.8,-70],[20.3,-70],[3.1,-62.4],[3.1,-53.1],[15.5,-56.3],[15.5,0]],\"c\":true},\"ix\":2},\"nm\":\"1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false}],\"nm\":\"1\",\"np\":3,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}]},\"fFamily\":\"DM Sans\"}]}");


var $2eb6cc606f63d897$exports = {};
$2eb6cc606f63d897$exports = JSON.parse("{\"v\":\"4.8.0\",\"meta\":{\"g\":\"LottieFiles AE 3.5.8\",\"a\":\"\",\"k\":\"\",\"d\":\"\",\"tc\":\"\"},\"fr\":29.9700012207031,\"ip\":0,\"op\":331.000013481906,\"w\":436,\"h\":452,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[{\"id\":\"image_0\",\"w\":65,\"h\":104,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABoCAYAAACuVJ27AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADpklEQVR4nOWc3XXbMAxGL3v6nmxgb5Bs4GzQdoKoE7QbVBs0G1TZwCO4GzgbeARnAvSBdpOqkq0fkASp79FHBqFrSPpAU0REKpYuEdmJSJM6j6Q6QZBFg3gHQRZ7abQgLBNEB4TlgeiBcBSR+9S5xdKHns9vgN1SQPRBgDcQ60i5JNMlCOBBbEXkNkYyqXQNAsAdviKKBTEEApxABMwjqYZCALgr1VWOgQDwWCKIsRDAg3hSzyShpkAA+FaSq5wKAeBXKSDmQAAP4kEjkZSaCwG8mcraXmtAyL7P0IAAbyCydJVaECBjEJoQINM+QxsCeBBNgLjBFAICwKec7HUoCJBRnxESAngQ3wOPMVuhIQD8tG6vY0AA431GLAjgQZh0lTEhgFF7HRuCyT4jNgTwIBpLrjIFBDBmr1NBAEMgUkIADyL5pG1qCGDAXluAAImn8a1AgITT+JYgQCJ7bQ0CeBCfYw5oEQJ4MxXNVVqFENVeW4UAEZcLWYYAkZYLWYcAEex1DhDAg9iGCp4LBIBNKHudEwQI1GfkBgE8iFozYI4QAH5o2utcIYBin5EzBFCaxs8dAijY6xIgzO4zSoAAM+11KRAAVky01yVBgIl9RmkQYMJyoRIhwMjlQqVCgBF9RskQwIOorh1UOgQYYK+XAAGugFgKBICnPle5JAi99npJEKAHxNIgQMdyoSVCgJa9XioEePfW78e0eXTqhYD/MbQlIvcWIdw65+qYA1q8HFaxF2pYhABQxxzMKoRVzJdOrUKAiNWgDeEV+AL8Voi1ibWfiyaEV+DBObdFb5VqrRTnsnr2WRqrfftXE5GDQlxpxw0hjUp4wVfAofV5rRAboFKK0y+ZVwnNldga1XAUw2uWnp1z1ZVjmhnxz7oBwi7unFgJ1cDYt6dfcq4OIRmMrYRX4KtzrhlysHPuiM6TYjUU/CSNqIRJO/OdqkFDuwCnDwyvhPMTYD92gFM1PI/9Xoc2EspKD6iEvcy8O4vIWqkaGqXT/i/BSxDUltSKSKMEYq2RTzu5PgiN8jgPShBU8zon1wUhyOv+F4CPkb556kisUh3g37G0qqHWTuwMIcrmtOJvtHN10Mzp/Ig8t8GjH4ETZM88iciTRH5VV3Qaq0PMnNUlIpUCBJHcN78TncZqp5FLyolWjXvDRnLeV1rmt9nb7C8H+HtTHqPj6Tvr1LmrSYY3VnsxvEXRbMnlxqopouSvqaMaDiJSF1XyQyT+JrcruuSt6w/YqcfF7vpUCwAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_1\",\"w\":68,\"h\":6,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAGCAYAAAB6gzjVAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABvUlEQVQ4jZ2UfZGkMBDFf721AiIBCUhAAhIiYSQgAQmRgISRgAQk4ODtH7xeMnt1e1PXVSlI+vXrzwRJFYukQdLMmyKp9vZv4EdJT0njbzpJRdLiVbxWSa23lTRJmn7hGWxTret5SmczJ88nMEk6I2IDKnAYXIEzIprBA3CYYwQ27xOfhdyAAqTNFhE7QETskp7Wv8gP3WoegAdw2tcTWIBZ0pA4SRhz2mfP8zC+Ou7ULcDDBW7GPj/8k8nMEdFsdAJF0urkqoNa/W190nZS/D/Y4e6A/yjAP2SIiM1NmszZeG1KNjCL0bxSD1dDd5+PQDMn3I1sXEUD4MMGo6/KngHZ2WwigCUiDmMqV2G+JSLWiOjP0nnrOP5L7BcHvkpaHEfhLtLOXYC/8eyeiIVuKpJHUvnM4HmdlIO7GFMSekxPEz5tB9ckZdJvT4M7VLqEU3Y3aADyzdm4JviQlPjJmMGxZowpxdd9Mufk2OeIODue0RwlusBaRMzej9x3d+Eqzu4KP7xfnXx2JMcup2T0+1PT1ty14xqAGhFLr+NqyAMgIhaffyea+M4G7qsycU9M8hxdLMlz+HnIfMeIaF9WRVh4PWwbCgAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_2\",\"w\":63,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAICAYAAABOICfKAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABr0lEQVQ4jc2UYY3kMAyFP58GQCEUQiAUQiEUwkAohEIIhEIohEIohDJ4+2NeNN6qq9uTbk9nqWqc2M9+jh0AJA2SZkmTpI4fEknrT2HfxCqSli/OFoCHpBEYgQoU/0dJxfs7cNqv91eBwXsr0Hm/AEdErA4y+ewwTtsf7L+lnHrbrhFx3CTcAVPDT/ppn9O4BdgiYpe023c0/umYBeABPCOiEdkkbSZegWcL6PMBWEyken82qaXZS2pFOvxVF3KSdCTbpRXE9pv1ciVve3hdTCO+2K9KajGq9Rav432pS+ICkrZrFI/A6HUbidmVxQXq0nqQNFvvJa0ZV9Jim+2Cc4t9Q5zkXyV1F/wjY2Rul1znhgPwi9dtN8DJrbK7sqT/J4mI87I1pBvZgFPS6C4Yk93xO+wvZCDdPtC50IX3aBbzqOnt2nl3QM6DR0TMkp682mIHBs9P7wdq590qZwLksl6NcRiz8hqJ0WcnsEdEK/SacI+MnVq1yWnsOcXarZ/A5Jwbj2q92cy8Wn5refC3xK00fNO2l7Tbp975uThD+u7egP9DTKj/A/tyN6P/Wj4AInGy0OrWKakAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_3\",\"w\":264,\"h\":265,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAAEJCAYAAABoqrlaAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADN0lEQVR4nO3UsQ2DMAAAQWzYK8rmjJCSMTKBlT7S11DcTfDVj+u6zg3gz5zzc4wxXneHAM+z1trm3RHAcxkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAMkggGQQQDIIIBkEkAwCSAYBJIMAkkEAySCAZBBAMgggGQSQDAJIBgEkgwCSQQDJIIBkEEAyCCAZBJAMAkgGASSDAJJBAOlYa73vjgCeZ9/37w+Ozw2ksSSzowAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_4\",\"w\":52,\"h\":17,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAARCAYAAACSGY9uAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABvUlEQVRIicWXTVbCMBSF76s/U9kB7EB2QHdgJyjDgCwg7sAlZANCnSkMZAl1B7ACcQcw8/iT54CTAiVt0xqOd9Y09yW3X06SEo6k3lCG/IOICW3TxoQVGLMvjdksVqtjjEtdIdsUQFUxsYacxmpuexcJ2Tg7QUzMVwUl1iASkwc1qzRbB51uwnCniokCJAAa2fZIyMZ5gATMlyUlLsD80h3I/nSkYpcxbwZyyeAmQK+TkQrz+gUuxawTsug8QAKUhklF4PH1rYzK+nUHUmzCAAB3ekMZ5vWtG8g6aJUwRsTlyz0A7neftd5/zvT1IwJkHR+Dm0WU9umkrlxK3gLVobO1bnfCrLJ0jPIoeQlUtKYdZfXb6RjZKXkk5F95dIxslLwE+viG9UyqoCTbUEzH6JCSl0CbU58WtQvQ4Qcpo2OUpeRzl4vr+eg9e2Nwo2O0T8lboOeRUnUoMR1u9650jHYped0UWEMAWLsb6PFvdNJCKaWAaywVBvVt7dNYzVlT6EKKQHeTsRKWF6VXIeuc9OYsozpmF3UHUoAQEXOI9O5HC2IkxFBPsVrafD0hWzrgt4rDrT81tY71S/Kv+gWLrbLoVBlcgAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_5\",\"w\":186,\"h\":21,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_6\",\"w\":199,\"h\":29,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_7\",\"w\":209,\"h\":211,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_8\",\"w\":295,\"h\":298,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_9\",\"w\":381,\"h\":385,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_10\",\"w\":469,\"h\":473,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_11\",\"w\":78,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAICAYAAABXq8lsAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAACAklEQVRIidWUXbHcMAyFP+1cAIEQBg2DBkIgBEIgLIOGQV0GgRAIhhAIYaA+5GhX69uH3mlnbquZjB1LOjr6sXH33t3v7j67e+fuK39JhDmk/w9hi9uir/9DLqPynH7Dtmidtb7j/QYUYAVGoAMGgQ/Aamankp+APfn2wKFvAg4z21LALtmEDElX5LcpxgxU4Zwq1A4s8t3E6wRmrchmAHozWxP+AVQzi/hFfnd3P5Qvwtmkq2a2A7u7j7IN3i81uckxDqKyowIXFa2I4F26UYEOnR/ApMlYE/GZV/kqHSLbya9TgcakH8VpU0Om5HfI7jtXcwpwKnYf3LXP0gOTmVXgm3IfUw6rGha5nVzNfKnJA83dJ3ffdbV2JYK71zzeadzv2o/ufsqnxppwN3Uu/ve819NQFXchiZowN4m3GFUcyi90axO7U5zq7kPwbPxn/e8Zr60JwE1OUckewMziGkTFI4E2kSqbieu6F+BQ8J5rkrMMIj0AneLU8JUuT+Sssz4SBnqdjcAX2R6xxlvNc0LRfxFm5ZrWyPHFv+EbXNqa8CbSiw7u2Zjrzm8iHkED/NRbtIhUFGBLOFtDMN6SjmcT9iCmyS7CPoQddouZVdkE3x9ag9PC8zl5xBZ2EfZuZvlmZP/gGrqi6/+4Rc3+88Td4x39r+T22QS4pvrf6OIH5Cf5wfggCitrlAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_12\",\"w\":61,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAICAYAAABK1ff3AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABrElEQVQ4jb2TUW3EMBBE31YFEAiBEAiGEAiBcBAMIRAMIRACIRACIQymHxnrrGvS6j7alU7nrHfHs+MxAJKSpCxpktTxRyFp+UPsSdJws/eQtEhKAJ+SRmAECjD4fzTACGzA4f7evwIk5xagc34A9ohYKhHv7cap+eT+teHWu3aJiP2G/Oi6zanNHKln3/QMwMPnDx/AIyKmiFgjYgayBy4mNZpgAiYftBmoA7KJzJWElZ2bgYtrJg88G3tusBOnuJdukPTgeQm1r/iMw9yuYvPAUC9P0vZaZauPXlfr52oPSWt9Bl4nSdnfva20Nniza9YXnEvsm6GXal+LmlvulcdNb9fufwCLpOKNyUBbo9ylghFxvKSShZg4b/GQNErqeVoQzpv/EfsmVk4XdTyf1m7hek7nfQvXL0CJiBXgMyKyrVM4h00RcdQbc243Rh20dUddL8bYjVk4rT967wC2iKgCLw3u3mKbaDvEERGz3VQsQH0K1bqZU+jU9nHafwV6STkiclyp827Ug6qSv9T2DdmJ5gaamquhvz3Dn7i82/d22BX9G/VD+47/O74AYs52vkAn13EAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_13\",\"w\":11,\"h\":11,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAARUlEQVQYlWNMKmpIYPrPkMBAADD+ZyhgYfrPkPCfgcGekGIGJoYAJoKKUNSPKiZD8T8Ghg8sjP8ZChiYGAIIKZzX1zABAFiAD2pM11vjAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_14\",\"w\":13,\"h\":13,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAsElEQVQokZ3R0Q3CIBSF4f+iA3QEN3AEO0JHIExgmIAJjBMYRugIjiCbdIFyfRAaHkyKnjfC/XIgV2jifLCiTAIDgMKiwvy4hdjOCYC9huEozAoXvietyhjvYQEwADsA4HwQnvVgnA92B2zQ+WABjChTB/g0KAWVT/ekvsgonHrR1gi8fphPnyZh7hUqRABTFpd6WnIuCGBVxh2YjGLrcqW9cT5Yo7R7SyrEnIkV/J03KkE+St9s8JYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_15\",\"w\":12,\"h\":12,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAAkElEQVQokYWNsRHDIAxFHzp6M0pGyCgUGUAjaAT3abKJM0JGYIQMkDNpMJfDBH6FhP57jiZRLXi4OHjfV3u1/9IuvKDZse2OZ1QLw0JUCzmjZVy81He/UA6WY84ZbS210NCPnCy10NL/WWRA71pkRO9ZZEI/WUSEOKL/WgDE7aTZcUkCcAA3tevs+gPpsVr6AjblNFAeCFgXAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_16\",\"w\":123,\"h\":38,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAAmCAYAAADk1+RWAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAHIklEQVR4nO1b25XcNgy9zPG/1UHUgScVWK7A00HkCjKpIEoFGVdgpYKog8gdjDuQO9BWcPNBcgcCQUoza3sfmXvOnNWSAAGBBPiCHMkjgB3yGJxzx0L9dwfJHYCoQ++c6x9RnecLkiPXcSJZPaKOjdCl+8Gyd8FGY3CMZ4tX6v8vAObwvAPwOjy/ATAAaH6MWk8KFYC3j63Et8BP6v+Dc64JvwrAB1H3tuTdJKvggQlN8I4mhONNINlspb0WQuf6e8t6ElBhvDHqT6J+H8o6yZNrI9DNakqYSLYZXXYkB0Xfk9xbYbyku9KxU3UV0+lrDrKrTPsLXGPrx4YO4xZm8Vwb9Uf4ML8A/fz2m0H/M4BPJCEXWsHII85TR8SvKC8gL4KQo3V+DeA9gIlk45w7fSuZTwU6jC8QDCMNPRpkbwB8BfBn+EXPjR19B+AjgHfhb8Qn5Y0jzh19B+B3+GnkC4zB9AAMor0vSg6CDofwfAj1EPTvwu/5wQqFPM9lMoTPgkeGyIlqng5lEQdVJ8P0EMp2Kko2gr5S7XUl3TM6doacmWINQbLOvKvcCYzXW/rxocP4v8xPR4dMee+ck8ap4EM1AMDYox/hwyVwXt3L6PHZOTcK/plkD+CPnGIXYC+eRxmqnXMTyV/gV98vElvmbAD4cMFBhuy4r7rSOTeKARXDdi1IJqPN7zF/Jm2+xHlaQnf231ga+wTvATOug7UNW/OcemPZQ/FiPTgH3dm9DKHXQHsuydo5NwmSRjxHzx9xDtO10eyW1bjmawyanB4AgLC+qADAOddtkPmsUFyNPwCfxXMfH4JXyzl8CH9l+PxZLcIa+O2XBcnXxQUX/W7AOvUaxfMbuXikP0P4C37Q7WGjzpQ/D5RWtAWe7IFFqN9xeZgyBzmybHHeTvLAJSYudwOJPJKtUW+hxDMxPTzROwitd3+xoZ8C+B06O9DoDtcGtubzPkN/zMnL8EwrPEeDJ6I39Erot9jpqeEVfJgdw//TRr4x83wP59yJPqwekB7MHK1Fn3Oupd97N4Fngg/7M84neaPBMwaeCn5qGOFDbo7nQPIEH67joIuL0QEKgX4M9DWAmela5IYbbrjhhhtuuOGGGy5E2FaMhd/B2iZdKOPF5HFtBf1tXc/0vKEv2ZPpbSPD/+2DZfEHJBzyBV0TbkEwvnUgJO1ZG3xrh0T9lbKqSDyqiuiBk2Z6wMv/3zpb3tnHA54jl543Kh5po4jB6If9iqzOkDVE4lICgB5ppnfznFCYq9/U2bGdDfaM9BclDAr6TWlOgXazPoIvGnrm8ki4Up0g62SnnbhM4JB9NClZsqNle4uEEKuh5MVUvR5VLe2EQk1X7GzmExMTfQL9waCfaZ/TV0xHeqRvM+1b9PFEsAj1rslpnGXvoKNErXhqVb8zZPWrsizhBYZWlK/NL13GAKNqX1+AaOiBUzrXJtVLszyfkalhc+fzEYmNLgGXYbky7GNOl8z0w1ZZViONItaXGbWhHOk7rGHqcRb9KNqXKcKzaKdT5ZXQx6JfDBilv6Tf03uJpJf6HBR9a+izCJeXoCC3tcoVr9Sh2yCrS9rksrP7QNQxvZKcRENyftHXgVLxPpTlOluO8p1qRyp7CGW1ML72eOnBjWHcQdG34deIMvm+Wh8ZUdo1Y2swjYQy2VG+q7k15QWdbciqgTRTJZckcIflhf578Vwp4XLU1wWFFomJAPaqAyVvA39TNsHfhI2x40NdDTvduIdPSACA9/QDtoe/BRtUoqT83OluRZ/se1ng8sNEwOf05XY3Dz3TaAF8UrKmWDlyHTpVeCvGQJ94NtOpYLWdwLdnuh3RaAR9aY4fmJ+aSuguMb7ibQ0aOZ2NaSvJe5jy12Rpz34XcsgqeA+KI30PkV6k8DlTDpSzQuV99t0K7Qm4Tx36R5R/DXXxbjrxbnF33YSfjCYxQuk0pDV9pkLdPZh62cdMlu7aVzfAMicg0c2QlWYEs/ydVsSkeKRn5ZST9Lk5+x5rbQT60lqhuKsQdBXTHUDNzEcC18Lwsn6FXq4XWlVXq7bqFVkLfkmY62x9ANCJOrk96VV7UfCJ5y8xcp09FNrpRDvtiq7mFyX0oS8OTJlcqN+tDuVyEOvBFN95pFocGja9qKMNm05Cpz3LJ29aVv7uIWfAUCe9W26B9HnsKSgrO+++PeY7W2/tTvQdpPfGtaHPRPsYUsrVW6nBaP90oT6LUzHDnnrgldAJvtp4D2tt0lwti+uHKtOCIW+Y0ouYnb2hncUpF71BcouznNeXFqAT0y1WaaE2c92rr17oMfVijfYhslxooA78vU6i43l7A2CZPE/vcVZC4SC3FoEuKjrphYPRzgy/CLH0qQJt1GmC39ZUomzBF95RJhdOov1kfg7vvDf0MRMljXdpSzQCo/4oQ9niLfwCeALQGba4SNZGuhteAv4D2HYK5wjv5aYAAAAASUVORK5CYII=\",\"e\":1},{\"id\":\"image_17\",\"w\":119,\"h\":18,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAASCAYAAABhAEFjAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAFBElEQVRoge2Z7XGENhCGH3lcAB2EEugglEAJSgW5DowrCOmAEuggpAPSASWQCjY/9O5JYHy2Y4/953aGOSSk/dRK2vcws2hmDV9IZlY5TzOb/8f8xsziF+pTm1n1SR5D8R7f0k8yh5P+F7a95X8zm8ys/5DCwCNQA6smr8AaQphP2hUQgUX9bQhhNLNW7UbPqHE7B8iAFpjU1Uj2FEJYD3pVQC3etfoWzZmArhg7hRA2yaqAUe0OqEIIo3RapdeOynk3+G6S7VQXcwGQL64+ks9cRuc2ATPQauykvlG8XMcphLAUMhpgKGIyq895VCTfVs4fmB4LhZ+AP4FeyhzboyZGYAB69Y3qi6QADBK4SZFfFdjxwGMUj5kcwCO1hRGIX0UOwgJ0ZjZqLMBFTvWdo9K85chcdl3n6X1TuzKz+oZuyI5NYyvJ3EjBWwHP0ig7n8jOX4p399VM8smFvBCX4vsT8Cz7O7ef5POL2hfxaR5KTUMIF5LTq5P2pvZFBu+yWyxajV013vs7UkYN+lYXbXfmazRI2bnUDeiljzunJgeqBWIIoStkvghuMa/MykFPBTQhhI7k8Fv69eQs6sTX7Wqka8nDbf9FPnJfjeK1+kBl8NWX4lMf7EeyR/GOQF1m7ltUa6V3ZGf/BfxGzqSR/Wqu1b+QtulFiq3kjNgAzKwNIcwf0KcT/7nQyWklZfDRybOZNb7lkTPqNdo+eNY1pMXfkxfMSrL91rlaF7tEJAXqllzn6Yl0Sg8k41ZSunOjfd0KQgijAvFMXjGrDBrlvEnt5xDCRN6OI3kLgnTeVAdj/Pv8yjvkc6aX/LrQ90I+4yY9vjhLOcNhntvhciJ5pxiLefMr4z1z3T+jHl9M/x5scB8PmjdJ5oU9jeV4Zb1vybHgWfIu9f05+ujt2MxmXbY+KqdVgL+NzKwzs9XMlrPb853udKc73elOX03vOW+EbNU/Ifut+aqlvV07CveVSNpX06Nuqh2plpoKxAnSTbLWuyNVNRldmkMIi5ldIN3iCjTGER5vN37ddwQshNAfkKtIAgB6L4sOvKPexxM9/bcio1RR/UfZkQwguK7O64im1cDvpJIP8RklexTvi/PQXL8xr5rTyn9rYXdpSyXbN7Vd7/kEvXs3PZIL8CseTL5Ot2SQoFefG9cDvhj+AJ5VEzpK0wiladkHoRX/JzO7Ft5kdGZlX7v1JJTsWrZIz+2gJ+TasipRqhPZUTJ6MkhS8i51aoF/yOWMo0XedoTIb/Dl3LqQfUXSDrZU5HKrU20euV1/v4seSChMJBnavjJuKAp/SLXuQK4v/xZy0gIX8fPVPwhJOaOOtOKHEEJNxrLXE1mNEKeOfdB2eurBdeEETy7oipoVC/uqExnu3Nz+EMIxuCXS1pDh0TJZvP6NKNvJdXgnfi0ZnyeE0H8mayFl7qZtpSoUbslI0hk5qO+Ft9NKQk4cGVpIq7EMhiNVkJGrlhSIgZTxlZxYkusJGXXqDu2SVl4Gti14eLslbddnOtU6dk7Y07CHND3ovsvFckFY+ncskgM6F3pHXv5x8Wl6KAQ6SjSSAz2Tz5cjXcgZPRZ9viIjOYtqMmozkBbPEbka9H1hn5nO2/U88vbteWaPFrkuFLLnA0/new34CZp2HA/5LHZZLmORXpH9okfjJi1at6VR/0D+I2A+kfc9JJRn/hHhX0iyo/8mWY1QqteOkzvd6WP0H0TdYeLMTIQPAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_18\",\"w\":106,\"h\":106,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_19\",\"w\":149,\"h\":151,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_20\",\"w\":192,\"h\":194,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_21\",\"w\":237,\"h\":239,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_22\",\"w\":129,\"h\":134,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACGCAYAAAD6penoAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABk0lEQVR4nO3WQVEjQBRF0dtdswcHMxKQgATigCgYoiSDguAAKAwgITiJAAi4mF7kHAVvcav+H1X7w+u/6iYuzPlht90cf+0Pb3eN89/Vc1hgjJfqz6zz/eotLPI9fu8Pz7ezul69hZXm7Wz4BS7drK5Wj2CtuXoA64kAESACEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBCQCEgGJgERAIiARkAhIBFSz0cfqEaw1O3daPYKV5nHWeFk9g5U+32d9PTkJF+q7x912cxpV+8PzdXWzeBL/12m33RyrfgBMlyG7GPiDiAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_23\",\"w\":78,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAAAICAYAAABXq8lsAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAACAklEQVRIidWUXbHcMAyFP+1cAIEQBg2DBkIgBEIgLIOGQV0GgRAIhhAIYaA+5GhX69uH3mlnbquZjB1LOjr6sXH33t3v7j67e+fuK39JhDmk/w9hi9uir/9DLqPynH7Dtmidtb7j/QYUYAVGoAMGgQ/Aamankp+APfn2wKFvAg4z21LALtmEDElX5LcpxgxU4Zwq1A4s8t3E6wRmrchmAHozWxP+AVQzi/hFfnd3P5Qvwtmkq2a2A7u7j7IN3i81uckxDqKyowIXFa2I4F26UYEOnR/ApMlYE/GZV/kqHSLbya9TgcakH8VpU0Om5HfI7jtXcwpwKnYf3LXP0gOTmVXgm3IfUw6rGha5nVzNfKnJA83dJ3ffdbV2JYK71zzeadzv2o/ufsqnxppwN3Uu/ve819NQFXchiZowN4m3GFUcyi90axO7U5zq7kPwbPxn/e8Zr60JwE1OUckewMziGkTFI4E2kSqbieu6F+BQ8J5rkrMMIj0AneLU8JUuT+Sssz4SBnqdjcAX2R6xxlvNc0LRfxFm5ZrWyPHFv+EbXNqa8CbSiw7u2Zjrzm8iHkED/NRbtIhUFGBLOFtDMN6SjmcT9iCmyS7CPoQddouZVdkE3x9ag9PC8zl5xBZ2EfZuZvlmZP/gGrqi6/+4Rc3+88Td4x39r+T22QS4pvrf6OIH5Cf5wfggCitrlAAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_24\",\"w\":146,\"h\":17,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJIAAAARCAYAAAA2X/X4AAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAE20lEQVRoge1Z0ZXbNhCczfO/1UHYgZkKjqkg7MBMB+zAdAVROqA7UAdHVxCmA14HTAXrD+6KwyVIyXfSfeRp3tOTCAK7gwGwC0ACg6oeAOQACgAdgF5ERmyA6kfstrsHApdeREZVPVpZLSL9O3AoEsWDiAx38pcBOAKAiJT38PHTUNVKVUddo9ppUyTqOzob3Pfiz1wKK3M078RhC+Oejm/wV5KP1IJ+X6hqToQGVW3s25FttOPB6+zD7e4eBTa4FFZWWl/eZUIHDV0Pxk2jhqoeVLVW1fqWdl+LDwAq+/0iIhkA6JQWBgAfAZSwELoFESn8t3XsLwCfVDXntGKDXAAYAZw47NuqzTCl1cHqHQB0qdRkA5MD6M1eRE7f3Vvsi8iJIlt7IV21ItKYjYPx+9X8nch+ZmWZceiovEr5Ig7eh+QisQhVeF3vH9t2jsHu2R/rRdzc7gGT5u3uNsZm+7i3kjgKJN45au+AplNnTW18BZ8SdavAbQjve/pdBA7NDey30f5On5tQ7n47KmN73IfM3ju/I7XJmK8m9DfurIXjmLDhOnE0b8jW2dcO51FTEd8INkRmSIkWCWyVE1m315v9Y6IOp4LOiLugI9nnem2ig25vIc6t7Sf0WPijgfVJ2ZLGjqPp4TxOYdAGslUzV01PpPO46Vrn0uo4H9elYV0SY3jQ5fan1Wnb4L7alBgs4qgb+6PUhLEPixI7vJi9OkUG1Xm1uG9OhSx6FgaMoxmLUaQG9tb2E3o4eI/Ekc8H0nk0KS3tmQcuD5Ok3WiTxTZW7pPpFJ67YNdxoP56SmSdXN+DcVjroXNE4gl1MbUlMJIADZV1ut6Ye4fcJ4fzA3cg+Mw2uFyaSDexvzORUqgS9fqgR+Tv+tSBZxk5JQY7pbNPCj7tud1R54Vdanqy86IYrP5Zi19YDBFpRaSxzfN3K65wGd/t8w3AnwDyK+5uBmsT653TzJ3uo+5t/xuA3wH8TWXdFe1cQ+fkG/MK04EHmA5EJ6SxdTod2G5o3xA/51gAeKJyR46pb/9hOjz8AeBZfWHqFOo6XW8SV3k6vF/l6I16vgLGUJ7pMgSvVoGVn1dqWJkV1am5XmjXvNJ+vWc/0c/ojw8sHdXro33Sk1M/pypvcwz1VTWZDqOdPPg66RJVaK+6Hq9C5yyTkZ4jMEekJwBfdJpUlRH+bO+2VsC16DDN4o86Tc5Cp/DcAfhHU5u1DVgEebFH51pjXllvgtn/1x4b06PFdJ3xGls+8E80ATuyX5oeRwDPAAafBHYMdy6f7Lvd8ddj0hmYrjtc5xPWOnehuV8RvKTq2OJ4Nrsl5uM/zt+2cjhHM3rduNCLK2IPur2fOgunV0QMe851fXz/meP/Jfs3O/4HWx2VpY7oqusoxZFwuKT/hjaq4eCky2g3UDn3swr+tjhXAPDBVk5hBTnmS75eRNqUaIYBwNed92eISKeqv2HKvwWmWdxjeaHVYpmrHe5jMFu9DWaJ+X/BI4Ca61E7t3et/RFApvPlaWfvPmMf0R/sP7/K7EBVMxEZiL/r3YEu/ggnzHuf+G5A0N+0yTFrA0w6H3k/aBy+0nuHX0Sn/JWYNM7pfYrzA8Biz1hRma/Ue2zOH/g/IoT3IaSK3b+KHnhgAV3e7qtFqPpyywceeOBN+AEyR4hkwZl9OQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_25\",\"w\":26,\"h\":26,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAACGUlEQVRIibWWMWgTURjHf+8MN5gDMwluEXSqYLMIhkgPR0H6tmQ0yd7WTbBgwIJrFB1bM9qpb3P0ChJXnSs0nQSnBGKHgnkO7y53uVzu4jX9w8H37nt3v/u+e+99nyBDVanXAQm4cZ+GgQDPBuUpMUx7j1jkqEntTqADbGR9DDACujZ0FwHnQK7UpQvoAZtLAOaAFsivSnipIB/iAfdzQKJq9pXoJYJWCEmEWYHhp2tVEICP/kIKQTWpXfL9kyx1Z0D+6roKbfhBYPnhzS3hdgOePA7HTtHcazdm7SxNYAdMRDJpQqsegpwifNgz95wijP8Yu1VfKqrNAORmzdzdgjtl+PwF3u4v9fIZ1aR2raxJ22149AB+DmDv3f9DAhXSnHdvQ2XN2C/e5IdMoJwakXMdxufGfrmVH2TBIBU0Podnz03aKmtQf3oJmIbBIufJKfz6Hf6bVsOkM6rKvfCK+wIV4LslzPmWqpNTODg0qdyNpfD96/Dabic+fuYpMSzYoC7MUXEj6j04NNEE2v9k9o9ThFs3jT+u6PyIeuCf3lWpO8CrrMhyaGRD2VNiaAHYJqLRFYCmFXdajx5KLQUcrRBy3FfCDQbT5f1NCQU0VwT5YcfO0Jl95FfEJpdL47ENbrxJSeyC/NLRZbkOKNAI6PaV6CQ5F7ZbMG25dkivvmdAL63VygRFVZV63YLSXyhdgyGYHZ/VOAb6B7I/o9XyIUhhAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_26\",\"w\":314,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAToAAAAICAYAAABphzNOAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADVUlEQVRoge2a0ZGkOgxFj6Y2AEIgBEIgBEJwCIRACIRACIRACIRACGSg9+Grwd3TPTu9+/ZnxrfKBRhJlkzptuRq3H1EcPfW3Qe+CHdP7p5ekO/cfXP37rN3Gou7z3rXuPuk0RRrL+7ePrG1uvss3Ub3i97F8/pKvBUV3w3Kh0n51PzDdeZ/aDs94ZTk7hvAL6Bz98HMViABhwJOwGlmi7v3QAscstEBq55DPghjBRogdFYz2wHMbNfCHzb07t2k9YNIe9kFGCXXSW5x9wk4NWJ+lE+95nb5O4bfktsK2xUVPwYih4WcEw2wKdcj/zdyDm9c+bzoGhyA7hsAM1tke5DcLpld861sr9I7pNsBi5kdn/g6yBfMbBM3NNxy0zvEXQngDZi5SGqQoxuZNBoxcS/nDskfCjiCD3JrdN+SSWQH1j/4pRgVcATQmtkqMu411mJTTvkz674lf7zYyFVxhb1NMQfpVVT8RIxAMrOtKHQacn7sek5c+bST83sk59nMRX7vfKEucZD8O3+I5BbZH2W7v7P9ASLf0JuBXsVNT87f9LtA31RtdWLgYN9WygOZLAAmEUtswE0pamazmZVzizZvKWx8CaruBjLBbV+Rp2B6bj/SKHsdeUPDn5O8SS/5VlHxXaE8alHumlkqXkehsQFzUThQyM/kfOrJfLFxS14dsGl+KubnsC1Su0dPzuONnMMAvZkl6f22LX4LRyUcCgeZ5CYFBryXnacWK403cbbGg7b0GXRW1j6YT1o7Ks3d3QfNbxpDbIoqxl5+hI+dRpS9K/nX6+AqkxfgfORDRcUPwApMOpvv3X0n586g3EwPdM4H90Nxvn+S8zMVeRk4yEVVtMb3dkrbJXYuggu9ozhXHB5qFfil60JmyKjoElcbOMnQaWaHux/c9vWn5D84UlzLAMrnCHi6e9eiElnncVNhfzazIKfEVXmW64c/DddZ3UL+IJ3sRYn99FygouI7w8xWd4ecDyf56OpQW7hwtbDR/cBt/u7FNWwkzYWNJWTUWcVc6Jb2DnLh0RdunvKzdfeV66x91hq9/DzvC62iu8M+3YmKioqKTyBS6s1s+oJsw1WddWQS+9B2PiC6/V7mif1HRFdRUVHxd4i290X58ZW/pf0f+A+MrlQdebCb3gAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_27\",\"w\":50,\"h\":16,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAQCAYAAABUWyyMAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAABzklEQVRIic2WP27CMBSHf88gygYrqAMRsIBQwwmqngCOQE9QblCOwBF6BI4AJ4AlYimykCisYQMEdgcwJCH/jFyp3+j4Oe/le3ZM+AMcvrIhWA8S9nWQwYWg0SGzG7UtyzX9TnL4ysaJDdNHYNaslvthj6acF3PiaQDgI2aFpRDUa9VLY61Mk9JyvtdjEF51goSgt2AilyLGAF5SLSLpvVkrfSVNcxY/A4A+AWwPbF+JsslSvTQFFxPpigAAksM531Tipkw5LwKk7BdyIhfaCYChQhy+shHfTmEUhJSxLX1JvHAbof65uHvMGBGs91CcRCcqsYANRaQVM4V4TydNssd8aOy9DUW4FWN7xCQRNhShVv5lIdE2FPdWzBTC8PAPjmVPvtgEG4o7K4Y2O40ejFw2reeZdyDZhsJvxUghh8xuBGCpG0eA7/hNaUPhs2KkkLZluUJQTytIYtKoln2FpLehuFlhj/R3sK8BoFUvjSHpHcA2cQGJySGz73qHNG0orlbofEeK/vUHIUmzRq0cuSfmfFMRUg4h0Ql5vCRgGDShcBbrGXSuObjd+0gnSIcp58XsMW9nSBZPklyWPbnBjR3kfP2nbtwcLwRy1Uf5BblCvMdP9tffAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_28\",\"w\":144,\"h\":16,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAAQCAYAAAD59vZgAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAFEUlEQVRoge1a3XHcOAz+4Mn77VXgvQqsDk4lbCqIOsi6gtN1sFeB5Q7WHcgdyB3IHcgV4B4Erj5CpKR14iQPwczOkCD+CIIgSK3AQFULAAcApaF6AB2ARkQGJEBV9wCOAApC9wBqEekzPDsAlfHsDd0CaEWkTfEkdDaEakSkSRJPPAWAk3U7ETlm6E6Y5nIUkW7Nno+U8yuC92VAVpqHzphmglR1WOCrEjx7k7eZJyGjdTz1Bp6S6NuNsss1uR8t51cE78sbC44HonkG8Ajg1fp3AM5OyA5j1viD0C9O14OO2YKhM3kw+U+O7yEVrKS3AvB3bvw3/Hi4wXicBLgXkVJEKowpOATRrVvYGlPwvAH4LCIFgD8RB0QdGsYfeF4AFCJyML7/iIftuYAF7Sk19ht+Htwgrl+a0LC6p6GxktoVtQ8iciYeri++ZPh9XcWBkctAJ0wB+JSh+e7gUnatqgc6hgdVPS9lTQA7VW10Ou673LGrqp426GhsAwU6LjlaJ6OmsSYxxrJ7VT2xbGfLyc31BGBGu+S8kz/LdaxjLpPL8HWeb0UPL1KzMt66fn2l/HaBbla7ON5c/dZpvMAsJ1cnpubZZGhTOmY+1nHRg75BqYRYkd2rC6IF+p7a7c2CMwsAX637hlBxTzcnEM5DT+0tEVtTu3V27BBnwuQN6gfBHcZj/V/EWfAOmaMXY9Z8BnCPsbYM8EXp0qDj7g4Z+9Xo7xHXog3xsx8CvsaUpU/hJqyqR5L9YnI/0xxuEZcbNeLT49F4no12GSySOcJ5oqu7WeM0WqdoiLZZkpeSpT8vA0U7VeMM3WTktE4Hz6czHGd1VToSbWzIjLHvWG7vdCazko1d1plwnGWOOXpNZSCdbljhtvS49s7yXjCnh0h/w/gOxeMFgH+s+yoi9UfYcQV0rnbj2+k+w+MLf+4HH3MN9czvRpZFWA/7qMboN2DyE0DZ0DZCyEoDgMqCrdZx8w1EG+y4ZBkR8fY33PnEnUzwVLge2CFtiiARPGXiwZKNfY8d3xve8yAYzUlEBtrsAdb81acEi0hvfvxK6KeFB9lbxIHmYadxzeqfZgDng0sAJYLnKRM8PbVztw/GzwrtTPB0jqYkW94A1OR4rqsqo119kV6xGYjfmJIXhA8C1rW/ktfPp1TVXebrwStcBnHQu37KlnlNq/OaJ6r4E/RLZyTXDMng4XHNXIGdnC1QL9i7c7RlgubABBk7aseTrK00roGWeIYEbpblnLyK8Hyd5zrpRDRcX23KoM5XezfGdV8LnX+SWAweE8IF2yUIVPXoZDWOb1PwGG1hjkv9ONh7w1U5WSbPX60P5ty9jgvBdp+J71sDiP3jNyrrYf1HwnOQqNraaHxlV5sHb+ySZDC+Ijzb06sFi45vW5d5kc7C2dL6yS5B6xT3K/SDxjeW40Y9swIhEQxX3cJo8kvf4QL495ZvDSCWyxBtIJ1n3F7nPubF50xQJ2R0RJtKEq3DtQv0wR4P7wsgUpILoll20ThrLcKGYLg6gIzPZwAPs+y7pEu3BRBnXYYyYZ/PNgwV0XEm8BuVdR8dT+5R85JliP6QoY2OsE8Yi6oW69BzR0TCV/oK42eKYMAZ6b+AbNGxFXqMj3lXyTWbCluMAlMB2mH8O8k5wbaki8d6wjdE29ivxFiUtgDOqSJXRBodA7HC9Okn0HP9smebnKwKiRurWy+ed5eat4icVfUvs6O0+TU2HPT1/wMUjN4CIiy8RQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_29\",\"w\":212,\"h\":29,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_30\",\"w\":138,\"h\":139,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_31\",\"w\":195,\"h\":197,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"image_32\",\"w\":252,\"h\":254,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPwAAAD+CAYAAAAeY2hsAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAM60lEQVR4nO3dvXMbxx3G8WePLNyRXdyJ7tIJsovEaozSnfgf+CKRM+5yVpWZFF7XmbHh2rIDVUkXqnMJVlJlkV2azJCdS6InblPgQIEgXu597+X7qWwKPGzz8Lf72707I7RWGNnDfWkgSXGgQSAdSpJzOjLSUd7rOunGGF3c/SDWRJJupavxyF4VGTP8Mr4HgO0WoY4DDcw8yAM3D/Zjj8OaGunCSVfG6MrFugikq59G9mL3r8InAt8gYWSPgkDDQDqS09DNq/eB73FldCnpwhldBLEuXo3sxPeA8AGB9+g0soNZoKFxGkoaqn3hTsVI5066kNNkJk3GI3vje0x9ReBrlFTw464HPIVLSRPjdMYMoF4EvmIvInsso6GkY0mPPA+niaaSJs7oLI51RvWvFoGvQBLyY81D3tcqntcbwl8dAl+S08gOYqNIhLxMb5zR2S/f27HvgXQFgS8gjOxhECg0TpGYrldpKukscBqx9VcMgc/hJLJDZxRK+sr3WHro0hmNmPLnQ+AzeP7ShsbJimreBFNJ45nTiNN/6RH4HcLIHu4Hitx82s7avJleM91Ph8BvQNDbx0jncrLs7W9G4FcQ9PYj+JsR+ARB7x4jnRuniKn+BwRe0slLawl6p72eOVmaez0PfHIibiS67r1gjL67jTXq83ZeLwMfRvZo32jspC98jwW1mzqjqK+n93oV+KV1+re+xwK/+rq+3/M9gLqcRHZojH6V9Mz3WNAIR87o68+eDs1vbycT34OpS+crfBjZwz2jsQg6Nrs2TmEftvE6HfikKTcW3Xek82PSze9sU6+TgU+q+kjc3ILsLgOnsKtr+86t4U8jOzBGE9GBRz4fO6OvnzwdTt+/nbzzPZiydarCJwdo6MCjFEY6v3U67tIUvxOBpzGHCk2N03FXGnqtn9IvTeH/5Hss6KSPZBR2ZYrf6gqfPJDin77Hgd54PXOK2jzFb23gX3xjx6ILj/pdzubr+ivfA8mjdYEPI3u4b3TGOXh4NA2chm3cugt8DyCLMLJHe0YTwg7PDmKj989f2tD3QLJqTdMuac69E7eyoiGMdNy2Zl4rAp88FvpXcUQWDWOkLz/9fPjJ+3eTM99jSaPxgU+mTf+R9JHnoQCbDNoS+kY37dh2Q8s0ftuusYEn7Gipy5nTsKmhb2TgCTtarrGhb1zgCTs6opGhb1TgCTs6pnGhb8zBG8KODnqcPIilMRqxLUfY0WGN2rLzHvjTyA4k/Vvss6O7GhN6r4E/jewgnt/Lzgk6dN3gydPh9fu3E6833HgLfBjZw+TBFX/wNQagTsnZe6+h99KlTx5JNZH02Mf3Ax55vbXWS5c+6VwSdvTRQWw0CSN75OPLaw/8yUtrxZNq0G8He0ZnYWQP6/7iWgP/IrLHPEYakORpj762pl0Y2aNgfk8722/A3KDuB2jU0rSjSQdsFjg9qauJV8uUniYdsFlc43q+8sC/iOyxaNIB2zxK3pxUuUrX8KzbgdT+WMd6vtIKv8+72YHUjNMPyb0llaks8CcvreX58UA2ccVT+0qm9KeRHTjpX1VcG+i4jz97OjS/vZ1Mqrh4JRW+6r9SQJc5p2+rmtqXHvjk6CxbcEABVRXNUqf0YWSPzPylEQCKqWRqX2qF32cqD5TGOX1b9l11pQX++Usb0pUHylV2ES1lSh9G9jAQB2yAChx9+ufh5ft3k/+WcbFSKvyekRUHbIBqGI3KOmtfOPDJGuOvxYcCYINH+4GiMi5UOPA06oDqOaeojAZeocCfRHZIow6oxUGydC6kWIUvYQAAUvuqaJXPHXi24YD6FV1C5w68cVR3oG5O+uIkssO8v58r8M9f2lDSo7xfCqCAAkvpXIGnugP+FKnymQNPdQcaIGeVzxx4qjvgn5O+yHPPfKbAJ9MIqjvQALHJfvouW4Vn3x1oksz78qkDnzynjn13oEH2Mlb51IHPM30AULkwy510qQKfXJC3xwDNcxAEOk774VSBDwKFuYcDoFLGpZ99pwp8lgsCqN3jtFt0OwPPVhzQfGl7bDsD7wzTeaAFjtM077YGnmYd0BqpmndbA5+l+wfAL+MKBj7NBQA0xrNdJ+82Bj6Zzj8re0QAqrNrVr4x8EzngfYxbnuTfWPgmc4DrfR427R+beCZzgPttW12vjbwTOeB9jJOw03/tjbwTOeBVnu26RDOpjX8sLqxAKja3oYMPwh8cnaeN8ECbWbWz9IfVviA6g50wHDdDx8GfsuCH0BrPFq3PXcv8GFkD3luHdANwZrZ+r3A70uZn3MNoJnWbc8FK//34AMAWmu4+oP7gWf9DnTJg3X8vcCzfge6ZW9lmX4X+DzvqQLQbCbYEPhZQMMO6JyVZfpd4I0j8EDXuE1TesOWHNBFB8uNu7vA07ADumm5cRdIUtZXzgJoj+XGXSBJ+9KRt9EAqJRzK4HnhB3QXUa6exhGIEnOaecragC003J/LpDo0ANdt3jk1bzCiwoPdNniTtjFttxjj2MBULFFUQ/SvGIWQLsttuYCHnoB9MfWt8cC6IjkJpog5i45oDeCgA490BtM6YEeWBy+CThlB/RHwCk7oD+Y0gM9QuCBnjiN7IDAAz3hpEMCD/QIgQd6hMADPRKsPrcaQHcFkq58DwJAPQIj3fgeBIB6sIYHeoTAAz1C4IEeIfBAT9xKVwQe6InxyBJ4oE8CGU18DwJAPajwQD9MJQIP9IKRLiQpcPH8PwB0H0drgR5wyT0zTOmBHjAmCfyrkZ34HQqAulDhgT6I59vvgSQZ6dzrYADUggoP9MBi6T4PPKftgC6bLv4jkKSYx1wBnbU4dCMlgQ9iAg90lVsN/K04bQd0lTMfCnogSeORvZF07WtAAKoTxCsVXpIM63igk25Xp/SS6NQD3XSdzOAlLQWeu+aATrqX67vAz2jcAZ1jzIbAj0f2SjTugG6J7y/VV4/WUuWBDlndcr8XeEfjDuiSy+WGnbQS+L2YwAMdMln9wb3A/zSyF1o6aA+gxdyOwCcefAhA+8x2VXiJdTzQEQ/W79KawMexzuoZD4CqGLM+xw8Cz3480H5mQ+He9IgrqjzQXtOkAf/A+sCv6e4BaI2NBXtt4H8e2TOxPQe0k8sY+ATTeqCFkoK91ubAb/krAaCx3mz7x42BZ1oPtI/bsB23sOtFFFR5oD2mv3xvx9s+sD3wTOuBNtmZ162BT6b1HMIBWsA4jXd9Zue75YzZfREA3l2nefX7zsDfxgQeaLq0hXln4Mcje8XrpIFmS1uYU70uOmZaDzTZm+Smt51SBT5p9dO8AxrIOI3SfjZV4CWad0BDpWrWLaQO/G2c/q8IgHo4I5vl86kDnzwu53XWAQGozDTrE6pSB16SZi7bXxMA1TFGo3XPrdsmU+CTTiBVHvBvmmeZnSnwUrrjewCqlae6SzkC/2pkJxzEAfzKewI2c+AlSazlAZ9epz1osypX4KnygDfTmVOU95fzVXhJt05h3t8FkE/etftC7sDTsQdql6szvyx34CX25YE6Fa3ukrRX5Jcv3k1uPns6NJKGRa4DYKfrn3+wx0UvUqjCS3dn7Hm6LVClAo26ZYUDPx7ZG2fKGQyAh4x0vu3lElkUDrw0v1+ebTqgGmXuiJUSeEkyJU05AHxgjL7Le8hmndICn7ye9seyrgdA12U/h6K0wEt323Q8CgsogXEKi27DrSo18OORvTGcwAPK8CbLo6vSKjXw0vycvZjaA0VMZxUVztIDLzG1BwqpYCq/UEngmdoDub0ua899nUoCLzG1B3K4LnLraxqmyotL0otv7IWkx1V/D9B2gdOTZHu7uu+o8uKSFMyn9py1B7YwRt9VHXap4N1yafz2bvL7k6fD341U+E4foIuMdP7qBxvW8V2VV3jp7t10PCwDeOj61tVXDCtfwy9jPQ/cV8e6/d731fVFkjSb/yVjPQ9IckZ/qTPsUs2BH4/sVeB4Og4g6XWy1K1V5U27VUkT75omHvrKSOdlPK4qj1or/AJNPPTYZZ1NulW1V/iF9+8mZ59+PvxE0sDXGICaTQOn419KfKBFVl4q/EJyjPDS5xiAmkwDp2HdTbpVXgM/Htmb2byJR+jRbU6h77BLNe/DbxJG9nDP6ErSge+xAGVzRn/x0ZFfx2uFXxiP7E2yXccePTqlSWGXGlLhF04jO4iNJqLSowOaFnapYYGXCD26oYlhlxoYeInQo92aGnapoYGXCD3aqclhlxoceInQo12aHnapIV36TX4a2YuZ00Ds06Ph2hB2qeEVfiHZp5+Ie+nRPFPjdFzFSyOq0OgKv7B0Iu+N77EAS6aB07AtYZdaUuGXnXxj/ybpS9/jQL85o//N9vT38T/s777HAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADw7f/xHC83LOdlpQAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_33\",\"w\":310,\"h\":312,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAE4CAYAAADRtt/ZAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAANq0lEQVR4nO3dPXYbWXoG4K8wyWQaR3bWDJ1JmZUJE8mZ6MxZcwcGVtA1KyB6BYZWMJxsFLmUMSR3IGUTCtlELAdVoCgKAPFz6xfPcw5PU0Wg6ib9nu/+Vhawp1l+/SYi/lT/c/rkT3+KiDcJHvEtIu6e/PuuvhaLfF4kuD9nIuu6AfTHk+Ca1pfq/2bvOmnQRuXXiPjy/Efw8ZRgO0Oz/Poiqgpr/XMRkb3usk1pZKuIh7uoKr27EHhnS7CN3Cy/Xldgb6r/Tt5ElK86bVTryvuogq6IiLtFPr/b/XmGTrCNTF2NTeMxzMZQiaWWrSIeiqiCrhB04yPYBu5JRTaNiMuI7JdOGzRIPwTdzSKff+m0OZxMsA1QXZVdVj99Gtgfi/JrRNxEVc3ddN0aDifYBqKesbyKiKnuZZuyVcTDTVSVnJAbCMHWY3VlNgtdzJ4QckMh2HqmHjO7qn5UZv31GHILkw/9I9h6YpZfX0YVZh+6bguHKr9GxCIilot8/q3r1iDYOlV3Na+qH13NcSg/RhVwRdctOWeCrQOz/HoaVZj92nFTaEz5NSLyqMbjVHEtE2wtmuXXV1EFmiUaZyNbRTysu6lfum7NuRBsDasnAy4jItfdPHflx4jIBVzzBFtD6kCbRUxm57c3k92MwzVNsCUm0Nhf+TmqCq7ouiVjI9gSmuXXuUDjcLqoqQm2BOpJgdwYGqcRcKkIthPUyzaWAo10HmdRF5aJHE+wHaFeWLu0bIPmZKuIh9kiny+7bskQCbYDfJ8YyH7rui2ci/I+ImYmGA4j2PZU7eWcLE0M0I3yY1QBp3u6B8H2At1O+kP3dF+CbQfLN+in8nNEXJk93U6wbVCfVrt0Hhr9la0iHvJFPl903ZI+EmzPVFWayQGGQvW2iWCr1WNpN6o0hkf19pxgi4hZfj2LmOTG0hi28m9RVW9nP3N61sFWr0tbOo6b8chWEQ+X577u7Q9dN6Ar9QRBEZH9R9dtgYT+GJFdvZ2+z26LT0XXjenKWVZsVdczu+66HdCs8nNEXJ5j1/Ssgk3Xk/Nznl3TSdcNaMuTrqdQ44yUryKy/6t6KefjLCo2+zwh4pz2m44+2IynwVPlfURMxx5uow62WX699O5OeC5bRTxMF/n8ruuWNGWUwVZPEhR2EcA22Sri4WqRz2+6bkkTRjd5UG+NKoQa7FK+isj+Wr+vY3RGtUC3mvmc3EaEdxDAXrLLt9P3/3JbfPp71y1JaTRd0TrUCjOfcIzy4yKfX3XdilRGEWxVOZ39b9ftgGEbz3KQwQebUIOUxrEcZNDBJtSgCcMPt8EGm1CDJg073AYZbEIN2jDccBtcsAk1aNMww21QwSbUoAvDC7fB7DwQatCV7HVEFF234hCDCLbq2CGhBt3JXleHSgxD77uidhRAnwxjh0Kv94oKNeib7M0Q9pb2Nti+Hz0U/9pxU4AfZG/fTt9/vS0+9fY8t152RZ2nBkNQ/ldfz3Pr6+TBUqhB302W9UuSeqd3FZvjvGFIslXEw0Xf1rj1qmKr16oJNRiM8lVEFPXwUW/0JtiqktZaNRie7HVELLpuxVO9mBWt0n5yFxF/7LotwDGyN2+n71e3xafbrlsS0Z+KrbBWDYYuu57l19OuWxHRg2Cb5dcLM6AwFpObPoy3dRps9WTB/3TZBiCl8lVEdL62rbMxtur9n5ObMK4GI5NdvJ2+z26LT0VXLeiyYrsxrgZjlf3W5XhbJ8FmXA3OQXfjba0HW5XixtVg/MpXEbHs4smtjrHV69Vuw7ganIns37tY39Z2xbY0rgbnZpJXk4UtPrGtB9XHe39o63lAX7TfJW2lK1p3QYvQBYUzlV202SVtq2Jb6oLCuWuvS9p4sOmCApX2uqSNdkXrNSw3EVnne8eAPsgu2nhfQtMVWx6R/dLwM4BBmSyaXrjbWLDVB0daiAs8U76Khg+mbLJi69WJmkCfZL82uZe0kWCrjyN618S9gdForPhJPnlQr1n7e1izBuyU/VtTEwlNVGwza9aA/TQzkZA02KrFd9lvKe8JjFn5KiJmqe+aumLLE98PGL3st9Q7EpIFW33OmpcdA8fIU94sZcWWJ7wXcFayX1NWbUmCra7WLO8ATpFs+Ueqii1PdB/gbGUfUi3aPTnYVGtAQnmKm6So2PIE9wCIiOxdiqrtpGBTrQENyE+9wakV28kNAPhR9u7UGdKjg021BjQoP+XLp1RsybdBAFROW9d2VLDVe0K9xwBoUn7sF4+t2I5+IMB+JpfHnvxxcLDV561dHvMwgP2VryLi6phvHlOxXTlvDWjJUWP5xwSbSQOgJdkv1buJD3NQsNUvP/Y6PaBNV4d+4dCK7eAHAJwm+3Do0o+9g80SD6BDV4d8+JCKzUwo0JWrQz58SLCZNAA6ctgkwl7BNsuv35g0ADqWNthCtQZ0Lvt1350IewabnQZAL+yVRS8GW9WvtdMA6IU0wbbvjQCal33Ypzu6R7DphgK98mIm7Qw23VCgh04Ltn1uANCul7ujLwSbbijQSzuzaWuwVS9r0Q0Feum4YHvpiwDdmUx3/nXH33Z+EaA75atdb4zfGGz1EUWvm2oSQAJbe5XbKrZpM+0ASGa67Q/bgs34GtBz2ettJ+tuCbbJtKmmACQ03XTxp2Crzl6zzAMYhOmmi5sqto0fBOih6aaLgg0YsOyXTeNsm4LtTfONAUjmp8z6Idjq9WvebQAMyfT5hecVm2oNGJrdFVsYXwMGJ3v3/IqKDRi8apnad8+C7efkAxiAzcH2PPEABmRrxXbRbjsAktkabCo2YKB+HEYTbMAoPN2BoCsKjMXF+pcnwebEXGDQputfJhFmRIFReHzX6OT5BYCBeizQ1sE27aYdAMlcrH9RsQEj8f1konWwGWMDBm+95GPXC5MBhuYi4jHYbH4HRuEiQsUGjMtFRMTEGjZgbCZhRhQYj2mErigwQpOw1AMYGV1RYESqFR66osDoqNiA0THGBoyOrigwKrP8eirYgNERbMDoCDZgdAQbMDqCDRgdwQaMziS8KBkYmUlEfOm6EQAp6YoCoyPYgNERbMDoCDZgdAQbMDqCDRgdwQaMzTfBBozKIp/fTSKi6LohACmp2IDREWzAiGSrCHtFgVF5uIsQbMAI6YoCY/ItQsUGjEvVFV3k8y8dNwQgqborWs0kAAzc4+RBrGcSAAbucYwNYCyeVmy2VQHDt8jnP1Rs3zpsC0AC5f36t3WwGWMDhu6xQFsH25du2gGQTLH+ZRIRYS0bMAI/VWwRUX7uoiUAiTwOqT1d7mECARiyjcFmAgEYqGy1XuoR8WOwFe03BiCFH3dPPQ22L+02BCCZ4uk/HoOtmhm1GR4YpK0VW9gMDwzUrmAzzgYMTbZ6vhZXsAED93NP83mw6YoCQ1M8v/BDsFXrQL7vkAcYgOL5hU0HTaragCF5sSsaYZwNGIzy/umOgzXBBgxZseniT8FWTZuWX5tuDUACxaaL217msvHDAD1TbLq4LdhummsHQArl503jaxEqNmC4thZgG4OtXs/mRF2gz4ptf9j1wmTdUaCnyq+LfL51ze2uYCvSNwYgiWLXH7cGW5WGln0AvbSzR7mrYnvxywDty1aLfH5SsC3TNQYghYcXC66dwaY7CvRQ8dIHXqrYInRHgd7IVot8vnzpU/sE24s3AWjHy93QiD2CTXcU6JE0wVZbHt8OgBReng1dE2zAQDws9/3kXsFWn9Fm7yjQpeW+H9y3YjvopgBplfe79oY+d0iw3URkqyNaBHCq5SEf3jvYqqOM9ptqBUhseciHD6nYIiIWB34e4ETlx20n5W5zULDVa9pMIgBtOrigOrRiizCJALSm/HzIpMHawcFW7dOyEwFoxfKYLx1TsR39MID9lV/32fC+ybHBtrD0A2jY8tgvHhVsln4AzcpWccIqjGMrtoiI/ITvAuzwsDh0icdTRwdbvX/047HfB9hhecqXT6nYIlRtQHLlx6pwOt5JwaZqAxqQn3qDUyu2JI0AqJxerUUkCDZVG5BQnuImKSq2CFUbcLLy9xTVWkSiYFO1AafJVpGwQEpVsUVE5HYjAMc5bd3ac8mCraraHpzXBhzotF0Gm6Ss2CLsIQUO9jBLWa1FJA62eg/pLOU9gTEr7489wWOX1BXb+ry2+9T3BUapkUIoebDVVG3AC8q/LfJ50cSdGwm2qrGWfwDbZKtosABqqmKLiJiZSAA2e1ikWoy7yR+auvFt8emfb6fv/xmR/WdTzwCGqLxf5PP/bvIJTVZsscjnC6/rA55pfAy+0WCrmUgAauXvTU0YPNV4sNUvWf5L088B+q78Gi0dmJG18ZCIiFl+fReRvW7reUDflH9uo1qLaKcrunbV4rOAXmmnC7rWWrDpksK5aq8LutZaV3RNlxTOTXtd0LU2u6Jrlxbuwrko/9J2qEU0uEB3m9vi07e30/f/iMgu23420KbmF+Ju00XFtj4BxF5SGK1sFRGdFS+dBFtt5ngjGKuHqyb3gr6ks2CrT8y8Mt4GY1P+vsjnN122oPUxtqdui0//MN4GY1LeL/J55/8/d9kVjQjjbTAe3Y6rAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACj9f9rr9GFApOHagAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_34\",\"w\":84,\"h\":8,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAAAICAYAAABnJ9hNAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAACKUlEQVRIie2W0Y3jMAxEHxdbgEpwCe5gU0JKUAm+DlyCSnAJLsHXgUtICe5g7sPDizbIAru4O+zPERAcxZohOaQII2mU1CRNkoqkxl8ySVXS2O2/zC3pIml48v8oqX6SozjHJmnwunw1ls/YK9CAGRiBCzBKmoACrBGxS7r6/c0L73fgAK7AERFNUgGq8aU7zwN3M26NiMPiHMAWEUeHuQCbpKPjbX5eLfYeEas5inFLxzM51ps5BmCQND+Jv0bE4jyuwGo89jt6Fce62e8ALC+dky0iVgOLA2iuZAU2J5crBV58tlisxRy7cb29GbM70AJUB59CF57b8oDFMWzA5JuQ/gpnk6TdOMUpETFzF/dmrox/NleKWbr3mWvmv3HqM3AvWH2NiLyWs6TNATR3zWxwcyXwPhMcusRSjDEirgCSMvG0n1m0TvyNs0taRCx8bOUBC2cXbo67AERE85nMBXfczlm8yr3DB/vOsZTdX70uFuv32Hrid+AUcwLaix1lR2ZQeVUOnndA2p4OfPYAds/jC2eVe3uTdPUIKfazc3bT6nlZUjQLN5oXYy983MVPTdLC/fomdoiIrYs/bXWeexffxvvR1esz+DkD06vBmXh7AGYl8grs3EW8dbOvmjQDmzirWx/4fnCvdu0SwFyDzydX5f0cnzpsFpsu4fTPw++pi2ny2Vs3zpIvb2br8qzG5AzPUdf7xdwz322Slv5L4L/9of2rz5fvsl/MQIGoBnJanwAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_35\",\"w\":99,\"h\":34,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAiCAYAAABLP2dcAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADIklEQVRoge2bu2tTURjAf4nhZonXcmmgYFqkuHgzNFNrBh9bOhUpGh+Lb5wEU3G/RWfTP0Clm1hLBkFMsYiPYtJOcUi6lII1Fy60BL3NkktNHNpcE99WzD3a81uSnO8kfOf88n3nZIgPoGGku6jXr9HgKHAESSd4CxRo1Cd8t248B/A1jHQXH+vPgQEvM9vhnPfdvD7pp16/hhThNRMNI93l32pNEm/Zw8ZGzO91FpLPSBkCIWUIhJQhEFKGQEgZAiFlCISUIRBShkAIJcN2auQsk5xlYju1n85PZjPkLLMDmXWGgNcJtFKsrHEym3Ff61o3U8OjqErwm/O/N/4j0oV5cpbJ1PDotvP8WwhVGU1Wzl3l9fGzlCprzKwsYzs1xuZmiU9PksxmKFZWgc1KUhUF26lx6dnjr+IzK8sksxni05OkC/MATC0tUqyskmyRLgpCymi2Ktj89t8uzJOzyhiDh1GVoLuRecvEdhzG5mYpVlbb4uWqzeVnj4mEVIzBw9wpFXi4tEi8J0JvSCUVG/Jyid9EqDbVZGzuKWZ1nQv6AIm+fu6WCthOzX1cd5y2s6JZCa3xmZVlAIzBQ6hKkOKZKwCUqzblqk28Z2/nF/YThJQxM3Ka+PRk21hUC5OKDbmb2Rva7cZ6QyoAqdgQpcoqtlMjsjX2rmrTG1J5uLSIroU7tobtIGSbUpUgl/QY90pvKFdtLuox8pbJ+MJLrs/NUqysuZsNcGL/ATc+vvCKd9V1En396Fo3yWyGxKP7jC+8QlUUdC1M3jKFPDOEqoyo1s2DrVtOKjbEwZ4IAIm+fp6MnCJvmURCKom+/rb3ndh/AF3rJm+Z6FrYbUFTw6PuNTnes5dISCWqhXkycgrbcTq7uF9AKBmqEmzr5a3Po1qYaEubad6Ovhdvft6X4ppzRUTINvUr5CyTC/qAkAfxdhGqMn4HEX+0/Sn/bGX8j0gZAiFlCISUIRBShkD4gX1eJyHZxA8UvE5CAgQC7/006hNe5yHhhc9IFfxb/w04D3zwOKGdygt2+Y8B+JojDSPdxcZGzLucdiCBwHufkXKPiU/X2iiHO+r5/wAAAABJRU5ErkJggg==\",\"e\":1},{\"id\":\"image_36\",\"w\":99,\"h\":34,\"u\":\"\",\"p\":\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAiCAYAAABLP2dcAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAADjUlEQVRoge2YMUwjRxRA38xaZwkHh4tukSK2sOMiAlsJjnQGKYUD0nGKhKUUkWhS5ChSBek4iqShSnOpQKK3kiKRIuUqqChifFWOxhTAVZwdCRqb4uIIJOt2d1KMMRAcpYpnJeZV9t+/M9/zdv7YFgCp2tqI9MPHCvEJUMQyCP4A9hRivXF/eQdApGprIyJQOyg+NFraLUYp9ahRWPlBSj98bEWYRQixnqqtjchua7KY5W18JqXpKiyXWBkRwsqIEFZGhLAyIoSVESGsjAhhZUQIKyNCGJeh6i1Us226jEhgVsZZB3/lZ4LVX42WERViJicPXxzBUBzV+gtVbyHSLuFvh6iDYzjr9GLO0hyq2SYoVxGJ+L/GSbs483mCje1ejlyY1rtv9wjn2xIAwcY2Iu0ish5BuYqqnyJzYzhLc5CIG1sPozsj3Kohp95DuMOElUMAVKtNWHkJiThysUi4f0JQrmo5Bye66MWilrCxfT2e9fCfbqKa7Z4of/WZlrz7SkuptwgrLxFZD3/1GQDO0gNUvaXHM4gxGarZRjVOEYUMspRHvTi6dt1ZmkNOZZClSdT+8c34fJ5w91UvLheLiJyHOjjB6b52Fotw3gFApO4RVg4JK4cId1jfdN6Bsw7hVg2AcP/k//3Q/4GxNqV29eIH32/1YuEVIRdthnoLRpOX8WYbkXZRjdblogLiImcorq/lPFSj1bsmZycIN/Wiy1K+ly9yHrKQITw4RhpsUWBQRrhZQ85P6qcX8J/8pAWNJmEortvL6DCqcYrzzXzvPt127ukd8PWDG+PK2XGC8nN99jROkTPjuuXNTBCUn+ucmYlubJxwaw+1f6zn6TPeIHHufvXwSyA16InVeQf58AN98AJi7B19eJ534I1PbOVTxFtxnC8+RuY8aOqzJPZ0Ad4EOItF5EfdshNxnQPIfAqZ9eBODGdhGlnK65w7MYSbRBYyiPff1blTGWTWQ9xN6HkuxjOC+NHYznAWpq+9FzkPAQS//K7fp13dpv6BSLs4V+JiNNl3LKcr5ypyduLmeDkP0SfXBEa/2vZDuEnoI4FEHJEdG3xBAyRyMvo9vaB3ROy7zwdczWAx/neI5RIrI0JYGRHCyogQVkaEkBj4wWfpjwT2TBdhARSvpUKsm67DQrVRWN6TjfvLO0qpR8Cfpiu6pVRVTHwGIC4iqdraCD6T5mq6hSheNwrLvWPib8OfSEka1scAAAAAAElFTkSuQmCC\",\"e\":1},{\"id\":\"image_37\",\"w\":577,\"h\":453,\"u\":\"\",\"p\":\"data:image/png;base64,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\",\"e\":1},{\"id\":\"comp_0\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":0,\"nm\":\"Scene 3\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":211.000008594206,\"op\":1111.00004525196,\"st\":211.000008594206,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"Scene 2\",\"refId\":\"comp_3\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":201,\"s\":[100]},{\"t\":211.000008594206,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":110.000004480392,\"op\":1010.00004113814,\"st\":110.000004480392,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_24\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[89.293,34.628,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[72.6,8.077,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 4\",\"refId\":\"image_25\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[402.5,32.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[12.75,12.75,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 20\",\"refId\":\"image_26\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":201,\"s\":[100]},{\"t\":211.000008594206,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218.468,114.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[156.55,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[80,0.486],[0,0],[0,8],[80,8.486]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_26\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218.468,114.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[156.55,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[243,0.458],[324,0.486],[324,8.486],[243,8.458]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 21\",\"refId\":\"image_27\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[201.125,156.75,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[7.375,8,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[0,0,100]},{\"t\":20.0000008146167,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[14.75,0],[0,0],[0,16],[14.75,16]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 22\",\"refId\":\"image_27\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[219.5,156.75,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[25.75,8,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":3,\"s\":[0,0,100]},{\"t\":23.0000009368092,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[14.75,0],[36.75,0.001],[33.25,16],[14.75,16]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_27\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[235.375,156.75,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[41.625,8,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":6,\"s\":[0,0,100]},{\"t\":26.0000010590017,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[51.25,0.001],[36.75,0.001],[33.25,16],[51.25,16.001]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_28\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":5,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":15,\"s\":[100]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[219.264,240.632,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[219.264,210.632,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[71.888,7.935,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"Layer 23\",\"refId\":\"image_29\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":8,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":18,\"s\":[100]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[217.182,273.812,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[217.182,243.812,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[106,7.437,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[212,0],[0,0],[0.057,14.875],[212.057,14.875]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":13,\"ty\":2,\"nm\":\"Layer 10\",\"refId\":\"image_29\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":11,\"s\":[0]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":21,\"s\":[100]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[217.211,288.312,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[217.211,258.312,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[106.029,21.938,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[212.182,31],[0.182,31],[0.057,14.875],[212.057,14.875]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_5\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[375,124],[62,124],[62,306.057],[375,306.057]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":15,\"ty\":4,\"nm\":\"Layer 15 Outlines\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218.5,215.171,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[156.75,91.421,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ef\":[{\"ty\":21,\"nm\":\"Fill\",\"np\":9,\"mn\":\"ADBE Fill\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":10,\"nm\":\"Fill Mask\",\"mn\":\"ADBE Fill-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":0,\"ix\":1}},{\"ty\":7,\"nm\":\"All Masks\",\"mn\":\"ADBE Fill-0007\",\"ix\":2,\"v\":{\"a\":0,\"k\":0,\"ix\":2}},{\"ty\":2,\"nm\":\"Color\",\"mn\":\"ADBE Fill-0002\",\"ix\":3,\"v\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[0.560784339905,0.627451002598,0.694117665291,1]},{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":120,\"s\":[0.670588254929,0.713725507259,0.75686275959,1]},{\"i\":{\"x\":[0.343],\"y\":[1]},\"o\":{\"x\":[0.674],\"y\":[0]},\"t\":197,\"s\":[0.670588254929,0.713725507259,0.75686275959,1]},{\"t\":227.0000092459,\"s\":[0.560784339905,0.627451002598,0.694117665291,1]}],\"ix\":3}},{\"ty\":7,\"nm\":\"Invert\",\"mn\":\"ADBE Fill-0006\",\"ix\":4,\"v\":{\"a\":0,\"k\":0,\"ix\":4}},{\"ty\":0,\"nm\":\"Horizontal Feather\",\"mn\":\"ADBE Fill-0003\",\"ix\":5,\"v\":{\"a\":0,\"k\":0,\"ix\":5}},{\"ty\":0,\"nm\":\"Vertical Feather\",\"mn\":\"ADBE Fill-0004\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Opacity\",\"mn\":\"ADBE Fill-0005\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.343,\"y\":1},\"o\":{\"x\":0.667,\"y\":0},\"t\":197,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-156.5,-91.171],[156.5,-91.171],[156.5,91.171],[-156.5,91.171]],\"c\":true}]},{\"t\":227.0000092459,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[-131.5,-132.062],[131.562,-132.062],[131.562,131.841],[-131.5,131.841]],\"c\":true}]}],\"ix\":2},\"nm\":\"Path 1\",\"mn\":\"ADBE Vector Shape - Group\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.560784313725,0.627450980392,0.694117647059,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[156.75,91.421],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Group 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":17,\"ty\":2,\"nm\":\"Layer 6\",\"refId\":\"image_34\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[332.892,317.31,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[41.996,3.74,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":18,\"ty\":2,\"nm\":\"Layer 18\",\"refId\":\"image_35\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[65,419.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[49.25,16.75,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.167]},\"t\":198,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":203,\"s\":[95,95,100]},{\"t\":208.000008472014,\"s\":[100,100,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":19,\"ty\":2,\"nm\":\"Layer 19\",\"refId\":\"image_36\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[371,419.5,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[49.25,16.75,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.167]},\"t\":93,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":98,\"s\":[95,95,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":103,\"s\":[100,100,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":309,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":314,\"s\":[95,95,100]},{\"t\":319.000012993136,\"s\":[100,100,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":20,\"ty\":0,\"nm\":\"bg\",\"refId\":\"comp_6\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_1\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 2\",\"refId\":\"image_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[120.597,73.396,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[33.68,2.91,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[318.13,74.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[31.044,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 6\",\"td\":1,\"refId\":\"image_3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218.5,215,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[131.876,132.25,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 16\",\"refId\":\"image_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[205.772,117.273,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[8,8.5,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[0,0,100]},{\"t\":20.0000008146167,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[16,0.023],[0,0],[0,17],[16,17.023]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 17\",\"refId\":\"image_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[224.772,117.285,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[27,8.512,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":3,\"s\":[0,0,100]},{\"t\":23.0000009368092,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[16,0.023],[38,0.069],[34.25,17.069],[16,17.023]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[240.896,117.308,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[43.125,8.535,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":6,\"s\":[0,0,100]},{\"t\":26.0000010590017,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[52.75,0.069],[38,0.069],[34.25,17.069],[52.75,17.069]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_5\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":5,\"s\":[0]},{\"t\":15.0000006109625,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[213.402,255.434,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[213.402,225.434,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[92.871,10.185,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 18\",\"refId\":\"image_6\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":8,\"s\":[0]},{\"t\":18.000000733155,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[216.754,288.276,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[216.754,258.276,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[99.5,7.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[199,0],[0,0],[-0.246,15],[198.754,15]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 9\",\"refId\":\"image_6\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":11,\"s\":[0]},{\"t\":21.0000008553475,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[216.631,302.776,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[216.631,272.776,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[99.377,22,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[198.754,31.5],[-0.246,31.5],[-0.246,15],[198.754,15]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":10,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[350.062,82.75],[87,83],[87,347.25],[350.062,347]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"Layer 15\",\"refId\":\"image_11\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[311.215,357.268,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[38.51,3.782,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_2\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 10\",\"refId\":\"image_7\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":16,\"s\":[216.104,592.906,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":46.0000018736184,\"s\":[216.104,400.906,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[104.321,105.202,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 11\",\"refId\":\"image_8\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":13,\"s\":[216.106,592.904,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":43.0000017514259,\"s\":[216.106,400.904,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[147.426,148.674,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 12\",\"refId\":\"image_9\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":10,\"s\":[216.108,592.9,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":40.0000016292334,\"s\":[216.108,400.9,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[190.492,192.104,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 13\",\"refId\":\"image_10\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":7,\"s\":[216.106,592.904,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":37.0000015070409,\"s\":[216.106,400.904,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[234.356,236.34,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_3\",\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 3\",\"refId\":\"image_12\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[344.322,114.306,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[30.111,3.82,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 4\",\"refId\":\"image_13\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[83.387,146.163,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.271,5.271,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":0,\"s\":[0,0,100]},{\"t\":20.0000008146167,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 5\",\"refId\":\"image_14\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[97.288,146.167,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[6.042,6.042,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":3,\"s\":[0,0,100]},{\"t\":23.0000009368092,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":5,\"ty\":2,\"nm\":\"Layer 6\",\"refId\":\"image_15\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[110.419,146.573,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[5.741,5.636,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":6,\"s\":[0,0,100]},{\"t\":26.0000010590017,\"s\":[100,100,100]}],\"ix\":6,\"x\":\"var $bm_rt;\\nvar p = 0.8;\\nvar a = 50;\\nvar s = 1.70158;\\nfunction outBack(t, b, c, d, a, p) {\\n    if (s == null)\\n        s = 1.70158;\\n    return $bm_sum($bm_mul(c, $bm_sum($bm_mul($bm_mul(t = t / d - 1, t), $bm_sum($bm_mul($bm_sum(s, 1), t), s)), 1)), b);\\n}\\nfunction easeAndWizz() {\\n    var t, d, sX, eX, sY, eY, sZ, eZ, val1, val2, val2, val3;\\n    var n = 0;\\n    if (numKeys > 0) {\\n        n = nearestKey(time).index;\\n        if (key(n).time > time) {\\n            n--;\\n        }\\n    }\\n    try {\\n        var key1 = key(n);\\n        var key2 = key($bm_sum(n, 1));\\n    } catch (e) {\\n        return null;\\n    }\\n    var dim = 1;\\n    try {\\n        key(1)[1].length;\\n        dim = 2;\\n        key(1)[2].length;\\n        dim = 3;\\n    } catch (e) {\\n    }\\n    t = $bm_sub(time, key1.time);\\n    d = $bm_sub(key2.time, key1.time);\\n    sX = key1[0];\\n    eX = $bm_sub(key2[0], key1[0]);\\n    if (dim >= 2) {\\n        sY = key1[1];\\n        eY = $bm_sub(key2[1], key1[1]);\\n        if (dim >= 3) {\\n            sZ = key1[2];\\n            eZ = $bm_sub(key2[2], key1[2]);\\n        }\\n    }\\n    if (time < key1.time || time > key2.time) {\\n        return value;\\n    } else {\\n        val1 = outBack(t, sX, eX, d, a, p, s);\\n        switch (dim) {\\n        case 1:\\n            return val1;\\n            break;\\n        case 2:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            return [\\n                val1,\\n                val2\\n            ];\\n            break;\\n        case 3:\\n            val2 = outBack(t, sY, eY, d, a, p, s);\\n            val3 = outBack(t, sZ, eZ, d, a, p, s);\\n            return [\\n                val1,\\n                val2,\\n                val3\\n            ];\\n            break;\\n        default:\\n            return null;\\n        }\\n    }\\n}\\n$bm_rt = easeAndWizz() || value;\"}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":6,\"ty\":2,\"nm\":\"Layer 17\",\"refId\":\"image_16\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":5,\"s\":[0]},{\"t\":15.0000006109625,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[140.751,234.402,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[140.751,204.402,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[61.5,8.875,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[123,0],[0,0],[0.001,17.75],[123.001,17.75]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":7,\"ty\":2,\"nm\":\"Layer 7\",\"refId\":\"image_16\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":8,\"s\":[0]},{\"t\":18.000000733155,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[140.752,253.402,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[140.752,223.402,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[61.501,27.875,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[123.001,39.25],[0.001,39.25],[0.001,17.75],[123.001,17.75]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":8,\"ty\":2,\"nm\":\"Layer 18\",\"refId\":\"image_17\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":11,\"s\":[0]},{\"t\":21.0000008553475,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[138.599,283.046,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[138.599,253.046,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[59.5,4.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[119,0],[0,0],[0.099,9],[119.099,9]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":9,\"ty\":2,\"nm\":\"Layer 8\",\"refId\":\"image_17\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":14,\"s\":[0]},{\"t\":24.00000097754,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[138.623,292.046,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":39.0000015885026,\"s\":[138.623,262.046,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[59.524,13.5,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[119.048,21.5],[0.048,21.5],[0.099,9],[119.099,9]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":11,\"ty\":0,\"nm\":\"Circles\",\"refId\":\"comp_4\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"hasMask\":true,\"masksProperties\":[{\"inv\":false,\"mode\":\"a\",\"pt\":{\"a\":0,\"k\":{\"i\":[[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0]],\"v\":[[356.09,146],[227.946,146],[227.965,279.094],[356.11,279.094]],\"c\":true},\"ix\":1},\"o\":{\"a\":0,\"k\":100,\"ix\":3},\"x\":{\"a\":0,\"k\":0,\"ix\":4},\"nm\":\"Mask 1\"}],\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":12,\"ty\":2,\"nm\":\"Layer 14\",\"refId\":\"image_22\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.167],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[291.694,212.611,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[64.295,66.702,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":14,\"ty\":2,\"nm\":\"Layer 16\",\"refId\":\"image_23\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":0,\"s\":[0]},{\"t\":10.0000004073083,\"s\":[100]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[335.715,317.268,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[38.51,3.782,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_4\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 10\",\"refId\":\"image_18\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[433.848,387.676,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":39.0000015885026,\"s\":[345.848,265.676,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[52.929,52.928,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 11\",\"refId\":\"image_19\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[433.848,387.676,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[345.848,265.676,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[74.408,75.431,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 12\",\"refId\":\"image_20\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[433.848,387.675,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[345.848,265.675,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[95.89,96.912,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 13\",\"refId\":\"image_21\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[433.848,387.676,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[345.848,265.676,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[118.142,119.165,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_5\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 11\",\"refId\":\"image_30\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":9,\"s\":[216.468,467.119,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":39.0000015885026,\"s\":[216.468,355.119,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[68.773,69.354,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":2,\"nm\":\"Layer 12\",\"refId\":\"image_31\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":6,\"s\":[216.468,466.831,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":36.0000014663101,\"s\":[216.468,354.831,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[97.228,98.099,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":2,\"nm\":\"Layer 13\",\"refId\":\"image_32\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":3,\"s\":[216.467,467.119,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":33.0000013441176,\"s\":[216.467,355.119,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[125.682,126.843,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":2,\"nm\":\"Layer 14\",\"refId\":\"image_33\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667],\"y\":[1]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":100,\"s\":[100]},{\"t\":110.000004480392,\"s\":[0]}],\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":0,\"s\":[216.467,467.119,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":30.0000012219251,\"s\":[216.467,355.119,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[154.717,155.879,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]},{\"id\":\"comp_6\",\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_37\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[216.5,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[288.5,226.25,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}]}],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":2,\"nm\":\"Layer 1\",\"refId\":\"image_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.342,\"y\":1},\"o\":{\"x\":0.664,\"y\":0},\"t\":50,\"s\":[488.246,451.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.342,\"y\":0.342},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":80,\"s\":[381.246,426.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.342,\"y\":1},\"o\":{\"x\":0.665,\"y\":0},\"t\":157,\"s\":[381.246,426.315,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.342,\"y\":0.342},\"o\":{\"x\":0.167,\"y\":0.167},\"t\":187,\"s\":[71.496,428.815,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.342,\"y\":1},\"o\":{\"x\":0.667,\"y\":0},\"t\":270,\"s\":[71.496,428.815,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":300.00001221925,\"s\":[381.246,426.315,0]}],\"ix\":2},\"a\":{\"a\":0,\"k\":[32.334,51.592,0],\"ix\":1},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.167]},\"t\":90,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,2.5]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":95,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":100,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":195,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":200,\"s\":[17,17,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":205,\"s\":[20,20,100]},{\"i\":{\"x\":[0.667,0.667,0.667],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":306,\"s\":[20,20,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":311,\"s\":[17,17,100]},{\"t\":316.000012870944,\"s\":[20,20,100]}],\"ix\":6}},\"ao\":0,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":2,\"ty\":0,\"nm\":\"Scene 1\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[218,226,0],\"ix\":2},\"a\":{\"a\":0,\"k\":[218,226,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6}},\"ao\":0,\"w\":436,\"h\":452,\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[]}");




const $e1088e7306747353$export$5faba96a460ce625 = ()=>{
    const { loginViaInvite: loginViaInvite, logout: logout } = (0, $701fdb377a36f454$export$1d39dc5b47e56ff0)();
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    const [searchParams] = (0, $32578012b727878c$export$f1a78c17382fe22a)();
    const [token] = (0, $acw62.useState)(searchParams.get('token') || null);
    const [isTokenValid, setIsTokenValid] = (0, $acw62.useState)(false);
    const [userEmail, setUserEmail] = (0, $acw62.useState)('');
    const [firstNameHasError, setFirstNameHasError] = (0, $acw62.useState)(false);
    const [firstName, setFirstName] = (0, $acw62.useState)('');
    const [lastNameHasError, setLastNameHasError] = (0, $acw62.useState)(false);
    const [lastName, setLastName] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (token) {
            const validateToken = async (token)=>{
                try {
                    const data = await (0, $ee0b2042adda2a3b$export$5ffdd261dd91a68a).validateInviteToken(token);
                    setIsTokenValid(true);
                    setUserEmail(data.email);
                } catch (e) {
                    (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Invitation seems to be invalid.');
                    console.error(e);
                }
            };
            validateToken(token);
        }
    }, [
        token
    ]);
    const handleCreateAccount = async (event)=>{
        event.preventDefault();
        setFirstNameHasError(!firstName);
        setLastNameHasError(!lastName);
        if (!firstName || !lastName || !token) return;
        try {
            logout();
            await loginViaInvite(token, firstName, lastName);
            await navigate('/templates');
        } catch (error) {
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Invitation seems to be invalid.');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen flex flex-row bg-black-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "md:w-2/5 w-full flex flex-col px-24 py-16",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-[400px] h-full flex flex-col justify-evenly",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94d85f23e314daf0$export$7cd68705ae4881ed), {
                            className: "mt-6"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "h-full w-full items-center justify-center flex flex-col gap-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-lg text-white font-normal w-[400px]",
                                    children: [
                                        "Finish creating your account for ",
                                        userEmail
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                    onSubmit: handleCreateAccount,
                                    className: "flex flex-col w-[400px] gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            className: "block text-white text-sm font-normal mb-2",
                                                            htmlFor: "firstNameField",
                                                            children: "First Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                                            id: "firstNameField",
                                                            type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                                            required: true,
                                                            value: firstName,
                                                            onChange: (value)=>{
                                                                setFirstName(value);
                                                            },
                                                            placeholder: "Type Here",
                                                            hasError: firstNameHasError,
                                                            errorMessage: "First name is required"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                            className: "block text-white text-sm font-normal mb-2",
                                                            htmlFor: "lastNameField",
                                                            children: "Last Name"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                                            id: "lastNameField",
                                                            type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                                            required: true,
                                                            value: lastName,
                                                            onChange: (value)=>{
                                                                setLastName(value);
                                                            },
                                                            placeholder: "Type Here",
                                                            hasError: lastNameHasError,
                                                            errorMessage: "Last name is required"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex items-center justify-between mt-2 w-full",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                                type: "submit",
                                                title: "Create Account",
                                                disabled: !isTokenValid,
                                                buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                                buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                                className: "w-full"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-3/5 gradient-background hidden md:block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "min-h-screen flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $beaa087bee1de3c0$export$144901db2ea8e967), {
                        autoPlay: true,
                        interval: 3000,
                        slideTexts: [
                            'Templatize designs from any platform',
                            'Set design rules that cannot be broken',
                            'Review and replace assets when needed'
                        ],
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4), {
                                animData: (0, (/*@__PURE__*/$parcel$interopDefault($fb253e3bb69c91eb$exports)))
                            }, 'slide1'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4), {
                                animData: (0, (/*@__PURE__*/$parcel$interopDefault($b4fcf6714a9caa92$exports)))
                            }, 'slide2'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4), {
                                animData: (0, (/*@__PURE__*/$parcel$interopDefault($2eb6cc606f63d897$exports)))
                            }, 'slide3')
                        ]
                    })
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");














var $acw62 = parcelRequire("acw62");
const $dfdcd69c00591d08$export$992fd9545a24ba0b = ({ onSignIn: onSignIn })=>{
    const [gsiScriptLoaded, setGsiScriptLoaded] = (0, $acw62.useState)(false);
    const [user, setUser] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        if (user?._id || gsiScriptLoaded) return;
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.onload = initializeGsi;
        script.async = true;
        script.id = 'google-client-script';
        document.querySelector('body')?.appendChild(script);
        return ()=>{
            window.google?.accounts.id.cancel();
            document.getElementById('google-client-script')?.remove();
        };
    }, [
        gsiScriptLoaded,
        user?._id
    ]);
    const initializeGsi = ()=>{
        if (!window.google || gsiScriptLoaded) return;
        setGsiScriptLoaded(true);
        window.google?.accounts.id.initialize({
            client_id: "419666866769-ddqrgdtqjhgc5rpsen0834euonvvgo4r.apps.googleusercontent.com" || '',
            callback: handleGoogleSignIn
        });
        window.google?.accounts.id.renderButton(document.querySelector('.g_id_signin'), {
            type: 'standard',
            use_fedcm_for_prompt: true,
            size: 'large',
            theme: 'filled_black',
            text: 'sign_in_with',
            shape: 'rectangular',
            logo_alignment: 'right',
            width: '400'
        });
    };
    const handleGoogleSignIn = async (res)=>{
        if (!res.clientId || !res.credential) return;
        onSignIn?.(res);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        type: "button",
        className: "g_id_signin"
    });
};


const $6a1531be10320632$export$21a94553ffa41578 = ()=>{
    const { login: login } = (0, $701fdb377a36f454$export$1d39dc5b47e56ff0)();
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    const [searchParams] = (0, $32578012b727878c$export$f1a78c17382fe22a)();
    const [token] = (0, $acw62.useState)(searchParams.get('token') || null);
    const [emailSent, setEmailSent] = (0, $acw62.useState)(false);
    const [emailValue, setEmailValue] = (0, $acw62.useState)('');
    const [emailHasError, setEmailHasError] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (token) {
            const tokenLogin = async (token)=>{
                try {
                    await login(token, (0, $e1959a6d31579a72$export$9c339144a54ec389).LOGIN_LINK);
                    await navigate('/templates');
                } catch (e) {
                    (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to login with token');
                    console.error(e);
                }
            };
            tokenLogin(token);
        }
    }, [
        token,
        navigate,
        login
    ]);
    const handleLoginLink = async (event)=>{
        event.preventDefault();
        // validte email using regex
        const emailRegex = '^(?:[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$';
        if (!emailValue || RegExp(emailRegex).test(emailValue) === false) {
            setEmailHasError(true);
            return;
        }
        try {
            await (0, $6e8033ab95c7a58f$export$51b5be145b8f662b).sendLoginLink(emailValue);
        } catch (error) {
            return;
        } finally{
            setEmailSent(true);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen flex flex-row bg-black-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "md:w-2/5 w-full flex flex-col px-24 py-16",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-[400px] h-full flex flex-col justify-evenly",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94d85f23e314daf0$export$7cd68705ae4881ed), {
                            className: "mt-6"
                        }),
                        emailSent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "h-full w-full flex flex-col justify-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-white text-xl",
                                    children: "Check your email!"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "text-gray-40 text-sm font-normal",
                                    children: [
                                        "You will receive a login link on ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-white",
                                            children: emailValue
                                        }),
                                        " if it's connected to Intaglio. Click the link to log in."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Try Again",
                                    className: "mt-4",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    onClick: ()=>{
                                        setEmailValue('');
                                        setEmailSent(false);
                                    }
                                })
                            ]
                        }),
                        !emailSent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "h-full w-full items-center justify-center flex flex-col gap-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-lg text-white font-normal w-[400px]",
                                    children: "Sign in using your work email, or your Google account connected to Intaglio."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dfdcd69c00591d08$export$992fd9545a24ba0b), {
                                    onSignIn: async (creds)=>{
                                        try {
                                            await login(creds.credential, (0, $e1959a6d31579a72$export$9c339144a54ec389).GOOGLE);
                                            await navigate('/templates');
                                        } catch (e) {
                                            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Unable to login with Google');
                                            console.error(e);
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-row items-center mt-2 w-[400px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                            className: "bg-gray-100 border-gray-100 w-full"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-gray-110 mx-2",
                                            children: "Or"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                            className: "bg-gray-100 border-gray-100 w-[400px]"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                    onSubmit: handleLoginLink,
                                    className: "flex flex-col w-[400px] gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                    className: "block text-white text-sm font-normal mb-2",
                                                    htmlFor: "emailField",
                                                    children: "Email Address"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                                    id: "emailField",
                                                    type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Email,
                                                    value: emailValue,
                                                    required: true,
                                                    onChange: (value)=>{
                                                        if (emailHasError) setEmailHasError(false);
                                                        setEmailValue(value);
                                                    },
                                                    placeholder: "Enter Email",
                                                    hasError: emailHasError,
                                                    errorMessage: "Please enter a valid email"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex items-center justify-between mt-2 w-full",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                                type: "submit",
                                                title: "Get Login Link",
                                                buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                                buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                                className: "w-full"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "w-3/5 gradient-background hidden md:block",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "min-h-screen flex items-center justify-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $beaa087bee1de3c0$export$144901db2ea8e967), {
                        autoPlay: true,
                        interval: 3000,
                        slideTexts: [
                            'Templatize designs from any platform',
                            'Set design rules that cannot be broken',
                            'Review and replace assets when needed'
                        ],
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4), {
                                animData: (0, (/*@__PURE__*/$parcel$interopDefault($fb253e3bb69c91eb$exports)))
                            }, 'slide1'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4), {
                                animData: (0, (/*@__PURE__*/$parcel$interopDefault($b4fcf6714a9caa92$exports)))
                            }, 'slide2'),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9caabaa36a6aed$export$cabb5ccfbd60cbd4), {
                                animData: (0, (/*@__PURE__*/$parcel$interopDefault($2eb6cc606f63d897$exports)))
                            }, 'slide3')
                        ]
                    })
                })
            })
        ]
    });
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");













parcelRequire("acw62");
const $488ccafe45063c61$export$b03df4088377e101 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "27",
        height: "26",
        viewBox: "0 0 27 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "SVG White Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19.3359 1V6.33333C19.3359 6.68695 19.4764 7.02609 19.7265 7.27614C19.9765 7.52619 20.3156 7.66667 20.6693 7.66667H26.0026",
                stroke: "white",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M23.3359 25H10.0026C9.29536 25 8.61708 24.719 8.11699 24.219C7.61689 23.7189 7.33594 23.0406 7.33594 22.3333V3.66667C7.33594 2.95942 7.61689 2.28115 8.11699 1.78105C8.61708 1.28095 9.29536 1 10.0026 1H19.3359L26.0026 7.66667V22.3333C26.0026 23.0406 25.7217 23.7189 25.2216 24.219C24.7215 24.719 24.0432 25 23.3359 25Z",
                stroke: "white",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "12.3333",
                width: "14.6667",
                height: "8",
                rx: "0.666667",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2 17.8333C2 18.1093 2.224 18.3333 2.5 18.3333H3.33333C3.51014 18.3333 3.67971 18.263 3.80474 18.138C3.92976 18.013 4 17.8434 4 17.6666V16.9999C4 16.8231 3.92976 16.6535 3.80474 16.5285C3.67971 16.4035 3.51014 16.3333 3.33333 16.3333H2.66667C2.48986 16.3333 2.32029 16.263 2.19526 16.138C2.07024 16.013 2 15.8434 2 15.6666V14.9999C2 14.8231 2.07024 14.6535 2.19526 14.5285C2.32029 14.4035 2.48986 14.3333 2.66667 14.3333H3.5C3.63261 14.3333 3.75979 14.3859 3.85355 14.4797C3.94732 14.5735 4 14.7006 4 14.8333",
                stroke: "#11161C",
                strokeWidth: "0.857143",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6 14.3333L7.33333 18.3333L8.66667 14.3333",
                stroke: "#11161C",
                strokeWidth: "0.857143",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.668 14.3333H12.0013C11.6477 14.3333 11.3085 14.4737 11.0585 14.7238C10.8084 14.9738 10.668 15.313 10.668 15.6666V16.9999C10.668 17.3535 10.8084 17.6927 11.0585 17.9427C11.3085 18.1928 11.6477 18.3333 12.0013 18.3333H12.668V16.9999",
                stroke: "#11161C",
                strokeWidth: "0.857143",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


const $0c417c97818a47bb$export$db0345794bfc14ed = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function $0c417c97818a47bb$export$8cc09085015f0dc7(file, path, h) {
    const f = $0c417c97818a47bb$var$withMimeType(file);
    const { webkitRelativePath: webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') $0c417c97818a47bb$var$setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    $0c417c97818a47bb$var$setObjProp(f, 'relativePath', p);
    return f;
}
function $0c417c97818a47bb$var$withMimeType(file) {
    const { name: name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = $0c417c97818a47bb$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function $0c417c97818a47bb$var$setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value: value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}


const $5cf572b3062ef12c$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $5cf572b3062ef12c$export$a36e16046ae8f1bb(evt) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        if ($5cf572b3062ef12c$var$isObject(evt) && $5cf572b3062ef12c$var$isDataTransfer(evt.dataTransfer)) return $5cf572b3062ef12c$var$getDataTransferFiles(evt.dataTransfer, evt.type);
        else if ($5cf572b3062ef12c$var$isChangeEvt(evt)) return $5cf572b3062ef12c$var$getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return $5cf572b3062ef12c$var$getFsHandleFiles(evt);
        return [];
    });
}
function $5cf572b3062ef12c$var$isDataTransfer(value) {
    return $5cf572b3062ef12c$var$isObject(value);
}
function $5cf572b3062ef12c$var$isChangeEvt(value) {
    return $5cf572b3062ef12c$var$isObject(value) && $5cf572b3062ef12c$var$isObject(value.target);
}
function $5cf572b3062ef12c$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $5cf572b3062ef12c$var$getInputFiles(evt) {
    return $5cf572b3062ef12c$var$fromList(evt.target.files).map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $5cf572b3062ef12c$var$getFsHandleFiles(handles) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file));
    });
}
function $5cf572b3062ef12c$var$getDataTransferFiles(dt, type) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = $5cf572b3062ef12c$var$fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map($5cf572b3062ef12c$var$toFilePromises));
            return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$flatten(files));
        }
        return $5cf572b3062ef12c$var$noIgnoredFiles($5cf572b3062ef12c$var$fromList(dt.files).map((file)=>(0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file)));
    });
}
function $5cf572b3062ef12c$var$noIgnoredFiles(files) {
    return files.filter((file)=>$5cf572b3062ef12c$var$FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $5cf572b3062ef12c$var$fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $5cf572b3062ef12c$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $5cf572b3062ef12c$var$fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $5cf572b3062ef12c$var$fromDirEntry(entry);
    return $5cf572b3062ef12c$var$fromDataTransferItem(item, entry);
}
function $5cf572b3062ef12c$var$flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? $5cf572b3062ef12c$var$flatten(files) : [
                files
            ]
        ], []);
}
function $5cf572b3062ef12c$var$fromDataTransferItem(item, entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $5cf572b3062ef12c$var$fromEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return entry.isDirectory ? $5cf572b3062ef12c$var$fromDirEntry(entry) : $5cf572b3062ef12c$var$fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $5cf572b3062ef12c$var$fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map($5cf572b3062ef12c$var$fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $5cf572b3062ef12c$var$fromFileEntry(entry) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, $0c417c97818a47bb$export$8cc09085015f0dc7)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}




var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};


function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$var$accepts = typeof (0, $000a86df99a95c54$export$2e2bcd8739ae039) === "function" ? (0, $000a86df99a95c54$export$2e2bcd8739ae039) : (0, $000a86df99a95c54$export$2e2bcd8739ae039).default; // Error codes
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
};
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(msg)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
};
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || $aaac53b849ab07d4$var$accepts(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $5cf572b3062ef12c$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $aaac53b849ab07d4$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $aaac53b849ab07d4$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $aaac53b849ab07d4$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $aaac53b849ab07d4$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $aaac53b849ab07d4$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $aaac53b849ab07d4$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $aaac53b849ab07d4$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $aaac53b849ab07d4$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $aaac53b849ab07d4$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $aaac53b849ab07d4$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $aaac53b849ab07d4$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $aaac53b849ab07d4$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $aaac53b849ab07d4$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}




const $8a3463e36227e6c3$export$54dc470bcc5c41d1 = ({ fileTypes: fileTypes, onFilesPicked: onFilesPicked, icon: icon })=>{
    const onDrop = (0, $acw62.useCallback)((acceptedFiles)=>{
        const filesWithUniqueNames = acceptedFiles.map((file)=>{
            const uniqueName = `${file.name.split('.')[0]}-${Date.now()}.${file.name.split('.').pop()}`;
            const newFile = new File([
                file
            ], uniqueName, {
                type: file.type
            });
            return newFile;
        });
        onFilesPicked?.(acceptedFiles);
    }, [
        onFilesPicked
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, acceptedFiles: acceptedFiles, open: open } = (0, $a24044586ed82795$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        accept: fileTypes
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...getRootProps({
            className: 'dropzone'
        }),
        className: "flex flex-col items-center justify-center w-full bg-gray-140 rounded-xl py-16 border-dashed border-[1px] border-gray-100",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                className: "input-zone",
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col gap-1 items-center rounded-[5px]",
                children: [
                    icon ? icon : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94b315f23341d3ba$export$8df90684a752ef81), {
                        className: "w-8 h-8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs font-normal text-white mt-2",
                        children: "Drag and Drop here"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center w-44 text-xs text-gray-100",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "w-full bg-gray-100 border-gray-100"
                            }),
                            " Or",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "w-full bg-gray-100 border-gray-100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                        buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                        buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                        title: "Browse files",
                        onClick: (e)=>{
                            e?.stopPropagation();
                            open();
                        }
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
function $a08ef469b8107069$var$ArrowPathIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    }));
}
const $a08ef469b8107069$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($a08ef469b8107069$var$ArrowPathIcon);
var $a08ef469b8107069$export$2e2bcd8739ae039 = $a08ef469b8107069$var$ForwardRef;



var $acw62 = parcelRequire("acw62");






var $98143630e6f1f4ba$var$FontState = /*#__PURE__*/ function(FontState) {
    FontState[FontState["DEFAULT"] = 0] = "DEFAULT";
    FontState[FontState["SUCCESS"] = 1] = "SUCCESS";
    FontState[FontState["INVALID_FILE"] = 2] = "INVALID_FILE";
    FontState[FontState["NO_MATCHING_FONT"] = 3] = "NO_MATCHING_FONT";
    return FontState;
}($98143630e6f1f4ba$var$FontState || {});
const $98143630e6f1f4ba$export$3b439b29d8e641e = ({ onUploadDone: onUploadDone, isOpen: isOpen, setIsOpen: setIsOpen, fonts: fonts, uploadedFonts: uploadedFonts })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [fontUiStates, setFontStates] = (0, $acw62.useState)({});
    const { mutate: createFontFile } = (0, $1232e344916108aa$export$6cb05837d2a9a681)();
    (0, $acw62.useEffect)(()=>{
        setFontStates((prevFontStates)=>{
            const newFontStates = {};
            for (const font of fonts){
                const fontHash = (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(font);
                const isUploaded = uploadedFonts.some((uploadedFont)=>fontHash === (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(uploadedFont));
                if (isUploaded) newFontStates[fontHash] = 1;
                else newFontStates[fontHash] = prevFontStates[fontHash] || 0;
            }
            return newFontStates;
        });
    }, [
        fonts,
        uploadedFonts
    ]);
    const updateFontState = (font, state)=>{
        setFontStates((prevFontStates)=>{
            const fontHash = (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(font);
            return {
                ...prevFontStates,
                [fontHash]: state
            };
        });
    };
    const handleFileChange = (font, event)=>{
        const file = event?.target?.files?.[0];
        if (file) {
            setIsLoading(true);
            file.arrayBuffer().then((arrBuf)=>{
                (0, $44052192468fac4a$export$f7c62c73429afa28)((res)=>{
                    const etcherSession = res.sessionId;
                    (0, $44052192468fac4a$export$672089c3debc1182)(etcherSession, arrBuf, (newFonts)=>{
                        if (newFonts.length === 0) {
                            updateFontState(font, 2);
                            setIsLoading(false);
                            return;
                        }
                        const fontHash = (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(font);
                        const hasMatchingFont = newFonts.some((newFont)=>fontHash === (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(newFont));
                        if (!hasMatchingFont) {
                            updateFontState(font, 3);
                            setIsLoading(false);
                            return;
                        }
                        createFontFile(file, {
                            onSuccess: ()=>{
                                setIsLoading(false);
                                for (const f of newFonts)onUploadDone?.(f);
                            }
                        });
                        (0, $44052192468fac4a$export$d855ee81853de6d2)(etcherSession);
                    });
                });
            });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-64 w-[30vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col justify-between p-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl text-white",
                            children: "The template uses fonts that are currently not available in your organization."
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white mt-1",
                            children: "To ensure the design remains intact, upload the missing fonts first."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col p-4 gap-2",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-gray-100",
                            children: [
                                "Missing Fonts (",
                                fonts.length,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex flex-col max-h-[25vh] overflow-y-auto no-scrollbar bg-gray-140 rounded-md",
                            children: fonts.map((font)=>{
                                const fileInputRef = /*#__PURE__*/ (0, $acw62.createRef)();
                                const fontHash = (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(font);
                                const uiState = fontUiStates[fontHash];
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col w-full px-3 py-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white",
                                            children: [
                                                font.family,
                                                font.style,
                                                font.weight
                                            ].join(' ')
                                        }),
                                        uiState === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            disabled: isLoading,
                                            className: "flex flex-row items-center gap-1.5 w-full py-1 text-blue-30 text-xs",
                                            onClick: ()=>fileInputRef.current?.click(),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94b315f23341d3ba$export$8df90684a752ef81), {
                                                    className: "h-4 w-4 stroke-blue-30"
                                                }),
                                                "Upload Font"
                                            ]
                                        }),
                                        uiState === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row items-center gap-1.5 w-full py-1 text-green-60 text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                                    className: "h-4 w-4 stroke-green-60"
                                                }),
                                                "Font Ready"
                                            ]
                                        }),
                                        uiState === 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row items-center gap-1.5 w-full py-1 text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: " text-red-50",
                                                    children: "Invalid Font File"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "flex flex-row items-center gap-1.5 text-blue-30",
                                                    onClick: ()=>fileInputRef.current?.click(),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a08ef469b8107069$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 stroke-blue-30"
                                                        }),
                                                        "Retry"
                                                    ]
                                                })
                                            ]
                                        }),
                                        uiState === 3 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-row items-center gap-1.5 w-full py-1 text-xs",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: " text-red-50",
                                                    children: "No Matching Font"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                    type: "button",
                                                    className: "flex flex-row items-center gap-1.5 text-blue-30",
                                                    onClick: ()=>fileInputRef.current?.click(),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a08ef469b8107069$export$2e2bcd8739ae039), {
                                                            className: "h-4 w-4 stroke-blue-30"
                                                        }),
                                                        "Retry"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            id: `${font.family}-${font.style}-${font.weight}`,
                                            type: "file",
                                            accept: "font/*",
                                            ref: fileInputRef,
                                            onChange: (e)=>{
                                                handleFileChange(font, e);
                                            },
                                            multiple: false,
                                            style: {
                                                display: 'none'
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                            className: "bg-gray-100 border-gray-120 opacity-20 mt-1"
                                        })
                                    ]
                                }, (0, $80cc0c4c52b399e2$export$9fe2dde95a9fb521)(font));
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "mt-2 bg-gray-100 border-gray-120"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-full flex flex-row justify-end gap-3 p-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Cancel",
                                    className: "hover:bg-gray-160",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    onClick: ()=>{
                                        setIsOpen(false);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Continue",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: uploadedFonts.length !== fonts.length,
                                    onClick: ()=>{
                                        setIsOpen(false);
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



const $a4e62830fccc337c$export$59e180a7e419c107 = ({ isOpen: isOpen, onFrameAdded: onFrameAdded, prevCount: prevCount, setIsOpen: setIsOpen, templateVersionId: templateVersionId })=>{
    const [files, setFiles] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isAddingFrames, setIsAddingFrames] = (0, $acw62.useState)(false);
    const [isMissingFontModalOpen, setIsMissingFontModalOpen] = (0, $acw62.useState)(false);
    const [missingFonts, setMissingFonts] = (0, $acw62.useState)([]);
    const [uploadedFonts, setUploadedFonts] = (0, $acw62.useState)([]);
    const [progressMap, setProgressMap] = (0, $acw62.useState)({});
    const addFrames = async ()=>{
        if (files.length === 0) return;
        const fileIds = files.map((file)=>({
                name: file.name,
                id: progressMap[file.name]?.file?.id
            })).map((f, index)=>({
                template_version: templateVersionId,
                svg_file: f.id ?? -1,
                name: f.name
            }));
        setIsAddingFrames(true);
        await (0, $2a781f80f599a2ae$export$cad58da5ead13057).createVariants(fileIds);
        (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Frames added successfully');
        setIsAddingFrames(false);
        setIsOpen(false);
        onFrameAdded?.();
    };
    const uploadFile = (0, $acw62.useCallback)(async (file)=>{
        if (progressMap[file.name]?.isUploaded || progressMap[file.name]?.xhr) return;
        const xhr = await (0, $9550621969846473$export$da5e64576956de1f).uploadSVGFile(file, (event)=>{
            if (event.lengthComputable) {
                const progress = Math.round(event.loaded / event.total * 100);
                setProgressMap((prev)=>({
                        ...prev,
                        [file.name]: {
                            progress: progress,
                            error: false,
                            isUploaded: false,
                            xhr: xhr,
                            file: null
                        }
                    }));
            }
        }, (event)=>{
            if (xhr.status === 201) setProgressMap((prev)=>({
                    ...prev,
                    [file.name]: {
                        progress: 100,
                        error: false,
                        isUploaded: true,
                        xhr: xhr,
                        file: JSON.parse(xhr.responseText)
                    }
                }));
            else {
                setProgressMap((prev)=>({
                        ...prev,
                        [file.name]: {
                            progress: 0,
                            error: true,
                            isUploaded: false,
                            xhr: xhr,
                            file: null
                        }
                    }));
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Failed to upload, double check the file and try again');
            }
        });
    }, [
        progressMap
    ]);
    (0, $acw62.useEffect)(()=>{
        const filesToUpload = files.filter((file)=>!progressMap[file.name]?.isUploaded);
        const uploadFiles = async ()=>{
            for (const file of filesToUpload)if (!progressMap[file.name]?.isUploaded) await uploadFile(file);
        };
        if (filesToUpload.length > 0) uploadFiles();
    }, [
        files,
        progressMap,
        uploadFile
    ]);
    (0, $acw62.useEffect)(()=>{
        if (missingFonts.filter((f)=>!uploadedFonts.some((uf)=>uf.family === f?.family && uf.weight === f?.weight && uf.style === f?.style)).length > 0) setIsMissingFontModalOpen(true);
    }, [
        missingFonts,
        uploadedFonts
    ]);
    const handleCancel = ()=>{
        setIsOpen(false);
        setFiles([]);
        setProgressMap({});
        for (const file of files){
            const xhr = progressMap[file.name]?.xhr;
            if (xhr) xhr.abort();
        }
    };
    const handleAddFrames = async ()=>{
        let missingFonts = files.flatMap((file)=>progressMap[file.name]?.file?.missing_fonts).filter((f)=>!uploadedFonts.some((uf)=>uf.family === f?.family && uf.weight === f?.weight && uf.style === f?.style));
        missingFonts = missingFonts.filter((value, index)=>{
            const _value = JSON.stringify(value);
            return index === missingFonts.findIndex((obj)=>{
                return JSON.stringify(obj) === _value;
            });
        });
        if (missingFonts.length > 0) {
            setMissingFonts(missingFonts.filter((font)=>font !== undefined));
            return;
        }
        await addFrames();
        setFiles([]);
        setIsOpen(false);
    };
    const handleCancelFileUpload = (file)=>{
        const xhr = progressMap[file.name]?.xhr;
        if (xhr) xhr.abort();
        setFiles(files.filter((f)=>f.name !== file.name));
    };
    const handleDeleteFile = (file)=>{
        setFiles(files.filter((f)=>f.name !== file.name));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
                isOpen: isOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col overflow-hidden absolute min-w-96 min-h-[50vh] max-h-[90vh] w-[38vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between p-6 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xl text-white",
                                    children: "Upload Frames"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                                    onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-100"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col p-6 flex-1 min-h-0 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a3463e36227e6c3$export$54dc470bcc5c41d1), {
                                    fileTypes: {
                                        'image/svg+xml': [
                                            '.svg'
                                        ]
                                    },
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $488ccafe45063c61$export$b03df4088377e101), {
                                        className: "w-14 h-14"
                                    }),
                                    onFilesPicked: async (selectedFiles)=>{
                                        setFiles((prev)=>[
                                                ...prev,
                                                ...selectedFiles.filter((file)=>!prev.some((f)=>f.name === file.name))
                                            ]);
                                    }
                                }),
                                files.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col flex-1 min-h-0 mt-6 overflow-y-auto gap-4 no-scrollbar",
                                    children: files.map((file, index)=>{
                                        const fileSizeUploaded = file.size * (progressMap[file.name]?.progress || 0) / 100;
                                        const fileSizeUploadedWithUnit = fileSizeUploaded > 1048576 ? `${(fileSizeUploaded / 1048576).toFixed(2)} MB` : `${(fileSizeUploaded / 1024).toFixed(2)} KB`;
                                        const fileSizeTotal = file.size > 1048576 ? `${(file.size / 1048576).toFixed(2)} MB` : `${(file.size / 1024).toFixed(2)} KB`;
                                        const progress = progressMap[file.name]?.progress || 0;
                                        const isUploaded = progressMap[file.name]?.isUploaded || false;
                                        const error = progressMap[file.name]?.error || false;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col rounded-md w-full bg-gray-140 p-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row w-full items-center mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $488ccafe45063c61$export$b03df4088377e101), {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-col justify-center ml-3 w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-row justify-between items-center w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm font-normal text-white",
                                                                            children: file.name.length > 50 ? `${file.name.slice(0, 25)}...${file.name.slice(-25)}` : file.name
                                                                        }),
                                                                        !isUploaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>handleCancelFileUpload(file),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                                                                className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30"
                                                                            })
                                                                        }),
                                                                        isUploaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>handleDeleteFile(file),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                                                                                className: "stroke-red-50"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-xxs text-gray-60",
                                                                    children: [
                                                                        fileSizeUploadedWithUnit,
                                                                        " of ",
                                                                        fileSizeTotal,
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-bold text-gray-40 mr-2 ml-2",
                                                                            children: "\xb7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: `${error ? 'text-red-60' : isUploaded ? 'text-green-60' : 'text-gray-60'}`,
                                                                            children: error ? 'Upload Error' : isUploaded ? 'Completed' : 'Uploading'
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex flex-row h-1.5 bg-gray-100 rounded-lg w-full",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "h-1.5 bg-blue-60 rounded-lg",
                                                        style: {
                                                            width: isUploaded ? '100%' : `${progress}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        }, `${file.name}-${file.size}-${file.lastModified}`);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "mt-2 bg-gray-100 border-gray-100"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-full flex flex-row justify-end gap-3 p-6 h-[88px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Cancel",
                                    className: "hover:bg-gray-160",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: isLoading,
                                    onClick: handleCancel
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Add Frames",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    isLoading: isAddingFrames,
                                    disabled: files.length === 0 || files.some((file)=>!progressMap[file.name]?.isUploaded) || isLoading,
                                    onClick: handleAddFrames
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98143630e6f1f4ba$export$3b439b29d8e641e), {
                fonts: missingFonts,
                uploadedFonts: uploadedFonts,
                onUploadDone: (font)=>{
                    setUploadedFonts((prev)=>[
                            ...prev,
                            font
                        ]);
                },
                isOpen: isMissingFontModalOpen,
                setIsOpen: setIsMissingFontModalOpen
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");






var $2df9454648380129$export$ed12481c953b8653 = /*#__PURE__*/ function(FieldType) {
    FieldType["Text"] = "text";
    FieldType["Image"] = "image";
    return FieldType;
}({});



























var $9ddb60e45a57b2a0$export$ad496c2c9edf09a4 = /*#__PURE__*/ function(EditorViewMode) {
    EditorViewMode["List"] = "list";
    EditorViewMode["Grid"] = "grid";
    return EditorViewMode;
}({});
var $9ddb60e45a57b2a0$export$29a261eca00055f9 = /*#__PURE__*/ function(FieldsPanelView) {
    FieldsPanelView["Default"] = "default";
    // Text
    FieldsPanelView["TextFieldEdit"] = "text_field_edit";
    FieldsPanelView["TextLayerEdit"] = "text_layer_edit";
    FieldsPanelView["TextLayerLink"] = "text_layer_link";
    // Image
    FieldsPanelView["ImageFieldEdit"] = "image_field_edit";
    FieldsPanelView["ImageLayerEdit"] = "image_layer_edit";
    FieldsPanelView["ImageLayerLink"] = "image_layer_link";
    return FieldsPanelView;
}({});
var $9ddb60e45a57b2a0$export$551ff448b1eb3ef1 = /*#__PURE__*/ function(LayerType) {
    LayerType["Text"] = "text";
    LayerType["Image"] = "image";
    return LayerType;
}({});
function $9ddb60e45a57b2a0$export$dda0b6f9ad25b04(fieldType) {
    switch(fieldType){
        case (0, $2df9454648380129$export$ed12481c953b8653).Text:
            return "text";
        case (0, $2df9454648380129$export$ed12481c953b8653).Image:
            return "image";
        default:
            throw new Error(`Unsupported field type: ${fieldType}`);
    }
}


const $e0acbec19c12fb9c$export$3956fa95edbebd53 = (0, $af9e91ea6e32034a$exports.create)()((0, $5ec635760157368f$export$5c593627aef9f076)((0, $6901b3de930503c1$export$428de7ec69ac95c)((set)=>({
        currentVariantIndex: 0,
        editorViewMode: (0, $9ddb60e45a57b2a0$export$ad496c2c9edf09a4).List,
        fieldsPanelView: (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default,
        fieldsPanelWidth: 360,
        highlightedLayer: null,
        editedFieldData: null,
        editedFieldId: null,
        selectedLayer: null,
        template: null,
        svgFiles: {},
        setCurrentVariantIndex: (index)=>set({
                currentVariantIndex: index
            }),
        setEditorViewMode: (mode)=>set({
                editorViewMode: mode
            }),
        setFields: (fields)=>{
            set((state)=>{
                if (state.template) state.template.latestVersion.fields = fields;
                return state;
            });
        },
        setFieldsPanelView: (view)=>set({
                fieldsPanelView: view
            }),
        setHighlightedLayer: (layer)=>set({
                highlightedLayer: layer
            }),
        setEditedFieldData: (field)=>set({
                editedFieldData: field
            }),
        setEditedFieldId: (id)=>set({
                editedFieldId: id
            }),
        setSelectedLayer: (layer)=>set({
                selectedLayer: layer
            }),
        setTemplateTags: (tags)=>{
            set((state)=>{
                if (state.template) state.template.tags = tags;
                return state;
            });
        },
        addSvgFile: (url, svgFile)=>{
            set((state)=>{
                state.svgFiles = {
                    ...state.svgFiles,
                    [url]: svgFile
                };
                return state;
            });
        },
        setTemplate: (template)=>set({
                template: template
            }),
        setIsEdited: ()=>set((state)=>{
                if (state.template) state.template.latestVersion.isEdited = true;
            })
    }))));






var $acw62 = parcelRequire("acw62");
function $6ce8445650392f52$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
        clipRule: "evenodd"
    }));
}
const $6ce8445650392f52$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($6ce8445650392f52$var$TrashIcon);
var $6ce8445650392f52$export$2e2bcd8739ae039 = $6ce8445650392f52$var$ForwardRef;


parcelRequire("acw62");



parcelRequire("acw62");
const $ec5715f534981f20$export$5068802198d106bd = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Document Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_4334_6804)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M11.6666 2.5V5.83333C11.6666 6.05435 11.7544 6.26631 11.9107 6.42259C12.067 6.57887 12.2789 6.66667 12.5 6.66667H15.8333",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M14.1666 17.5H5.83329C5.39127 17.5 4.96734 17.3244 4.65478 17.0118C4.34222 16.6993 4.16663 16.2754 4.16663 15.8333V4.16667C4.16663 3.72464 4.34222 3.30072 4.65478 2.98816C4.96734 2.67559 5.39127 2.5 5.83329 2.5H11.6666L15.8333 6.66667V15.8333C15.8333 16.2754 15.6577 16.6993 15.3451 17.0118C15.0326 17.3244 14.6087 17.5 14.1666 17.5Z",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 7.5H8.33333",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 10.833H12.5",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 14.167H12.5",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_4334_6804",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};




parcelRequire("acw62");
const $4fd7436a47c881db$export$5ecba4fa11723cf6 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Picture Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_1568_3658)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12.5 6.66663H12.51",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M2.5 5C2.5 4.33696 2.76339 3.70107 3.23223 3.23223C3.70107 2.76339 4.33696 2.5 5 2.5H15C15.663 2.5 16.2989 2.76339 16.7678 3.23223C17.2366 3.70107 17.5 4.33696 17.5 5V15C17.5 15.663 17.2366 16.2989 16.7678 16.7678C16.2989 17.2366 15.663 17.5 15 17.5H5C4.33696 17.5 3.70107 17.2366 3.23223 16.7678C2.76339 16.2989 2.5 15.663 2.5 15V5Z",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M2.66797 13.3333L6.83463 9.16665C7.60797 8.42248 8.5613 8.42248 9.33463 9.16665L13.5013 13.3333",
                        stroke: "white",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M12 11.4998L12.4993 10.8333C13.2727 10.0891 14.226 10.0891 14.9993 10.8333L17.4993 13.3333",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_1568_3658",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};



parcelRequire("acw62");
const $f4610b495d4375c7$export$4a7d2a945910cc57 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Text Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_1568_3667)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M9.16797 12.998H10.8346",
                        stroke: "white",
                        strokeWidth: "1.2",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10 13.0013V7.16797",
                        stroke: "white",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 8.0013V7.16797H12.5V8.0013",
                        stroke: "white",
                        strokeWidth: "1.2",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M16.5866 1.96094H3.41185C2.74419 1.96094 2.20492 2.50588 2.21191 3.1735L2.35345 16.6935C2.36034 17.3513 2.89555 17.8809 3.55339 17.8809H16.445C17.1029 17.8809 17.6381 17.3513 17.645 16.6935L17.7865 3.1735C17.7935 2.50588 17.2542 1.96094 16.5866 1.96094Z",
                        stroke: "white",
                        strokeWidth: "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_1568_3667",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};






parcelRequire("acw62");



const $b7d148c77fdb7375$export$d59ace3569612be2 = ({ field: field, quickAction: quickAction, button: button, linkedLayers: linkedLayers, onClick: onClick })=>{
    return(// biome-ignore lint/a11y/useKeyWithClickEvents: needs improvement for accessibility
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `bg-gray-130 rounded align-top flex flex-col gap-2 transition-opacity ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-3 rounded align-top flex flex-row gap-2",
                children: [
                    field.type === (0, $2df9454648380129$export$ed12481c953b8653).Image ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fd7436a47c881db$export$5ecba4fa11723cf6), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4610b495d4375c7$export$4a7d2a945910cc57), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col text-sm text-white w-full",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: field.name
                            }),
                            linkedLayers
                        ]
                    }),
                    quickAction
                ]
            }),
            button && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-3 pb-3 w-full flex flex-row",
                children: button
            })
        ]
    }));
};



parcelRequire("acw62");

parcelRequire("acw62");
const $277c689232f42f22$export$cd5641a207362f73 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Layer Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "2.79844",
                y: "2.80027",
                width: "11.2",
                height: "11.2",
                rx: "1.2",
                stroke: "white",
                strokeWidth: "0.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.72699 7.03748V6.32754H10.0719V7.03748H8.825V10.4003H7.97386V7.03748H6.72699Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "16",
                height: "16",
                rx: "3.2",
                fill: "#32EAA7"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                clipPath: "url(#clip0_1570_9013)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                    clipPath: "url(#clip1_1570_9013)",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M6 10L10 6",
                            stroke: "#192028",
                            strokeWidth: "0.8",
                            strokeLinecap: "square",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M7.33594 4.00041L7.6446 3.64307C8.26981 3.01796 9.11773 2.66681 10.0018 2.66687C10.8859 2.66693 11.7338 3.0182 12.3589 3.64341C12.9841 4.26861 13.3352 5.11653 13.3351 6.00064C13.3351 6.88475 12.9838 7.73263 12.3586 8.35774L12.0026 8.66707",
                            stroke: "#192028",
                            strokeWidth: "0.8",
                            strokeLinecap: "square",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M8.66416 11.9998L8.39949 12.3558C7.76699 12.9813 6.91335 13.332 6.02382 13.332C5.1343 13.332 4.28066 12.9813 3.64816 12.3558C3.3364 12.0475 3.08889 11.6805 2.91996 11.2759C2.75104 10.8713 2.66406 10.4372 2.66406 9.9988C2.66406 9.56036 2.75104 9.12629 2.91996 8.7217C3.08889 8.31712 3.3364 7.95006 3.64816 7.6418L3.99749 7.33313",
                            stroke: "#192028",
                            strokeWidth: "0.8",
                            strokeLinecap: "square",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: "clip0_1570_9013",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: "clip1_1570_9013",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    });
};


const $fefae429da777b46$export$9319993eb57b55e8 = ({ linkedLayers: linkedLayers })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: linkedLayers && linkedLayers.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-row items-center gap-1 mt-2",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $277c689232f42f22$export$cd5641a207362f73), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "flex flex-col text-xs text-green",
                    children: [
                        linkedLayers.length,
                        " Layer",
                        linkedLayers.length > 1 ? 's' : ''
                    ]
                })
            ]
        })
    });
};


const $9d097b84a14210ae$export$a937454cfc93e41e = ()=>{
    const fields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.fields);
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    const setFields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFields);
    const setFieldsPanelView = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFieldsPanelView);
    const setEditedFieldId = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setEditedFieldId);
    const setTemplateEdited = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setIsEdited);
    const { mutate: deleteField } = (0, $3205bad321c9d9e6$export$39416e8dff3fda6f)({
        onSuccess: (_, id)=>{
            const newFields = fields?.filter((f)=>f.id !== id) || [];
            setFields(newFields);
            setTemplateEdited();
        }
    });
    const onCreateTextField = ()=>setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextFieldEdit);
    const onCreateImageField = ()=>setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).ImageFieldEdit);
    const onEditField = (field)=>{
        setEditedFieldId(field.id);
        setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextFieldEdit);
    };
    const onDeleteField = (field)=>{
        if (window.confirm(`Are you sure you want to delete the field "${field.name}"?`)) deleteField(field.id);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 flex-grow-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec5715f534981f20$export$5068802198d106bd), {
                                className: "w-5 h-5 text-white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-base text-white font-medium",
                                children: "Content Fields"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                            className: "w-5 h-5 text-white hover:text-gray-30 cursor-pointer"
                        }),
                        items: [
                            {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4610b495d4375c7$export$4a7d2a945910cc57), {}),
                                name: 'Text Field',
                                onClick: onCreateTextField,
                                id: 'Text Field'
                            },
                            {
                                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fd7436a47c881db$export$5ecba4fa11723cf6), {}),
                                name: 'Image Field',
                                onClick: onCreateImageField,
                                id: 'Image Field'
                            }
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "h-full px-4",
                children: fields && fields.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex flex-col gap-2 overflow-y-scroll",
                    children: fields.map((field)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                            field: field,
                            linkedLayers: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fefae429da777b46$export$9319993eb57b55e8), {
                                linkedLayers: field.linkedLayers
                            }),
                            onClick: ()=>onEditField(field),
                            quickAction: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ce8445650392f52$export$2e2bcd8739ae039), {
                                className: "size-4 mt-1 stroke-red-50 cursor-pointer",
                                onClick: (e)=>{
                                    onDeleteField(field);
                                    e.stopPropagation();
                                }
                            })
                        }, field.id))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col justify-center items-center h-full",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-50 ",
                            children: "Start creating your first"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-2 items-center mt-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4610b495d4375c7$export$4a7d2a945910cc57), {}),
                                    title: "Text Field",
                                    onClick: onCreateTextField
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-gray-100 text-xs",
                                    children: "or"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fd7436a47c881db$export$5ecba4fa11723cf6), {}),
                                    title: "Image Field",
                                    onClick: onCreateImageField
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("acw62");





const $52a3034debf5e1c2$export$1c0e81db696eca60 = ({ onClose: onClose })=>{
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    const handleSave = ()=>{};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-white font-medium",
                        children: "New Image Field"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Cancel",
                        className: "text-white text-xs font-normal h-5",
                        type: "button",
                        onClick: ()=>onClose(),
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "h-full px-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-white",
                                    children: "Field Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                    id: "imageFieldName",
                                    type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                    value: "",
                                    onChange: ()=>{},
                                    placeholder: "Enter Image Field Name"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-white",
                                    children: "Layers"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-2 bg-blue-60 bg-opacity-20",
                                    onClick: ()=>{},
                                    onKeyUp: (e)=>{
                                        e.key === 'Enter' || e.key;
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-xs text-blue-30",
                                        children: "Select an image layer in each frame. "
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                                    showMenu: true,
                                    showLinkButton: false,
                                    isImage: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Done",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            onClick: handleSave
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("acw62");




const $e5b0fa4f8ee5f7b7$export$b352c10ec5579eb5 = ({ layer: layer, onClose: onClose, onCreateField: onCreateField, onLinkField: onLinkField })=>{
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    // TODO: Fetch field associated with the layer
    const field = null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-white font-medium",
                        children: "Image Layer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Cancel",
                        className: "text-white text-xs font-normal h-5",
                        type: "button",
                        onClick: ()=>onClose(),
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "h-full px-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white font-semibold",
                            children: "Details"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col gap-1 w-[130px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Dimensions"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Position"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col gap-1 w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: "W 300px H 150 px"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: "X 125 Y 125"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-100 w-full"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-white font-semibold",
                                    children: "Content Field"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: `text-sm ${field?.linked ? 'text-green' : 'text-gray-110'} font-semibold`,
                                    children: field?.linked ? 'Linked' : 'Not Linked'
                                })
                            ]
                        }),
                        field?.linked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                            showMenu: false,
                            showLinkButton: false,
                            isImage: true
                        }),
                        field?.linked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Unlink",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                            onClick: ()=>{}
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Link to Image Field",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            onClick: ()=>onLinkField()
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("acw62");




const $62936777db5cfe12$export$e612a1930b9bb9fb = ({ onClose: onClose, onCreateField: onCreateField })=>{
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-white font-medium",
                        children: "Link with Image Field"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Done",
                        className: "text-white text-xs font-normal h-5",
                        type: "button",
                        onClick: ()=>{
                            onClose();
                        },
                        children: "Done"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "h-full px-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                title: "Create New Image Field",
                                className: "w-full",
                                buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                onClick: ()=>onCreateField()
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-100 w-full"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white font-semibold",
                            children: "Image Fields"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                            showMenu: true,
                            showLinkButton: true,
                            isImage: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                            showMenu: true,
                            showLinkButton: true,
                            isImage: true
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                            showMenu: true,
                            showLinkButton: true,
                            isImage: true
                        })
                    ]
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


const $61b2e175e61b40cd$export$ea5f704b89d806f6 = ({ checked: checked, className: className, description: description, label: label, onChange: onChange })=>{
    const iconSize = 22;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex flex-row items-start gap-2 ${className || ''}`,
        "aria-checked": checked,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "cursor-pointer",
                onClick: ()=>onChange(!checked),
                onKeyDown: ()=>onChange(!checked),
                children: checked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f87e2995c0ae886d$export$7dd004358974b05d), {
                    size: iconSize,
                    title: label
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $430181ea01cc3dc6$export$30d0dc241a918823), {
                    size: iconSize,
                    title: label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col w-full item",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-white",
                        children: label
                    }),
                    description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-xs text-gray-110 mt-1",
                        children: description
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");
var $acc626a49418fcae$exports = {};

$parcel$export($acc626a49418fcae$exports, "counter", () => $acc626a49418fcae$export$e575061ef2a070eb, (v) => $acc626a49418fcae$export$e575061ef2a070eb = v);
var $acc626a49418fcae$export$e575061ef2a070eb;
$acc626a49418fcae$export$e575061ef2a070eb = `nMmPBG_counter`;


const $e2c3cd25491f02d7$export$1b74141c5fe63a28 = ({ className: className, disabled: disabled, max: max = Number.POSITIVE_INFINITY, min: min = Number.NEGATIVE_INFINITY, onChange: onChange, value: value })=>{
    const setValue = (rawValue)=>{
        if (disabled) return;
        let value = typeof rawValue === 'string' ? Number.parseInt(rawValue, 10) : rawValue;
        if (Number.isNaN(value)) return;
        value = value < min ? Math.max(value, min) : Math.min(value, max);
        onChange?.(value);
    };
    const decrement = ()=>value > min && setValue(value - 1);
    const increment = ()=>value < max && setValue(value + 1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `flex flex-row items-center p-[1px] bg-gray-100 rounded-md ${disabled ? 'opacity-50' : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "bg-gray-150 w-7 text-xl text-white px-2 rounded-tl-md rounded-bl-md",
                onClick: decrement,
                children: "-"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "number",
                value: value,
                onChange: (e)=>setValue(e.target.value),
                className: `border-none outline-none bg-gray-100 w-10 py-1 px-1 text-white text-center text-sm ${className} ${(0, (/*@__PURE__*/$parcel$interopDefault($acc626a49418fcae$exports))).counter}`
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "bg-gray-150 w-7 text-xl text-white px-2 rounded-tr-md rounded-br-md",
                onClick: increment,
                children: "+"
            })
        ]
    });
};









parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $beefe28644f6e8ce$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    }));
}
const $beefe28644f6e8ce$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($beefe28644f6e8ce$var$TrashIcon);
var $beefe28644f6e8ce$export$2e2bcd8739ae039 = $beefe28644f6e8ce$var$ForwardRef;




const $89c4e718aca68921$export$d914031c54e1e2ae = ({ layer: layer, onEdit: onEdit, onDelete: onDelete })=>{
    const varirants = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.variants);
    const getVariantName = (variantId)=>{
        const variant = varirants?.find((v)=>v.id === variantId);
        return variant?.name || '';
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "bg-gray-130 rounded align-top flex flex-col gap-2",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-gray-130 p-3 rounded align-top flex flex-row gap-2 items-start",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $277c689232f42f22$export$cd5641a207362f73), {
                    className: "flex-shrink-0 size-4 mt-1"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col text-sm text-white flex-grow min-w-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "truncate",
                            children: layer.name
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xs text-gray-110 mt-1",
                            children: getVariantName(layer.variant)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $beefe28644f6e8ce$export$2e2bcd8739ae039), {
                    className: "flex-shrink-0 size-4 mt-1 stroke-red-50 cursor-pointer",
                    onClick: onDelete,
                    onKeyDown: onDelete
                })
            ]
        })
    });
};


const $a77b48b006189ba1$var$CHAR_LIMIT_DEFAULT_VALUE = 120;
const $a77b48b006189ba1$var$CHAR_LIMIT_MAX_VALUE = 1000;
const $a77b48b006189ba1$export$f5e5b2f8d9e5797c = ({ field: field })=>{
    const fields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.fields);
    const templateVersionId = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.id);
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    const setFields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFields);
    const setFieldsPanelView = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFieldsPanelView);
    const setEditedFieldData = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setEditedFieldData);
    const setEditedFieldId = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setEditedFieldId);
    const setTemplateEdited = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setIsEdited);
    const [name, setName] = (0, $acw62.useState)(field?.name || '');
    const [linkedLayers, setLinkedLayers] = (0, $acw62.useState)(field?.linkedLayers || []);
    const [autoTextScaling, setAutoTextScaling] = (0, $acw62.useState)(field?.properties.autoTextScaling || false);
    const [enableCharLimit, setEnableCharLimit] = (0, $acw62.useState)(field?.properties?.charLimit && field?.properties?.charLimit > 0 || false);
    const [charLimit, setCharLimit] = (0, $acw62.useState)(field?.properties.charLimit || $a77b48b006189ba1$var$CHAR_LIMIT_DEFAULT_VALUE);
    const { mutate: createField } = (0, $3205bad321c9d9e6$export$dedb17a472ec9063)({
        onSuccess: (data)=>{
            syncLinkedLayers(data.id).then((updatedLayers)=>{
                data.linkedLayers = updatedLayers;
                setFields([
                    ...fields || [],
                    data
                ]);
                setTemplateEdited();
                closeView();
            });
        }
    });
    const { mutate: updateField } = (0, $3205bad321c9d9e6$export$68dc441545c63e86)({
        onSuccess: (data)=>{
            syncLinkedLayers(data.id).then((updatedLayers)=>{
                data.linkedLayers = updatedLayers;
                const newFields = fields?.map((f)=>f.id === data.id ? data : f) || [];
                setFields(newFields);
                setTemplateEdited();
                closeView();
            });
        }
    });
    const { mutateAsync: createLinkedLayer } = (0, $98e5698f5c571300$export$b38a330f0ab1cd0a)();
    const { mutateAsync: deleteLinkedLayer } = (0, $98e5698f5c571300$export$33896a2e5f59f05e)();
    const syncLinkedLayers = async (fieldId)=>{
        const originalLinkedLayers = field?.linkedLayers || [];
        const newLinkedLayers = linkedLayers.filter((l)=>!originalLinkedLayers.find((ol)=>ol.layerUuid === l.layerUuid));
        const deleteLinkedLayers = originalLinkedLayers.filter((ol)=>!linkedLayers.find((l)=>l.layerUuid === ol.layerUuid));
        const insertRequests = Promise.all(newLinkedLayers.map(async (_layer)=>{
            // Create a new object to avoid weird mutation issues likely due to Zustand use of proxies
            const layer = Object.assign({}, _layer);
            layer.field = fieldId;
            return createLinkedLayer(layer, {
                onSuccess: ()=>setTemplateEdited()
            });
        }));
        const removeRequests = Promise.all(deleteLinkedLayers.map(async (layer)=>deleteLinkedLayer(layer.id, {
                onSuccess: ()=>setTemplateEdited()
            })));
        return await Promise.all([
            insertRequests,
            removeRequests
        ]).then((data)=>{
            const newLinkedLayersData = data[0];
            return originalLinkedLayers.concat(newLinkedLayersData).filter((l)=>!deleteLinkedLayers.find((dl)=>dl.id === l.id));
        });
    };
    const getEditedFieldData = (0, $acw62.useCallback)(()=>{
        return {
            id: field?.id,
            name: name,
            type: (0, $2df9454648380129$export$ed12481c953b8653).Text,
            templateVersion: templateVersionId,
            linkedLayers: linkedLayers,
            properties: {
                autoTextScaling: autoTextScaling,
                charLimit: enableCharLimit ? charLimit : 0
            }
        };
    }, [
        autoTextScaling,
        charLimit,
        enableCharLimit,
        field,
        linkedLayers,
        name,
        templateVersionId
    ]);
    const handleNameChange = (val)=>{
        setName(val);
    };
    const handleAutoTextScalingChange = (val)=>{
        setAutoTextScaling(val);
    };
    const handleCharLimitChange = (val)=>{
        setCharLimit(val);
    };
    const handleSave = ()=>{
        const editedField = getEditedFieldData();
        editedField.linkedLayers = undefined;
        editedField.id ? updateField(editedField) : createField(editedField);
    };
    const handleLayerDeletion = (layer)=>{
        setLinkedLayers(linkedLayers.filter((l)=>l.layerUuid !== layer.layerUuid));
    };
    const handleLayerSelection = (0, $acw62.useCallback)((selectedLayer, lastSelectedLayer)=>{
        if (selectedLayer && selectedLayer !== lastSelectedLayer && !linkedLayers.find((l)=>l.layerUuid === selectedLayer.id || l.variant === selectedLayer.variantId)) {
            const textProps = selectedLayer.props;
            const linkedLayer = {
                field: 0,
                variant: selectedLayer.variantId,
                layerUuid: selectedLayer.id,
                initialValue: textProps.text,
                name: textProps.text.substring(0, 255),
                posX: selectedLayer.rect.x,
                posY: selectedLayer.rect.y,
                width: selectedLayer.rect.width,
                height: selectedLayer.rect.height,
                fontFamily: textProps.fontFamily,
                fontWeight: textProps.fontWeight,
                fontStyle: textProps.fontStyle,
                fontSize: textProps.fontSize,
                lineHeight: (0, $80cc0c4c52b399e2$export$63ad841d70774900)(textProps.lineHeight, 2),
                fill: textProps.fill
            };
            setLinkedLayers([
                ...linkedLayers,
                linkedLayer
            ]);
        }
    }, [
        linkedLayers
    ]);
    const isFieldValid = ()=>{
        if (!name || name.length === 0) return false;
        if (linkedLayers.length === 0) return false;
        if (enableCharLimit && (charLimit <= 0 || charLimit > $a77b48b006189ba1$var$CHAR_LIMIT_MAX_VALUE)) return false;
        return true;
    };
    const closeView = ()=>{
        setEditedFieldId(null);
        setEditedFieldData(null);
        setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default);
    };
    (0, $acw62.useEffect)(()=>{
        const initState = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53).getState();
        handleLayerSelection(initState.selectedLayer, null);
        return (0, $e0acbec19c12fb9c$export$3956fa95edbebd53).subscribe((s)=>s.selectedLayer, handleLayerSelection);
    }, [
        handleLayerSelection
    ]);
    // update edited field data when field prop changes
    (0, $acw62.useEffect)(()=>{
        setEditedFieldData(getEditedFieldData());
    }, [
        getEditedFieldData,
        setEditedFieldData
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4610b495d4375c7$export$4a7d2a945910cc57), {
                                className: "w-5 h-5 text-white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-base text-white font-medium",
                                children: "New Text Field"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Cancel",
                        className: "text-white text-xs font-normal h-5",
                        type: "button",
                        onClick: closeView,
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-col gap-3 h-full px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-white",
                                children: "Field Name"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                id: "fieldName",
                                type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                value: name,
                                onChange: handleNameChange,
                                placeholder: "Enter Text Field Name"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-white",
                                children: "Layers"
                            }),
                            !linkedLayers.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "p-2 bg-blue-60 bg-opacity-20",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs text-blue-30",
                                    children: "Select a text layer from any frame"
                                })
                            }),
                            linkedLayers.map((layer)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89c4e718aca68921$export$d914031c54e1e2ae), {
                                    layer: layer,
                                    onEdit: ()=>{},
                                    onDelete: ()=>handleLayerDeletion(layer)
                                }, layer.layerUuid))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-white",
                                children: "Style Control"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61b2e175e61b40cd$export$ea5f704b89d806f6), {
                                className: "mt-2",
                                label: "Enable Text Scaling",
                                description: "Automatically reduce font size if content does not fit text box.",
                                checked: autoTextScaling,
                                onChange: handleAutoTextScalingChange
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-row justify-between items-center mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $61b2e175e61b40cd$export$ea5f704b89d806f6), {
                                        label: "Set Character Limit",
                                        checked: enableCharLimit,
                                        onChange: setEnableCharLimit
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2c3cd25491f02d7$export$1b74141c5fe63a28), {
                                        disabled: !enableCharLimit,
                                        defaultValue: $a77b48b006189ba1$var$CHAR_LIMIT_DEFAULT_VALUE,
                                        min: 1,
                                        max: $a77b48b006189ba1$var$CHAR_LIMIT_MAX_VALUE,
                                        value: charLimit,
                                        onChange: handleCharLimitChange
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                        title: "Done",
                        disabled: !isFieldValid(),
                        className: "mt-2",
                        buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                        onClick: handleSave
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");









const $ab3fa3dfe8487646$export$781d2cc689900ba3 = ({ layer: layer })=>{
    const textLayerProps = layer.props;
    const fields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.fields);
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    const setSelectedLayer = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setSelectedLayer);
    const setFields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFields);
    const setFieldsPanelView = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFieldsPanelView);
    const { mutate: deleteLinkedLayer } = (0, $98e5698f5c571300$export$33896a2e5f59f05e)();
    const linkedField = fields ? fields.find((f)=>f.linkedLayers?.find((l)=>l.layerUuid === layer.id)) : null;
    const handleUnlinkField = ()=>{
        if (!linkedField || !fields) return; // should never happen, keeping typescript happy
        const linkedLayer = linkedField.linkedLayers?.find((l)=>l.layerUuid === layer.id);
        if (linkedLayer) deleteLinkedLayer(linkedLayer.id, {
            onSuccess: ()=>{
                const updatedFields = fields.map((f)=>{
                    const field = window.structuredClone(f);
                    if (f.id === linkedField.id) {
                        const linkedLayers = f.linkedLayers?.filter((l)=>l.layerUuid !== linkedLayer.layerUuid);
                        field.linkedLayers = linkedLayers;
                    }
                    return field;
                });
                setFields(updatedFields);
                closeView();
            }
        });
    };
    const handleLinkField = ()=>{
        setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextLayerLink);
    };
    const handleNewField = ()=>{
        setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextFieldEdit);
    };
    const closeView = ()=>{
        setSelectedLayer(null);
        setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4610b495d4375c7$export$4a7d2a945910cc57), {
                                className: "w-5 h-5 text-white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-base text-white font-medium",
                                children: "Text Layer"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Cancel",
                        className: "text-white text-xs font-normal h-5",
                        type: "button",
                        onClick: closeView,
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "h-full px-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white font-semibold",
                            children: "Details"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col gap-1 w-[130px]",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Dimensions"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Position"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Font"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Font Size"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Font Weight"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Font Style"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Fill"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-gray-110 ",
                                            children: "Line Height"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col gap-1 w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-white ",
                                            children: [
                                                "W ",
                                                (0, $80cc0c4c52b399e2$export$63ad841d70774900)(layer.rect.width, 2),
                                                "px H ",
                                                (0, $80cc0c4c52b399e2$export$63ad841d70774900)(layer.rect.height, 2),
                                                "px"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-sm text-white ",
                                            children: [
                                                "X ",
                                                (0, $80cc0c4c52b399e2$export$63ad841d70774900)(layer.rect.x),
                                                " Y ",
                                                (0, $80cc0c4c52b399e2$export$63ad841d70774900)(layer.rect.y)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: textLayerProps.fontFamily
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: textLayerProps.fontSize
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: textLayerProps.fontWeight
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: textLayerProps.fontStyle
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: textLayerProps.fill
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white ",
                                            children: (0, $80cc0c4c52b399e2$export$63ad841d70774900)(textLayerProps.lineHeight, 2)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-100 w-full"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-white font-semibold",
                                    children: "Content Field"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: `text-sm ${linkedField ? 'text-green' : 'text-gray-110'} font-semibold`,
                                    children: linkedField ? 'Linked' : 'Not Linked'
                                })
                            ]
                        }),
                        linkedField ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                            field: linkedField,
                            linkedLayers: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fefae429da777b46$export$9319993eb57b55e8), {
                                linkedLayers: linkedField.linkedLayers
                            }),
                            button: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                title: "Unlink",
                                buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                className: "w-full",
                                onClick: handleUnlinkField
                            })
                        }) : fields && fields.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Link to Text Field",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            onClick: handleLinkField
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                            title: "Create New Text Field",
                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                            onClick: handleNewField
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("acw62");








const $a5576c2d52f67711$export$da515b7e23a9525b = ({ layer: layer })=>{
    const fields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.fields);
    const width = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    const setFields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFields);
    const setFieldsPanelView = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFieldsPanelView);
    const setTemplateEdited = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setIsEdited);
    const { mutate: createLinkedLayer } = (0, $98e5698f5c571300$export$b38a330f0ab1cd0a)();
    const handleNewField = ()=>{
        setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextFieldEdit);
    };
    const handleLinkField = (field)=>{
        const textProps = layer.props;
        createLinkedLayer({
            field: field.id,
            variant: layer.variantId,
            layerUuid: layer.id,
            name: textProps.text.substring(0, 255),
            initialValue: textProps.text,
            posX: layer.rect.x,
            posY: layer.rect.y,
            width: layer.rect.width,
            height: layer.rect.height,
            fontFamily: textProps.fontFamily,
            fontWeight: textProps.fontWeight,
            fontStyle: textProps.fontStyle,
            fontSize: textProps.fontSize,
            lineHeight: (0, $80cc0c4c52b399e2$export$63ad841d70774900)(textProps.lineHeight, 2),
            fill: textProps.fill
        }, {
            onSuccess: (data)=>{
                if (!fields) throw new Error('Unexpected missing fields');
                const updatedFields = fields?.map((f)=>{
                    const updatedField = window.structuredClone(f);
                    if (f.id === field.id) {
                        updatedField.linkedLayers = updatedField.linkedLayers || [];
                        updatedField.linkedLayers.push(data);
                    }
                    return updatedField;
                });
                setFields(updatedFields);
                setTemplateEdited();
                setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextLayerEdit);
            }
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
        className: "pr-4 py-4 h-full flex-shrink-0 overflow-y-auto",
        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
        width: width,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "flex flex-row justify-between items-center px-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row gap-2 items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f4610b495d4375c7$export$4a7d2a945910cc57), {
                                className: "w-5 h-5 text-white"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-base text-white font-medium",
                                children: "Link with Text Field"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        title: "Cancel",
                        className: "text-white text-xs font-normal h-5",
                        type: "button",
                        onClick: ()=>setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default),
                        children: "Cancel"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                className: "h-full px-4",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white font-semibold mt-2",
                            children: "Text Fields"
                        }),
                        fields?.map((field)=>{
                            const isLinked = field.linkedLayers?.some((l)=>l.variant === layer.variantId);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7d148c77fdb7375$export$d59ace3569612be2), {
                                field: field,
                                linkedLayers: isLinked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-gray-60 my-2",
                                    children: "Already linked to a text layer on this frame."
                                }),
                                button: !isLinked ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Link",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    className: "w-full",
                                    onClick: ()=>handleLinkField(field)
                                }) : null
                            }, field.id);
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col gap-3 mt-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Create New Text Field",
                                    className: "w-full",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    onClick: handleNewField
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Done",
                                    className: "w-full",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    onClick: ()=>setFieldsPanelView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


const $d8286a6df1f01b60$export$9c944d4866fff1e8 = ()=>{
    const editedFieldId = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.editedFieldId);
    const fields = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.fields);
    const selectedLayer = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.selectedLayer);
    const view = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelView);
    const setView = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setFieldsPanelView);
    const setDefaultMode = ()=>{
        setView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default);
    };
    const setCreateMode = (type)=>{
        switch(type){
            case (0, $2df9454648380129$export$ed12481c953b8653).Text:
                setView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextFieldEdit);
                break;
            case (0, $2df9454648380129$export$ed12481c953b8653).Image:
                setView((0, $9ddb60e45a57b2a0$export$29a261eca00055f9).ImageFieldEdit);
                break;
        }
    };
    const setLinkMode = (type)=>{};
    let viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {});
    let redirectView = view;
    switch(view){
        case (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextFieldEdit:
            viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a77b48b006189ba1$export$f5e5b2f8d9e5797c), {
                field: fields?.find((f)=>f.id === editedFieldId) || null
            });
            break;
        case (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextLayerEdit:
            if (selectedLayer) viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3fa3dfe8487646$export$781d2cc689900ba3), {
                layer: selectedLayer
            });
            else redirectView = (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default;
            break;
        case (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextLayerLink:
            if (selectedLayer) {
                const linkedField = fields ? fields.find((f)=>f.linkedLayers?.find((l)=>l.layerUuid === selectedLayer.id)) : null;
                if (!linkedField) {
                    viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a5576c2d52f67711$export$da515b7e23a9525b), {
                        layer: selectedLayer
                    });
                    break;
                }
            }
            redirectView = (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default;
            break;
        case (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).ImageFieldEdit:
            viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52a3034debf5e1c2$export$1c0e81db696eca60), {
                onClose: setDefaultMode
            });
            break;
        case (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).ImageLayerEdit:
            if (selectedLayer) viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5b0fa4f8ee5f7b7$export$b352c10ec5579eb5), {
                layer: selectedLayer,
                onClose: setDefaultMode,
                onCreateField: ()=>setCreateMode((0, $2df9454648380129$export$ed12481c953b8653).Image),
                onLinkField: ()=>setLinkMode((0, $2df9454648380129$export$ed12481c953b8653).Image)
            });
            else redirectView = (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).Default;
            break;
        case (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).ImageLayerLink:
            viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $62936777db5cfe12$export$e612a1930b9bb9fb), {
                onClose: setDefaultMode,
                onCreateField: ()=>setCreateMode((0, $2df9454648380129$export$ed12481c953b8653).Image)
            });
            break;
        default:
            if (selectedLayer) switch(selectedLayer.type){
                case (0, $9ddb60e45a57b2a0$export$551ff448b1eb3ef1).Text:
                    redirectView = (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).TextLayerEdit;
                    break;
                case (0, $9ddb60e45a57b2a0$export$551ff448b1eb3ef1).Image:
                    redirectView = (0, $9ddb60e45a57b2a0$export$29a261eca00055f9).ImageLayerEdit;
                    break;
            }
            else // Default view
            viewContent = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d097b84a14210ae$export$a937454cfc93e41e), {});
            break;
    }
    (0, $acw62.useEffect)(()=>{
        setView(redirectView);
    }, [
        redirectView,
        setView
    ]);
    return viewContent;
};






parcelRequire("acw62");



parcelRequire("acw62");
const $54aa10b98fbe62ba$export$fa17e9a974485717 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Grid Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.40625 4.16732C3.40625 3.9463 3.49405 3.73434 3.65033 3.57806C3.80661 3.42178 4.01857 3.33398 4.23958 3.33398H7.57292C7.79393 3.33398 8.00589 3.42178 8.16217 3.57806C8.31845 3.73434 8.40625 3.9463 8.40625 4.16732V7.50065C8.40625 7.72166 8.31845 7.93363 8.16217 8.08991C8.00589 8.24619 7.79393 8.33398 7.57292 8.33398H4.23958C4.01857 8.33398 3.80661 8.24619 3.65033 8.08991C3.49405 7.93363 3.40625 7.72166 3.40625 7.50065V4.16732Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.7422 4.16732C11.7422 3.9463 11.83 3.73434 11.9863 3.57806C12.1425 3.42178 12.3545 3.33398 12.5755 3.33398H15.9089C16.1299 3.33398 16.3418 3.42178 16.4981 3.57806C16.6544 3.73434 16.7422 3.9463 16.7422 4.16732V7.50065C16.7422 7.72166 16.6544 7.93363 16.4981 8.08991C16.3418 8.24619 16.1299 8.33398 15.9089 8.33398H12.5755C12.3545 8.33398 12.1425 8.24619 11.9863 8.08991C11.83 7.93363 11.7422 7.72166 11.7422 7.50065V4.16732Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M3.40625 12.4993C3.40625 12.2783 3.49405 12.0664 3.65033 11.9101C3.80661 11.7538 4.01857 11.666 4.23958 11.666H7.57292C7.79393 11.666 8.00589 11.7538 8.16217 11.9101C8.31845 12.0664 8.40625 12.2783 8.40625 12.4993V15.8327C8.40625 16.0537 8.31845 16.2657 8.16217 16.4219C8.00589 16.5782 7.79393 16.666 7.57292 16.666H4.23958C4.01857 16.666 3.80661 16.5782 3.65033 16.4219C3.49405 16.2657 3.40625 16.0537 3.40625 15.8327V12.4993Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.7422 12.4993C11.7422 12.2783 11.83 12.0664 11.9863 11.9101C12.1425 11.7538 12.3545 11.666 12.5755 11.666H15.9089C16.1299 11.666 16.3418 11.7538 16.4981 11.9101C16.6544 12.0664 16.7422 12.2783 16.7422 12.4993V15.8327C16.7422 16.0537 16.6544 16.2657 16.4981 16.4219C16.3418 16.5782 16.1299 16.666 15.9089 16.666H12.5755C12.3545 16.666 12.1425 16.5782 11.9863 16.4219C11.83 16.2657 11.7422 16.0537 11.7422 15.8327V12.4993Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};




parcelRequire("acw62");
const $417444549d036587$export$230671d7ba50d3c8 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "List Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M2.875 4.66667C2.875 4.22464 3.05059 3.80072 3.36316 3.48816C3.67572 3.17559 4.09964 3 4.54167 3H15.5417C15.9837 3 16.4076 3.17559 16.7202 3.48816C17.0327 3.80072 17.2083 4.22464 17.2083 4.66667V14.6667C17.2083 15.1087 17.0327 15.5326 16.7202 15.8452C16.4076 16.1577 15.9837 16.3333 15.5417 16.3333H4.54167C4.09964 16.3333 3.67572 16.1577 3.36316 15.8452C3.05059 15.5326 2.875 15.1087 2.875 14.6667V4.66667Z",
                stroke: "#8E8D93",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.04297 3V16.3333",
                stroke: "#8E8D93",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};






const $2c5dc5a0ac94f108$export$e2b0760399e6dece = ()=>{
    const fieldsPanelWidth = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.fieldsPanelWidth);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col min-h-0 h-screen w-full bg-black-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                type: (0, $b3f317f73d7705c5$export$9baf8232abef7d17).LIGHT,
                leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {}),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                            className: "w-32 h-5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-0.5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "py-1 px-2 rounded-md bg-gray-100",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $417444549d036587$export$230671d7ba50d3c8), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "py-1 px-2 rounded-md",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54aa10b98fbe62ba$export$fa17e9a974485717), {})
                                })
                            ]
                        })
                    ]
                }),
                center: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "bg-blue-60 h-9 w-28 rounded"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex min-h-0 flex-row h-full max-w-full min-w-full",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        className: "pl-4 py-4 h-full w-64 flex-shrink-0 flex-grow-0",
                        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-white text-base",
                                        children: "Untitled Template"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-40 h-5 mt-1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "bg-blue-60 h-11 w-full mt-4 rounded flex items-center justify-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94b315f23341d3ba$export$8df90684a752ef81), {
                                            className: "h-5 w-5 stroke-white"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                            className: "bg-white opacity-70 w-20 h-3"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: " px-4 flex flex-col gap-2 h-full max-h-full min-h-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-20 h-5 mt-4"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-full bg-black-50 h-40 rounded "
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-row items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                                className: "w-24 h-5"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-gray-90 text-xs",
                                                children: "1024 x 1024"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "w-full h-full flex flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a11906f52e293a19$export$a55cbd7077614be3), {
                                className: "w-16 h-16"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-gray-60 text-2xl",
                                children: "Setting up your template..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                        className: "pr-4 py-4 h-full w-80 flex-shrink-0 flex-grow-0",
                        type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                        width: fieldsPanelWidth,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "px-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-row items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                            className: "w-32 h-5"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                            className: "h-5 w-5 text-white"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                className: "flex flex-col items-center justify-center gap-2 h-full max-h-full min-h-0",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-[80%] h-5"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4c7625211ce832c$export$8f31e4c4a37b8e9c), {
                                        className: "w-[60%] h-5"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");
const $b904f7be4bfe30f3$export$51b6cd98f8778f0d = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "12",
        height: "14",
        viewBox: "0 0 12 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Copy Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "3.5",
                y: "5",
                width: "8",
                height: "8",
                rx: "1"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.5 4V2C8.5 1.44772 8.05228 1 7.5 1H1.5C0.947715 1 0.5 1.44772 0.5 2V8C0.5 8.55228 0.947715 9 1.5 9H2.5"
            })
        ]
    });
};




parcelRequire("acw62");
const $cea6b6c33f45e51f$export$7260929c376dfc01 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Info Warn Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_4011_5416)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10 5V2.5",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.5391 6.45573L15.3307 4.66406",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M15 10H17.5",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M13.5391 13.5391L15.3307 15.3307",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10 15V17.5",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.45573 13.5391L4.66406 15.3307",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M5 10H2.5",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6.45573 6.45573L4.66406 4.66406",
                        stroke: "#FFA25F",
                        strokeLinecap: "square",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_4011_5416",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};




parcelRequire("acw62");
const $6cf9e2fe7ee656af$export$e6c98715275d28b = ({ className: className, size: size = 18, title: title = '' })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_4011_5270)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10Z",
                        fill: "#32EAA7",
                        stroke: "#32EAA7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6 10L8.5 12.5L13.5 7.5",
                        stroke: "#11161C",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_4011_5270",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};




const $2a0799c1d5f6f802$export$a7932105fec13fb9 = ({ onCancel: onCancel, onPublish: onPublish, template: template, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [shareMail, setShareMail] = (0, $acw62.useState)('');
    const { mutate: publishTemplate } = (0, $181035219bfd394d$export$b0413934fb19e7d1)({
        onSuccess: ()=>{
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Template published successfully');
            setIsLoading(false);
            onPublish?.();
        },
        onError: ()=>{
            (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Failed to publish template');
            setIsLoading(false);
        }
    });
    const shareTemplate = ()=>async ()=>{
            if (shareMail) {
                setIsLoading(true);
                await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).shareTemplate(template.id, shareMail);
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Mail sent successfully');
                setShareMail('');
                setIsLoading(false);
            }
        };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[36vw] bg-transparent shadow-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col rounded-xl bg-gray-150",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between p-6 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xl text-white",
                                    children: "Publish Template"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                                    onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-100"
                        }),
                        !template.publishedVersion && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white p-6",
                            children: "When you publish this template, everyone in your team on Intaglio will have access to this template."
                        }),
                        template.publishedVersion && !template.latestVersion.isEdited && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex fled-row items-center p-6 gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6cf9e2fe7ee656af$export$e6c98715275d28b), {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-row justify-between w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-green-60",
                                            children: "This Template is published."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-white",
                                            children: (0, $80cc0c4c52b399e2$export$9b9f695373d1284f)(template.publishedVersion.publishedAt)
                                        })
                                    ]
                                })
                            ]
                        }),
                        template.publishedVersion && template.latestVersion.isEdited && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex fled-row p-6 gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cea6b6c33f45e51f$export$7260929c376dfc01), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-row justify-between w-full",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm text-orange-50",
                                            children: "Your published template has unsaved changes."
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                            className: "text-xs text-white text-right",
                                            children: [
                                                "Last Published",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                (0, $80cc0c4c52b399e2$export$9b9f695373d1284f)(template.publishedVersion.publishedAt)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        template.publishedVersion && template.latestVersion.isEdited && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-sm text-white px-6",
                            children: [
                                "This template contains modifications that haven't been applied yet.",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                "To make these changes visible for your team, publish the template again."
                            ]
                        }),
                        (!template.publishedVersion || template.latestVersion.isEdited) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-full flex flex-row justify-end gap-3 p-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Cancel",
                                    className: "px-5",
                                    disabled: isLoading,
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    onClick: ()=>{
                                        setIsOpen(false);
                                        onCancel?.();
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Publish",
                                    isLoading: isLoading,
                                    disabled: isLoading,
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    className: "bg-blue-60 text-white px-8",
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    onClick: ()=>{
                                        setIsLoading(true);
                                        publishTemplate(template.id);
                                    }
                                })
                            ]
                        })
                    ]
                }),
                template.publishedVersion && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col rounded-xl bg-gray-150 mt-4 p-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white ml-1",
                            children: "Share Link"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row bg-gray-100 items-center justify-between p-3 rounded-md mt-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-white text-sm",
                                    children: window.location.href
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "button",
                                    className: "text-blue-60 text-sm",
                                    onClick: ()=>{
                                        (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Link copied to clipboard');
                                        navigator.clipboard.writeText(window.location.href);
                                    },
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b904f7be4bfe30f3$export$51b6cd98f8778f0d), {
                                        className: "h-4 w-4 stroke-blue-30"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-white ml-1 mt-6",
                            children: "Send via Email"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row items-center justify-between mt-2 gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                    className: "rounded-md w-full",
                                    id: "share-template-mail",
                                    type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Email,
                                    value: shareMail,
                                    onChange: setShareMail,
                                    placeholder: "person@gmail.com"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Send",
                                    className: "px-12 rounded-md",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: isLoading || !shareMail,
                                    onClick: shareTemplate()
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $8a0698c6496742e6$var$SELECTABLE_NODE_TYPES = [
    'text',
    'tspan',
    'image'
];
function $8a0698c6496742e6$var$getTextLayerProps(parentNode) {
    // usvg always adds a tspan element inside the text element
    // so we can use it to get the font properties
    const tspan = parentNode.querySelector('tspan[font-family]') || parentNode;
    const computedStyles = window.getComputedStyle(tspan);
    const fontSize = Number.parseFloat(computedStyles.fontSize);
    // remove quotes if name has space otherwise can fail to match in etcher
    const fontFamily = computedStyles.fontFamily.replace(/['"]/g, '');
    const fontWeight = Number.parseInt(computedStyles.fontWeight, 10);
    const fontStyle = computedStyles.fontStyle;
    const lineHeight = Number.parseFloat(computedStyles.lineHeight) / fontSize;
    const fill = computedStyles.fill;
    return {
        text: parentNode.textContent || '',
        fontSize: fontSize,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        lineHeight: lineHeight,
        fill: fill
    };
}
const $8a0698c6496742e6$export$b89a827e9254211a = ({ variant: variant, width: width })=>{
    const svgContent = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.svgFiles[variant.svgFile.file]);
    const editedFieldData = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.editedFieldData);
    const setHighlightedLayer = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setHighlightedLayer);
    const setSelectedLayer = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setSelectedLayer);
    const overlayRef = (0, $acw62.useRef)(null);
    const highlightRectRef = (0, $acw62.useRef)(null);
    const linkedLayerRef = (0, $acw62.useRef)(null);
    const selectRectRef = (0, $acw62.useRef)(null);
    const [linkedLayer, setLinkedLayer] = (0, $acw62.useState)(null);
    const [outlineRects, setOutlineRects] = (0, $acw62.useState)([]);
    const [showOutlineFor, setShowOutlineFor] = (0, $acw62.useState)(null);
    const [zoom, setZoom] = (0, $acw62.useState)(1);
    // This is a workaround to ensure that the SVG content is rendered before we try to access the SVG elements.
    // Any tasks that need to be executed on the SVG element should be added to this array.
    const [svgScheduledTasks, setSvgScheduledTasks] = (0, $acw62.useState)([]);
    const svgRef = (0, $acw62.useCallback)((node)=>{
        if (node) {
            const svg = node.querySelector('svg');
            let svgWidth = variant.svgFile.width;
            let svgHeight = variant.svgFile.height;
            let ratio = 1;
            if (width) {
                ratio = width / svgWidth;
                svgHeight = ratio * svgHeight;
                svgWidth = width;
            }
            setZoom(ratio);
            svg.setAttribute('width', svgWidth.toString());
            svg.setAttribute('height', svgHeight.toString());
            const textNodes = svg.querySelectorAll('text');
            const outlines = [];
            for (const node of textNodes)outlines.push(getElementRect(node));
            setOutlineRects(outlines);
            for (const task of svgScheduledTasks)task(node);
        }
    }, [
        svgScheduledTasks,
        variant,
        width
    ]);
    const getElementId = (el)=>{
        const id = el.dataset.ntglLayerId;
        if (!id) throw new Error('Layer ID is missing');
        return id;
    };
    const getElementType = (el)=>{
        switch(el.nodeName.toLowerCase()){
            case 'text':
                return (0, $9ddb60e45a57b2a0$export$551ff448b1eb3ef1).Text;
            case 'image':
                return (0, $9ddb60e45a57b2a0$export$551ff448b1eb3ef1).Image;
            default:
                throw new Error(`Unsupported element type: ${el.nodeName}`);
        }
    };
    const getElementRect = (0, $acw62.useCallback)((target)=>{
        const boundingRect = target.getBoundingClientRect();
        const overlayRect = overlayRef.current?.getBoundingClientRect();
        return {
            x: boundingRect.x / zoom - overlayRect.x / zoom,
            y: boundingRect.y / zoom - overlayRect.y / zoom,
            width: boundingRect.width / zoom,
            height: boundingRect.height / zoom
        };
    }, [
        zoom
    ]);
    const selectLayer = (node)=>{
        if (linkedLayer) return;
        const id = getElementId(node);
        const type = getElementType(node);
        const rect = getElementRect(node);
        const selectRect = selectRectRef.current;
        if (selectRect) {
            selectRect.setAttribute('x', String(rect.x));
            selectRect.setAttribute('y', String(rect.y));
            selectRect.setAttribute('width', String(rect.width));
            selectRect.setAttribute('height', String(rect.height));
            selectRect.setAttribute('opacity', '1');
        }
        const props = $8a0698c6496742e6$var$getTextLayerProps(node);
        setSelectedLayer({
            id: id,
            type: type,
            rect: rect,
            props: props,
            variantId: variant.id
        });
    };
    const unselectLayer = (0, $acw62.useCallback)(()=>{
        selectRectRef.current?.setAttribute('opacity', '0');
        setSelectedLayer(null);
    }, [
        setSelectedLayer
    ]);
    const highlightLayer = (node)=>{
        if (linkedLayer) return;
        const id = getElementId(node);
        const type = getElementType(node);
        const rect = getElementRect(node);
        const highlightRect = highlightRectRef.current;
        if (highlightRect) {
            highlightRect.setAttribute('x', String(rect.x));
            highlightRect.setAttribute('y', String(rect.y));
            highlightRect.setAttribute('width', String(rect.width));
            highlightRect.setAttribute('height', String(rect.height));
            highlightRect.setAttribute('opacity', '1');
        }
        const props = $8a0698c6496742e6$var$getTextLayerProps(node);
        setHighlightedLayer({
            id: id,
            type: type,
            rect: rect,
            props: props,
            variantId: variant.id
        });
    };
    const unhighlightLayer = (0, $acw62.useCallback)(()=>{
        highlightRectRef.current?.setAttribute('opacity', '0');
        setHighlightedLayer(null);
    }, [
        setHighlightedLayer
    ]);
    const getClosestSelectableElement = (element)=>{
        if (element.nodeName.toLowerCase() !== 'tspan') return element;
        return element.closest('text');
    };
    (0, $acw62.useEffect)(()=>{
        if (editedFieldData) {
            const linkedLayer = editedFieldData.linkedLayers?.find((layer)=>layer.variant === variant.id);
            setLinkedLayer(linkedLayer || null);
            if (linkedLayer) {
                setSvgScheduledTasks((tasks)=>[
                        ...tasks,
                        (svg)=>{
                            const node = svg.querySelector(`[data-ntgl-layer-id="${linkedLayer.layerUuid}"]`);
                            if (node instanceof SVGElement) {
                                const rect = getElementRect(node);
                                const linkedLayerRect = linkedLayerRef.current?.querySelector('rect');
                                linkedLayerRect.setAttribute('x', String(rect.x));
                                linkedLayerRect.setAttribute('y', String(rect.y));
                                linkedLayerRect.setAttribute('width', String(rect.width));
                                linkedLayerRect.setAttribute('height', String(rect.height));
                                const layerIcon = linkedLayerRef.current?.querySelector('.layer-icon');
                                layerIcon.setAttribute('transform', `translate(${rect.x + rect.width - 8}, ${rect.y - 8})`);
                            }
                        }
                    ]);
                unhighlightLayer;
                unselectLayer();
                setShowOutlineFor(null);
            } else setShowOutlineFor((0, $9ddb60e45a57b2a0$export$dda0b6f9ad25b04)(editedFieldData.type));
        } else {
            setLinkedLayer(null);
            setShowOutlineFor(null);
        }
    }, [
        editedFieldData,
        variant,
        getElementRect,
        unhighlightLayer,
        unselectLayer
    ]);
    return svgContent && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col flex-grow-1 basis-1 justify-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-row mb-1 gap-2",
                style: {
                    width: `${variant.svgFile.width}px`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-white text-xs overflow-hidden whitespace-nowrap text-ellipsis flex-shrink-0 max-w-[60%]",
                        title: variant.name,
                        children: variant.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-gray-110 text-xs overflow-hidden whitespace-nowrap text-ellipsis max-w-[40%]",
                        title: `${variant.svgFile.width}x${variant.svgFile.height}`,
                        children: `${variant.svgFile.width}x${variant.svgFile.height}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "relative pointer-events-none",
                style: {
                    zIndex: (0, $39e6c01191458113$export$cda00df1b02ce137)
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    className: "absolute",
                    ref: overlayRef,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: `${variant.svgFile.width * zoom}px`,
                    height: `${variant.svgFile.height * zoom}px`,
                    viewBox: `0 0 ${variant.svgFile.width} ${variant.svgFile.height}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            ref: highlightRectRef,
                            className: "fill-none stroke-blue-50 stroke-[2px] transition-opacity duration-200",
                            x: "0",
                            y: "0",
                            width: "0",
                            height: "0",
                            opacity: "0"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            ref: selectRectRef,
                            className: "fill-none stroke-blue-70 stroke-[2px] transition-opacity duration-200",
                            x: "0",
                            y: "0",
                            width: "0",
                            height: "0",
                            opacity: "0"
                        }),
                        outlineRects.map((rect, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                className: `fill-none stroke-blue-50 stroke-[2px] transition-opacity duration-200 ${showOutlineFor === (0, $9ddb60e45a57b2a0$export$551ff448b1eb3ef1).Text ? 'opacity-100' : 'opacity-0'}`,
                                strokeDasharray: "1",
                                x: rect.x,
                                y: rect.y,
                                width: rect.width,
                                height: rect.height
                            }, index)),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            ref: linkedLayerRef,
                            opacity: linkedLayer ? '1' : '0',
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                                    className: "fill-none stroke-green-60 stroke-[2px] transition-opacity duration-200",
                                    x: "0",
                                    y: "0",
                                    width: "0",
                                    height: "0"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                                    className: "layer-icon",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $277c689232f42f22$export$cd5641a207362f73), {})
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                ref: svgRef,
                className: `border border-gray-150 [&_svg]:pointer-events-none [&_svg_text]:pointer-events-auto ${linkedLayer ? '[&_svg_text]:cursor-default' : '[&_svg_text]:cursor-pointer'}`,
                // biome-ignore lint/security/noDangerouslySetInnerHtml: will be updated to use a safer method
                dangerouslySetInnerHTML: {
                    __html: svgContent
                },
                onMouseOver: (event)=>{
                    const target = event.target;
                    if (target instanceof SVGElement && $8a0698c6496742e6$var$SELECTABLE_NODE_TYPES.includes(target.nodeName.toLowerCase())) highlightLayer(getClosestSelectableElement(target));
                    else unhighlightLayer();
                },
                onMouseOut: ()=>{
                    unhighlightLayer();
                },
                onMouseDown: (event)=>{
                    const target = event.target;
                    if (target instanceof SVGElement && $8a0698c6496742e6$var$SELECTABLE_NODE_TYPES.includes(target.nodeName.toLowerCase())) selectLayer(getClosestSelectableElement(target));
                    else unselectLayer();
                }
            })
        ]
    });
};




const $c7e86cb05868c709$export$208cd1682bd0e4b6 = ()=>{
    const currentVariantIndex = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.currentVariantIndex);
    const editorViewMode = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.editorViewMode);
    const variants = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template?.latestVersion.variants);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex flex-row flex-wrap flex-grow flex-shrink h-full bg-gray-800 p-6 justify-around items-center gap-6 overflow-auto",
        children: variants && variants?.length > 0 && (editorViewMode === (0, $9ddb60e45a57b2a0$export$ad496c2c9edf09a4).Grid ? variants.map((variant)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a0698c6496742e6$export$b89a827e9254211a), {
                variant: variant,
                width: 300
            }, variant.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a0698c6496742e6$export$b89a827e9254211a), {
            variant: variants[currentVariantIndex]
        }, variants[currentVariantIndex].id))
    });
};




parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $925c09d2304d0187$var$ChevronDownIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
        clipRule: "evenodd"
    }));
}
const $925c09d2304d0187$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($925c09d2304d0187$var$ChevronDownIcon);
var $925c09d2304d0187$export$2e2bcd8739ae039 = $925c09d2304d0187$var$ForwardRef;



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");




const $155266e295c990bb$export$ae4d92bd01bc67d6 = ({ isOpen: isOpen, setIsOpen: setIsOpen, onCreate: onCreate })=>{
    const [tagName, setTagName] = (0, $acw62.useState)('');
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const { mutate: createTag } = (0, $35340290a6a27606$export$d2f036f27e89d9f4)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col absolute min-w-96 w-[38vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row justify-between p-4 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-xl text-white",
                            children: "Create a new tag"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                            className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                            onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                    className: "bg-gray-100 border-gray-120"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col p-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "ml-1 mb-1 text-white text-sm",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75939bf917d0aeac$export$2c73285ae9390cec), {
                                    id: "tag-name",
                                    required: true,
                                    type: (0, $75939bf917d0aeac$export$f1dd0e7fe1bbaedf).Text,
                                    value: tagName,
                                    placeholder: "Tag Name",
                                    onChange: (value)=>{
                                        setTagName(value);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "mt-2 bg-gray-100 border-gray-120"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-full flex flex-row justify-end gap-3 p-6",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Cancel",
                                    className: "hover:bg-gray-160",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: isLoading,
                                    onClick: ()=>setIsOpen(false)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Done",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: !tagName || isLoading,
                                    onClick: async ()=>{
                                        createTag(tagName, {
                                            onSuccess: (data)=>{
                                                const tag = data;
                                                setTagName('');
                                                setIsOpen(false);
                                                onCreate?.(tag.id);
                                            }
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




const $f5dbeb0fec94ed95$export$1614b6becc4e262c = ({ templateId: templateId, tags: tags, setTags: setTags })=>{
    const [tagList, setTagList] = (0, $acw62.useState)([]);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const { refetch: _ } = (0, $35340290a6a27606$export$7ea88a09033402a2)({
        onSuccess: (data)=>setTagList(data),
        staleTime: Number.POSITIVE_INFINITY,
        cacheTime: 0
    });
    const getSortedTags = (data)=>{
        const appliedTags = data.filter((tag)=>tags.some((t)=>t.tag.id === tag.id));
        const unAppliedTags = data.filter((tag)=>!tags.some((t)=>t.tag.id === tag.id));
        const sorted = [
            ...appliedTags,
            ...unAppliedTags
        ];
        return sorted;
    };
    const deleteTag = (0, $acw62.useCallback)(async (tagId)=>{
        try {
            await (0, $4de9f2a2c6cffb7a$export$c4e1fba60e7266e2).deleteTemplateTag(tagId);
            const tags = await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).getTemplateTags(templateId);
            setTags(tags);
        } catch (error) {
            console.error('Error deleting tag:', error);
        }
    }, [
        templateId,
        setTags
    ]);
    const addTag = (0, $acw62.useCallback)(async (tagId)=>{
        try {
            await (0, $4de9f2a2c6cffb7a$export$c4e1fba60e7266e2).createTemplateTag(templateId, tagId);
            const tags = await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).getTemplateTags(templateId);
            setTags(tags);
        } catch (error) {
            console.error('Error adding tag:', error);
        }
    }, [
        templateId,
        setTags
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-row gap-2 items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-sm text-gray-110",
                            children: "Select Tags"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $925c09d2304d0187$export$2e2bcd8739ae039), {
                            className: "text-gray-110 h-4 w-4"
                        })
                    ]
                }),
                items: [
                    ...getSortedTags(tagList).map((tag)=>{
                        const templateTag = tags.find((t)=>t.tag.id === tag.id);
                        return {
                            name: tag.name,
                            icon: templateTag ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f87e2995c0ae886d$export$7dd004358974b05d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $430181ea01cc3dc6$export$30d0dc241a918823), {}),
                            onClick: ()=>{
                                if (templateTag) deleteTag(templateTag.id);
                                else addTag(tag.id);
                            },
                            id: tag.id.toString()
                        };
                    }),
                    {
                        name: 'Add Tag',
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                            className: "h-4 w-4 text-blue-30"
                        }),
                        color: 'blue-30',
                        onClick: ()=>setIsOpen(true),
                        id: 'Add Tag'
                    }
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155266e295c990bb$export$ae4d92bd01bc67d6), {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                onCreate: (id)=>addTag(id)
            })
        ]
    });
};


const $f0ddfc0dd17dbaf0$export$d815a3ff201050e3 = ()=>{
    const template = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template);
    const setTemplateTags = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setTemplateTags);
    if (!template) throw new Error('Unexpected missing template');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-white text-base font-normal w-full truncate",
                children: template.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f5dbeb0fec94ed95$export$1614b6becc4e262c), {
                templateId: template.id,
                tags: template.tags,
                setTags: setTemplateTags
            })
        ]
    });
};



const $92f36d5484bd3120$export$72b66677513e0cef = ()=>{
    const params = (0, $32578012b727878c$export$99eaa27ddbbb95ef)();
    const templateId = Number.parseInt(params.templateId || '');
    if (Number.isNaN(templateId)) {
        console.error('Invalid template ID in url params:', params.templateId);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
            to: "/templates",
            replace: true
        });
    }
    const currentVariantIndex = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.currentVariantIndex);
    const editorViewMode = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.editorViewMode);
    const template = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.template);
    const setCurrentVariantIndex = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setCurrentVariantIndex);
    const setEditorViewMode = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setEditorViewMode);
    const setSelectedLayer = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setSelectedLayer);
    const setTemplate = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.setTemplate);
    const addSvgFile = (0, $e0acbec19c12fb9c$export$3956fa95edbebd53)((s)=>s.addSvgFile);
    const [isAddFrameModalOpen, setAddFrameModalOpen] = (0, $acw62.useState)(false);
    const [isPublishModalOpen, setPublishModalOpen] = (0, $acw62.useState)(false);
    const [initFetchComplete, setInitFetchComplete] = (0, $acw62.useState)(false);
    const [isVariantDeleteConfirmationOpen, setIsVariantDeleteConfirmationOpen] = (0, $acw62.useState)(false);
    const [variantForDeletion, setVariantForDeletion] = (0, $acw62.useState)(null);
    const { refetch: refetchTemplate } = (0, $181035219bfd394d$export$b6557d05127509d7)(templateId, {
        onSuccess: (data)=>{
            setTemplate(data);
        },
        staleTime: Number.POSITIVE_INFINITY,
        cacheTime: 0
    });
    const { mutate: deleteVariant } = (0, $b9d442414baa9d07$export$646aa5fa861e2f37)();
    const fonts = template?.latestVersion.variants.flatMap((v)=>v.svgFile.availableFonts) || [];
    const fontFileQueryResults = (0, $1232e344916108aa$export$8241329de5df3c0f)(fonts, {
        enabled: !!template
    });
    const fontFilesLoaded = fontFileQueryResults.every((result)=>result.isSuccess);
    const svgFiles = template?.latestVersion.variants.map((v)=>v.svgFile.file) || [];
    const svgFileQueryResults = (0, $4856298da5031936$export$aec46e5bb7a508cb)(svgFiles, {
        enabled: !!template
    });
    const svgFilesLoaded = svgFileQueryResults.every((result)=>result.isSuccess);
    const handleVariantChange = (0, $acw62.useCallback)((index)=>{
        setCurrentVariantIndex(index);
        setSelectedLayer(null);
    }, [
        setCurrentVariantIndex,
        setSelectedLayer
    ]);
    const onVariantDeleteSuccss = (0, $acw62.useCallback)(()=>{
        const newVariants = template?.latestVersion.variants.filter((variant)=>variant.id !== variantForDeletion);
        if (newVariants && template) {
            const newTemplate = {
                ...template,
                latestVersion: {
                    ...template.latestVersion,
                    variants: newVariants
                }
            };
            setTemplate(newTemplate);
        }
        setVariantForDeletion(null);
        setIsVariantDeleteConfirmationOpen(false);
    }, [
        variantForDeletion,
        template,
        setTemplate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (variantForDeletion !== null) setIsVariantDeleteConfirmationOpen(true);
    }, [
        variantForDeletion
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isVariantDeleteConfirmationOpen) setVariantForDeletion(null);
    }, [
        isVariantDeleteConfirmationOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (fontFilesLoaded && svgFilesLoaded && template) {
            const promises = [];
            for (const res of fontFileQueryResults){
                const { url: url, file: file, font: font } = res.data;
                promises.push((0, $80cc0c4c52b399e2$export$f546da154e07664d)(font, file));
            }
            for (const res of svgFileQueryResults)addSvgFile(res.data.url, res.data.file);
            Promise.all(promises).then(()=>{
                setInitFetchComplete(true);
            });
        }
    }, [
        addSvgFile,
        fontFilesLoaded,
        fontFileQueryResults,
        svgFilesLoaded,
        svgFileQueryResults,
        template
    ]);
    return template && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `flex flex-col min-h-0 h-screen w-full bg-black-50 ${initFetchComplete ? 'hidden' : ''}`,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c5dc5a0ac94f108$export$e2b0760399e6dece), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `flex flex-col min-h-0 h-screen w-full bg-black-50 ${initFetchComplete ? '' : 'hidden'}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                        type: (0, $b3f317f73d7705c5$export$9baf8232abef7d17).LIGHT,
                        leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {})
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-sm text-white font-normal",
                                    children: "Create Template"
                                })
                            ]
                        }),
                        center: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}),
                        trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-2.5 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c75eb4c4478911c$export$c6aea0e298dc6482), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "h-6 border-gray-100 border-l-[1px]"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Publish Template",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    onClick: ()=>setPublishModalOpen(true)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex min-h-0 flex-row h-full max-w-full min-w-full",
                        children: [
                            editorViewMode === (0, $9ddb60e45a57b2a0$export$ad496c2c9edf09a4).List && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                                className: "pl-4 py-4 h-full w-64 flex-shrink-0 flex-grow-0",
                                type: (0, $ae78cd9e765d6623$export$af3435520bc7eae6).LIGHT,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "px-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0ddfc0dd17dbaf0$export$d815a3ff201050e3), {})
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "px-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            title: "Upload Frames",
                                            className: "w-full mt-4",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94b315f23341d3ba$export$8df90684a752ef81), {
                                                className: "h-5 w-5 stroke-white"
                                            }),
                                            onClick: ()=>setAddFrameModalOpen(true)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                        className: "flex flex-col gap-2 h-full max-h-full min-h-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-sm text-white px-4",
                                                children: "Frames"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "flex flex-col flex-grow gap-4 px-4 overflow-y-auto",
                                                children: template.latestVersion.variants.map((variant, index)=>{
                                                    const isActive = template.latestVersion.variants[currentVariantIndex]?.id === variant.id;
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c4a2f417ac728b7$export$8b9b55c785b7377d), {
                                                        index: index + 1,
                                                        title: variant.name,
                                                        thumbnail: variant.thumbnail,
                                                        size: `${variant.svgFile.width}x${variant.svgFile.height}`,
                                                        isActive: isActive,
                                                        onDelete: ()=>setVariantForDeletion(variant.id),
                                                        onClick: ()=>handleVariantChange(index)
                                                    }, variant.id);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex-grow flex-shrink h-full min-w-0 overflow-auto",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col h-full min-w-0",
                                    children: [
                                        editorViewMode === (0, $9ddb60e45a57b2a0$export$ad496c2c9edf09a4).Grid && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "p-4",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "inline-block bg-gray-150 p-4 rounded-md w-60",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f0ddfc0dd17dbaf0$export$d815a3ff201050e3), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c7e86cb05868c709$export$208cd1682bd0e4b6), {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8286a6df1f01b60$export$9c944d4866fff1e8), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4e62830fccc337c$export$59e180a7e419c107), {
                        templateVersionId: template.latestVersion.id,
                        prevCount: template.latestVersion.variants.length,
                        isOpen: isAddFrameModalOpen,
                        setIsOpen: setAddFrameModalOpen,
                        onFrameAdded: refetchTemplate
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a0799c1d5f6f802$export$a7932105fec13fb9), {
                        template: template,
                        isOpen: isPublishModalOpen,
                        setIsOpen: setPublishModalOpen,
                        onCancel: ()=>{},
                        onPublish: ()=>{}
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fbad6cc0f9b3f8$export$1f33f980da756c46), {
                        isOpen: isVariantDeleteConfirmationOpen,
                        setIsOpen: setIsVariantDeleteConfirmationOpen,
                        type: (0, $d6fbad6cc0f9b3f8$export$b71090edac4832f0).WARN,
                        confirmText: "Delete",
                        cancelText: "Cancel",
                        message: "Delete Frame",
                        subMessage: "Are you sure you want to delete this frame?",
                        onConfirm: ()=>{
                            deleteVariant(variantForDeletion, {
                                onSuccess: ()=>onVariantDeleteSuccss()
                            });
                        }
                    })
                ]
            })
        ]
    });
};




const $858fae968d725bbc$export$b78c417a59fec2a7 = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$3565eb3d00ca5a74), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
            path: "/:templateId",
            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $92f36d5484bd3120$export$72b66677513e0cef), {})
        })
    });
};




var $acw62 = parcelRequire("acw62");
function $96fa020988d12076$var$ChevronRightIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m8.25 4.5 7.5 7.5-7.5 7.5"
    }));
}
const $96fa020988d12076$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($96fa020988d12076$var$ChevronRightIcon);
var $96fa020988d12076$export$2e2bcd8739ae039 = $96fa020988d12076$var$ForwardRef;



var $acw62 = parcelRequire("acw62");









parcelRequire("acw62");
const $9060d195d3dc9c03$export$cd4d3acee7a2dcb9 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Edit Document Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6465 4.64642L15.3536 3.35353C15.1583 3.15827 14.8417 3.15827 14.6465 3.35353L9.08348 8.91653C9.0286 8.97142 8.98724 9.03833 8.9627 9.11197L8 12L10.888 11.0373C10.9617 11.0128 11.0286 10.9714 11.0835 10.9165L16.6465 5.35353C16.8417 5.15827 16.8417 4.84169 16.6465 4.64642Z",
                stroke: "white",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 7L13 5",
                stroke: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11 11L8.99999 9",
                stroke: "white"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15 11V15C15 15.5523 14.5523 16 14 16H5C4.44772 16 4 15.5523 4 15V6C4 5.44772 4.44772 5 5 5H9",
                stroke: "white"
            })
        ]
    });
};



parcelRequire("acw62");
const $e0ddc4dcb7542735$export$2ad141e9e3d81b82 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Edit Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M16.6473 5.44642L14.5544 3.35353C14.3591 3.15827 14.0425 3.15827 13.8473 3.35353L5.88427 11.3165C5.82939 11.3714 5.78803 11.4383 5.76349 11.512L4.40078 15.6L8.48884 14.2373C8.56247 14.2127 8.62939 14.1714 8.68427 14.1165L16.6473 6.15353C16.8425 5.95827 16.8425 5.64168 16.6473 5.44642Z",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M14.1953 8.60034L11.3953 5.80034"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.59766 14.2004L5.79764 11.4004"
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");
function $f474ae3dc3820ad9$var$ChevronUpIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
        clipRule: "evenodd"
    }));
}
const $f474ae3dc3820ad9$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($f474ae3dc3820ad9$var$ChevronUpIcon);
var $f474ae3dc3820ad9$export$2e2bcd8739ae039 = $f474ae3dc3820ad9$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
const $0691ba840a4acbbd$export$eb2ca1350bb61eb0 = ({ options: options, onChange: onChange })=>{
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const [currentOption, setCurrentOption] = (0, $acw62.useState)(options[0]);
    const ref = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const toggleMenu = ()=>{
        setIsOpen((prev)=>!prev);
    };
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (ref.current && !ref.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "relative inline-block",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: toggleMenu,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "rounded-md h-11 gap-1 border-gray-100 w-40 border-solid border-[1px] flex items-center justify-center hover:pointer hover:bg-gray-150",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm text-gray-110",
                            children: "Sort By:"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-sm text-white",
                            children: currentOption.name
                        }),
                        isOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f474ae3dc3820ad9$export$2e2bcd8739ae039), {
                            className: "h-2.5 w-2.5 text-white"
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $925c09d2304d0187$export$2e2bcd8739ae039), {
                            className: "h-2.5 w-2.5 text-white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `absolute left-0 right-0 bg-gray-100 mt-1 shadow-xl rounded-md transition-all duration-100 ease-in-out
          ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`,
                ref: menuRef,
                children: options.map((option)=>{
                    const isLastOption = options.length - 1 === options.indexOf(option);
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                type: "button",
                                className: `flex flex-row gap-2 items-center w-full px-4 py-2 text-white text-xs hover:bg-gray-80 hover:font-semibold rounded-md text-left ${option.id === currentOption.id ? 'font-semibold' : ''}`,
                                onClick: ()=>{
                                    onChange(option.id);
                                    setCurrentOption(option);
                                    toggleMenu();
                                },
                                children: [
                                    option.name,
                                    ' ',
                                    option.id === currentOption.id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                        className: "h-3 w-3 text-white"
                                    })
                                ]
                            }),
                            !isLastOption && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                className: "bg-gray-70 border-gray-70  opacity-20 mt-1"
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
};



parcelRequire("acw62");
const $84b3b1ac2e9f7f18$export$80beb1cb95701424 = ({ className: className })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        className: className,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: "Tag Icon"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                clipPath: "url(#clip0_4280_7082)",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M6 6.83333C6 7.05435 6.0878 7.26631 6.24408 7.42259C6.40036 7.57887 6.61232 7.66667 6.83333 7.66667C7.05435 7.66667 7.26631 7.57887 7.42259 7.42259C7.57887 7.26631 7.66667 7.05435 7.66667 6.83333C7.66667 6.61232 7.57887 6.40036 7.42259 6.24408C7.26631 6.0878 7.05435 6 6.83333 6C6.61232 6 6.40036 6.0878 6.24408 6.24408C6.0878 6.40036 6 6.61232 6 6.83333Z",
                        fill: "white",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M2.5 5V9.31C2.50009 9.75199 2.67575 10.1758 2.98833 10.4883L9.41333 16.9133C9.78996 17.2899 10.3007 17.5015 10.8333 17.5015C11.3659 17.5015 11.8767 17.2899 12.2533 16.9133L16.9133 12.2533C17.2899 11.8767 17.5015 11.3659 17.5015 10.8333C17.5015 10.3007 17.2899 9.78996 16.9133 9.41333L10.4883 2.98833C10.1758 2.67575 9.75199 2.50009 9.31 2.5H5C4.33696 2.5 3.70107 2.76339 3.23223 3.23223C2.76339 3.70107 2.5 4.33696 2.5 5Z",
                        stroke: "white",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                    id: "clip0_4280_7082",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");








const $df172b5502887faa$export$ecdb1fd4c4d0b7a7 = ({ onSuccess: onSuccess, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [files, setFiles] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isCreatingTemplate, setIsCreatingTemplate] = (0, $acw62.useState)(false);
    const [isMissingFontModalOpen, setIsMissingFontModalOpen] = (0, $acw62.useState)(false);
    const [missingFonts, setMissingFonts] = (0, $acw62.useState)([]);
    const [uploadedFonts, setUploadedFonts] = (0, $acw62.useState)([]);
    const [progressMap, setProgressMap] = (0, $acw62.useState)({});
    const createTemplate = async ()=>{
        if (files.length === 0) return;
        let missingFonts = files.flatMap((file)=>progressMap[file.name]?.file?.missing_fonts).filter((f)=>!uploadedFonts.some((uf)=>uf.family === f?.family && uf.weight === f?.weight && uf.style === f?.style));
        missingFonts = missingFonts.filter((value, index)=>{
            const _value = JSON.stringify(value);
            return index === missingFonts.findIndex((obj)=>{
                return JSON.stringify(obj) === _value;
            });
        });
        if (missingFonts.length > 0) {
            setMissingFonts(missingFonts.filter((font)=>font !== undefined));
            return;
        }
        const variants = files.map((file)=>({
                id: progressMap[file.name]?.file?.id,
                name: file.name
            })).map((f)=>({
                svg_file: f.id,
                name: f.name
            }));
        setIsCreatingTemplate(true);
        const resp = await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).createTemplate({
            name: 'Untitled',
            latest_version: {
                variants: variants
            }
        });
        (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).success('Template created successfully');
        setIsCreatingTemplate(false);
        setFiles([]);
        setProgressMap({});
        setIsOpen(false);
        onSuccess?.(resp.id);
    };
    const uploadFile = (0, $acw62.useCallback)(async (file)=>{
        if (progressMap[file.name]?.isUploaded || progressMap[file.name]?.xhr) return;
        const xhr = await (0, $9550621969846473$export$da5e64576956de1f).uploadSVGFile(file, (event)=>{
            if (event.lengthComputable) {
                const progress = Math.round(event.loaded / event.total * 100);
                setProgressMap((prev)=>({
                        ...prev,
                        [file.name]: {
                            progress: progress,
                            error: false,
                            isUploaded: false,
                            xhr: xhr,
                            file: null
                        }
                    }));
            }
        }, (event)=>{
            if (xhr.status === 201) setProgressMap((prev)=>({
                    ...prev,
                    [file.name]: {
                        progress: 100,
                        error: false,
                        isUploaded: true,
                        xhr: xhr,
                        file: JSON.parse(xhr.responseText)
                    }
                }));
            else {
                setProgressMap((prev)=>({
                        ...prev,
                        [file.name]: {
                            progress: 0,
                            error: true,
                            isUploaded: false,
                            xhr: xhr,
                            file: null
                        }
                    }));
                (0, $297bc9fd20328fd0$export$533a00e25ce4cf63).error('Failed to upload, double check the file and try again');
            }
        });
    }, [
        progressMap
    ]);
    const handleCancelPressed = ()=>{
        setIsOpen(false);
        setFiles([]);
        setProgressMap({});
        for (const file of files){
            const xhr = progressMap[file.name]?.xhr;
            if (xhr) xhr.abort();
        }
    };
    const handleCancelFileUpload = (file)=>{
        const xhr = progressMap[file.name]?.xhr;
        if (xhr) xhr.abort();
        setFiles(files.filter((f)=>f.name !== file.name));
    };
    const handleDeleteFile = (file)=>{
        setFiles(files.filter((f)=>f.name !== file.name));
    };
    (0, $acw62.useEffect)(()=>{
        const filesToUpload = files.filter((file)=>!progressMap[file.name]?.isUploaded);
        const uploadFiles = async ()=>{
            for (const file of filesToUpload)if (!progressMap[file.name]?.isUploaded) await uploadFile(file);
        };
        if (filesToUpload.length > 0) uploadFiles();
    }, [
        files,
        progressMap,
        uploadFile
    ]);
    (0, $acw62.useEffect)(()=>{
        if (missingFonts.filter((f)=>!uploadedFonts.some((uf)=>uf.family === f?.family && uf.weight === f?.weight && uf.style === f?.style)).length > 0) setIsMissingFontModalOpen(true);
    }, [
        missingFonts,
        uploadedFonts
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
                isOpen: isOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col overflow-hidden absolute min-w-96 h-[85vh] max-h-[750px] w-[38vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between p-6 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xl text-white",
                                    children: "Upload SVG files to create a template."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                                    onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-100"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col p-6 flex-1 min-h-0 overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a3463e36227e6c3$export$54dc470bcc5c41d1), {
                                    fileTypes: {
                                        'image/svg+xml': [
                                            '.svg'
                                        ]
                                    },
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $488ccafe45063c61$export$b03df4088377e101), {
                                        className: "w-14 h-14"
                                    }),
                                    onFilesPicked: async (selectedFiles)=>{
                                        setFiles((prev)=>[
                                                ...prev,
                                                ...selectedFiles.filter((file)=>!prev.some((f)=>f.name === file.name))
                                            ]);
                                    }
                                }),
                                files.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col mt-8",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-gray-110 font-normal",
                                                    children: "Step 1"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-white font-normal",
                                                    children: "Export your design artboards as SVG files."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col mt-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-gray-110 font-normal",
                                                    children: "Step 2"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-sm text-white font-normal",
                                                    children: "Upload one or multiple artboards you want to combine into one template."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                files.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col flex-1 min-h-0 mt-6 overflow-y-auto gap-4 no-scrollbar",
                                    children: files.map((file)=>{
                                        const fileSizeUploaded = file.size * (progressMap[file.name]?.progress || 0) / 100;
                                        const fileSizeUploadedWithUnit = fileSizeUploaded > 1048576 ? `${(fileSizeUploaded / 1048576).toFixed(2)} MB` : `${(fileSizeUploaded / 1024).toFixed(2)} KB`;
                                        const fileSizeTotal = file.size > 1048576 ? `${(file.size / 1048576).toFixed(2)} MB` : `${(file.size / 1024).toFixed(2)} KB`;
                                        const progress = progressMap[file.name]?.progress || 0;
                                        const isUploaded = progressMap[file.name]?.isUploaded || false;
                                        const error = progressMap[file.name]?.error || false;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col rounded-md w-full bg-gray-140 p-3",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row w-full items-center mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $488ccafe45063c61$export$b03df4088377e101), {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-col justify-center ml-3 w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "flex flex-row justify-between items-center w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            className: "text-sm font-normal text-white",
                                                                            children: file.name.length > 50 ? `${file.name.slice(0, 25)}...${file.name.slice(-25)}` : file.name
                                                                        }),
                                                                        !isUploaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>handleCancelFileUpload(file),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                                                                className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30"
                                                                            })
                                                                        }),
                                                                        isUploaded && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            type: "button",
                                                                            onClick: ()=>handleDeleteFile(file),
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                                                                                className: "stroke-red-50"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-xxs text-gray-60",
                                                                    children: [
                                                                        fileSizeUploadedWithUnit,
                                                                        " of ",
                                                                        fileSizeTotal,
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-xs font-bold text-gray-40 mr-2 ml-2",
                                                                            children: "\xb7"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: `${error ? 'text-red-60' : isUploaded ? 'text-green-60' : 'text-gray-60'}`,
                                                                            children: error ? 'Upload Error' : isUploaded ? 'Completed' : 'Uploading'
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "flex flex-row h-1.5 bg-gray-100 rounded-lg w-full",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "h-1.5 bg-blue-60 rounded-lg",
                                                        style: {
                                                            width: isUploaded ? '100%' : `${progress}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        }, `${file.name}-${file.size}-${file.lastModified}`);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "mt-4 bg-gray-100 border-gray-100"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "w-full flex flex-row justify-end gap-3 p-6 h-[88px]",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Cancel",
                                    className: "hover:bg-gray-160",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    disabled: isLoading,
                                    onClick: handleCancelPressed
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                    title: "Create Template",
                                    buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                    buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                    isLoading: isCreatingTemplate,
                                    disabled: files.length === 0 || files.some((file)=>!progressMap[file.name]?.isUploaded) || isLoading,
                                    onClick: async ()=>{
                                        await createTemplate();
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98143630e6f1f4ba$export$3b439b29d8e641e), {
                fonts: missingFonts,
                uploadedFonts: uploadedFonts,
                onUploadDone: (font)=>{
                    setUploadedFonts((prev)=>[
                            ...prev,
                            font
                        ]);
                },
                isOpen: isMissingFontModalOpen,
                setIsOpen: setIsMissingFontModalOpen
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



const $0f2a847676ac967c$export$faf7d44439998149 = ({ title: title, createdAt: createdAt, thumbnail: thumbnail, menuItems: menuItems, isRenaming: isRenaming, onRename: onRename, onClick: onClick })=>{
    const [titleValue, setTitleValue] = (0, $acw62.useState)(title);
    const [thumbnailLoadFailed, setThumbnailLoadFailed] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (!isRenaming) setTitleValue(title);
    }, [
        isRenaming,
        title
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-row min-w-[300px] max-w-[480px] w-full border-gray-130 border-[1px] border-solid rounded-md relative",
        onClick: onClick,
        onKeyUp: isRenaming ? ()=>{} : (e)=>e.key === 'Enter' && onClick && onClick(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex items-center justify-center w-[28%] aspect-square bg-black-50 rounded chess-sm",
                children: thumbnailLoadFailed || !thumbnail ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $115490f100597f79$export$385cd24c05318684), {
                    className: "w-2/3 h-2/3"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: thumbnail,
                    alt: "thumbnail",
                    className: "w-full aspect-square object-contain",
                    onError: (e)=>{
                        setThumbnailLoadFailed(true);
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col pl-4 pr-2 py-3 w-[72%]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-row justify-between items-center w-full h-9",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-red-50 text-sm bg-red-05 bg-opacity-20 px-3 py-1 rounded ",
                                children: "Draft"
                            }),
                            menuItems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac8e38bb87a65c17$export$d9b273488cd8ce6f), {
                                items: menuItems
                            })
                        ]
                    }),
                    isRenaming ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "text",
                        className: "mr-4 text-white bg-transparent border-none outline-none text-base truncate w-full overflow-hidden whitespace-nowrap",
                        onKeyUp: (e)=>e.key === 'Enter' && onRename?.(titleValue),
                        value: titleValue,
                        onChange: (e)=>setTitleValue(e.target.value),
                        onClick: (e)=>e.stopPropagation(),
                        // biome-ignore lint/a11y/noAutofocus: <explanation>
                        autoFocus: true
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-white text-base truncate w-full overflow-hidden whitespace-nowrap pr-4",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        className: "flex flex-row gap-1 text-white text-xs w-full text-ellipsis",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-gray-60",
                                children: "Created"
                            }),
                            `${(0, $80cc0c4c52b399e2$export$9b9f695373d1284f)(createdAt)}`
                        ]
                    })
                ]
            })
        ]
    });
};











var $acw62 = parcelRequire("acw62");
function $ff5faef1904db43a$var$PlusIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
        clipRule: "evenodd"
    }));
}
const $ff5faef1904db43a$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($ff5faef1904db43a$var$PlusIcon);
var $ff5faef1904db43a$export$2e2bcd8739ae039 = $ff5faef1904db43a$var$ForwardRef;



var $acw62 = parcelRequire("acw62");
const $1ef513998692c190$export$5ce3274d32104b7b = ({ onDone: onDone, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [tags, setTags] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [addTagModalOpen, setAddTagModalOpen] = (0, $acw62.useState)(false);
    const [deleteTagModalOpen, setDeleteTagModalOpen] = (0, $acw62.useState)(false);
    const [selectedForDelete, setSelectedForDelete] = (0, $acw62.useState)(null);
    const { refetch: _ } = (0, $35340290a6a27606$export$7ea88a09033402a2)({
        onSuccess: (data)=>setTags(data),
        staleTime: Number.POSITIVE_INFINITY,
        cacheTime: 0
    });
    const { mutate: deleteTag } = (0, $35340290a6a27606$export$b62c4ec00e56f561)();
    (0, $acw62.useEffect)(()=>{
        if (selectedForDelete !== null) setDeleteTagModalOpen(true);
    }, [
        selectedForDelete
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) setSelectedForDelete(null);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
                isOpen: isOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col absolute min-w-64 w-[30vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between p-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xl text-white",
                                    children: "Edit Tags"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                                    onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-120"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col max-h-[40vh] overflow-y-auto no-scrollbar",
                                    children: tags.map((tag, index)=>{
                                        const count = tag.count + tag.draftCount;
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row p-3 justify-between items-center w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "flex flex-col",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-base text-white",
                                                                    children: tag.name
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                    className: "text-xs text-gray-50",
                                                                    children: [
                                                                        count,
                                                                        " Template",
                                                                        count === 1 ? '' : 's'
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>setSelectedForDelete(tag.id),
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                                                                className: "stroke-gray-50 hover:stroke-red-50"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                                    className: "bg-gray-100 border-gray-120 opacity-20 mt-1"
                                                })
                                            ]
                                        }, `${Date.now().toString()}${index}`);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "group flex flex-row items-center gap-1.5 w-full py-2 text-blue-30 hover:text-blue-50 text-xs",
                                        onClick: ()=>setAddTagModalOpen(true),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff5faef1904db43a$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-blue-30 group-hover:stroke-blue-50"
                                            }),
                                            "Create New Tag"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "mt-2 bg-gray-100 border-gray-120"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "w-full flex flex-row justify-end gap-3 p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            title: "Cancel",
                                            className: "hover:bg-gray-160",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            disabled: isLoading,
                                            onClick: ()=>setIsOpen(false)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            title: "Done",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            disabled: isLoading,
                                            onClick: ()=>{
                                                onDone?.();
                                                setIsOpen(false);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155266e295c990bb$export$ae4d92bd01bc67d6), {
                isOpen: addTagModalOpen,
                setIsOpen: setAddTagModalOpen
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fbad6cc0f9b3f8$export$1f33f980da756c46), {
                isOpen: deleteTagModalOpen,
                setIsOpen: setDeleteTagModalOpen,
                type: (0, $d6fbad6cc0f9b3f8$export$b71090edac4832f0).DEFAULT,
                confirmText: "Delete Tag",
                cancelText: "Cancel",
                message: "Are you sure you want to permanently delete this tag?",
                subMessage: "This tag will be removed off of all templates.",
                onConfirm: ()=>{
                    deleteTag(selectedForDelete ?? -1);
                }
            })
        ]
    });
};






var $acw62 = parcelRequire("acw62");







const $6d30f2fc9305b8a7$export$2ca68fd5c50cde74 = ({ onDone: onDone, isOpen: isOpen, setIsOpen: setIsOpen, template: template, setTags: setTags })=>{
    const [tagList, setTagList] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [addTagModalOpen, setAddTagModalOpen] = (0, $acw62.useState)(false);
    const { refetch: fetchTags } = (0, $35340290a6a27606$export$7ea88a09033402a2)({
        onSuccess: (data)=>setTagList(data),
        staleTime: Number.POSITIVE_INFINITY,
        cacheTime: 0
    });
    const getSortedTags = (data)=>{
        const appliedTags = data.filter((tag)=>template.tags.some((t)=>t.tag.id === tag.id));
        const unAppliedTags = data.filter((tag)=>!template.tags.some((t)=>t.tag.id === tag.id));
        const sorted = [
            ...appliedTags,
            ...unAppliedTags
        ];
        return sorted;
    };
    const deleteTag = (0, $acw62.useCallback)(async (tagId)=>{
        try {
            await (0, $4de9f2a2c6cffb7a$export$c4e1fba60e7266e2).deleteTemplateTag(tagId);
            const tags = await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).getTemplateTags(template.id);
            setTags(tags);
        } catch (error) {
            console.error('Error deleting tag:', error);
        }
    }, [
        template,
        setTags
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchTags();
    }, [
        fetchTags
    ]);
    const addTag = (0, $acw62.useCallback)(async (tagId)=>{
        try {
            await (0, $4de9f2a2c6cffb7a$export$c4e1fba60e7266e2).createTemplateTag(template.id, tagId);
            const tags = await (0, $1dd987508bfe6892$export$9fb430c001a9d1c7).getTemplateTags(template.id);
            setTags(tags);
        } catch (error) {
            console.error('Error adding tag:', error);
        }
    }, [
        template,
        setTags
    ]);
    const toggleTag = (templateTag, tag)=>{
        if (templateTag) deleteTag(templateTag.id);
        else addTag(tag.id);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e331d67b7935c065$export$2b77a92f1a5ad772), {
                isOpen: isOpen,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col absolute min-w-64 w-[30vw] max-w-[650px] bg-gray-150 shadow-xl rounded-xl transition-all duration-300 ease-in-out",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row justify-between p-4 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xl text-white",
                                    children: "Edit Tags"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $968d99013e9e02bc$export$2e2bcd8739ae039), {
                                    className: "h-5 w-5 text-white hover:cursor-pointer hover:text-gray-30",
                                    onClick: isLoading ? ()=>{} : ()=>setIsOpen(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                            className: "bg-gray-100 border-gray-120"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col max-h-[40vh] overflow-y-auto no-scrollbar",
                                    children: getSortedTags(tagList).map((tag, index)=>{
                                        const selectedTag = template.tags.find((t)=>t.tag.id === tag.id);
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col w-full",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row p-3 gap-2 items-center w-full hover:bg-gray-140 cursor-pointer",
                                                    onClick: ()=>toggleTag(selectedTag, tag),
                                                    onKeyDown: (e)=>{
                                                        if (e.key === 'Enter' || e.key === ' ') toggleTag(selectedTag, tag);
                                                    },
                                                    children: [
                                                        selectedTag ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f87e2995c0ae886d$export$7dd004358974b05d), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $430181ea01cc3dc6$export$30d0dc241a918823), {}),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-base text-white",
                                                            children: tag.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                                    className: "bg-gray-100 border-gray-120 opacity-20 mt-1"
                                                })
                                            ]
                                        }, `${Date.now().toString()}${index}`);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-3",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        type: "button",
                                        className: "group flex flex-row items-center gap-1.5 w-full py-2 text-blue-30 hover:text-blue-50 text-xs",
                                        onClick: ()=>setAddTagModalOpen(true),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff5faef1904db43a$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-blue-30 group-hover:stroke-blue-50"
                                            }),
                                            "Create New Tag"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                    className: "mt-2 bg-gray-100 border-gray-120"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "w-full flex flex-row justify-end gap-3 p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            title: "Cancel",
                                            className: "hover:bg-gray-160",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).SECONDARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            disabled: isLoading,
                                            onClick: ()=>setIsOpen(false)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            title: "Done",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            disabled: isLoading,
                                            onClick: ()=>{
                                                onDone?.();
                                                setIsOpen(false);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $155266e295c990bb$export$ae4d92bd01bc67d6), {
                isOpen: addTagModalOpen,
                setIsOpen: setAddTagModalOpen
            })
        ]
    });
};


var $2d6d20050e6878f4$var$TemplateListSortBy = /*#__PURE__*/ function(TemplateListSortBy) {
    TemplateListSortBy["NEWEST"] = "newest";
    TemplateListSortBy["OLDEST"] = "oldest";
    TemplateListSortBy["A_Z"] = "a-z";
    TemplateListSortBy["Z_A"] = "z-a";
    return TemplateListSortBy;
}($2d6d20050e6878f4$var$TemplateListSortBy || {});
var $2d6d20050e6878f4$var$ListMode = /*#__PURE__*/ function(ListMode) {
    ListMode["ALL"] = "ALL";
    ListMode["DRAFT"] = "DRAFT";
    return ListMode;
}($2d6d20050e6878f4$var$ListMode || {});
const $2d6d20050e6878f4$export$c5a06aa0f041765d = ()=>{
    const [selectedTag, setSelectedTag] = (0, $acw62.useState)(null);
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $acw62.useState)(false);
    const [isEditTagModalOpen, setIsEditTagModalOpen] = (0, $acw62.useState)(false);
    const [isTemplateDeleteConfirmationOpen, setIsTemplateDeleteConfirmationOpen] = (0, $acw62.useState)(false);
    const [isEditTemplateTagModalOpen, setIsEditTemplateTagModalOpen] = (0, $acw62.useState)(false);
    const [templateList, setTemplateList] = (0, $acw62.useState)([]);
    const [draftTemplates, setDraftTemplates] = (0, $acw62.useState)([]);
    const [count, setCount] = (0, $acw62.useState)(0);
    const [draftCount, setDraftCount] = (0, $acw62.useState)(0);
    const [templateTags, setTemplateTags] = (0, $acw62.useState)([]);
    const [selectedSortBy, setSelectedSortBy] = (0, $acw62.useState)("newest");
    const [templateListMode, setTemplateListMode] = (0, $acw62.useState)("ALL");
    const [templateForDeletion, setTemplateForDeletion] = (0, $acw62.useState)(null);
    const [templateForTagEdit, setTemplateForTagEdit] = (0, $acw62.useState)(null);
    const [templateForEdit, setTemplateForEdit] = (0, $acw62.useState)(null);
    const draftContainerRef = (0, $acw62.useRef)(null);
    const [isFetching, setIsFetching] = (0, $acw62.useState)(true);
    const [visibleDraftCount, setVisibleDraftCount] = (0, $acw62.useState)(0);
    const [query, setQuery] = (0, $acw62.useState)({
        sort: "newest",
        draft: false
    });
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    (0, $acw62.useEffect)(()=>{
        if (isFetching) return;
        const updateVisibleDraftCount = ()=>{
            const cardGap = 16;
            const cardWidth = 300;
            if (draftContainerRef.current) {
                const containerWidth = draftContainerRef.current.offsetWidth;
                const count = Math.floor((containerWidth + cardGap) / (cardWidth + cardGap));
                setVisibleDraftCount(count === 0 ? 1 : count);
            }
        };
        const resizeObserver = new ResizeObserver(updateVisibleDraftCount);
        if (draftContainerRef.current) resizeObserver.observe(draftContainerRef.current);
        updateVisibleDraftCount();
        return ()=>resizeObserver.disconnect();
    }, [
        isFetching
    ]);
    const draftContextMenuItems = (template)=>[
            {
                name: 'Edit Draft',
                onClick: ()=>navigate(`/templates/${template.id}`),
                id: 'Edit Draft',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9060d195d3dc9c03$export$cd4d3acee7a2dcb9), {
                    className: "w-5 h-5"
                })
            },
            {
                name: 'Delete Draft',
                onClick: ()=>setTemplateForDeletion(template),
                id: 'Delete Draft',
                color: 'red-50',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                    className: "mb-1 w-5 h-5 stroke-red-50"
                })
            }
        ];
    const contextMenuItems = (template)=>[
            {
                name: 'Edit Template',
                onClick: ()=>navigate(`/templates/${template.id}`),
                id: 'Edit Template',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9060d195d3dc9c03$export$cd4d3acee7a2dcb9), {
                    className: "w-5 h-5"
                })
            },
            {
                name: 'Rename Template',
                onClick: ()=>setTemplateForEdit(template),
                id: 'Rename Template',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ddc4dcb7542735$export$2ad141e9e3d81b82), {
                    className: "w-5 h-5 stroke-white"
                })
            },
            {
                name: 'Edit Tags',
                onClick: ()=>setTemplateForTagEdit(template),
                id: 'Edit Tags',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84b3b1ac2e9f7f18$export$80beb1cb95701424), {
                    className: "w-5 h-5"
                })
            },
            {
                name: 'Duplicate Template',
                onClick: ()=>duplicateTemplate(template.id, {
                        onSuccess: (obj)=>navigate(`/templates/${obj.id}`)
                    }),
                id: 'Duplicate Template',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b904f7be4bfe30f3$export$51b6cd98f8778f0d), {
                    className: "w-5 h-4 stroke-white"
                })
            },
            {
                name: 'Delete Template',
                onClick: ()=>setTemplateForDeletion(template),
                id: 'Delete Template',
                color: 'red-50',
                icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ea415cf0d608da9$export$9f8870621d779f41), {
                    className: "mb-1 w-5 h-5 stroke-red-50"
                })
            }
        ];
    const { refetch: refetchTemplateList } = (0, $181035219bfd394d$export$2f5885556d0225e8)(query, {
        onSuccess: (data)=>{
            setTemplateList(data.results);
            setCount(data.totalCount);
            setDraftCount(data.draftCount);
            setDraftTemplates(data.recentDrafts);
            setTemplateTags(data.tags);
            setIsFetching(false);
        }
    });
    const { mutate: deleteTemplate } = (0, $181035219bfd394d$export$79b62a94a6821975)();
    const { mutate: duplicateTemplate } = (0, $181035219bfd394d$export$fe8b509dc1873566)();
    const { mutate: editTemplate } = (0, $181035219bfd394d$export$436c7386a3e8362d)();
    const updateSelectedTag = (tag)=>{
        setSelectedTag(tag);
        setTemplateListMode("ALL");
    };
    const handleTemplateTagUpdate = (tags)=>{
        if (!templateForTagEdit) return;
        setTemplateForTagEdit({
            ...templateForTagEdit,
            tags: tags
        });
        setTemplateList((prev)=>prev.map((t)=>{
                if (t.id === templateForTagEdit.id) return {
                    ...t,
                    tags: tags
                };
                return t;
            }));
    };
    const updateTemplateNameInState = (templateId, name, isDraft)=>{
        if (isDraft) {
            setDraftTemplates((prev)=>prev.map((t)=>{
                    if (t.id === templateId) return {
                        ...t,
                        name: name
                    };
                    return t;
                }));
            return;
        }
        setTemplateList((prev)=>prev.map((t)=>{
                if (t.id === templateId) return {
                    ...t,
                    name: name
                };
                return t;
            }));
    };
    const updateTemplateName = (template, name, isDraft)=>{
        const oldValue = template.name;
        updateTemplateNameInState(template.id, name, isDraft);
        editTemplate({
            id: template.id,
            data: {
                name: name
            }
        }, {
            onError: ()=>{
                updateTemplateNameInState(template.id, oldValue, isDraft);
            }
        });
        setTemplateForEdit(null);
    };
    const setDraftTab = ()=>{
        setTemplateListMode("DRAFT");
        setSelectedTag(null);
    };
    const getTagTile = (templateTag)=>{
        const count = templateTag.count;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            onClick: templateTag.count + templateTag.draftCount > 0 ? ()=>updateSelectedTag(templateTag) : ()=>{},
            onKeyUp: templateTag.count + templateTag.draftCount > 0 ? (e)=>{
                if (e.key === 'Enter') updateSelectedTag(templateTag);
            } : ()=>{},
            className: `flex flex-row justify-between items-center rounded-md px-2.5 py-1.5 hover:cursor-pointer hover:bg-gray-150 transition-colors ${selectedTag?.id !== templateTag.id ? '' : 'bg-gray-100'}`,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `text-xs font-normal ${selectedTag?.id !== templateTag.id ? 'text-gray-60' : 'text-white'}`,
                    children: templateTag.name
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: `flex h-6 w-6 bg-gray-100 rounded-md ${selectedTag?.id !== templateTag.id ? 'text-gray-60' : 'text-white'} text-xs text-center justify-center items-center`,
                    children: count
                })
            ]
        }, templateTag.id);
    };
    const getTitle = ()=>{
        let title = '';
        if (templateListMode === "ALL" && (templateList.length > 0 || draftTemplates.length > 0)) title = selectedTag ? selectedTag.name : 'All Templates';
        else if (templateListMode === "DRAFT") title = 'Drafts';
        return title;
    };
    (0, $acw62.useEffect)(()=>{
        const query = {
            sort: selectedSortBy,
            draft: templateListMode === "DRAFT"
        };
        if (selectedTag) query.tag = selectedTag.id;
        setQuery(query);
    }, [
        selectedTag,
        selectedSortBy,
        templateListMode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (templateForDeletion !== null) setIsTemplateDeleteConfirmationOpen(true);
    }, [
        templateForDeletion
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isTemplateDeleteConfirmationOpen) setTemplateForDeletion(null);
    }, [
        isTemplateDeleteConfirmationOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (templateForTagEdit !== null) setIsEditTemplateTagModalOpen(true);
    }, [
        templateForTagEdit
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isEditTemplateTagModalOpen) setTemplateForTagEdit(null);
    }, [
        isEditTemplateTagModalOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex min-h-0 flex-row h-full",
                children: isFetching ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "w-full h-full flex flex-col items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a11906f52e293a19$export$a55cbd7077614be3), {
                            className: "w-16 h-16"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "text-gray-60 text-2xl",
                            children: "Loading templates ..."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$cbfa8a8d33d01a14), {
                            className: "px-4 h-full w-[250px] flex-shrink-0 overflow-y-auto",
                            omitSeperator: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                    className: "px-4 my-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            className: "w-full",
                                            title: "Create Template",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-white"
                                            }),
                                            onClick: ()=>setIsCreateModalOpen(true)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                            className: "bg-gray-100 border-gray-100 w-full mt-4"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ae78cd9e765d6623$export$b5a557b20f0498cb), {
                                    className: "flex flex-col mt-2 gap-2 px-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            onClick: ()=>{
                                                updateSelectedTag(null);
                                                setTemplateListMode("ALL");
                                            },
                                            onKeyUp: (e)=>{
                                                if (e.key === 'Enter') {
                                                    updateSelectedTag(null);
                                                    setTemplateListMode("ALL");
                                                }
                                            },
                                            className: `flex flex-row justify-between items-center rounded-md px-2.5 py-1.5 hover:cursor-pointer hover:bg-gray-150 transition-colors ${templateListMode === "ALL" && !selectedTag ? 'bg-gray-100' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex flex-row gap-2.5 items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5b0e2b9e347c28dd$export$a245117220b0b0f2), {
                                                            className: `w-4 h-4 ${templateListMode === "ALL" && !selectedTag ? 'stroke-white' : 'stroke-gray-60'}`
                                                        }),
                                                        ' ',
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `${templateListMode === "ALL" && !selectedTag ? 'text-white' : 'text-gray-60'} text-sm font-normal`,
                                                            children: "All Templates"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: `flex h-6 w-6 bg-gray-100 rounded-md ${templateListMode === "ALL" && !selectedTag ? 'text-white' : 'text-gray-60'} text-xs text-center justify-center items-center`,
                                                    children: count
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "ml-6",
                                            children: [
                                                draftCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    onClick: setDraftTab,
                                                    onKeyUp: (e)=>{
                                                        if (e.key === 'Enter') setDraftTab();
                                                    },
                                                    className: `flex flex-row justify-between items-center rounded-md px-2.5 py-1.5 hover:cursor-pointer hover:bg-gray-150 transition-colors ${templateListMode === "DRAFT" ? 'bg-gray-100' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            className: `${templateListMode === "DRAFT" ? 'text-white' : 'text-gray-60'} text-xs font-normal`,
                                                            children: "Drafts"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: `flex h-6 w-6 bg-gray-100 rounded-md ${templateListMode === "DRAFT" ? 'text-white' : 'text-gray-60'} text-xs text-center justify-center items-center`,
                                                            children: draftCount
                                                        })
                                                    ]
                                                }),
                                                draftCount > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "border-b-[1px] border-solid border-gray-100 ml-3 mr-3 mt-1 mb-2"
                                                }),
                                                templateTags.filter((tag)=>tag.count > 0).map((templateTag)=>getTagTile(templateTag))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                            type: "button",
                                            className: "group flex flex-row items-center gap-2 w-full py-2 text-blue-30 hover:text-blue-50 text-xs",
                                            onClick: ()=>setIsEditTagModalOpen(true),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-4 h-4"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e0ddc4dcb7542735$export$2ad141e9e3d81b82), {
                                                    className: "stroke-blue-30 group-hover:stroke-blue-50"
                                                }),
                                                "Edit tags"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mt-2 p-5 flex flex-col flex-grow overflow-hidden",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-row justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-white text-2xl font-normal items-start",
                                            children: getTitle()
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0691ba840a4acbbd$export$eb2ca1350bb61eb0), {
                                            options: [
                                                {
                                                    name: 'Newest',
                                                    id: "newest"
                                                },
                                                {
                                                    name: 'Oldest',
                                                    id: "oldest"
                                                },
                                                {
                                                    name: 'A-Z',
                                                    id: "a-z"
                                                },
                                                {
                                                    name: 'Z-A',
                                                    id: "z-a"
                                                }
                                            ],
                                            onChange: (setSortBy)=>setSelectedSortBy(setSortBy)
                                        })
                                    ]
                                }),
                                templateList.length === 0 && draftCount === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col items-center justify-center flex-grow",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd5d46306eb83dc9$export$d7db36bc683573), {
                                            className: "h-32 w-28"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-white text-3xl font-normal mt-10",
                                            children: "Create your First Template"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $962788b972601ad7$export$353f5b6fc5456de1), {
                                            className: "mt-4",
                                            title: "Create Template",
                                            buttonType: (0, $962788b972601ad7$export$d3d950cd69e1ac66).PRIMARY,
                                            buttonSize: (0, $962788b972601ad7$export$5dd2748b7940a2a0).LARGE,
                                            leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd820b171ebe1162$export$2e2bcd8739ae039), {
                                                className: "h-5 w-5 text-white"
                                            }),
                                            onClick: ()=>setIsCreateModalOpen(true)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "min-h-0 overflow-y-scroll flex-1 no-scrollbar",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            ref: draftContainerRef,
                                            className: "w-full",
                                            children: draftCount > 0 && templateListMode === "ALL" && !selectedTag && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-col w-full bg-gray-150 mt-8 p-6 rounded-lg",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-gray-40 text-lg",
                                                        children: "Drafts"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex gap-4 overflow-hidden mt-3",
                                                        children: draftTemplates.slice(0, visibleDraftCount).map((template, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0f2a847676ac967c$export$faf7d44439998149), {
                                                                title: template.name,
                                                                createdAt: template.createdAt,
                                                                isRenaming: templateForEdit === template,
                                                                onRename: (value)=>updateTemplateName(template, value, true),
                                                                menuItems: draftContextMenuItems(template),
                                                                thumbnail: template.latestVersion?.thumbnail || '',
                                                                onClick: ()=>navigate(`/templates/${template.id}`)
                                                            }, template.id))
                                                    }),
                                                    draftCount > visibleDraftCount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        type: "button",
                                                        className: "flex flex-row gap-2 items-center mt-3 w-32",
                                                        onClick: ()=>{
                                                            setTemplateListMode("DRAFT");
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-blue-30 text-xs",
                                                                children: "Show more"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $96fa020988d12076$export$2e2bcd8739ae039), {
                                                                className: "w-4 h-4 text-blue-30"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        templateList.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "mt-10 no-scrollbar",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "grid gap-6 justify-stretch grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] max-sm:grid-cols-1",
                                                children: templateList.map((template)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90a2ffb9ba471d3e$export$16a9184edda9e700), {
                                                        title: template.name,
                                                        createdAt: template.createdAt,
                                                        tags: template.tags,
                                                        thumbnail: template.latestVersion?.thumbnail || '',
                                                        isRenaming: templateForEdit === template,
                                                        isDraft: template.publishedVersion === null,
                                                        onRename: (value)=>updateTemplateName(template, value, false),
                                                        menuItems: contextMenuItems(template),
                                                        onClick: ()=>navigate(`/templates/${template.id}`)
                                                    }, template.id))
                                            })
                                        }),
                                        templateList.length === 0 && draftTemplates.length > 0 && templateListMode === "ALL" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "flex flex-col items-center justify-center w-full mt-8",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {
                                                    className: "bg-gray-100 border-gray-100 w-full"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xl text-gray-40 mt-8",
                                                    children: "No Published Templates"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df172b5502887faa$export$ecdb1fd4c4d0b7a7), {
                isOpen: isCreateModalOpen,
                setIsOpen: setIsCreateModalOpen,
                onSuccess: (id)=>navigate(`/templates/${id}`)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ef513998692c190$export$5ce3274d32104b7b), {
                isOpen: isEditTagModalOpen,
                setIsOpen: setIsEditTagModalOpen,
                onDone: ()=>{
                    refetchTemplateList();
                }
            }),
            templateForTagEdit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d30f2fc9305b8a7$export$2ca68fd5c50cde74), {
                isOpen: isEditTemplateTagModalOpen,
                setIsOpen: setIsEditTemplateTagModalOpen,
                template: templateForTagEdit,
                setTags: handleTemplateTagUpdate,
                onDone: refetchTemplateList
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d6fbad6cc0f9b3f8$export$1f33f980da756c46), {
                isOpen: isTemplateDeleteConfirmationOpen,
                setIsOpen: setIsTemplateDeleteConfirmationOpen,
                type: (0, $d6fbad6cc0f9b3f8$export$b71090edac4832f0).WARN,
                confirmText: "Delete",
                cancelText: "Cancel",
                message: "Delete Template",
                subMessage: "Are you sure you want to delete this template?",
                onConfirm: ()=>{
                    deleteTemplate(templateForDeletion?.id ?? -1);
                }
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");
const $74f3e98177c64a27$export$f97dc4a5a0177256 = ({ tabs: tabs, selectedTab: selectedTab, onTabChange: onTabChange })=>{
    const tabsRef = (0, $acw62.useRef)([]);
    const [activeTabIndex, setActiveTabIndex] = (0, $acw62.useState)(null);
    const [tabUnderlineWidth, setTabUnderlineWidth] = (0, $acw62.useState)();
    const [tabUnderlineLeft, setTabUnderlineLeft] = (0, $acw62.useState)();
    function getRef(element, index) {
        tabsRef.current[index] = element;
    }
    (0, $acw62.useEffect)(()=>{
        const initialIndex = tabs.findIndex((tab)=>tab.id === selectedTab);
        setActiveTabIndex(initialIndex >= 0 ? initialIndex : 0);
    }, [
        selectedTab,
        tabs
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (activeTabIndex === null) return;
        const currentTab = tabsRef.current[activeTabIndex];
        setTabUnderlineLeft(currentTab?.offsetLeft ?? 0);
        setTabUnderlineWidth(currentTab?.clientWidth ?? 0);
    }, [
        activeTabIndex
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex-row relative mx-auto flex rounded-3xl bg-gray-100 hover:bg-gray-90 px-1 backdrop-blur-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "absolute bottom-0 top-0 flex overflow-hidden rounded-3xl py-1 transition-all duration-300",
                style: {
                    left: tabUnderlineLeft,
                    width: tabUnderlineWidth
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "h-full w-full rounded-3xl bg-blue-00 z-10"
                })
            }),
            tabs.map((tab, index)=>{
                const isActive = activeTabIndex === index;
                const element = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    ref: (el)=>getRef(el, index),
                    className: `${isActive ? 'text-black-50 font-medium' : 'text-gray-50 font-light'} z-20 flex-grow cursor-pointer select-none rounded-full px-10 py-2 text-center text-sm`,
                    onClick: ()=>{
                        setActiveTabIndex(index);
                        onTabChange?.(tab.id);
                    },
                    children: tab.name
                }, tab.id);
                return element;
            })
        ]
    });
};



const $0e8091e91b7ae40f$var$TABS = [
    {
        name: 'Template',
        id: 'templates'
    },
    {
        name: 'Creative',
        id: 'creatives'
    }
];
function $0e8091e91b7ae40f$var$tabToPath(tab) {
    let path = '';
    switch(tab){
        case 'templates':
            path = '/templates';
            break;
        case 'creatives':
            path = '/creatives';
            break;
    }
    return path;
}
function $0e8091e91b7ae40f$var$pathToTab(path) {
    let tab = '';
    switch(path){
        case '/templates':
            tab = 'templates';
            break;
        case '/creatives':
            tab = 'creatives';
            break;
    }
    return tab;
}
const $0e8091e91b7ae40f$export$4b9717fdb2660b26 = ()=>{
    const location = (0, $32578012b727878c$export$45d76561a5302f2b)();
    const navigate = (0, $32578012b727878c$export$9770f232ac06a008)();
    const [currentTab, setCurrentTab] = (0, $acw62.useState)($0e8091e91b7ae40f$var$pathToTab(location.pathname));
    const [isAccountSettingsOpen, setIsAccountSettingsOpen] = (0, $acw62.useState)(false);
    const [isAdminControlsOpen, setIsAdminControlsOpen] = (0, $acw62.useState)(false);
    const [user, setUser] = (0, $acw62.useState)(null);
    const handleTabChange = (0, $acw62.useCallback)((tabId)=>{
        const path = $0e8091e91b7ae40f$var$tabToPath(tabId);
        if (path) navigate(path);
        setCurrentTab(tabId);
    }, [
        navigate
    ]);
    const fetchUser = (0, $acw62.useCallback)((refetch)=>{
        (0, $c0753412de87ef15$export$86659b0ff913db80).getCurrentUser(refetch).then((response)=>{
            setUser(response);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (user?.type === (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER) navigate('/creatives');
    }, [
        user,
        navigate
    ]);
    (0, $acw62.useEffect)(()=>{
        fetchUser(false);
    }, [
        fetchUser
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col h-screen w-screen bg-black-50",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3f317f73d7705c5$export$42cfbb80f7861e77), {
                        leading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$a6c7ac8248d6e38a), {
                            to: "/",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d9bddfe2f0bb60b$export$d59d68c5c4589499), {})
                        }),
                        center: user?.type !== (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74f3e98177c64a27$export$f97dc4a5a0177256), {
                            selectedTab: currentTab,
                            onTabChange: handleTabChange,
                            tabs: $0e8091e91b7ae40f$var$TABS
                        }),
                        trailing: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-row gap-2.5 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c75eb4c4478911c$export$c6aea0e298dc6482), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "h-6 border-gray-100 border-l-[1px]"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $22923ec698324d83$export$72d0b49a56703654), {
                                    user: user,
                                    onLogout: ()=>{
                                        (0, $e1959a6d31579a72$export$a0973bcfe11b05c9)();
                                        navigate('/login', {
                                            replace: true
                                        });
                                    },
                                    onAccountSettings: ()=>setIsAccountSettingsOpen(true),
                                    onOrganizationSettings: ()=>setIsAdminControlsOpen(true)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$910ae8079b2c2852), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee9165ed7aac49d0$export$2ec38366d6add659), {
                isOpen: isAccountSettingsOpen,
                setIsOpen: setIsAccountSettingsOpen,
                onAccountUpdated: ()=>fetchUser(true)
            }),
            user?.type === (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4096c6d546e14db9$export$ab5bd7780c936eb2), {
                isOpen: isAdminControlsOpen,
                setIsOpen: setIsAdminControlsOpen,
                onAccountUpdated: ()=>fetchUser(true)
            })
        ]
    });
};


const $ef2b36529b83920e$var$DefaultRoute = ({ path: path })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
        to: path,
        replace: true
    });
};
const $ef2b36529b83920e$var$ProtectedRoute = ({ component: component, allowedUserTypes: allowedUserTypes, redirectToIfNotAllowed: redirectToIfNotAllowed })=>{
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(null);
    const [user, setUser] = (0, $acw62.useState)(null);
    const { checkAuth: checkAuth } = (0, $701fdb377a36f454$export$1d39dc5b47e56ff0)();
    const authCheck = (0, $acw62.useCallback)(async ()=>{
        const authStatus = await checkAuth();
        if (authStatus) {
            const user = await (0, $c0753412de87ef15$export$86659b0ff913db80).getCurrentUser();
            setUser(user);
        }
        setIsAuthenticated(authStatus);
    }, [
        checkAuth
    ]);
    (0, $acw62.useEffect)(()=>{
        authCheck();
    }, [
        authCheck
    ]);
    if (isAuthenticated === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
    if (!isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
        to: "/login",
        replace: true
    });
    if (allowedUserTypes && user && !allowedUserTypes.includes(user.type)) {
        if (!redirectToIfNotAllowed) throw new Error('redirectToIfNotAllowed is required when allowedUserTypes is provided');
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
            to: redirectToIfNotAllowed,
            replace: true
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: component
    });
};
const $ef2b36529b83920e$var$LoginRoute = ()=>{
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(null);
    const [user, setUser] = (0, $acw62.useState)(null);
    const { checkAuth: checkAuth } = (0, $701fdb377a36f454$export$1d39dc5b47e56ff0)();
    const authCheck = (0, $acw62.useCallback)(async ()=>{
        const authStatus = await checkAuth();
        if (authStatus) {
            const user = await (0, $c0753412de87ef15$export$86659b0ff913db80).getCurrentUser();
            setUser(user);
        }
        setIsAuthenticated(authStatus);
    }, [
        checkAuth
    ]);
    (0, $acw62.useEffect)(()=>{
        authCheck();
    }, [
        authCheck
    ]);
    if (isAuthenticated === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
    if (isAuthenticated && user) {
        if (user.type === (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
            to: "/creatives",
            replace: true
        });
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$444b3ab0cb9aec40), {
            to: "/templates",
            replace: true
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a1531be10320632$export$21a94553ffa41578), {});
};
const $ef2b36529b83920e$export$86fbec116b87613f = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col w-screen h-screen",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b00d3e7401eac195$export$f2815235e76a62b9), {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                newestOnTop: true,
                closeOnClick: false,
                rtl: false,
                pauseOnFocusLoss: true,
                draggable: false,
                pauseOnHover: true,
                theme: "colored",
                icon: ({ type: type, theme: theme })=>{
                    switch(type){
                        case 'error':
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $288db5f145d66c42$export$2e2bcd8739ae039), {
                                className: "stroke-red-500"
                            });
                        case 'success':
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef03f1e36d447ce4$export$2e2bcd8739ae039), {
                                className: "stroke-green-500"
                            });
                        default:
                            return null;
                    }
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $32578012b727878c$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                        index: true,
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$DefaultRoute, {
                            path: "/login"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$LoginRoute, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                        path: "/invite",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1088e7306747353$export$5faba96a460ce625), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$ProtectedRoute, {
                            component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e8091e91b7ae40f$export$4b9717fdb2660b26), {})
                        }),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                                path: "/templates",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$ProtectedRoute, {
                                    component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2d6d20050e6878f4$export$c5a06aa0f041765d), {}),
                                    allowedUserTypes: [
                                        (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN,
                                        (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER
                                    ],
                                    redirectToIfNotAllowed: "/creatives"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                                path: "/creatives",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$ProtectedRoute, {
                                    component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $69df7f0959bce31d$export$96a663cec1eeedf2), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                        path: "/templates/*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$ProtectedRoute, {
                            component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $858fae968d725bbc$export$b78c417a59fec2a7), {}),
                            allowedUserTypes: [
                                (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN,
                                (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER
                            ],
                            redirectToIfNotAllowed: "/creatives"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$e7b0ac011bb776c6), {
                        path: "/creatives/*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef2b36529b83920e$var$ProtectedRoute, {
                            component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb62b2fe07ca4069$export$bfac4771245e54dc), {}),
                            allowedUserTypes: [
                                (0, $4e6833270179d7a4$export$8436e53e45ffe15b).ADMIN,
                                (0, $4e6833270179d7a4$export$8436e53e45ffe15b).DESIGNER,
                                (0, $4e6833270179d7a4$export$8436e53e45ffe15b).MEMBER
                            ],
                            redirectToIfNotAllowed: "/templates"
                        })
                    })
                ]
            })
        ]
    });
};


const $dc056242afbabd27$var$environment = "preview";
if ($dc056242afbabd27$var$environment) $07b303fd558e140e$export$2cd8252107eb640b({
    dsn: 'https://d1d14b2ae0e37d39e310968f05d0c784@o814635.ingest.us.sentry.io/4509248918978560',
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        (0, $5e3cd3c8fb9f0af3$export$923ea8233b386e99)
    ],
    environment: $dc056242afbabd27$var$environment,
    sendDefaultPii: true
});
const $dc056242afbabd27$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById('fm-root'));
const $dc056242afbabd27$var$queryClient = new (0, $13e074efb1ecf7c6$export$405d0624ed55a03f)();
$dc056242afbabd27$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8921079907ea55d7$export$e926676385687eaf, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32578012b727878c$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $701fdb377a36f454$export$87091915187a1a85), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccb8f828cefd6075$export$45604f0cc8ae667b), {
                    client: $dc056242afbabd27$var$queryClient,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef2b36529b83920e$export$86fbec116b87613f), {})
                })
            })
        })
    })
}));


//# sourceMappingURL=index.a7890f9e.js.map
